import { defineComponent as X, openBlock as $, createElementBlock as k, renderSlot as W, withAsyncContext as ld, ref as de, onMounted as r1, watch as Ce, normalizeClass as z, createElementVNode as x, createCommentVNode as P, nextTick as P1, withKeys as m1, toDisplayString as E, createVNode as y, unref as u, withCtx as b, createBlock as _, resolveDynamicComponent as Oe, computed as j, createTextVNode as R, Fragment as ae, renderList as he, useCssVars as g2, resolveDirective as g1, withDirectives as Ge, mergeProps as fe, mergeModels as ye, useModel as ze, reactive as Kd, isRef as dt, shallowRef as Nd, onBeforeUnmount as id, normalizeStyle as Ue, onDeactivated as h2, useAttrs as ud, useId as j1, withModifiers as Qe, vModelCheckbox as v2, Teleport as Zd, Transition as N1, vShow as cd, normalizeProps as A1, resolveComponent as b2, useSlots as hn, createSlots as Dt, onBeforeMount as y2, useTemplateRef as Xt, watchEffect as vn, toRefs as fd, inject as bn, provide as H0, guardReactiveProps as X1, toHandlers as wt } from "vue";
import * as x2 from "@cfgtech/icons";
import { ChevronDownIcon as F1, InfoCircleIcon as Qt, CheckCircleIcon as w2, DangerTriangleFillIcon as yn, ErrorOctagonIcon as C2, ChevronLeftIcon as Ct, ChevronRightIcon as D1, LeftArrowIcon as k2, RightArrowIcon as S2, TickIcon as u1, HomeIcon as M2, QuestionCircleIcon as ht, CheckmarkIcon as qd, SearchIcon as T2, DangerTriangleIcon as L2, CalendarIcon as Jd, TicketIcon as xn, WalletMoneyIcon as wn, UserGroupIcon as A2, ArrowLeftIcon as D2, MoreDotsIcon as I2, LockIcon as E2, BrifecaseTickIcon as z2, Bag2Icon as B2, HouseIcon as P2, SecurityUserIcon as V2, BuildingsIcon as O2, DocumentIcon as R2, CalendarTickIcon as N2, ArrowRightIcon as F2, QuestionIcon as _2, MoneySendIcon as Cn, TickCircleIcon as j2, EyeIcon as H2 } from "@cfgtech/icons";
import { templateRef as ed, watchDebounced as kn, useArrayMap as kt, useFocus as ot, unrefElement as G2, tryOnScopeDispose as U2, useEventListener as Fd, useTextareaAutosize as W2, useElementSize as Xd, onClickOutside as Sn, useElementBounding as St, useMouseInElement as G0, computedAsync as Y2, useResizeObserver as K2, asyncComputed as Z2, computedEager as q2, useWindowSize as J2, useWindowScroll as X2, useDebounceFn as Q2 } from "@vueuse/core";
import { translations as _d, asyncArrayFilter as er, BankCodes as Ed, bankTranslations as tr, validators as dr, getBirthDateFromBirthNumber as nr, useMoneyFormat as Gt, roundToNearest as rr } from "@cfgtech/helpers";
import td from "dayjs";
import { ProgressRoot as sr, ProgressIndicator as or, PinInputRoot as ar, PinInputInput as lr, PopoverRoot as ir, PopoverTrigger as ur, PopoverPortal as cr, PopoverContent as fr, TabsTrigger as Mn, TabsContent as Tn, TabsRoot as Ln, TabsList as An, TabsIndicator as $r, SliderRoot as pr, SliderTrack as mr, SliderRange as gr, SliderThumb as hr } from "reka-ui";
import { useFloating as Qd, autoUpdate as e0, flip as Dn, shift as In, offset as En, autoPlacement as zn } from "@floating-ui/vue";
import { cloneDeep as bt, isEqual as Mt, pick as x1, isUndefined as jd, isEmpty as U0, omit as $d, pickBy as vr } from "lodash-es";
import { SwitchGroup as br, Switch as yr, SwitchLabel as xr, SwitchDescription as wr, TransitionRoot as t0, Dialog as d0, TransitionChild as nt, DialogPanel as n0, DialogTitle as Cr, DialogDescription as kr, Listbox as Sr, ListboxButton as Mr, ListboxOptions as Tr, ListboxOption as Lr } from "@headlessui/vue";
import { createFocusTrap as Ar } from "focus-trap";
const G9 = /* @__PURE__ */ X({
  __name: "CfgAccordion",
  props: {
    opened: {}
  },
  emits: ["update:opened"],
  setup(e, { emit: t }) {
    const d = e, r = t;
    function n(a) {
      r("update:opened", a !== d.opened ? a : -1);
    }
    return (a, s) => ($(), k("ul", null, [
      W(a.$slots, "default", {
        activeIdx: a.opened,
        on: { "click:header": n }
      })
    ]));
  }
}), Bn = /* @__PURE__ */ X({
  __name: "CfgCollapsable",
  props: {
    closedHeight: {
      type: Number,
      default: 0
    },
    opened: {
      type: Boolean,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:opened", "update:content-overflowed"],
  async setup(e, { emit: t }) {
    let d, r;
    const n = e, a = t, { default: s } = ([d, r] = ld(() => import("gsap")), d = await d, r(), d), l = ed("contentController"), i = ed("contentWrapper"), f = de(n.opened), p = de(n.opened ?? !0);
    r1(() => {
      n.opened || C();
    }), kn([p, () => n.disabled], () => C(), {
      debounce: 50
    }), Ce(
      () => n.opened,
      (v) => {
        p.value = v ?? !1;
      }
    ), Ce(
      () => p.value,
      () => {
        p.value !== n.opened && a("update:opened", p.value);
      }
    );
    const m = de(!1), h = de([]);
    async function C(v = !0) {
      if (!i.value)
        return;
      if (m.value) {
        h.value.push(() => C(v));
        return;
      }
      await (async () => {
        m.value = !0;
        const L = p.value && !n.disabled, T = v ? 0.4 : 0;
        i.value && (i.value.style.overflow = "hidden"), await P1(async () => {
          L && (s.set(i.value, { height: 0 }), await P1(() => {
            f.value = !0;
          })), await P1(() => new Promise((g) => {
            s.to(i.value, {
              duration: L ? T * 1.3 : T * 0.7,
              ease: "expo.inOut",
              autoAlpha: L ? 1 : 0
            }), s.to(i.value, {
              duration: T,
              ease: "expo.inOut",
              height: L ? "auto" : 0,
              onComplete() {
                i.value && (i.value.style.overflow = "initial"), L || (f.value = !1), m.value = !1, g(!0);
              }
            });
          }));
        });
      })();
      const S = h.value;
      h.value = [];
      for await (const L of S)
        await L();
    }
    return (v, M) => ($(), k("div", {
      class: z(["collapsable_wrapper transform-all relative duration-300", {
        closed: !p.value && !e.disabled
      }])
    }, [
      x("div", {
        ref_key: "contentWrapper",
        ref: i,
        class: "relative"
      }, [
        x("div", {
          ref_key: "contentController",
          ref: l
        }, [
          f.value ? W(v.$slots, "default", { key: 0 }) : P("", !0)
        ], 512)
      ], 512)
    ], 2));
  }
}), Dr = {
  key: 0,
  class: "shrink grow text-md font-highlighted"
}, U9 = /* @__PURE__ */ X({
  __name: "CfgAccordionItem",
  props: {
    opened: { type: Boolean },
    headerText: { default: "" },
    index: {},
    headClass: { default: "" },
    bodyClass: { default: "" }
  },
  emits: ["click:header"],
  setup(e, { emit: t }) {
    const d = e, r = t;
    function n() {
      r("click:header", d.index);
    }
    return (a, s) => ($(), k("li", null, [
      W(a.$slots, "static"),
      x("header", {
        class: z(["flex cursor-pointer justify-between py-3", {
          "text-brand": a.opened,
          "text-dark-200": !a.opened,
          [a.headClass]: a.headClass
        }]),
        onClick: n,
        onKeydown: m1(n, ["enter"])
      }, [
        W(a.$slots, "head", {}, () => [
          a.headerText ? ($(), k("span", Dr, E(a.headerText), 1)) : P("", !0)
        ]),
        x("span", {
          class: z(["shrink-0 transition-all duration-300", { "rotate-180": a.opened }])
        }, [
          y(u(F1))
        ], 2)
      ], 34),
      x("main", {
        class: z({ [a.bodyClass]: a.bodyClass })
      }, [
        y(Bn, {
          "closed-height": 0,
          opened: a.opened
        }, {
          default: b(() => [
            W(a.$slots, "default")
          ]),
          _: 3
        }, 8, ["opened"])
      ], 2)
    ]));
  }
});
var He = /* @__PURE__ */ ((e) => (e.brand = "brand", e.success = "success", e.warning = "warning", e.info = "info", e.error = "error", e))(He || {}), H = /* @__PURE__ */ ((e) => (e.h1 = "h1", e.h2 = "h2", e.h3 = "h3", e.h4 = "h4", e.h5 = "h5", e.h6 = "h6", e.subtitle = "subtitle", e.md = "md", e.sm = "sm", e.xs = "xs", e["h1-large"] = "h1-large", e.label = "label", e.xl = "xl", e.lg = "lg", e.perex = "perex", e.small = "small", e.micro = "micro", e))(H || {});
const Ir = ["innerHTML"], Er = /* @__PURE__ */ X({
  __name: "CfgTypography",
  props: {
    size: {
      type: String,
      default: H.md
    },
    tagName: {
      type: String,
      default: "span"
    },
    html: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return (t, d) => t.$slots.default ? ($(), _(Oe(e.tagName), {
      key: 0,
      class: z(["heading", {
        [`heading-${e.size}`]: !!e.size
      }])
    }, {
      default: b(() => [
        W(t.$slots, "default", {}, () => [
          e.html ? ($(), k("span", {
            key: 0,
            innerHTML: e.html
          }, null, 8, Ir)) : P("", !0)
        ], !0)
      ]),
      _: 3
    }, 8, ["class"])) : e.html ? ($(), _(Oe(e.tagName), {
      key: 1,
      class: z(["heading", {
        [`heading-${e.size}`]: !!e.size
      }]),
      innerHTML: e.html
    }, null, 8, ["class", "innerHTML"])) : P("", !0);
  }
}), h1 = (e, t) => {
  const d = e.__vccOpts || e;
  for (const [r, n] of t)
    d[r] = n;
  return d;
}, O = /* @__PURE__ */ h1(Er, [["__scopeId", "data-v-78af6141"]]), zr = { class: "flex gap-x-3" }, Br = { class: "space-y-1" }, W9 = /* @__PURE__ */ X({
  __name: "CfgAlert",
  props: {
    variant: {
      type: String,
      default: He.info
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, d = j(() => {
      if (t.variant === He.info)
        return Qt;
      if (t.variant === He.success)
        return w2;
      if (t.variant === He.warning)
        return yn;
      if (t.variant === He.error)
        return C2;
    });
    return (r, n) => ($(), k("div", {
      class: z(["mb-4 rounded-md px-3 py-4 text-black md:px-4", {
        "bg-brand/20": e.variant === u(He).brand,
        "bg-blue/20": e.variant === u(He).info,
        "bg-success-light": e.variant === u(He).success,
        "bg-warning-light": e.variant === u(He).warning,
        "bg-red-light": e.variant === u(He).error
      }])
    }, [
      x("div", zr, [
        d.value || r.$slots.icon ? ($(), k("div", {
          key: 0,
          class: z(["w-6 flex-none [&>*]:text-[24px]", {
            "text-brand": e.variant === u(He).brand,
            "text-blue": e.variant === u(He).info,
            "text-success": e.variant === u(He).success,
            "text-warning": e.variant === u(He).warning,
            "text-red": e.variant === u(He).error
          }])
        }, [
          W(r.$slots, "icon", {}, () => [
            ($(), _(Oe(d.value), { "aria-hidden": "true" }))
          ])
        ], 2)) : P("", !0),
        x("div", Br, [
          e.title ? ($(), _(O, {
            key: 0,
            class: "text-start !font-highlighted",
            size: u(H).md,
            "tag-name": "h3"
          }, {
            default: b(() => [
              R(E(e.title), 1)
            ]),
            _: 1
          }, 8, ["size"])) : P("", !0),
          y(O, {
            size: u(H).md,
            "tag-name": "p"
          }, {
            default: b(() => [
              W(r.$slots, "text", {}, () => [
                R(E(e.text), 1)
              ])
            ]),
            _: 3
          }, 8, ["size"])
        ])
      ])
    ], 2));
  }
}), Pr = {}, Vr = { class: "lds-ring" };
function Or(e, t) {
  return $(), k("span", Vr, [
    ($(), k(ae, null, he(4, (d) => x("span", { key: d })), 64))
  ]);
}
const It = /* @__PURE__ */ h1(Pr, [["render", Or]]), _e = {
  primary: "primary",
  primaryLight: "primary-light",
  secondary: "secondary",
  successLight: "success-light",
  success: "success",
  grey: "grey",
  light: "light",
  orangeLight: "orange-light",
  orange: "orange",
  dark: "dark",
  danger: "danger",
  dangerLight: "danger-light",
  black: "black",
  stroke: "stroke",
  white: "white"
}, Rr = { class: "relative block" }, Nr = {
  key: 0,
  class: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
}, I1 = /* @__PURE__ */ X({
  __name: "CfgButton",
  props: {
    variant: { default: _e.primary },
    label: { default: "" },
    flat: { type: Boolean },
    text: { type: Boolean },
    loading: { type: Boolean },
    small: { type: Boolean },
    stroke: { type: Boolean },
    as: { default: "button" },
    iconPlacement: { default: "right" },
    disabledClasses: {},
    rippleScale: { type: Boolean }
  },
  setup(e) {
    g2((s) => ({
      "5cf2609a": a.value.y,
      "5cf26099": a.value.x
    }));
    const t = e, d = j(() => ({
      [_e.primary]: {
        DEFAULT: "text-white bg-brand border-brand",
        stroke: "border-brand text-brand",
        text: "text-brand"
      },
      "primary-inverted": {
        DEFAULT: "text-brand bg-white border-white",
        stroke: "border-white text-white",
        text: "text-white"
      },
      [_e.primaryLight]: {
        DEFAULT: "text-brand bg-brand-opacity border-brand-opacity",
        stroke: "border-brand-opacity text-brand-opacity",
        text: "text-brand-opacity"
      },
      [_e.secondary]: {
        DEFAULT: "text-white bg-secondary border-secondary",
        stroke: "border-secondary text-secondary",
        text: "text-secondary"
      },
      [_e.grey]: {
        DEFAULT: "text-white bg-grey-300 border-grey-300",
        stroke: "border-grey-300 text-grey-300",
        text: "text-grey-300"
      },
      [_e.dark]: {
        DEFAULT: "text-white bg-secondary-dark border-secondary-dark",
        stroke: "border-secondary-dark text-secondary-dark",
        text: "text-secondary-dark"
      },
      [_e.light]: {
        DEFAULT: "text-secondary-dark bg-grey-100 border-grey-100",
        stroke: "border-grey-100 text-grey-100",
        text: "text text-grey-100"
      },
      [_e.orange]: {
        DEFAULT: "text-white bg-orange border-orange",
        stroke: "border-orange text-orange",
        text: "text-orange"
      },
      [_e.orangeLight]: {
        DEFAULT: "text-orange bg-orange-light border-orange",
        stroke: "border-orange-light text-orange-light",
        text: "text-orange-light"
      },
      [_e.danger]: {
        DEFAULT: "text-red-light bg-red border-red",
        stroke: "border-red text-red",
        text: "text-red"
      },
      [_e.dangerLight]: {
        DEFAULT: "text-red bg-red-light border-red-light",
        stroke: "border-red-light text-red-light",
        text: "text-red-light"
      },
      [_e.success]: {
        DEFAULT: "text-success-light bg-success border-success",
        stroke: "border-success text-success",
        text: "text-success"
      },
      [_e.successLight]: {
        DEFAULT: "text-success bg-success-light border-success-light",
        stroke: "border-success-light text-success-light",
        text: "text-success-light"
      },
      [_e.black]: {
        DEFAULT: "text-white bg-black border-black",
        stroke: "border-black text-black",
        text: "text-black"
      },
      [_e.stroke]: {
        DEFAULT: "text-grey-100 bg-black border-grey-100",
        stroke: "border-grey-100 text-black",
        text: "text-black"
      },
      [_e.white]: {
        DEFAULT: "text-black bg-white border-black",
        stroke: "border-white text-white",
        text: "text-white"
      }
    })), r = j(() => {
      if (t.text && t.stroke)
        throw new Error("CfgButton cannot have both text and stroke properties");
      return t.stroke ? "stroke" : t.text ? "text" : "DEFAULT";
    }), n = j(() => {
      const s = t.variant || _e.primary;
      return d.value[s][r.value];
    }), a = j(() => r.value === "text" ? { y: "0.4em", x: "1em" } : { y: "1.2em", x: "1.8em" });
    return (s, l) => {
      const i = g1("ripple");
      return Ge(($(), _(Oe(s.as), fe({
        ...s.as === "button" && !s.$attrs.type ? { type: "button" } : {}
      }, {
        class: ["button focusable inline-block px-0 font-display font-highlighted", {
          [`button-variant__${s.variant}`]: !0,
          "button-flat": s.flat,
          "button-small": s.small,
          "button-text": s.text,
          "opacity-60": s.$attrs.disabled && !s.disabledClasses,
          [s.disabledClasses]: s.$attrs.disabled && s.disabledClasses,
          "cursor-not-allowed": s.$attrs.disabled,
          "button-stroke": s.stroke,
          [n.value]: !0
        }],
        disabled: s.$attrs.disabled || s.loading
      }), {
        default: b(() => [
          x("span", Rr, [
            x("span", {
              class: z(["flex items-center justify-center", {
                "opacity-0": s.loading,
                "gap-x-3": !s.small,
                "gap-x-2": s.small
              }])
            }, [
              s.label || s.$slots.default ? ($(), k("span", {
                key: 0,
                class: z(["button_label block text-center first-letter:uppercase", { "order-2": s.iconPlacement === "left" }])
              }, [
                W(s.$slots, "default", {}, () => [
                  R(E(s.label), 1)
                ])
              ], 2)) : P("", !0),
              s.$slots.icon ? ($(), k("span", {
                key: 1,
                class: z({ "order-1": s.iconPlacement === "left" })
              }, [
                W(s.$slots, "icon")
              ], 2)) : P("", !0)
            ], 2),
            s.loading ? ($(), k("span", Nr, [
              y(It, {
                class: z({
                  "text-[7px]": !s.small,
                  "text-[5px]": s.small
                })
              }, null, 8, ["class"])
            ])) : P("", !0)
          ])
        ]),
        _: 3
      }, 16, ["class", "disabled"])), [
        [i, { scale: s.rippleScale ? { x: 1.03, y: 1.09 } : {} }]
      ]);
    };
  }
});
var Pn = 60, Vn = Pn * 60, On = Vn * 24, Fr = On * 7, rt = 1e3, zd = Pn * rt, W0 = Vn * rt, _r = On * rt, jr = Fr * rt, r0 = "millisecond", K1 = "second", Z1 = "minute", q1 = "hour", T1 = "day", Kt = "week", l1 = "month", Rn = "quarter", L1 = "year", J1 = "date", Hr = "YYYY-MM-DDTHH:mm:ssZ", Y0 = "Invalid Date", Gr = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, Ur = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g;
const Wr = {
  name: "en",
  weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
  months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
  ordinal: function(t) {
    var d = ["th", "st", "nd", "rd"], r = t % 100;
    return "[" + t + (d[(r - 20) % 10] || d[r] || d[0]) + "]";
  }
};
var Hd = function(t, d, r) {
  var n = String(t);
  return !n || n.length >= d ? t : "" + Array(d + 1 - n.length).join(r) + t;
}, Yr = function(t) {
  var d = -t.utcOffset(), r = Math.abs(d), n = Math.floor(r / 60), a = r % 60;
  return (d <= 0 ? "+" : "-") + Hd(n, 2, "0") + ":" + Hd(a, 2, "0");
}, Kr = function e(t, d) {
  if (t.date() < d.date()) return -e(d, t);
  var r = (d.year() - t.year()) * 12 + (d.month() - t.month()), n = t.clone().add(r, l1), a = d - n < 0, s = t.clone().add(r + (a ? -1 : 1), l1);
  return +(-(r + (d - n) / (a ? n - s : s - n)) || 0);
}, Zr = function(t) {
  return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
}, qr = function(t) {
  var d = {
    M: l1,
    y: L1,
    w: Kt,
    d: T1,
    D: J1,
    h: q1,
    m: Z1,
    s: K1,
    ms: r0,
    Q: Rn
  };
  return d[t] || String(t || "").toLowerCase().replace(/s$/, "");
}, Jr = function(t) {
  return t === void 0;
};
const Xr = {
  s: Hd,
  z: Yr,
  m: Kr,
  a: Zr,
  p: qr,
  u: Jr
};
var yt = "en", V1 = {};
V1[yt] = Wr;
var Nn = "$isDayjsObject", s0 = function(t) {
  return t instanceof pd || !!(t && t[Nn]);
}, dd = function e(t, d, r) {
  var n;
  if (!t) return yt;
  if (typeof t == "string") {
    var a = t.toLowerCase();
    V1[a] && (n = a), d && (V1[a] = d, n = a);
    var s = t.split("-");
    if (!n && s.length > 1)
      return e(s[0]);
  } else {
    var l = t.name;
    V1[l] = t, n = l;
  }
  return !r && n && (yt = n), n || !r && yt;
}, Te = function(t, d) {
  if (s0(t))
    return t.clone();
  var r = typeof d == "object" ? d : {};
  return r.date = t, r.args = arguments, new pd(r);
}, Qr = function(t, d) {
  return Te(t, {
    locale: d.$L,
    utc: d.$u,
    x: d.$x,
    $offset: d.$offset
    // todo: refactor; do not use this.$offset in you code
  });
}, ke = Xr;
ke.l = dd;
ke.i = s0;
ke.w = Qr;
var es = function(t) {
  var d = t.date, r = t.utc;
  if (d === null) return /* @__PURE__ */ new Date(NaN);
  if (ke.u(d)) return /* @__PURE__ */ new Date();
  if (d instanceof Date) return new Date(d);
  if (typeof d == "string" && !/Z$/i.test(d)) {
    var n = d.match(Gr);
    if (n) {
      var a = n[2] - 1 || 0, s = (n[7] || "0").substring(0, 3);
      return r ? new Date(Date.UTC(n[1], a, n[3] || 1, n[4] || 0, n[5] || 0, n[6] || 0, s)) : new Date(n[1], a, n[3] || 1, n[4] || 0, n[5] || 0, n[6] || 0, s);
    }
  }
  return new Date(d);
}, pd = /* @__PURE__ */ function() {
  function e(d) {
    this.$L = dd(d.locale, null, !0), this.parse(d), this.$x = this.$x || d.x || {}, this[Nn] = !0;
  }
  var t = e.prototype;
  return t.parse = function(r) {
    this.$d = es(r), this.init();
  }, t.init = function() {
    var r = this.$d;
    this.$y = r.getFullYear(), this.$M = r.getMonth(), this.$D = r.getDate(), this.$W = r.getDay(), this.$H = r.getHours(), this.$m = r.getMinutes(), this.$s = r.getSeconds(), this.$ms = r.getMilliseconds();
  }, t.$utils = function() {
    return ke;
  }, t.isValid = function() {
    return this.$d.toString() !== Y0;
  }, t.isSame = function(r, n) {
    var a = Te(r);
    return this.startOf(n) <= a && a <= this.endOf(n);
  }, t.isAfter = function(r, n) {
    return Te(r) < this.startOf(n);
  }, t.isBefore = function(r, n) {
    return this.endOf(n) < Te(r);
  }, t.$g = function(r, n, a) {
    return ke.u(r) ? this[n] : this.set(a, r);
  }, t.unix = function() {
    return Math.floor(this.valueOf() / 1e3);
  }, t.valueOf = function() {
    return this.$d.getTime();
  }, t.startOf = function(r, n) {
    var a = this, s = ke.u(n) ? !0 : n, l = ke.p(r), i = function(L, T) {
      var g = ke.w(a.$u ? Date.UTC(a.$y, T, L) : new Date(a.$y, T, L), a);
      return s ? g : g.endOf(T1);
    }, f = function(L, T) {
      var g = [0, 0, 0, 0], I = [23, 59, 59, 999];
      return ke.w(a.toDate()[L].apply(
        // eslint-disable-line prefer-spread
        a.toDate("s"),
        (s ? g : I).slice(T)
      ), a);
    }, p = this.$W, m = this.$M, h = this.$D, C = "set" + (this.$u ? "UTC" : "");
    switch (l) {
      case L1:
        return s ? i(1, 0) : i(31, 11);
      case l1:
        return s ? i(1, m) : i(0, m + 1);
      case Kt: {
        var v = this.$locale().weekStart || 0, M = (p < v ? p + 7 : p) - v;
        return i(s ? h - M : h + (6 - M), m);
      }
      case T1:
      case J1:
        return f(C + "Hours", 0);
      case q1:
        return f(C + "Minutes", 1);
      case Z1:
        return f(C + "Seconds", 2);
      case K1:
        return f(C + "Milliseconds", 3);
      default:
        return this.clone();
    }
  }, t.endOf = function(r) {
    return this.startOf(r, !1);
  }, t.$set = function(r, n) {
    var a, s = ke.p(r), l = "set" + (this.$u ? "UTC" : ""), i = (a = {}, a[T1] = l + "Date", a[J1] = l + "Date", a[l1] = l + "Month", a[L1] = l + "FullYear", a[q1] = l + "Hours", a[Z1] = l + "Minutes", a[K1] = l + "Seconds", a[r0] = l + "Milliseconds", a)[s], f = s === T1 ? this.$D + (n - this.$W) : n;
    if (s === l1 || s === L1) {
      var p = this.clone().set(J1, 1);
      p.$d[i](f), p.init(), this.$d = p.set(J1, Math.min(this.$D, p.daysInMonth())).$d;
    } else i && this.$d[i](f);
    return this.init(), this;
  }, t.set = function(r, n) {
    return this.clone().$set(r, n);
  }, t.get = function(r) {
    return this[ke.p(r)]();
  }, t.add = function(r, n) {
    var a = this, s;
    r = Number(r);
    var l = ke.p(n), i = function(h) {
      var C = Te(a);
      return ke.w(C.date(C.date() + Math.round(h * r)), a);
    };
    if (l === l1)
      return this.set(l1, this.$M + r);
    if (l === L1)
      return this.set(L1, this.$y + r);
    if (l === T1)
      return i(1);
    if (l === Kt)
      return i(7);
    var f = (s = {}, s[Z1] = zd, s[q1] = W0, s[K1] = rt, s)[l] || 1, p = this.$d.getTime() + r * f;
    return ke.w(p, this);
  }, t.subtract = function(r, n) {
    return this.add(r * -1, n);
  }, t.format = function(r) {
    var n = this, a = this.$locale();
    if (!this.isValid()) return a.invalidDate || Y0;
    var s = r || Hr, l = ke.z(this), i = this.$H, f = this.$m, p = this.$M, m = a.weekdays, h = a.months, C = a.meridiem, v = function(g, I, N, Z) {
      return g && (g[I] || g(n, s)) || N[I].slice(0, Z);
    }, M = function(g) {
      return ke.s(i % 12 || 12, g, "0");
    }, S = C || function(T, g, I) {
      var N = T < 12 ? "AM" : "PM";
      return I ? N.toLowerCase() : N;
    }, L = function(g) {
      switch (g) {
        case "YY":
          return String(n.$y).slice(-2);
        case "YYYY":
          return ke.s(n.$y, 4, "0");
        case "M":
          return p + 1;
        case "MM":
          return ke.s(p + 1, 2, "0");
        case "MMM":
          return v(a.monthsShort, p, h, 3);
        case "MMMM":
          return v(h, p);
        case "D":
          return n.$D;
        case "DD":
          return ke.s(n.$D, 2, "0");
        case "d":
          return String(n.$W);
        case "dd":
          return v(a.weekdaysMin, n.$W, m, 2);
        case "ddd":
          return v(a.weekdaysShort, n.$W, m, 3);
        case "dddd":
          return m[n.$W];
        case "H":
          return String(i);
        case "HH":
          return ke.s(i, 2, "0");
        case "h":
          return M(1);
        case "hh":
          return M(2);
        case "a":
          return S(i, f, !0);
        case "A":
          return S(i, f, !1);
        case "m":
          return String(f);
        case "mm":
          return ke.s(f, 2, "0");
        case "s":
          return String(n.$s);
        case "ss":
          return ke.s(n.$s, 2, "0");
        case "SSS":
          return ke.s(n.$ms, 3, "0");
        case "Z":
          return l;
      }
      return null;
    };
    return s.replace(Ur, function(T, g) {
      return g || L(T) || l.replace(":", "");
    });
  }, t.utcOffset = function() {
    return -Math.round(this.$d.getTimezoneOffset() / 15) * 15;
  }, t.diff = function(r, n, a) {
    var s = this, l = ke.p(n), i = Te(r), f = (i.utcOffset() - this.utcOffset()) * zd, p = this - i, m = function() {
      return ke.m(s, i);
    }, h;
    switch (l) {
      case L1:
        h = m() / 12;
        break;
      case l1:
        h = m();
        break;
      case Rn:
        h = m() / 3;
        break;
      case Kt:
        h = (p - f) / jr;
        break;
      case T1:
        h = (p - f) / _r;
        break;
      case q1:
        h = p / W0;
        break;
      case Z1:
        h = p / zd;
        break;
      case K1:
        h = p / rt;
        break;
      default:
        h = p;
        break;
    }
    return a ? h : ke.a(h);
  }, t.daysInMonth = function() {
    return this.endOf(l1).$D;
  }, t.$locale = function() {
    return V1[this.$L];
  }, t.locale = function(r, n) {
    if (!r) return this.$L;
    var a = this.clone(), s = dd(r, n, !0);
    return s && (a.$L = s), a;
  }, t.clone = function() {
    return ke.w(this.$d, this);
  }, t.toDate = function() {
    return new Date(this.valueOf());
  }, t.toJSON = function() {
    return this.isValid() ? this.toISOString() : null;
  }, t.toISOString = function() {
    return this.$d.toISOString();
  }, t.toString = function() {
    return this.$d.toUTCString();
  }, e;
}(), Fn = pd.prototype;
Te.prototype = Fn;
[["$ms", r0], ["$s", K1], ["$m", Z1], ["$H", q1], ["$W", T1], ["$M", l1], ["$y", L1], ["$D", J1]].forEach(function(e) {
  Fn[e[1]] = function(t) {
    return this.$g(t, e[0], e[1]);
  };
});
Te.extend = function(e, t) {
  return e.$i || (e(t, pd, Te), e.$i = !0), Te;
};
Te.locale = dd;
Te.isDayjs = s0;
Te.unix = function(e) {
  return Te(e * 1e3);
};
Te.en = V1[yt];
Te.Ls = V1;
Te.p = {};
const Zt = 7, ts = 5;
function ds(e) {
  const t = new Date(e.getFullYear(), e.getMonth() + 1, 0), d = Array.from({ length: t.getDate() }, (a, s) => s + 1).map((a) => Bd(new Date(
    Date.UTC(e.getFullYear(), e.getMonth(), a)
  )));
  if (d[0].dayOfWeek !== 1) {
    const a = new Date(e.getFullYear(), e.getMonth(), 0), s = new Date(a.getFullYear(), a.getMonth() + 1, 0).getDate(), l = d[0].dayOfWeek - 1, i = [];
    let f = 0;
    for (; f < l; )
      i.unshift(
        Bd(
          new Date(a.getFullYear(), a.getMonth(), s - f),
          { isPast: !0 }
        )
      ), f++;
    d.unshift(...i);
  }
  if (d[d.length - 1].dayOfWeek !== 7) {
    const a = new Date(e.getFullYear(), e.getMonth() + 1, 1), s = Zt * ts + 1 - d.length;
    let l = 0;
    for (; l < s; )
      d.push(
        Bd(
          new Date(a.getFullYear(), a.getMonth(), l + 1),
          { isFuture: !0 }
        )
      ), l++;
  }
  const r = Array.from({ length: 6 }, (a, s) => s + 1).map((a) => d.slice((a - 1) * Zt, a * Zt)), n = r[r.length - 1];
  return (!n.length || n.every((a) => a.inNextMonth)) && r.pop(), r;
}
function Bd(e, t) {
  const d = /* @__PURE__ */ new Date(), r = e.getDay();
  return {
    day: e.getDate(),
    date: e.toISOString(),
    isToday: e.getDate() === d.getDate() && e.getMonth() === d.getMonth() && e.getFullYear() === d.getFullYear(),
    isWeekend: [6, 7].includes(e.getDay()),
    dayOfWeek: r === 0 ? Zt : r,
    inPastMonth: t == null ? void 0 : t.isPast,
    inNextMonth: t == null ? void 0 : t.isFuture
  };
}
const _n = {
  disabledDates: {
    type: Array,
    default: () => []
  },
  minDate: {
    type: Date,
    default: null
  },
  maxDate: {
    type: Date,
    default: null
  },
  format: {
    type: String,
    default: "D. M. YYYY"
  }
}, ns = { class: "mb-5" }, rs = { class: "flex items-center justify-center gap-x-10 pb-5" }, ss = ["disabled"], os = ["disabled"], as = {
  key: 0,
  class: "absolute left-0 top-10 z-10 size-full overflow-auto bg-white pb-10"
}, ls = { class: "grid max-h-full grid-cols-3 gap-3" }, is = ["onClick"], us = { key: 1 }, cs = { class: "grid auto-rows-fr grid-cols-3 gap-3 pb-10" }, fs = ["disabled", "onClick"], $s = /* @__PURE__ */ X({
  __name: "CfgMonthAndYearSelection",
  props: /* @__PURE__ */ ye({
    minDate: {
      type: Date,
      default: () => new Date(1900, 0, 1)
    },
    maxDate: {
      type: Date,
      default: () => new Date((/* @__PURE__ */ new Date()).getFullYear() + 10, 0, 1)
    },
    openWindow: {
      type: String,
      default: "month"
    }
  }, {
    modelValue: { default: null },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ye(["close"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const d = e, r = t, n = [..._d.localeObjectCs.months], a = j(() => {
      const g = [];
      for (let I = new Date(d.minDate).getFullYear(); I <= new Date(d.maxDate).getFullYear(); I += 1)
        g.push(I);
      return g.sort((I, N) => N - I);
    }), s = ze(e, "modelValue"), l = de(s.value.year), i = de(d.openWindow === "year"), f = kt(n, (g, I) => {
      const N = td(
        new Date(l.value, I, 1)
      );
      return {
        month: g,
        number: I,
        isSelected: I === s.value.month,
        disabled: N.isBefore(d.minDate, "month") || N.isAfter(d.maxDate, "month")
      };
    }), p = kt(a, (g) => ({
      year: g,
      isSelected: g === l.value
    })), m = de([]), h = j(() => l.value > new Date(d.minDate).getFullYear()), C = j(() => l.value < new Date(d.maxDate).getFullYear());
    Ce(() => d.modelValue, (g) => {
      l.value = g.year;
    }), Ce(() => d.openWindow, () => {
      i.value = d.openWindow === "year";
    }), Ce(i, (g) => {
      g && P1(() => {
        var I, N;
        (N = (I = m.value) == null ? void 0 : I[a.value.findIndex((Z) => Z === l.value)]) == null || N.focus();
      });
    });
    function v() {
      l.value += 1;
    }
    function M() {
      l.value -= 1;
    }
    function S(g) {
      s.value = {
        month: g,
        year: l.value
      };
    }
    function L(g) {
      l.value = g, i.value = !1;
    }
    function T() {
      i.value ? i.value = !1 : r("close");
    }
    return (g, I) => ($(), k("div", null, [
      x("div", ns, [
        y(u(I1), {
          "aria-label": i.value ? "Měsíc" : "Zavřít",
          class: "mb-5",
          "icon-placement": "left",
          text: "",
          onClick: T
        }, {
          icon: b(() => [
            y(u(Ct), { class: "text-sm" })
          ]),
          default: b(() => [
            y(u(O), {
              size: u(H).sm
            }, {
              default: b(() => [
                R(E(i.value ? "Měsíc" : "Zpět"), 1)
              ]),
              _: 1
            }, 8, ["size"])
          ]),
          _: 1
        }, 8, ["aria-label"])
      ]),
      x("div", rs, [
        x("button", {
          class: "focusable rounded-md border border-grey-stroke p-1 disabled:cursor-not-allowed disabled:opacity-50",
          disabled: !h.value,
          type: "button",
          onClick: M
        }, [
          y(u(Ct))
        ], 8, ss),
        y(u(O), {
          class: "flex min-w-[140px] shrink-0 grow justify-center text-center",
          size: u(H).sm
        }, {
          default: b(() => [
            x("button", {
              class: "flex items-center justify-center gap-x-2 capitalize lg:transition lg:duration-200 lg:hover:text-brand",
              type: "button",
              onClick: I[0] || (I[0] = (N) => i.value = !0)
            }, [
              x("span", null, E(l.value), 1),
              y(u(F1), { class: "text-[0.85em] text-grey-300" })
            ])
          ]),
          _: 1
        }, 8, ["size"]),
        x("button", {
          class: "focusable rounded-md border border-grey-stroke p-1 disabled:cursor-not-allowed disabled:opacity-50",
          disabled: !C.value,
          type: "button",
          onClick: v
        }, [
          y(u(D1))
        ], 8, os)
      ]),
      i.value ? ($(), k("div", as, [
        x("ul", ls, [
          ($(!0), k(ae, null, he(u(p), ({ year: N, isSelected: Z }) => ($(), k("li", { key: N }, [
            x("button", {
              ref_for: !0,
              ref_key: "yearsButtonRefs",
              ref: m,
              class: z(["flex w-full flex-1 items-center justify-center rounded-xl border border-grey-stroke p-3 lg:transition lg:duration-200 lg:hover:border-brand", {
                "border-brand text-brand": Z
              }]),
              type: "button",
              onClick: (Y) => L(N)
            }, [
              y(u(O), {
                class: "capitalize",
                size: u(H).sm
              }, {
                default: b(() => [
                  R(E(N), 1)
                ]),
                _: 2
              }, 1032, ["size"])
            ], 10, is)
          ]))), 128))
        ])
      ])) : ($(), k("div", us, [
        x("ul", cs, [
          ($(!0), k(ae, null, he(u(f), ({
            month: N,
            number: Z,
            isSelected: Y,
            disabled: G
          }) => ($(), k("li", {
            key: N,
            class: "col-span-1 flex"
          }, [
            x("button", {
              class: z(["focusable flex w-full flex-1 items-center justify-center rounded-xl border border-grey-stroke p-3 disabled:cursor-not-allowed disabled:line-through disabled:opacity-50 lg:transition lg:duration-200 lg:hover:border-brand", {
                "border-brand text-brand": Y
              }]),
              disabled: G,
              type: "button",
              onClick: (U) => S(Z)
            }, [
              y(u(O), {
                class: "capitalize",
                size: u(H).sm
              }, {
                default: b(() => [
                  R(E(N), 1)
                ]),
                _: 2
              }, 1032, ["size"])
            ], 10, fs)
          ]))), 128))
        ])
      ]))
    ]));
  }
}), ps = { class: "relative" }, ms = {
  key: 0,
  class: "absolute left-0 top-0 z-20 flex size-full bg-white"
}, gs = { class: "flex items-center justify-center gap-x-5 px-1 pb-7" }, hs = ["disabled"], vs = {
  key: 1,
  class: "grid grid-cols-7"
}, bs = { class: "mt-3 grid grid-cols-7" }, ys = ["aria-label", "data-selected", "disabled", "onClick"], xs = { class: "cfg-day-item__content" }, ws = { class: "block w-full" }, Cs = /* @__PURE__ */ X({
  __name: "CfgCalendar",
  props: /* @__PURE__ */ ye(_n, {
    modelValue: { default: null, type: Date },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ye(["selectDate"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const d = e, r = t, n = [..._d.localeObjectCs.weekdaysShort];
    n.push(n.shift());
    const a = [..._d.localeObjectCs.months], s = ze(e, "modelValue"), l = de([]), i = de(!1), f = de("month"), p = Te(s.value || /* @__PURE__ */ new Date()), m = Kd({
      year: p.year(),
      month: p.month()
    }), h = j(() => a[m.month]), C = j(() => new Date(m.year, m.month, 1)), v = j(() => I(
      N(
        ds(C.value)
      )
    )), M = j(() => new Date(d.minDate || "1900") < new Date(C.value)), S = j(() => d.maxDate ? Te(d.maxDate).isAfter(Te(C.value), "month") : !0);
    r1(() => {
      l.value.length && (l.value.find((U) => U.getAttribute("data-selected") === "true") || l.value[0]).focus();
    });
    function L() {
      m.month === 11 ? (m.month = 0, m.year += 1) : m.month += 1;
    }
    function T() {
      m.month === 0 ? (m.month = 11, m.year -= 1) : m.month -= 1;
    }
    function g(G) {
      s.value = new Date(G), r("selectDate", new Date(G));
    }
    function I(G) {
      return G.map((U) => U.map((te) => {
        var q;
        const B = Te(te.date);
        let V = (q = d.disabledDates) == null ? void 0 : q.some((J) => {
          const ee = Te(J);
          return B.isSame(ee, "day");
        });
        if (!V && d.minDate) {
          const J = Te(d.minDate);
          V = B.isBefore(J, "day");
        }
        if (!V && d.maxDate) {
          const J = Te(d.maxDate);
          V = B.isAfter(J, "day");
        }
        return { ...te, disabled: V };
      }));
    }
    function N(G) {
      return G.map((U) => U.map((te) => {
        const B = Te(te.date), V = Te(s.value);
        return { ...te, selected: B.isSame(V, "day") };
      }));
    }
    function Z({ month: G, year: U }) {
      m.month = G, m.year = U, i.value = !1;
    }
    function Y(G = "month") {
      f.value = G, i.value = !0;
    }
    return (G, U) => ($(), k("div", ps, [
      i.value ? ($(), k("div", ms, [
        y($s, {
          class: "w-full flex-1",
          "max-date": G.maxDate || void 0,
          "min-date": G.minDate || void 0,
          "model-value": {
            year: m.year,
            month: m.month
          },
          "open-window": f.value,
          onClose: U[0] || (U[0] = (te) => i.value = !1),
          "onUpdate:modelValue": Z
        }, null, 8, ["max-date", "min-date", "model-value", "open-window"])
      ])) : P("", !0),
      x("div", gs, [
        x("button", {
          class: "focusable rounded-md border border-grey-stroke p-1 disabled:cursor-not-allowed disabled:opacity-50",
          disabled: !M.value,
          type: "button",
          onClick: T
        }, [
          y(u(Ct))
        ], 8, hs),
        y(O, {
          class: "flex min-w-[140px] shrink-0 grow items-center justify-center gap-x-5 text-center",
          size: u(H).sm
        }, {
          default: b(() => [
            y(O, {
              class: "flex items-center gap-x-2 capitalize lg:transition lg:duration-200 lg:hover:text-brand",
              size: u(H).sm,
              "tag-name": "button",
              type: "button",
              onClick: U[1] || (U[1] = (te) => Y("month"))
            }, {
              default: b(() => [
                R(E(h.value) + " ", 1),
                y(u(F1), { class: "text-[0.85em] text-grey-300" })
              ]),
              _: 1
            }, 8, ["size"]),
            y(O, {
              class: "flex items-center gap-x-2 capitalize lg:transition lg:duration-200 lg:hover:text-brand",
              size: u(H).sm,
              "tag-name": "button",
              type: "button",
              onClick: U[2] || (U[2] = (te) => Y("year"))
            }, {
              default: b(() => [
                R(E(m.year) + " ", 1),
                y(u(F1), { class: "text-[0.85em] text-grey-300" })
              ]),
              _: 1
            }, 8, ["size"])
          ]),
          _: 1
        }, 8, ["size"]),
        y(O, {
          class: "focusable rounded-md border border-grey-stroke p-1 disabled:cursor-not-allowed disabled:opacity-50",
          disabled: !S.value,
          size: u(H).sm,
          "tag-name": "button",
          type: "button",
          onClick: L
        }, {
          default: b(() => [
            y(u(D1))
          ]),
          _: 1
        }, 8, ["disabled", "size"])
      ]),
      i.value ? P("", !0) : ($(), k("div", vs, [
        ($(), k(ae, null, he(n, (te) => y(O, {
          key: te,
          class: "px-3 text-center text-grey-300",
          size: u(H).xs
        }, {
          default: b(() => [
            R(E(te), 1)
          ]),
          _: 2
        }, 1032, ["size"])), 64))
      ])),
      x("div", bs, [
        ($(!0), k(ae, null, he(v.value, (te) => ($(), k(ae, null, [
          ($(!0), k(ae, null, he(te, (B) => ($(), k("button", {
            key: B.day,
            ref_for: !0,
            ref_key: "dayRefs",
            ref: l,
            "aria-label": B.date,
            class: z(["focusable cfg-day-item disabled:cursor-not-allowed disabled:line-through disabled:opacity-50", {
              selected: B.selected
            }]),
            "data-selected": B.selected,
            disabled: B.disabled,
            type: "button",
            onClick: (V) => !B.disabled && g(B.date)
          }, [
            y(O, {
              class: z({
                "text-grey-200": (B.inPastMonth || B.inNextMonth) && !m,
                disabled: B.disabled
              }),
              disabled: B.disabled,
              size: u(H).sm,
              "tag-name": "span"
            }, {
              default: b(() => [
                x("span", xs, [
                  x("span", ws, E(B.day), 1),
                  B.isToday ? ($(), k("span", {
                    key: 0,
                    class: z(["absolute bottom-1.5 left-1/2 block size-1 -translate-x-1/2 rounded-full bg-brand", { "!bg-white": B.selected }])
                  }, null, 2)) : P("", !0)
                ])
              ]),
              _: 2
            }, 1032, ["class", "disabled", "size"])
          ], 10, ys))), 128))
        ], 64))), 256))
      ])
    ]));
  }
}), ks = /* @__PURE__ */ h1(Cs, [["__scopeId", "data-v-3a16ba56"]]), Ss = {}, Ms = { class: "rounded-xl p-5" };
function Ts(e, t) {
  return $(), k("div", Ms, [
    W(e.$slots, "default")
  ]);
}
const Y9 = /* @__PURE__ */ h1(Ss, [["render", Ts]]), Ls = {
  active: !0,
  breakpoints: {},
  delay: 4e3,
  jump: !1,
  playOnInit: !0,
  stopOnFocusIn: !0,
  stopOnInteraction: !0,
  stopOnMouseEnter: !1,
  stopOnLastSnap: !1,
  rootNode: null
};
function o0(e = {}) {
  let t, d, r, n = !1, a = !0, s = !1, l = 0;
  function i(I, N) {
    d = I;
    const {
      mergeOptions: Z,
      optionsAtMedia: Y
    } = N, G = Z(Ls, o0.globalOptions), U = Z(G, e);
    if (t = Y(U), d.scrollSnapList().length <= 1) return;
    s = t.jump, r = !1;
    const {
      eventStore: te,
      ownerDocument: B
    } = d.internalEngine(), V = d.rootNode(), q = t.rootNode && t.rootNode(V) || V, J = d.containerNode();
    d.on("pointerDown", m), t.stopOnInteraction || d.on("pointerUp", p), t.stopOnMouseEnter && (te.add(q, "mouseenter", () => {
      a = !1, m();
    }), t.stopOnInteraction || te.add(q, "mouseleave", () => {
      a = !0, p();
    })), t.stopOnFocusIn && (d.on("slideFocusStart", m), t.stopOnInteraction || te.add(J, "focusout", p)), te.add(B, "visibilitychange", h), t.playOnInit && !C() && p();
  }
  function f() {
    d.off("pointerDown", m).off("pointerUp", p).off("slideFocusStart", m), m(), r = !0, n = !1;
  }
  function p() {
    if (r || !a) return;
    n || d.emit("autoplay:play");
    const {
      ownerWindow: I
    } = d.internalEngine();
    I.clearInterval(l), l = I.setInterval(T, t.delay), n = !0;
  }
  function m() {
    if (r) return;
    n && d.emit("autoplay:stop");
    const {
      ownerWindow: I
    } = d.internalEngine();
    I.clearInterval(l), l = 0, n = !1;
  }
  function h() {
    if (C())
      return a = n, m();
    a && p();
  }
  function C() {
    const {
      ownerDocument: I
    } = d.internalEngine();
    return I.visibilityState === "hidden";
  }
  function v(I) {
    typeof I < "u" && (s = I), a = !0, p();
  }
  function M() {
    n && m();
  }
  function S() {
    n && v();
  }
  function L() {
    return n;
  }
  function T() {
    const {
      index: I
    } = d.internalEngine(), N = I.clone().add(1).get(), Z = d.scrollSnapList().length - 1;
    t.stopOnLastSnap && N === Z && m(), d.canScrollNext() ? d.scrollNext(s) : d.scrollTo(0, s);
  }
  return {
    name: "autoplay",
    options: e,
    init: i,
    destroy: f,
    play: v,
    stop: M,
    reset: S,
    isPlaying: L
  };
}
o0.globalOptions = void 0;
function As(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function K0(e) {
  return As(e) || Array.isArray(e);
}
function Ds() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function a0(e, t) {
  const d = Object.keys(e), r = Object.keys(t);
  if (d.length !== r.length) return !1;
  const n = JSON.stringify(Object.keys(e.breakpoints || {})), a = JSON.stringify(Object.keys(t.breakpoints || {}));
  return n !== a ? !1 : d.every((s) => {
    const l = e[s], i = t[s];
    return typeof l == "function" ? `${l}` == `${i}` : !K0(l) || !K0(i) ? l === i : a0(l, i);
  });
}
function Z0(e) {
  return e.concat().sort((t, d) => t.name > d.name ? 1 : -1).map((t) => t.options);
}
function Is(e, t) {
  if (e.length !== t.length) return !1;
  const d = Z0(e), r = Z0(t);
  return d.every((n, a) => {
    const s = r[a];
    return a0(n, s);
  });
}
function l0(e) {
  return typeof e == "number";
}
function Gd(e) {
  return typeof e == "string";
}
function md(e) {
  return typeof e == "boolean";
}
function q0(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Be(e) {
  return Math.abs(e);
}
function i0(e) {
  return Math.sign(e);
}
function xt(e, t) {
  return Be(e - t);
}
function Es(e, t) {
  if (e === 0 || t === 0 || Be(e) <= Be(t)) return 0;
  const d = xt(Be(e), Be(t));
  return Be(d / e);
}
function Tt(e) {
  return Lt(e).map(Number);
}
function i1(e) {
  return e[Et(e)];
}
function Et(e) {
  return Math.max(0, e.length - 1);
}
function u0(e, t) {
  return t === Et(e);
}
function J0(e, t = 0) {
  return Array.from(Array(e), (d, r) => t + r);
}
function Lt(e) {
  return Object.keys(e);
}
function jn(e, t) {
  return [e, t].reduce((d, r) => (Lt(r).forEach((n) => {
    const a = d[n], s = r[n], l = q0(a) && q0(s);
    d[n] = l ? jn(a, s) : s;
  }), d), {});
}
function Ud(e, t) {
  return typeof t.MouseEvent < "u" && e instanceof t.MouseEvent;
}
function zs(e, t) {
  const d = {
    start: r,
    center: n,
    end: a
  };
  function r() {
    return 0;
  }
  function n(i) {
    return a(i) / 2;
  }
  function a(i) {
    return t - i;
  }
  function s(i, f) {
    return Gd(e) ? d[e](i) : e(t, i, f);
  }
  return {
    measure: s
  };
}
function At() {
  let e = [];
  function t(n, a, s, l = {
    passive: !0
  }) {
    let i;
    if ("addEventListener" in n)
      n.addEventListener(a, s, l), i = () => n.removeEventListener(a, s, l);
    else {
      const f = n;
      f.addListener(s), i = () => f.removeListener(s);
    }
    return e.push(i), r;
  }
  function d() {
    e = e.filter((n) => n());
  }
  const r = {
    add: t,
    clear: d
  };
  return r;
}
function Bs(e, t, d, r) {
  const n = At(), a = 1e3 / 60;
  let s = null, l = 0, i = 0;
  function f() {
    n.add(e, "visibilitychange", () => {
      e.hidden && v();
    });
  }
  function p() {
    C(), n.clear();
  }
  function m(S) {
    if (!i) return;
    s || (s = S);
    const L = S - s;
    for (s = S, l += L; l >= a; )
      d(a), l -= a;
    const T = l / a;
    r(T), i && t.requestAnimationFrame(m);
  }
  function h() {
    i || (i = t.requestAnimationFrame(m));
  }
  function C() {
    t.cancelAnimationFrame(i), s = null, l = 0, i = 0;
  }
  function v() {
    s = null, l = 0;
  }
  return {
    init: f,
    destroy: p,
    start: h,
    stop: C,
    update: () => d(a),
    render: r
  };
}
function Ps(e, t) {
  const d = t === "rtl", r = e === "y", n = r ? "y" : "x", a = r ? "x" : "y", s = !r && d ? -1 : 1, l = p(), i = m();
  function f(v) {
    const {
      height: M,
      width: S
    } = v;
    return r ? M : S;
  }
  function p() {
    return r ? "top" : d ? "right" : "left";
  }
  function m() {
    return r ? "bottom" : d ? "left" : "right";
  }
  function h(v) {
    return v * s;
  }
  return {
    scroll: n,
    cross: a,
    startEdge: l,
    endEdge: i,
    measureSize: f,
    direction: h
  };
}
function _1(e = 0, t = 0) {
  const d = Be(e - t);
  function r(f) {
    return f < e;
  }
  function n(f) {
    return f > t;
  }
  function a(f) {
    return r(f) || n(f);
  }
  function s(f) {
    return a(f) ? r(f) ? e : t : f;
  }
  function l(f) {
    return d ? f - d * Math.ceil((f - t) / d) : f;
  }
  return {
    length: d,
    max: t,
    min: e,
    constrain: s,
    reachedAny: a,
    reachedMax: n,
    reachedMin: r,
    removeOffset: l
  };
}
function Hn(e, t, d) {
  const {
    constrain: r
  } = _1(0, e), n = e + 1;
  let a = s(t);
  function s(h) {
    return d ? Be((n + h) % n) : r(h);
  }
  function l() {
    return a;
  }
  function i(h) {
    return a = s(h), m;
  }
  function f(h) {
    return p().set(l() + h);
  }
  function p() {
    return Hn(e, l(), d);
  }
  const m = {
    get: l,
    set: i,
    add: f,
    clone: p
  };
  return m;
}
function Vs(e, t, d, r, n, a, s, l, i, f, p, m, h, C, v, M, S, L, T) {
  const {
    cross: g,
    direction: I
  } = e, N = ["INPUT", "SELECT", "TEXTAREA"], Z = {
    passive: !1
  }, Y = At(), G = At(), U = _1(50, 225).constrain(C.measure(20)), te = {
    mouse: 300,
    touch: 400
  }, B = {
    mouse: 500,
    touch: 600
  }, V = v ? 43 : 25;
  let q = !1, J = 0, ee = 0, le = !1, K = !1, re = !1, ne = !1;
  function ce(oe) {
    if (!T) return;
    function ge(Le) {
      (md(T) || T(oe, Le)) && $e(Le);
    }
    const we = t;
    Y.add(we, "dragstart", (Le) => Le.preventDefault(), Z).add(we, "touchmove", () => {
    }, Z).add(we, "touchend", () => {
    }).add(we, "touchstart", ge).add(we, "mousedown", ge).add(we, "touchcancel", Me).add(we, "contextmenu", Me).add(we, "click", We, !0);
  }
  function ie() {
    Y.clear(), G.clear();
  }
  function ve() {
    const oe = ne ? d : t;
    G.add(oe, "touchmove", Pe, Z).add(oe, "touchend", Me).add(oe, "mousemove", Pe, Z).add(oe, "mouseup", Me);
  }
  function se(oe) {
    const ge = oe.nodeName || "";
    return N.includes(ge);
  }
  function be() {
    return (v ? B : te)[ne ? "mouse" : "touch"];
  }
  function Ae(oe, ge) {
    const we = m.add(i0(oe) * -1), Le = p.byDistance(oe, !v).distance;
    return v || Be(oe) < U ? Le : S && ge ? Le * 0.5 : p.byIndex(we.get(), 0).distance;
  }
  function $e(oe) {
    const ge = Ud(oe, r);
    ne = ge, re = v && ge && !oe.buttons && q, q = xt(n.get(), s.get()) >= 2, !(ge && oe.button !== 0) && (se(oe.target) || (le = !0, a.pointerDown(oe), f.useFriction(0).useDuration(0), n.set(s), ve(), J = a.readPoint(oe), ee = a.readPoint(oe, g), h.emit("pointerDown")));
  }
  function Pe(oe) {
    if (!Ud(oe, r) && oe.touches.length >= 2) return Me(oe);
    const we = a.readPoint(oe), Le = a.readPoint(oe, g), Ne = xt(we, J), Ye = xt(Le, ee);
    if (!K && !ne && (!oe.cancelable || (K = Ne > Ye, !K)))
      return Me(oe);
    const qe = a.pointerMove(oe);
    Ne > M && (re = !0), f.useFriction(0.3).useDuration(0.75), l.start(), n.add(I(qe)), oe.preventDefault();
  }
  function Me(oe) {
    const we = p.byDistance(0, !1).index !== m.get(), Le = a.pointerUp(oe) * be(), Ne = Ae(I(Le), we), Ye = Es(Le, Ne), qe = V - 10 * Ye, Je = L + Ye / 50;
    K = !1, le = !1, G.clear(), f.useDuration(qe).useFriction(Je), i.distance(Ne, !v), ne = !1, h.emit("pointerUp");
  }
  function We(oe) {
    re && (oe.stopPropagation(), oe.preventDefault(), re = !1);
  }
  function De() {
    return le;
  }
  return {
    init: ce,
    destroy: ie,
    pointerDown: De
  };
}
function Os(e, t) {
  let r, n;
  function a(m) {
    return m.timeStamp;
  }
  function s(m, h) {
    const v = `client${(h || e.scroll) === "x" ? "X" : "Y"}`;
    return (Ud(m, t) ? m : m.touches[0])[v];
  }
  function l(m) {
    return r = m, n = m, s(m);
  }
  function i(m) {
    const h = s(m) - s(n), C = a(m) - a(r) > 170;
    return n = m, C && (r = m), h;
  }
  function f(m) {
    if (!r || !n) return 0;
    const h = s(n) - s(r), C = a(m) - a(r), v = a(m) - a(n) > 170, M = h / C;
    return C && !v && Be(M) > 0.1 ? M : 0;
  }
  return {
    pointerDown: l,
    pointerMove: i,
    pointerUp: f,
    readPoint: s
  };
}
function Rs() {
  function e(d) {
    const {
      offsetTop: r,
      offsetLeft: n,
      offsetWidth: a,
      offsetHeight: s
    } = d;
    return {
      top: r,
      right: n + a,
      bottom: r + s,
      left: n,
      width: a,
      height: s
    };
  }
  return {
    measure: e
  };
}
function Ns(e) {
  function t(r) {
    return e * (r / 100);
  }
  return {
    measure: t
  };
}
function Fs(e, t, d, r, n, a, s) {
  const l = [e].concat(r);
  let i, f, p = [], m = !1;
  function h(S) {
    return n.measureSize(s.measure(S));
  }
  function C(S) {
    if (!a) return;
    f = h(e), p = r.map(h);
    function L(T) {
      for (const g of T) {
        if (m) return;
        const I = g.target === e, N = r.indexOf(g.target), Z = I ? f : p[N], Y = h(I ? e : r[N]);
        if (Be(Y - Z) >= 0.5) {
          S.reInit(), t.emit("resize");
          break;
        }
      }
    }
    i = new ResizeObserver((T) => {
      (md(a) || a(S, T)) && L(T);
    }), d.requestAnimationFrame(() => {
      l.forEach((T) => i.observe(T));
    });
  }
  function v() {
    m = !0, i && i.disconnect();
  }
  return {
    init: C,
    destroy: v
  };
}
function _s(e, t, d, r, n, a) {
  let s = 0, l = 0, i = n, f = a, p = e.get(), m = 0;
  function h(Z) {
    const Y = Z / 1e3, G = i * Y, U = r.get() - e.get(), te = !i;
    let B = 0;
    return te ? (s = 0, d.set(r), e.set(r), B = U) : (d.set(e), s += U / G, s *= f, p += s, e.add(s * Y), B = p - m), l = i0(B), m = p, N;
  }
  function C() {
    const Z = r.get() - t.get();
    return Be(Z) < 1e-3;
  }
  function v() {
    return i;
  }
  function M() {
    return l;
  }
  function S() {
    return s;
  }
  function L() {
    return g(n);
  }
  function T() {
    return I(a);
  }
  function g(Z) {
    return i = Z, N;
  }
  function I(Z) {
    return f = Z, N;
  }
  const N = {
    direction: M,
    duration: v,
    velocity: S,
    seek: h,
    settled: C,
    useBaseFriction: T,
    useBaseDuration: L,
    useFriction: I,
    useDuration: g
  };
  return N;
}
function js(e, t, d, r, n) {
  const a = n.measure(10), s = n.measure(50), l = _1(0.1, 0.99);
  let i = !1;
  function f() {
    return !(i || !e.reachedAny(d.get()) || !e.reachedAny(t.get()));
  }
  function p(C) {
    if (!f()) return;
    const v = e.reachedMin(t.get()) ? "min" : "max", M = Be(e[v] - t.get()), S = d.get() - t.get(), L = l.constrain(M / s);
    d.subtract(S * L), !C && Be(S) < a && (d.set(e.constrain(d.get())), r.useDuration(25).useBaseFriction());
  }
  function m(C) {
    i = !C;
  }
  return {
    shouldConstrain: f,
    constrain: p,
    toggleActive: m
  };
}
function Hs(e, t, d, r, n) {
  const a = _1(-t + e, 0), s = m(), l = p(), i = h();
  function f(v, M) {
    return xt(v, M) < 1;
  }
  function p() {
    const v = s[0], M = i1(s), S = s.lastIndexOf(v), L = s.indexOf(M) + 1;
    return _1(S, L);
  }
  function m() {
    return d.map((v, M) => {
      const {
        min: S,
        max: L
      } = a, T = a.constrain(v), g = !M, I = u0(d, M);
      return g ? L : I || f(S, T) ? S : f(L, T) ? L : T;
    }).map((v) => parseFloat(v.toFixed(3)));
  }
  function h() {
    if (t <= e + n) return [a.max];
    if (r === "keepSnaps") return s;
    const {
      min: v,
      max: M
    } = l;
    return s.slice(v, M);
  }
  return {
    snapsContained: i,
    scrollContainLimit: l
  };
}
function Gs(e, t, d) {
  const r = t[0], n = d ? r - e : i1(t);
  return {
    limit: _1(n, r)
  };
}
function Us(e, t, d, r) {
  const a = t.min + 0.1, s = t.max + 0.1, {
    reachedMin: l,
    reachedMax: i
  } = _1(a, s);
  function f(h) {
    return h === 1 ? i(d.get()) : h === -1 ? l(d.get()) : !1;
  }
  function p(h) {
    if (!f(h)) return;
    const C = e * (h * -1);
    r.forEach((v) => v.add(C));
  }
  return {
    loop: p
  };
}
function Ws(e) {
  const {
    max: t,
    length: d
  } = e;
  function r(a) {
    const s = a - t;
    return d ? s / -d : 0;
  }
  return {
    get: r
  };
}
function Ys(e, t, d, r, n) {
  const {
    startEdge: a,
    endEdge: s
  } = e, {
    groupSlides: l
  } = n, i = m().map(t.measure), f = h(), p = C();
  function m() {
    return l(r).map((M) => i1(M)[s] - M[0][a]).map(Be);
  }
  function h() {
    return r.map((M) => d[a] - M[a]).map((M) => -Be(M));
  }
  function C() {
    return l(f).map((M) => M[0]).map((M, S) => M + i[S]);
  }
  return {
    snaps: f,
    snapsAligned: p
  };
}
function Ks(e, t, d, r, n, a) {
  const {
    groupSlides: s
  } = n, {
    min: l,
    max: i
  } = r, f = p();
  function p() {
    const h = s(a), C = !e || t === "keepSnaps";
    return d.length === 1 ? [a] : C ? h : h.slice(l, i).map((v, M, S) => {
      const L = !M, T = u0(S, M);
      if (L) {
        const g = i1(S[0]) + 1;
        return J0(g);
      }
      if (T) {
        const g = Et(a) - i1(S)[0] + 1;
        return J0(g, i1(S)[0]);
      }
      return v;
    });
  }
  return {
    slideRegistry: f
  };
}
function Zs(e, t, d, r, n) {
  const {
    reachedAny: a,
    removeOffset: s,
    constrain: l
  } = r;
  function i(v) {
    return v.concat().sort((M, S) => Be(M) - Be(S))[0];
  }
  function f(v) {
    const M = e ? s(v) : l(v), S = t.map((T, g) => ({
      diff: p(T - M, 0),
      index: g
    })).sort((T, g) => Be(T.diff) - Be(g.diff)), {
      index: L
    } = S[0];
    return {
      index: L,
      distance: M
    };
  }
  function p(v, M) {
    const S = [v, v + d, v - d];
    if (!e) return v;
    if (!M) return i(S);
    const L = S.filter((T) => i0(T) === M);
    return L.length ? i(L) : i1(S) - d;
  }
  function m(v, M) {
    const S = t[v] - n.get(), L = p(S, M);
    return {
      index: v,
      distance: L
    };
  }
  function h(v, M) {
    const S = n.get() + v, {
      index: L,
      distance: T
    } = f(S), g = !e && a(S);
    if (!M || g) return {
      index: L,
      distance: v
    };
    const I = t[L] - T, N = v + p(I, 0);
    return {
      index: L,
      distance: N
    };
  }
  return {
    byDistance: h,
    byIndex: m,
    shortcut: p
  };
}
function qs(e, t, d, r, n, a, s) {
  function l(m) {
    const h = m.distance, C = m.index !== t.get();
    a.add(h), h && (r.duration() ? e.start() : (e.update(), e.render(1), e.update())), C && (d.set(t.get()), t.set(m.index), s.emit("select"));
  }
  function i(m, h) {
    const C = n.byDistance(m, h);
    l(C);
  }
  function f(m, h) {
    const C = t.clone().set(m), v = n.byIndex(C.get(), h);
    l(v);
  }
  return {
    distance: i,
    index: f
  };
}
function Js(e, t, d, r, n, a, s, l) {
  const i = {
    passive: !0,
    capture: !0
  };
  let f = 0;
  function p(C) {
    if (!l) return;
    function v(M) {
      if ((/* @__PURE__ */ new Date()).getTime() - f > 10) return;
      s.emit("slideFocusStart"), e.scrollLeft = 0;
      const T = d.findIndex((g) => g.includes(M));
      l0(T) && (n.useDuration(0), r.index(T, 0), s.emit("slideFocus"));
    }
    a.add(document, "keydown", m, !1), t.forEach((M, S) => {
      a.add(M, "focus", (L) => {
        (md(l) || l(C, L)) && v(S);
      }, i);
    });
  }
  function m(C) {
    C.code === "Tab" && (f = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: p
  };
}
function vt(e) {
  let t = e;
  function d() {
    return t;
  }
  function r(i) {
    t = s(i);
  }
  function n(i) {
    t += s(i);
  }
  function a(i) {
    t -= s(i);
  }
  function s(i) {
    return l0(i) ? i : i.get();
  }
  return {
    get: d,
    set: r,
    add: n,
    subtract: a
  };
}
function Gn(e, t) {
  const d = e.scroll === "x" ? a : s, r = t.style;
  let n = !1;
  function a(m) {
    return `translate3d(${m}px,0px,0px)`;
  }
  function s(m) {
    return `translate3d(0px,${m}px,0px)`;
  }
  function l(m) {
    n || (r.transform = d(e.direction(m)));
  }
  function i(m) {
    n = !m;
  }
  function f() {
    n || (r.transform = "", t.getAttribute("style") || t.removeAttribute("style"));
  }
  return {
    clear: f,
    to: l,
    toggleActive: i
  };
}
function Xs(e, t, d, r, n, a, s, l, i) {
  const p = Tt(n), m = Tt(n).reverse(), h = L().concat(T());
  function C(Y, G) {
    return Y.reduce((U, te) => U - n[te], G);
  }
  function v(Y, G) {
    return Y.reduce((U, te) => C(U, G) > 0 ? U.concat([te]) : U, []);
  }
  function M(Y) {
    return a.map((G, U) => ({
      start: G - r[U] + 0.5 + Y,
      end: G + t - 0.5 + Y
    }));
  }
  function S(Y, G, U) {
    const te = M(G);
    return Y.map((B) => {
      const V = U ? 0 : -d, q = U ? d : 0, J = U ? "end" : "start", ee = te[B][J];
      return {
        index: B,
        loopPoint: ee,
        slideLocation: vt(-1),
        translate: Gn(e, i[B]),
        target: () => l.get() > ee ? V : q
      };
    });
  }
  function L() {
    const Y = s[0], G = v(m, Y);
    return S(G, d, !1);
  }
  function T() {
    const Y = t - s[0] - 1, G = v(p, Y);
    return S(G, -d, !0);
  }
  function g() {
    return h.every(({
      index: Y
    }) => {
      const G = p.filter((U) => U !== Y);
      return C(G, t) <= 0.1;
    });
  }
  function I() {
    h.forEach((Y) => {
      const {
        target: G,
        translate: U,
        slideLocation: te
      } = Y, B = G();
      B !== te.get() && (U.to(B), te.set(B));
    });
  }
  function N() {
    h.forEach((Y) => Y.translate.clear());
  }
  return {
    canLoop: g,
    clear: N,
    loop: I,
    loopPoints: h
  };
}
function Qs(e, t, d) {
  let r, n = !1;
  function a(i) {
    if (!d) return;
    function f(p) {
      for (const m of p)
        if (m.type === "childList") {
          i.reInit(), t.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((p) => {
      n || (md(d) || d(i, p)) && f(p);
    }), r.observe(e, {
      childList: !0
    });
  }
  function s() {
    r && r.disconnect(), n = !0;
  }
  return {
    init: a,
    destroy: s
  };
}
function eo(e, t, d, r) {
  const n = {};
  let a = null, s = null, l, i = !1;
  function f() {
    l = new IntersectionObserver((v) => {
      i || (v.forEach((M) => {
        const S = t.indexOf(M.target);
        n[S] = M;
      }), a = null, s = null, d.emit("slidesInView"));
    }, {
      root: e.parentElement,
      threshold: r
    }), t.forEach((v) => l.observe(v));
  }
  function p() {
    l && l.disconnect(), i = !0;
  }
  function m(v) {
    return Lt(n).reduce((M, S) => {
      const L = parseInt(S), {
        isIntersecting: T
      } = n[L];
      return (v && T || !v && !T) && M.push(L), M;
    }, []);
  }
  function h(v = !0) {
    if (v && a) return a;
    if (!v && s) return s;
    const M = m(v);
    return v && (a = M), v || (s = M), M;
  }
  return {
    init: f,
    destroy: p,
    get: h
  };
}
function to(e, t, d, r, n, a) {
  const {
    measureSize: s,
    startEdge: l,
    endEdge: i
  } = e, f = d[0] && n, p = v(), m = M(), h = d.map(s), C = S();
  function v() {
    if (!f) return 0;
    const T = d[0];
    return Be(t[l] - T[l]);
  }
  function M() {
    if (!f) return 0;
    const T = a.getComputedStyle(i1(r));
    return parseFloat(T.getPropertyValue(`margin-${i}`));
  }
  function S() {
    return d.map((T, g, I) => {
      const N = !g, Z = u0(I, g);
      return N ? h[g] + p : Z ? h[g] + m : I[g + 1][l] - T[l];
    }).map(Be);
  }
  return {
    slideSizes: h,
    slideSizesWithGaps: C,
    startGap: p,
    endGap: m
  };
}
function no(e, t, d, r, n, a, s, l, i) {
  const {
    startEdge: f,
    endEdge: p,
    direction: m
  } = e, h = l0(d);
  function C(L, T) {
    return Tt(L).filter((g) => g % T === 0).map((g) => L.slice(g, g + T));
  }
  function v(L) {
    return L.length ? Tt(L).reduce((T, g, I) => {
      const N = i1(T) || 0, Z = N === 0, Y = g === Et(L), G = n[f] - a[N][f], U = n[f] - a[g][p], te = !r && Z ? m(s) : 0, B = !r && Y ? m(l) : 0, V = Be(U - B - (G + te));
      return I && V > t + i && T.push(g), Y && T.push(L.length), T;
    }, []).map((T, g, I) => {
      const N = Math.max(I[g - 1] || 0);
      return L.slice(N, T);
    }) : [];
  }
  function M(L) {
    return h ? C(L, d) : v(L);
  }
  return {
    groupSlides: M
  };
}
function ro(e, t, d, r, n, a, s) {
  const {
    align: l,
    axis: i,
    direction: f,
    startIndex: p,
    loop: m,
    duration: h,
    dragFree: C,
    dragThreshold: v,
    inViewThreshold: M,
    slidesToScroll: S,
    skipSnaps: L,
    containScroll: T,
    watchResize: g,
    watchSlides: I,
    watchDrag: N,
    watchFocus: Z
  } = a, Y = 2, G = Rs(), U = G.measure(t), te = d.map(G.measure), B = Ps(i, f), V = B.measureSize(U), q = Ns(V), J = zs(l, V), ee = !m && !!T, le = m || !!T, {
    slideSizes: K,
    slideSizesWithGaps: re,
    startGap: ne,
    endGap: ce
  } = to(B, U, te, d, le, n), ie = no(B, V, S, m, U, te, ne, ce, Y), {
    snaps: ve,
    snapsAligned: se
  } = Ys(B, J, U, te, ie), be = -i1(ve) + i1(re), {
    snapsContained: Ae,
    scrollContainLimit: $e
  } = Hs(V, be, se, T, Y), Pe = ee ? Ae : se, {
    limit: Me
  } = Gs(be, Pe, m), We = Hn(Et(Pe), p, m), De = We.clone(), xe = Tt(d), oe = ({
    dragHandler: o1,
    scrollBody: G1,
    scrollBounds: it,
    options: {
      loop: U1
    }
  }, ut) => {
    U1 || it.constrain(o1.pointerDown()), G1.seek(ut);
  }, ge = ({
    scrollBody: o1,
    translate: G1,
    location: it,
    offsetLocation: U1,
    scrollLooper: ut,
    slideLooper: Vt,
    dragHandler: Ot,
    animation: Rt,
    eventHandler: Nt,
    scrollBounds: vd,
    options: {
      loop: Ft
    }
  }, E1) => {
    const ct = o1.settled(), w1 = !vd.shouldConstrain(), v1 = Ft ? ct : ct && w1;
    v1 && !Ot.pointerDown() && (Rt.stop(), Nt.emit("settle")), v1 || Nt.emit("scroll");
    const bd = it.get() * E1 + qe.get() * (1 - E1);
    U1.set(bd), Ft && (ut.loop(o1.direction()), Vt.loop()), G1.to(U1.get());
  }, we = Bs(r, n, (o1) => oe(f1, o1), (o1) => ge(f1, o1)), Le = 0.68, Ne = Pe[We.get()], Ye = vt(Ne), qe = vt(Ne), Je = vt(Ne), c1 = vt(Ne), s1 = _s(Ye, Je, qe, c1, h, Le), H1 = Zs(m, Pe, be, Me, c1), lt = qs(we, We, De, s1, H1, c1, s), zt = Ws(Me), Bt = At(), gd = eo(t, d, s, M), {
    slideRegistry: Pt
  } = Ks(ee, T, Pe, $e, ie, xe), hd = Js(e, d, Pt, lt, s1, Bt, s, Z), f1 = {
    ownerDocument: r,
    ownerWindow: n,
    eventHandler: s,
    containerRect: U,
    slideRects: te,
    animation: we,
    axis: B,
    dragHandler: Vs(B, e, r, n, c1, Os(B, n), Ye, we, lt, s1, H1, We, s, q, C, v, L, Le, N),
    eventStore: Bt,
    percentOfView: q,
    index: We,
    indexPrevious: De,
    limit: Me,
    location: Ye,
    offsetLocation: Je,
    previousLocation: qe,
    options: a,
    resizeHandler: Fs(t, s, n, d, B, g, G),
    scrollBody: s1,
    scrollBounds: js(Me, Je, c1, s1, q),
    scrollLooper: Us(be, Me, Je, [Ye, Je, qe, c1]),
    scrollProgress: zt,
    scrollSnapList: Pe.map(zt.get),
    scrollSnaps: Pe,
    scrollTarget: H1,
    scrollTo: lt,
    slideLooper: Xs(B, V, be, K, re, ve, Pe, Je, d),
    slideFocus: hd,
    slidesHandler: Qs(t, s, I),
    slidesInView: gd,
    slideIndexes: xe,
    slideRegistry: Pt,
    slidesToScroll: ie,
    target: c1,
    translate: Gn(B, t)
  };
  return f1;
}
function so() {
  let e = {}, t;
  function d(f) {
    t = f;
  }
  function r(f) {
    return e[f] || [];
  }
  function n(f) {
    return r(f).forEach((p) => p(t, f)), i;
  }
  function a(f, p) {
    return e[f] = r(f).concat([p]), i;
  }
  function s(f, p) {
    return e[f] = r(f).filter((m) => m !== p), i;
  }
  function l() {
    e = {};
  }
  const i = {
    init: d,
    emit: n,
    off: s,
    on: a,
    clear: l
  };
  return i;
}
const oo = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function ao(e) {
  function t(a, s) {
    return jn(a, s || {});
  }
  function d(a) {
    const s = a.breakpoints || {}, l = Lt(s).filter((i) => e.matchMedia(i).matches).map((i) => s[i]).reduce((i, f) => t(i, f), {});
    return t(a, l);
  }
  function r(a) {
    return a.map((s) => Lt(s.breakpoints || {})).reduce((s, l) => s.concat(l), []).map(e.matchMedia);
  }
  return {
    mergeOptions: t,
    optionsAtMedia: d,
    optionsMediaQueries: r
  };
}
function lo(e) {
  let t = [];
  function d(a, s) {
    return t = s.filter(({
      options: l
    }) => e.optionsAtMedia(l).active !== !1), t.forEach((l) => l.init(a, e)), s.reduce((l, i) => Object.assign(l, {
      [i.name]: i
    }), {});
  }
  function r() {
    t = t.filter((a) => a.destroy());
  }
  return {
    init: d,
    destroy: r
  };
}
function nd(e, t, d) {
  const r = e.ownerDocument, n = r.defaultView, a = ao(n), s = lo(a), l = At(), i = so(), {
    mergeOptions: f,
    optionsAtMedia: p,
    optionsMediaQueries: m
  } = a, {
    on: h,
    off: C,
    emit: v
  } = i, M = B;
  let S = !1, L, T = f(oo, nd.globalOptions), g = f(T), I = [], N, Z, Y;
  function G() {
    const {
      container: xe,
      slides: oe
    } = g;
    Z = (Gd(xe) ? e.querySelector(xe) : xe) || e.children[0];
    const we = Gd(oe) ? Z.querySelectorAll(oe) : oe;
    Y = [].slice.call(we || Z.children);
  }
  function U(xe) {
    const oe = ro(e, Z, Y, r, n, xe, i);
    if (xe.loop && !oe.slideLooper.canLoop()) {
      const ge = Object.assign({}, xe, {
        loop: !1
      });
      return U(ge);
    }
    return oe;
  }
  function te(xe, oe) {
    S || (T = f(T, xe), g = p(T), I = oe || I, G(), L = U(g), m([T, ...I.map(({
      options: ge
    }) => ge)]).forEach((ge) => l.add(ge, "change", B)), g.active && (L.translate.to(L.location.get()), L.animation.init(), L.slidesInView.init(), L.slideFocus.init(De), L.eventHandler.init(De), L.resizeHandler.init(De), L.slidesHandler.init(De), L.options.loop && L.slideLooper.loop(), Z.offsetParent && Y.length && L.dragHandler.init(De), N = s.init(De, I)));
  }
  function B(xe, oe) {
    const ge = ie();
    V(), te(f({
      startIndex: ge
    }, xe), oe), i.emit("reInit");
  }
  function V() {
    L.dragHandler.destroy(), L.eventStore.clear(), L.translate.clear(), L.slideLooper.clear(), L.resizeHandler.destroy(), L.slidesHandler.destroy(), L.slidesInView.destroy(), L.animation.destroy(), s.destroy(), l.clear();
  }
  function q() {
    S || (S = !0, l.clear(), V(), i.emit("destroy"), i.clear());
  }
  function J(xe, oe, ge) {
    !g.active || S || (L.scrollBody.useBaseFriction().useDuration(oe === !0 ? 0 : g.duration), L.scrollTo.index(xe, ge || 0));
  }
  function ee(xe) {
    const oe = L.index.add(1).get();
    J(oe, xe, -1);
  }
  function le(xe) {
    const oe = L.index.add(-1).get();
    J(oe, xe, 1);
  }
  function K() {
    return L.index.add(1).get() !== ie();
  }
  function re() {
    return L.index.add(-1).get() !== ie();
  }
  function ne() {
    return L.scrollSnapList;
  }
  function ce() {
    return L.scrollProgress.get(L.location.get());
  }
  function ie() {
    return L.index.get();
  }
  function ve() {
    return L.indexPrevious.get();
  }
  function se() {
    return L.slidesInView.get();
  }
  function be() {
    return L.slidesInView.get(!1);
  }
  function Ae() {
    return N;
  }
  function $e() {
    return L;
  }
  function Pe() {
    return e;
  }
  function Me() {
    return Z;
  }
  function We() {
    return Y;
  }
  const De = {
    canScrollNext: K,
    canScrollPrev: re,
    containerNode: Me,
    internalEngine: $e,
    destroy: q,
    off: C,
    on: h,
    emit: v,
    plugins: Ae,
    previousScrollSnap: ve,
    reInit: M,
    rootNode: Pe,
    scrollNext: ee,
    scrollPrev: le,
    scrollProgress: ce,
    scrollSnapList: ne,
    scrollTo: J,
    selectedScrollSnap: ie,
    slideNodes: We,
    slidesInView: se,
    slidesNotInView: be
  };
  return te(t, d), setTimeout(() => i.emit("init"), 0), De;
}
nd.globalOptions = void 0;
function c0(e = {}, t = []) {
  const d = dt(e), r = dt(t);
  let n = d ? e.value : e, a = r ? t.value : t;
  const s = Nd(), l = Nd();
  function i() {
    l.value && l.value.reInit(n, a);
  }
  return r1(() => {
    !Ds() || !s.value || (nd.globalOptions = c0.globalOptions, l.value = nd(s.value, n, a));
  }), id(() => {
    l.value && l.value.destroy();
  }), d && Ce(e, (f) => {
    a0(n, f) || (n = f, i());
  }), r && Ce(t, (f) => {
    Is(a, f) || (a = f, i());
  }), [s, l];
}
c0.globalOptions = void 0;
function O1() {
  return O1 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var d = arguments[t];
      for (var r in d)
        Object.prototype.hasOwnProperty.call(d, r) && (e[r] = d[r]);
    }
    return e;
  }, O1.apply(this, arguments);
}
var io = 0.996, uo = function(t, d) {
  return d === void 0 && (d = io), t * d / (1 - d);
};
function co(e) {
  return e[e.length - 1];
}
function fo(e) {
  return e.reduce(function(t, d) {
    return t + d;
  }) / e.length;
}
var $o = function(t, d, r) {
  return Math.min(Math.max(d, t), r);
};
function Pd(e, t) {
  if (e.length !== t.length)
    throw new Error("vectors must be same length");
  return e.map(function(d, r) {
    return d + t[r];
  });
}
function X0(e) {
  return Math.max.apply(Math, e.map(Math.abs));
}
function st(e) {
  return Object.freeze(e), Object.values(e).forEach(function(t) {
    t !== null && typeof t == "object" && !Object.isFrozen(t) && st(t);
  }), e;
}
function po() {
  var e = {};
  function t(n, a) {
    return e[n] = (e[n] || []).concat(a), function() {
      return d(n, a);
    };
  }
  function d(n, a) {
    e[n] = (e[n] || []).filter(function(s) {
      return s !== a;
    });
  }
  function r(n, a) {
    n in e && e[n].forEach(function(s) {
      return s(a);
    });
  }
  return st({
    on: t,
    off: d,
    dispatch: r
  });
}
function mo(e) {
  var t = [], d = function(s) {
    return s.addEventListener("wheel", e, {
      passive: !1
    }), t.push(s), function() {
      return r(s);
    };
  }, r = function(s) {
    s.removeEventListener("wheel", e), t = t.filter(function(l) {
      return l !== s;
    });
  }, n = function() {
    t.forEach(r);
  };
  return st({
    observe: d,
    unobserve: r,
    disconnect: n
  });
}
var go = 16 * 1.125, ho = typeof window < "u" && window.innerHeight || 800, Vd = [1, go, ho];
function vo(e) {
  var t = e.deltaX * Vd[e.deltaMode], d = e.deltaY * Vd[e.deltaMode], r = (e.deltaZ || 0) * Vd[e.deltaMode];
  return {
    timeStamp: e.timeStamp,
    axisDelta: [t, d, r]
  };
}
var bo = [-1, -1, -1];
function yo(e, t) {
  if (!t)
    return e;
  var d = t === !0 ? bo : t.map(function(r) {
    return r ? -1 : 1;
  });
  return O1({}, e, {
    axisDelta: e.axisDelta.map(function(r, n) {
      return r * d[n];
    })
  });
}
var Q0 = 700, xo = function(t) {
  return O1({}, t, {
    axisDelta: t.axisDelta.map(function(d) {
      return $o(d, -Q0, Q0);
    })
  });
}, Od = process.env.NODE_ENV !== "production", wo = 0.6, Co = 0.96, ko = 2, en = 5, tn = /* @__PURE__ */ st({
  preventWheelAction: !0,
  reverseSign: [!0, !0, !1]
}), So = 400;
function dn() {
  return {
    isStarted: !1,
    isStartPublished: !1,
    isMomentum: !1,
    startTime: 0,
    lastAbsDelta: 1 / 0,
    axisMovement: [0, 0, 0],
    axisVelocity: [0, 0, 0],
    accelerationFactors: [],
    scrollPoints: [],
    scrollPointsToMerge: [],
    willEndTimeout: So
  };
}
function Mo(e) {
  e === void 0 && (e = {});
  var t = po(), d = t.on, r = t.off, n = t.dispatch, a = tn, s = dn(), l, i = !1, f, p = function(J) {
    Array.isArray(J) ? J.forEach(function(ee) {
      return v(ee);
    }) : v(J);
  }, m = function(J) {
    return J === void 0 && (J = {}), Object.values(J).some(function(ee) {
      return ee == null;
    }) ? (Od && console.error("updateOptions ignored! undefined & null options not allowed"), a) : a = st(O1({}, tn, a, J));
  }, h = function(J) {
    var ee = O1({
      event: l,
      isStart: !1,
      isEnding: !1,
      isMomentumCancel: !1,
      isMomentum: s.isMomentum,
      axisDelta: [0, 0, 0],
      axisVelocity: s.axisVelocity,
      axisMovement: s.axisMovement,
      get axisMovementProjection() {
        return Pd(ee.axisMovement, ee.axisVelocity.map(function(le) {
          return uo(le);
        }));
      }
    }, J);
    n("wheel", O1({}, ee, {
      previous: f
    })), f = ee;
  }, C = function(J, ee) {
    var le = a, K = le.preventWheelAction, re = ee[0], ne = ee[1], ce = ee[2];
    if (typeof K == "boolean") return K;
    switch (K) {
      case "x":
        return Math.abs(re) >= J;
      case "y":
        return Math.abs(ne) >= J;
      case "z":
        return Math.abs(ce) >= J;
      default:
        return Od && console.warn("unsupported preventWheelAction value: " + K, "warn"), !1;
    }
  }, v = function(J) {
    var ee = xo(yo(vo(J), a.reverseSign)), le = ee.axisDelta, K = ee.timeStamp, re = X0(le);
    if (J.preventDefault && C(re, le) && J.preventDefault(), s.isStarted ? s.isMomentum && re > Math.max(2, s.lastAbsDelta * 2) && (G(!0), Z()) : Z(), re === 0 && Object.is && Object.is(J.deltaX, -0)) {
      i = !0;
      return;
    }
    l = J, s.axisMovement = Pd(s.axisMovement, le), s.lastAbsDelta = re, s.scrollPointsToMerge.push({
      axisDelta: le,
      timeStamp: K
    }), M(), h({
      axisDelta: le,
      isStart: !s.isStartPublished
    }), s.isStartPublished = !0, Y();
  }, M = function() {
    s.scrollPointsToMerge.length === ko ? (s.scrollPoints.unshift({
      axisDeltaSum: s.scrollPointsToMerge.map(function(J) {
        return J.axisDelta;
      }).reduce(Pd),
      timeStamp: fo(s.scrollPointsToMerge.map(function(J) {
        return J.timeStamp;
      }))
    }), L(), s.scrollPointsToMerge.length = 0, s.scrollPoints.length = 1, s.isMomentum || I()) : s.isStartPublished || S();
  }, S = function() {
    s.axisVelocity = co(s.scrollPointsToMerge).axisDelta.map(function(J) {
      return J / s.willEndTimeout;
    });
  }, L = function() {
    var J = s.scrollPoints, ee = J[0], le = J[1];
    if (!(!le || !ee)) {
      var K = ee.timeStamp - le.timeStamp;
      if (K <= 0) {
        Od && console.warn("invalid deltaTime");
        return;
      }
      var re = ee.axisDeltaSum.map(function(ce) {
        return ce / K;
      }), ne = re.map(function(ce, ie) {
        return ce / (s.axisVelocity[ie] || 1);
      });
      s.axisVelocity = re, s.accelerationFactors.push(ne), T(K);
    }
  }, T = function(J) {
    var ee = Math.ceil(J / 10) * 10 * 1.2;
    s.isMomentum || (ee = Math.max(100, ee * 2)), s.willEndTimeout = Math.min(1e3, Math.round(ee));
  }, g = function(J) {
    return J === 0 ? !0 : J <= Co && J >= wo;
  }, I = function() {
    if (s.accelerationFactors.length >= en) {
      if (i && (i = !1, X0(s.axisVelocity) >= 0.2)) {
        N();
        return;
      }
      var J = s.accelerationFactors.slice(en * -1), ee = J.every(function(le) {
        var K = !!le.reduce(function(ne, ce) {
          return ne && ne < 1 && ne === ce ? 1 : 0;
        }), re = le.filter(g).length === le.length;
        return K || re;
      });
      ee && N(), s.accelerationFactors = J;
    }
  }, N = function() {
    s.isMomentum = !0;
  }, Z = function() {
    s = dn(), s.isStarted = !0, s.startTime = Date.now(), f = void 0, i = !1;
  }, Y = /* @__PURE__ */ function() {
    var q;
    return function() {
      clearTimeout(q), q = setTimeout(G, s.willEndTimeout);
    };
  }(), G = function(J) {
    J === void 0 && (J = !1), s.isStarted && (s.isMomentum && J ? h({
      isEnding: !0,
      isMomentumCancel: !0
    }) : h({
      isEnding: !0
    }), s.isMomentum = !1, s.isStarted = !1);
  }, U = mo(p), te = U.observe, B = U.unobserve, V = U.disconnect;
  return m(e), st({
    on: d,
    off: r,
    observe: te,
    unobserve: B,
    disconnect: V,
    feedWheel: p,
    updateOptions: m
  });
}
var To = {
  active: !0,
  breakpoints: {},
  wheelDraggingClass: "is-wheel-dragging",
  forceWheelAxis: void 0,
  target: void 0
};
f0.globalOptions = void 0;
var Lo = process.env.NODE_ENV !== "production";
function f0(e) {
  e === void 0 && (e = {});
  var t, d = function() {
  };
  function r(a, s) {
    var l, i, f = s.mergeOptions, p = s.optionsAtMedia, m = f(To, f0.globalOptions), h = f(m, e);
    t = p(h);
    var C = a.internalEngine(), v = (l = t.target) != null ? l : a.containerNode().parentNode, M = (i = t.forceWheelAxis) != null ? i : C.options.axis, S = Mo({
      preventWheelAction: M,
      reverseSign: [!0, !0, !1]
    }), L = S.observe(v), T = S.on("wheel", V), g = !1, I;
    function N(q) {
      try {
        I = new MouseEvent("mousedown", q.event), B(I);
      } catch {
        return Lo && console.warn("Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)"), d();
      }
      g = !0, Y(), t.wheelDraggingClass && v.classList.add(t.wheelDraggingClass);
    }
    function Z(q) {
      g = !1, B(te("mouseup", q)), G(), t.wheelDraggingClass && v.classList.remove(t.wheelDraggingClass);
    }
    function Y() {
      document.documentElement.addEventListener("mousemove", U, !0), document.documentElement.addEventListener("mouseup", U, !0), document.documentElement.addEventListener("mousedown", U, !0);
    }
    function G() {
      document.documentElement.removeEventListener("mousemove", U, !0), document.documentElement.removeEventListener("mouseup", U, !0), document.documentElement.removeEventListener("mousedown", U, !0);
    }
    function U(q) {
      g && q.isTrusted && q.stopImmediatePropagation();
    }
    function te(q, J) {
      var ee, le;
      if (M === C.options.axis) {
        var K = J.axisMovement;
        ee = K[0], le = K[1];
      } else {
        var re = J.axisMovement;
        le = re[0], ee = re[1];
      }
      if (!C.options.skipSnaps && !C.options.dragFree) {
        var ne = C.containerRect.width, ce = C.containerRect.height;
        ee = ee < 0 ? Math.max(ee, -ne) : Math.min(ee, ne), le = le < 0 ? Math.max(le, -ce) : Math.min(le, ce);
      }
      return new MouseEvent(q, {
        clientX: I.clientX + ee,
        clientY: I.clientY + le,
        screenX: I.screenX + ee,
        screenY: I.screenY + le,
        movementX: ee,
        movementY: le,
        button: 0,
        bubbles: !0,
        cancelable: !0,
        composed: !0
      });
    }
    function B(q) {
      a.containerNode().dispatchEvent(q);
    }
    function V(q) {
      var J = q.axisDelta, ee = J[0], le = J[1], K = M === "x" ? ee : le, re = M === "x" ? le : ee, ne = q.isMomentum && q.previous && !q.previous.isMomentum, ce = q.isEnding && !q.isMomentum || ne, ie = Math.abs(K) > Math.abs(re);
      ie && !g && !q.isMomentum && N(q), g && (ce ? Z(q) : B(te("mousemove", q)));
    }
    d = function() {
      L(), T(), G();
    };
  }
  var n = {
    name: "wheelGestures",
    options: e,
    init: r,
    destroy: function() {
      return d();
    }
  };
  return n;
}
const Ao = { class: "relative size-[4em]" }, Do = {
  class: "size-full",
  viewBox: "0 0 100 100"
}, Io = ["d"], Eo = ["d"], nn = 45, zo = /* @__PURE__ */ X({
  __name: "CfgCircularProgress",
  props: /* @__PURE__ */ ye({
    circleClass: { default: "stroke-brand" },
    useBackground: { type: Boolean, default: !1 }
  }, {
    modelValue: { default: 0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = 2 * Math.PI * nn, d = ze(e, "modelValue"), r = j(() => {
      const a = nn;
      return `
          M 50 50
          m 0 -${a}
          a ${a} ${a} 0 1 1 0 ${a * 2}
          a ${a} ${a} 0 1 1 0 -${a * 2}
          `;
    }), n = j(() => d.value / 100 * t);
    return (a, s) => ($(), k("div", Ao, [
      y(u(sr), {
        modelValue: d.value,
        "onUpdate:modelValue": s[0] || (s[0] = (l) => d.value = l),
        "as-child": ""
      }, {
        default: b(() => [
          ($(), k("svg", Do, [
            a.useBackground ? ($(), k("path", {
              key: 0,
              class: "fill-none stroke-grey-50 stroke-[8px]",
              d: r.value
            }, null, 8, Io)) : P("", !0),
            y(u(or), { "as-child": "" }, {
              default: b(() => [
                x("path", {
                  class: z(["fill-none stroke-[8px] transition-[stroke-dasharray,opacity] duration-700 data-[value='0']:opacity-0", a.circleClass]),
                  d: r.value,
                  style: Ue({
                    "stroke-linecap": "round",
                    "stroke-dasharray": `${n.value}px, ${t}px`,
                    "stroke-dashoffset": "0px"
                  })
                }, null, 14, Eo)
              ]),
              _: 1
            })
          ]))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]));
  }
}), Bo = { class: "flex h-full" }, Po = { key: 0 }, Vo = { class: "mt-5 flex items-center justify-center gap-x-3" }, Oo = {
  key: 0,
  class: "absolute bottom-4 left-4"
}, Ro = {
  key: 1,
  class: "absolute right-4 top-4"
}, No = {
  key: 2,
  class: "absolute bottom-4 right-4 flex items-center gap-6"
}, rn = 4e3, K9 = /* @__PURE__ */ X({
  __name: "CfgCarousel",
  props: {
    autoplay: { type: [Boolean, Object], default: !1 },
    dots: { type: Boolean, default: !1 },
    items: {},
    options: { default: () => ({}) },
    wheelGestures: { type: Boolean, default: !1 },
    partialVisibility: { type: Boolean, default: !0 },
    arrows: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = j(() => ({
      containScroll: e.partialVisibility ? "trimSnaps" : !1,
      ...e.options
    })), d = j(() => {
      const g = [];
      if (e.wheelGestures && g.push(
        f0(
          typeof e.wheelGestures == "boolean" ? {} : e.wheelGestures
        )
      ), e.autoplay) {
        const I = {
          stopOnInteraction: !1
        };
        g.push(
          o0(
            typeof e.autoplay == "boolean" ? I : { ...I, ...e.autoplay }
          )
        );
      }
      return g;
    }), [r, n] = c0(t.value, d.value), a = de(!1), s = de(!1), l = de(0), i = de([]), f = de(100), p = de(null), m = j(
      () => {
        var g;
        return typeof e.autoplay == "boolean" ? rn : ((g = e.autoplay) == null ? void 0 : g.delay) || rn;
      }
    );
    function h(g) {
      i.value = (g == null ? void 0 : g.scrollSnapList()) || [];
    }
    function C(g) {
      a.value = (g == null ? void 0 : g.canScrollNext()) || !1, s.value = (g == null ? void 0 : g.canScrollPrev()) || !1, l.value = (g == null ? void 0 : g.selectedScrollSnap()) || 0;
    }
    function v() {
      var g;
      (g = n.value) == null || g.scrollPrev();
    }
    function M() {
      var g;
      (g = n.value) == null || g.scrollNext();
    }
    function S(g) {
      var I;
      (I = n.value) == null || I.scrollTo(g);
    }
    function L(g) {
      const I = "ArrowLeft", N = "ArrowRight";
      if (g.key === I) {
        g.preventDefault(), v();
        return;
      }
      g.key === N && (g.preventDefault(), M());
    }
    r1(() => {
      var g, I, N, Z, Y;
      n.value && ((g = n.value) == null || g.on("init", h), (I = n.value) == null || I.on("init", C), (N = n.value) == null || N.on("reInit", h), (Z = n.value) == null || Z.on("reInit", C), (Y = n.value) == null || Y.on("select", C));
    }), h2(() => {
      clearInterval(p.value || 0);
    });
    function T() {
      clearInterval(p.value || 0), f.value = 0, p.value = setInterval(() => {
        const g = 1 / m.value * 1e5;
        f.value += g, f.value >= 100 && clearInterval(p.value || 0);
      }, 1e3);
    }
    return Ce(
      l,
      () => {
        !e.autoplay || !e.dots || T();
      },
      { immediate: !0 }
    ), (g, I) => ($(), k("section", {
      "aria-roledescription": "carousel",
      class: "relative",
      role: "region",
      tabindex: "0",
      onKeydown: L
    }, [
      x("div", {
        ref_key: "emblaRef",
        ref: r,
        class: "hide-scrollbar h-full overflow-hidden"
      }, [
        x("ul", Bo, [
          ($(!0), k(ae, null, he(g.items, (N, Z) => ($(), k("li", {
            key: Z,
            "aria-roledescription": "slide",
            class: z(["shrink-0 grow-0", {
              "size-4/5": g.partialVisibility || g.wheelGestures,
              "size-full": !g.partialVisibility && !g.wheelGestures,
              "px-2": g.wheelGestures
            }]),
            role: "group"
          }, [
            W(g.$slots, "items", {
              index: Z,
              item: N
            })
          ], 2))), 128))
        ]),
        g.dots ? ($(), k("div", Po, [
          W(g.$slots, "dot", {
            scrollTo: S,
            selectedIndex: l.value
          }, () => [
            x("ul", Vo, [
              ($(!0), k(ae, null, he(g.items, (N, Z) => ($(), k("li", { key: Z }, [
                y(zo, {
                  class: z(["transition-all duration-200", {
                    "!size-[24px]": Z === l.value,
                    "!size-[16px] opacity-50": Z !== l.value
                  }]),
                  "model-value": Z === l.value ? f.value : 100,
                  "use-background": "",
                  onClick: (Y) => S(Z)
                }, null, 8, ["class", "model-value", "onClick"])
              ]))), 128))
            ])
          ])
        ])) : P("", !0)
      ], 512),
      g.$slots.counter ? ($(), k("div", Oo, [
        W(g.$slots, "counter", {
          current: l.value + 1,
          total: g.items.length
        })
      ])) : P("", !0),
      g.$slots["top-right"] ? ($(), k("div", Ro, [
        W(g.$slots, "top-right")
      ])) : P("", !0),
      g.arrows ? ($(), k("div", No, [
        y(u(k2), {
          class: "!size-6 cursor-pointer text-white",
          onClick: v
        }),
        y(u(S2), {
          class: "!size-6 cursor-pointer text-white",
          onClick: M
        })
      ])) : P("", !0)
    ], 32));
  }
}), Fe = {
  required: {
    type: Boolean,
    default: !1
  },
  /**
   * Placeholder text
   */
  placeholder: {
    type: String,
    default: ""
  },
  /**
   * Field error state (will show error message if provided and set to true)
   */
  error: {
    type: Boolean,
    default: !1
  },
  /**
   * Field error message
   */
  errorMessage: {
    type: String,
    default: ""
  },
  /**
   * Caption text. Will be shown below input. Recommended length is 2-3 words, like 'Enter your name'.
   * In case of error, will be replaced with error message
   */
  caption: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  /**
   * Will set input focus on mount
   */
  initialFocused: {
    type: Boolean,
    default: !1
  },
  loading: {
    type: Boolean,
    default: !1
  }
}, Ze = {
  ...Fe,
  /**
   * Input type like text, number, email, etc.
   */
  type: {
    type: String,
    default: "text"
  },
  /**
   * Will make input fluid (100% width)
   */
  fluid: {
    type: Boolean,
    default: !1
  },
  readonly: {
    type: Boolean,
    default: !1
  },
  /**
   * Input suffix. The Recommended length is 2-3 characters, like 'Let'
   */
  suffix: {
    type: String,
    default: ""
  },
  transformToCommaDelimiter: {
    type: Boolean,
    default: void 0
  }
}, Fo = { class: "flex items-start" }, _o = { class: "cfg-checkbox__checkbox mt-[calc(var(--font-sm-leading)*1px)] flex size-[1.3em] items-center" }, jo = ["id", "disabled"], Ho = ["innerHTML"], Go = {
  key: 0,
  class: "text-red"
}, Uo = /* @__PURE__ */ X({
  inheritAttrs: !1,
  __name: "CfgCheckbox",
  props: /* @__PURE__ */ ye({
    ...Fe,
    inputClasses: {
      type: String,
      default: ""
    },
    focused: {
      type: Boolean,
      default: !1
    },
    link: {
      type: String,
      default: ""
    }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ye(["update:focused"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const d = e, r = t, { class: n, ...a } = ud(), s = j(() => a.id || j1()), l = ed("inputRef"), i = ze(e, "modelValue"), f = j(() => ({
      root: {
        class: n || "",
        ...d.link ? { href: d.link } : {}
      },
      input: a
    })), { focused: p } = ot(l, {
      initialValue: d.initialFocused
    });
    return Ce(p, (m) => {
      r("update:focused", m);
    }), Ce(() => d.focused, (m) => {
      p.value = m;
    }), (m, h) => ($(), _(Oe(e.link ? "a" : "span"), fe(f.value.root, {
      class: ["cfg-checkbox relative block", {
        focused: e.focused,
        disabled: m.disabled,
        "opacity-60": m.disabled,
        "cursor-pointer": !m.disabled,
        "cursor-not-allowed": m.disabled
      }],
      onClick: h[3] || (h[3] = Qe((C) => i.value = !i.value, ["prevent"]))
    }), {
      default: b(() => [
        x("span", Fo, [
          x("label", _o, [
            Ge(x("input", fe({
              id: String(s.value),
              ref_key: "inputRef",
              ref: l,
              "onUpdate:modelValue": h[0] || (h[0] = (C) => i.value = C)
            }, f.value.input, {
              class: ["relative z-10 size-[1.3em] rounded border-grey-stroke text-brand focus:ring-brand-200", e.inputClasses],
              disabled: m.disabled,
              type: "checkbox",
              onClick: h[1] || (h[1] = Qe(() => {
              }, ["stop"]))
            }), null, 16, jo), [
              [v2, i.value]
            ])
          ]),
          x("span", {
            class: z(["ml-3 block text-sm", {
              "text-red": m.error
            }])
          }, [
            y(O, {
              class: z(["block", {
                "cursor-pointer": !m.disabled,
                "cursor-not-allowed": m.disabled,
                "pt-1": !m.caption && !m.$slots.label && !m.placeholder,
                "text-grey-400": !m.error
              }]),
              for: String(s.value),
              size: u(H).sm,
              "tag-name": "label",
              onClick: h[2] || (h[2] = Qe(() => {
              }, ["stop"]))
            }, {
              default: b(() => [
                m.$slots.label || m.placeholder ? W(m.$slots, "label", {
                  key: 0,
                  checked: e.modelValue,
                  focused: e.focused
                }, () => [
                  x("span", {
                    class: "leading-6",
                    innerHTML: m.placeholder
                  }, null, 8, Ho),
                  m.required ? ($(), k("span", Go, "*")) : P("", !0)
                ], !0) : P("", !0)
              ]),
              _: 3
            }, 8, ["class", "for", "size"]),
            m.caption && m.placeholder ? ($(), _(O, {
              key: 0,
              class: z(["mt-1 block", {
                "text-grey-300": !m.error
              }]),
              size: u(H).xs
            }, {
              default: b(() => [
                R(E(m.caption), 1)
              ]),
              _: 1
            }, 8, ["class", "size"])) : P("", !0)
          ], 2)
        ]),
        m.error && m.errorMessage ? ($(), _(O, {
          key: 0,
          class: "mt-3 block text-red",
          size: u(H).xs
        }, {
          default: b(() => [
            R(E(m.errorMessage), 1)
          ]),
          _: 1
        }, 8, ["size"])) : m.caption && !m.placeholder ? ($(), _(O, {
          key: 1,
          class: "mt-3 block text-grey-300",
          size: u(H).xs
        }, {
          default: b(() => [
            R(E(m.caption), 1)
          ]),
          _: 1
        }, 8, ["size"])) : P("", !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), rd = /* @__PURE__ */ h1(Uo, [["__scopeId", "data-v-dd7aa615"]]), Wo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rd
}, Symbol.toStringTag, { value: "Module" })), t1 = {
  default: "brand",
  blue: "blue",
  success: "success",
  warning: "warning",
  danger: "danger",
  neutral: "neutral"
}, Yo = { class: "cfg-assist-chip__content" }, sd = /* @__PURE__ */ X({
  __name: "CfgChip",
  props: {
    label: {},
    color: { default: t1.default }
  },
  setup(e) {
    const t = e, d = j(() => ({
      background: {
        "bg-brand-light": t.color === t1.default,
        "bg-blue/20": t.color === t1.blue,
        "bg-success/20": t.color === t1.success,
        "bg-warning/20": t.color === t1.warning,
        "bg-red/20": t.color === t1.danger,
        "bg-grey-100": t.color === t1.neutral
      },
      text: {
        "text-brand": t.color === t1.default,
        "text-blue": t.color === t1.blue,
        "text-success": t.color === t1.success,
        "text-warning": t.color === t1.warning,
        "text-red": t.color === t1.danger,
        "text-black": t.color === t1.neutral
      }
    }));
    return (r, n) => ($(), k("span", {
      class: z(["cfg-assist-chip rounded-full", { ...d.value.background, ...d.value.text }])
    }, [
      x("span", Yo, [
        r.$slots.leadingIcon ? W(r.$slots, "leadingIcon", { key: 0 }) : P("", !0),
        y(O, {
          size: u(H).xs
        }, {
          default: b(() => [
            r.$slots.default ? W(r.$slots, "default", { key: 0 }) : ($(), k(ae, { key: 1 }, [
              R(E(t.label), 1)
            ], 64))
          ]),
          _: 3
        }, 8, ["size"])
      ])
    ], 2));
  }
}), Ko = { class: "relative block" }, Zo = ["value"], qo = {
  inheritAttrs: !1
}, sn = /* @__PURE__ */ X({
  ...qo,
  __name: "CfgCompactInput",
  props: {
    modelValue: {
      type: String,
      required: !0
    },
    /**
     * @param string
     * Suffix to be displayed after the input. Recommended length is 2-3 characters.
     */
    suffix: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", "blur", "keydown:enter"],
  setup(e, { emit: t }) {
    const d = t;
    function r(s) {
      var l;
      d("update:modelValue", ((l = s == null ? void 0 : s.target) == null ? void 0 : l.value) || "");
    }
    function n(s) {
      var l;
      d("blur", ((l = s == null ? void 0 : s.target) == null ? void 0 : l.value) || "");
    }
    function a(s) {
      var l;
      d("keydown:enter", ((l = s == null ? void 0 : s.target) == null ? void 0 : l.value) || "");
    }
    return (s, l) => {
      var i;
      return $(), k("label", Ko, [
        x("input", fe({
          class: ["cfg-slider__input focusable w-full rounded-md border border-grey-stroke px-3 py-2 text-xs !leading-none", {
            "!pr-11": !!((i = e.suffix) != null && i.trim())
          }],
          value: e.modelValue
        }, s.$attrs, {
          onBlur: n,
          onInput: r,
          onKeydown: m1(a, ["enter"])
        }), null, 16, Zo),
        e.suffix ? ($(), _(O, {
          key: 0,
          class: "absolute right-4 top-1/2 -translate-y-1/2 leading-none text-grey-300",
          size: u(H).xs
        }, {
          default: b(() => [
            R(E(e.suffix), 1)
          ]),
          _: 1
        }, 8, ["size"])) : P("", !0)
      ]);
    };
  }
});
function on(e) {
  return typeof e == "function" ? e() : u(e);
}
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Jo = (e) => e != null;
function Xo(e, t = {}) {
  let d;
  const { immediate: r, ...n } = t, a = de(!1), s = de(!1), l = (h) => d && d.activate(h), i = (h) => d && d.deactivate(h), f = () => {
    d && (d.pause(), s.value = !0);
  }, p = () => {
    d && (d.unpause(), s.value = !1);
  }, m = j(() => {
    const h = on(e);
    return (Array.isArray(h) ? h : [h]).map((C) => {
      const v = on(C);
      return typeof v == "string" ? v : G2(v);
    }).filter(Jo);
  });
  return Ce(
    m,
    (h) => {
      h.length && (d = Ar(h, {
        ...n,
        onActivate() {
          a.value = !0, t.onActivate && t.onActivate();
        },
        onDeactivate() {
          a.value = !1, t.onDeactivate && t.onDeactivate();
        }
      }), r && l());
    },
    { flush: "post" }
  ), U2(() => i()), {
    hasFocus: a,
    isPaused: s,
    activate: l,
    deactivate: i,
    pause: f,
    unpause: p
  };
}
const Qo = ["aria-expanded"], ea = {
  inheritAttrs: !1
}, ta = /* @__PURE__ */ X({
  ...ea,
  __name: "CfgDropdown",
  props: {
    /**
     * Controls the position of the menu;
     */
    originX: {
      type: String,
      default: "right"
    },
    /**
     * Controls showing overlay under other elements
     */
    overlay: {
      type: Boolean,
      default: !1
    },
    maxWidth: {
      type: String,
      default: "280px"
    },
    hideOnScroll: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, { expose: t }) {
    const d = e, r = 50, n = de(!1), a = de(null), s = de(null), l = de(null), i = de(n.value);
    let f = null;
    const { deactivate: p, activate: m } = Xo(l, {
      immediate: !1,
      preventScroll: !0,
      clickOutsideDeactivates: !0
    });
    r1(() => {
      if (Fd(document.documentElement, "keydown", (g) => {
        g.key === "Escape" && T();
      }), d.hideOnScroll) {
        let g = 0;
        Fd(window, "scroll", () => {
          g += 1, g > 3 && (T(), g = 0);
        });
      }
    });
    const { x: h, y: C, strategy: v } = Qd(s, l, {
      placement: "bottom-end",
      whileElementsMounted: e0
    });
    Ce(n, (g) => {
      g || (f && (clearTimeout(f), f = null), f = setTimeout(() => {
        i.value = g;
      }, g ? 0 : r), S() && p()), i.value = g;
    });
    function M() {
      S() && m();
    }
    function S() {
      return l.value && l.value.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').length > 0;
    }
    function L() {
      n.value = !0;
    }
    function T() {
      n.value = !1;
    }
    return t({ open: L, close: T }), (g, I) => ($(), k("div", {
      ref_key: "dropdownRoot",
      ref: a
    }, [
      x("div", fe(g.$attrs, {
        class: ["relative w-max", {
          "z-floating-overlay": n.value && e.overlay
        }]
      }), [
        x("div", {
          ref_key: "menuButton",
          ref: s
        }, [
          x("button", {
            "aria-expanded": n.value,
            class: z(["focusable flex cursor-pointer items-center justify-center", {
              "relative z-floating-trigger rounded-t-xl bg-white": n.value && e.overlay,
              "lg:hover:bor==der-brand rounded-xl hover:!text-brand": !n.value && e.overlay,
              "border-2 border-transparent !transition-all !duration-300": e.overlay
            }]),
            type: "button",
            onClick: I[0] || (I[0] = (N) => n.value ? T() : L())
          }, [
            W(g.$slots, "trigger", { opened: n.value })
          ], 10, Qo)
        ], 512),
        ($(), _(Zd, { to: "body" }, [
          x("div", {
            class: z(["fixed inset-0 z-floating-overlay", {
              "pointer-events-none opacity-0": !n.value,
              "bg-black/30": e.overlay
            }]),
            onClick: T,
            onKeydown: m1(() => {
            }, ["enter"])
          }, null, 34),
          y(N1, {
            "enter-active-class": "transition duration-200 ease-out",
            "enter-from-class": "transform scale-75 -translate-y-3 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100 translate-y-0",
            "leave-active-class": "transition duration-200 ease-out",
            "leave-from-class": "transform scale-100 translate-y-0 opacity-100",
            "leave-to-class": "transform scale-75 -translate-y-3 opacity-0",
            onAfterEnter: M
          }, {
            default: b(() => [
              i.value ? Ge(($(), k("div", {
                key: 0,
                ref_key: "dropdownContent",
                ref: l,
                class: z(["dropdown-content z-floating-content w-max bg-white focus:outline-none", {
                  "origin-top-right": e.originX === "right",
                  "left-0 origin-top-left": e.originX === "left",
                  "mt-2 rounded-xl shadow-extra": !e.overlay,
                  "rounded-b-xl rounded-tl-xl": e.overlay
                }]),
                style: Ue({
                  top: `${u(C)}px`,
                  left: `${u(h)}px`,
                  position: u(v),
                  maxWidth: e.maxWidth
                })
              }, [
                W(g.$slots, "default", {
                  close: T,
                  opened: n.value
                })
              ], 6)), [
                [cd, n.value]
              ]) : P("", !0)
            ]),
            _: 3
          })
        ]))
      ], 16)
    ], 512));
  }
}), da = /* @__PURE__ */ X({
  inheritAttrs: !1,
  __name: "CfgTransition",
  props: {
    from: {},
    to: {},
    rendered: { type: Boolean },
    as: { default: "span" }
  },
  async setup(e) {
    let t, d;
    const r = ([t, d] = ld(() => import("gsap")), t = await t, d(), t).default;
    return (n, a) => ($(), _(N1, {
      css: !1,
      onBeforeEnter: a[0] || (a[0] = (s) => {
        u(r).set(s, n.from);
      }),
      onEnter: a[1] || (a[1] = (s, l) => {
        u(r).to(s, { ...n.to, onComplete: l });
      }),
      onLeave: a[2] || (a[2] = (s, l) => {
        u(r).to(s, {
          ...n.from,
          onComplete: l
        });
      })
    }, {
      default: b(() => [
        n.rendered ? ($(), k("span", A1(fe({ key: 0 }, n.$attrs)), [
          W(n.$slots, "default")
        ], 16)) : P("", !0)
      ]),
      _: 3
    }));
  }
}), na = ["aria-pressed"], ra = { class: "filter-chip__content" }, sa = {
  class: "filter-chip__close-icon",
  style: { "--stroke-width": "2px" }
}, Z9 = /* @__PURE__ */ X({
  __name: "CfgFilterChip",
  props: /* @__PURE__ */ ye({
    label: {}
  }, {
    modelValue: { type: Boolean, type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = ze(e, "modelValue");
    return (d, r) => ($(), k("button", {
      "aria-pressed": t.value,
      class: z(["filter-chip focusabl", {
        "filter-chip--selected !border-brand-light bg-brand-light focus:!border-brand-light": t.value,
        "!border-grey-300 focus:!border-grey-300": !t.value
      }]),
      type: "button",
      onClick: r[0] || (r[0] = () => {
        d.$attrs.disabled || (t.value = !t.value);
      })
    }, [
      x("span", ra, [
        d.$slots.leadingIcon ? W(d.$slots, "leadingIcon", { key: 0 }) : P("", !0),
        y(O, {
          size: u(H).sm,
          "tag-name": "span"
        }, {
          default: b(() => [
            R(E(d.label), 1)
          ]),
          _: 1
        }, 8, ["size"])
      ]),
      y(da, {
        from: {
          width: 0,
          autoAlpha: 0,
          duration: 0.25,
          ease: "power3.out"
        },
        rendered: t.value,
        to: {
          autoAlpha: 1,
          width: 20,
          duration: 0.25,
          ease: "power3.out"
        }
      }, {
        default: b(() => [
          x("span", sa, [
            y(u(u1), { class: "text-[12px] text-grey-400" })
          ])
        ]),
        _: 1
      }, 8, ["rendered"])
    ], 10, na));
  }
}), oa = {
  primary: "primary",
  secondary: "secondary",
  grey: "grey",
  light: "light",
  warning: "warning",
  dark: "dark"
}, aa = { class: "container mx-auto py-3" }, la = { class: "flex flex-wrap items-center justify-between" }, ia = { class: "flex w-0 flex-1 items-center" }, ua = {
  key: 0,
  class: "cfg-header-banner--icon flex rounded-lg p-2"
}, ca = {
  key: 1,
  class: "cfg-header-banner--text ml-3"
}, fa = {
  key: 0,
  class: "order-3 mt-2 w-full shrink-0 sm:order-2 sm:mt-0 sm:w-auto"
}, $a = { class: "order-2 shrink-0 sm:order-3 sm:ml-3" }, q9 = /* @__PURE__ */ X({
  __name: "CfgHeaderBanner",
  props: /* @__PURE__ */ ye({
    variant: { default: oa.primary },
    modelValue: { type: Boolean, default: !0 },
    text: { default: "" },
    buttonText: { default: "" },
    buttonLink: { default: "" }
  }, {
    modelValue: { type: Boolean, default: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = ze(e, "modelValue");
    return (d, r) => {
      const n = b2("RouterLink");
      return Ge(($(), k("div", {
        class: z(["cfg-header-banner", { [`cfg-header-banner--${d.variant}`]: !0 }])
      }, [
        x("div", aa, [
          x("div", la, [
            x("div", ia, [
              d.$slots.icon ? ($(), k("span", ua, [
                W(d.$slots, "icon", {
                  ariaHidden: "true",
                  class: "size-6"
                })
              ])) : P("", !0),
              d.text || d.$slots.default ? ($(), k("p", ca, [
                W(d.$slots, "default", {}, () => [
                  R(E(d.text), 1)
                ])
              ])) : P("", !0)
            ]),
            d.buttonLink ? ($(), k("div", fa, [
              y(n, {
                class: "cfg-header-banner--link flex items-center justify-center rounded-md border border-transparent px-4 py-2 text-sm",
                to: d.buttonLink
              }, {
                default: b(() => [
                  R(E(d.buttonText || d.buttonLink), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])) : P("", !0),
            x("div", $a, [
              x("button", {
                class: "cfg-header-banner--dismiss -mr-1 flex rounded-md p-2 focus:outline-none focus:ring-2 sm:-mr-2",
                type: "button",
                onClick: r[0] || (r[0] = (a) => t.value = !1)
              }, [
                r[1] || (r[1] = x("span", { class: "sr-only" }, "Dismiss", -1)),
                y(u(u1), {
                  "aria-hidden": "true",
                  class: "size-6"
                })
              ])
            ])
          ])
        ])
      ], 2)), [
        [cd, t.value]
      ]);
    };
  }
}), pa = {
  key: 0,
  class: "text-field-template__left top-4 !max-w-[30px]"
}, ma = {
  key: 0,
  class: "text-red"
}, ga = {
  key: 1,
  class: "text-field-template__right absolute top-1/2 flex -translate-y-1/2 items-center justify-center"
}, ha = /* @__PURE__ */ X({
  __name: "AbstractTextField",
  props: {
    required: { type: Boolean },
    placeholder: { default: "" },
    fluid: { type: Boolean },
    error: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    empty: { type: Boolean, default: !0 },
    focused: { type: Boolean },
    placeholderAs: { default: "span" },
    placeholderAttrs: { default: () => ({}) },
    loading: { type: Boolean },
    height: { default: void 0 },
    as: { default: "span" }
  },
  emits: ["update:focused"],
  setup(e, { emit: t }) {
    const d = e, r = t, n = j(() => ({
      "--height": d.height || "var(--input-height)"
    })), a = de(), { focused: s } = ot(a), l = j(() => d.focused || !d.empty);
    return Ce(s, (i) => {
      r("update:focused", i);
    }), (i, f) => {
      var p, m, h, C;
      return $(), _(Oe(i.as), {
        ref_key: "textFieldRef",
        ref: a,
        class: z(["text-field-template relative block rounded-xl text-sm transition-all duration-200", {
          "w-full": i.fluid,
          "w-max": !i.fluid,
          "with-right-content": (m = (p = i.$slots).placeRight) == null ? void 0 : m.call(p),
          "with-left-content": (C = (h = i.$slots).placeLeft) == null ? void 0 : C.call(h),
          "opacity-50": i.disabled
        }]),
        style: Ue(n.value),
        onClick: f[0] || (f[0] = () => {
          s.value = !0;
        }),
        onKeypress: f[1] || (f[1] = m1(() => {
          s.value = !0;
        }, ["enter"]))
      }, {
        default: b(() => [
          i.$slots.placeLeft ? ($(), k("span", pa, [
            W(i.$slots, "placeLeft", {}, void 0, !0)
          ])) : P("", !0),
          ($(), _(Oe(i.placeholderAs), fe(i.placeholderAttrs, {
            class: ["text-field-template__placeholder absolute left-[var(--pl)] origin-top-left -translate-y-1/2 cursor-text leading-none text-grey-200 transition-all duration-200", {
              active: l.value,
              "text-red": i.error,
              "!text-brand": !i.error && l.value && i.focused
            }]
          }), {
            default: b(() => [
              R(E(i.placeholder) + " ", 1),
              i.required ? ($(), k("span", ma, "*")) : P("", !0)
            ]),
            _: 1
          }, 16, ["class"])),
          x("span", {
            class: z(["text-field-template__wrapper block rounded-xl border transition duration-200", {
              "border-grey-stroke": !l.value || !i.focused,
              "border-brand": l.value && i.focused,
              "disabled:border-gray-200 disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-grey-500": i.disabled,
              "error border-red text-red": i.error
            }])
          }, [
            W(i.$slots, "default", {}, void 0, !0)
          ], 2),
          i.$slots.placeRight || i.loading ? ($(), k("span", ga, [
            i.loading ? ($(), _(u(It), {
              key: 0,
              class: "text-[6px] text-brand"
            })) : W(i.$slots, "placeRight", { key: 1 }, void 0, !0)
          ])) : P("", !0)
        ]),
        _: 3
      }, 40, ["class", "style"]);
    };
  }
}), $0 = /* @__PURE__ */ h1(ha, [["__scopeId", "data-v-21ffe7d3"]]), va = { class: "absolute left-3 top-4 z-10" }, ba = { class: "block leading-none" }, ya = ["id", "disabled", "readonly", "tabindex", "type", "value"], xa = { class: "absolute inset-y-0 right-0 flex items-center" }, wa = {
  key: 0,
  class: "block max-w-full pt-1 text-red"
}, Ca = ["innerHTML"], n1 = /* @__PURE__ */ X({
  __name: "CfgInput",
  props: /* @__PURE__ */ ye({
    ...Fe,
    ...Ze,
    fieldClass: {
      type: String,
      default: ""
    },
    /**
     * If false, icon slot will have pointer-events-none class
     * @default false
     */
    interactWithIcon: {
      type: Boolean,
      default: !1
    }
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ye(["input", "focusout", "focusin", "blur", "keydown"], ["update:modelValue"]),
  setup(e, { expose: t, emit: d }) {
    const r = e, n = d, a = j1(), s = ze(e, "modelValue"), l = j(() => r.transformToCommaDelimiter !== void 0 ? r.transformToCommaDelimiter : r.type === "number"), i = j(() => l.value && l.value && r.type === "number" ? "tel" : r.type), f = j(() => l.value ? String(s.value).replaceAll(".", ",") : s.value), p = hn(), m = j(() => !String(s.value).trim().length), h = j(() => !!(p.icon || r.suffix) || r.type === "search" && !m.value), C = de(), { focused: v } = ot(C, {
      initialValue: r.initialFocused
    });
    t({
      focus() {
        v.value = !0;
      }
    }), Ce(v, (g) => {
      n(g ? "focusin" : "focusout");
    });
    function M(g) {
      g && (v.value = !0);
    }
    function S(g) {
      const { value: I } = g.target;
      if (l.value) {
        s.value = L(
          I.replace(/[^0-9,.]/g, "").replaceAll(",", ".")
          // replace comma with dot
        );
        return;
      }
      s.value = I;
    }
    function L(g) {
      const I = g.split(".");
      if (I.length > 1 && I[0] !== "") {
        const N = I[0], Z = I.slice(1).join("");
        return `${N}.${Z}`;
      }
      return g.replaceAll(".", "");
    }
    function T() {
      s.value = "", M(!0);
    }
    return (g, I) => ($(), k("div", {
      class: z({ "w-full": g.fluid, "w-72": !g.fluid })
    }, [
      x("div", va, [
        W(g.$slots, "placeLeft")
      ]),
      y(u($0), {
        as: "label",
        class: z(["cfg-input cursor-text bg-white", { [e.fieldClass]: e.fieldClass }]),
        disabled: g.disabled,
        empty: m.value,
        error: g.error,
        fluid: !0,
        focused: u(v),
        loading: g.loading,
        placeholder: g.placeholder,
        "placeholder-as": "span",
        "placeholder-attrs": { for: u(a) },
        readonly: g.readonly,
        required: g.required,
        "onUpdate:focused": M
      }, Dt({
        default: b(() => [
          x("span", ba, [
            x("input", fe({
              id: u(a),
              ref_key: "inputRef",
              ref: C,
              class: "cfg-input__input h-[1em] w-full border-none bg-transparent p-0 leading-none outline-none focus:border-none focus:outline-none focus:ring-0 focus-visible:outline-none",
              disabled: g.disabled,
              readonly: g.readonly,
              tabindex: g.readonly ? -1 : 0,
              type: i.value,
              value: f.value
            }, g.$attrs.autocomplete ? {
              autocomplete: g.$attrs.autocomplete
            } : {}, {
              onBlur: I[0] || (I[0] = (N) => n("blur")),
              onFocusin: I[1] || (I[1] = (N) => v.value = !0),
              onFocusout: I[2] || (I[2] = (N) => v.value = !1),
              onInput: S,
              onKeydown: I[3] || (I[3] = (N) => n("keydown", N))
            }), null, 16, ya)
          ])
        ]),
        _: 2
      }, [
        g.$slots.placeLeft ? {
          name: "placeLeft",
          fn: b(() => []),
          key: "0"
        } : void 0,
        h.value ? {
          name: "placeRight",
          fn: b(() => [
            x("div", xa, [
              g.suffix ? ($(), k("span", {
                key: 0,
                id: "price-currency",
                class: z(["text-grey-500 sm:text-sm", { "pointer-events-none": !e.interactWithIcon }])
              }, E(g.suffix), 3)) : P("", !0),
              g.type === "search" && String(s.value).length ? ($(), _(I1, {
                key: 1,
                flat: "",
                text: "",
                onClick: T
              }, {
                default: b(() => [
                  y(u(u1))
                ]),
                _: 1
              })) : g.$slots.icon ? W(g.$slots, "icon", {
                key: 2,
                class: z({ "pointer-events-none": !e.interactWithIcon })
              }) : P("", !0)
            ])
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["class", "disabled", "empty", "error", "focused", "loading", "placeholder", "placeholder-attrs", "readonly", "required"]),
      g.error && g.errorMessage ? ($(), k("small", wa, E(g.errorMessage), 1)) : P("", !0),
      !(g.errorMessage && g.error) && g.caption ? ($(), k("small", {
        key: 1,
        class: "block max-w-full pt-1 text-grey-300",
        innerHTML: g.caption
      }, null, 8, Ca)) : P("", !0)
    ], 2));
  }
}), J9 = /* @__PURE__ */ X({
  __name: "CfgOtpInput",
  props: /* @__PURE__ */ ye({
    placeholder: {},
    disabled: { type: Boolean },
    size: { default: 6 },
    error: { type: Boolean, default: !1 },
    inputClass: { default: "" }
  }, {
    modelValue: { default: [] },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ye(["complete"], ["update:modelValue"]),
  setup(e) {
    const t = ze(e, "modelValue");
    return (d, r) => ($(), _(u(ar), {
      modelValue: t.value,
      "onUpdate:modelValue": r[0] || (r[0] = (n) => t.value = n),
      class: "flex items-center gap-x-4",
      otp: "",
      type: "number",
      onComplete: r[1] || (r[1] = (n) => d.$emit("complete", n))
    }, {
      default: b(() => [
        ($(!0), k(ae, null, he(d.size, (n, a) => ($(), _(u(lr), {
          key: n,
          class: z(["size-14 rounded-lg border-[#e8e8f0] bg-white text-center focus:border-[#e8e8f0] focus:outline focus:outline-2 focus:outline-offset-0 focus:outline-brand", {
            [d.inputClass]: !0,
            "shadow-[0_2px_0_0_#D16363]": d.error
          }]),
          index: a
        }, null, 8, ["class", "index"]))), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), ka = { class: "flex items-center gap-x-4" }, Sa = { class: "-m-3 flex grow justify-center gap-x-1 overflow-auto p-3 transition-all md:gap-x-2.5" }, Ma = /* @__PURE__ */ X({
  __name: "CfgPagination",
  props: {
    page: {},
    totalItems: {},
    itemsPerPage: {},
    goToPage: { type: Boolean, default: !1 }
  },
  emits: ["update:page"],
  setup(e, { emit: t }) {
    const d = e, r = t, n = de(d.page), a = j(() => Array.from({
      length: Math.ceil(d.totalItems / d.itemsPerPage)
    })), s = j(() => {
      const C = Math.ceil(d.totalItems / d.itemsPerPage), v = 1, M = [], S = 5 + v * 2;
      let L = C <= S ? 1 : d.page - v, T = C <= S ? C : d.page + v;
      if (T = T > C ? C : T, L = L < 1 ? 1 : L, C > S) {
        const g = L - 1 < 3, I = C - T < 3;
        if (g) {
          T = S - 2;
          for (let N = 1; N < L; N++)
            M.push(N);
        } else
          M.push(1), M.push(null);
        if (I) {
          L = C - (S - 3);
          for (let N = L; N <= C; N++)
            M.push(N);
        } else {
          for (let N = L; N <= T; N++)
            M.push(N);
          M.push(null), M.push(C);
        }
      } else
        for (let g = L; g <= T; g++)
          M.push(g);
      return M;
    }), l = j(() => d.page > 1), i = j(() => d.page < a.value.length);
    function f() {
      if (l.value) {
        const C = d.page - 1;
        n.value = C, r("update:page", C);
      }
    }
    function p() {
      if (i.value) {
        const C = d.page + 1;
        n.value = C, r("update:page", C);
      }
    }
    function m(C) {
      r("update:page", C);
    }
    function h() {
      const C = Number(n.value), v = d.page;
      C && C > 0 && C <= a.value.length && C !== v ? r("update:page", C) : C > a.value.length && r("update:page", a.value.length);
    }
    return (C, v) => ($(), k("nav", ka, [
      x("button", {
        "aria-label": "Předchozí stránka",
        class: z(["focusable hidden rounded-md px-2 text-lg text-brand md:block", {
          "cursor-not-allowed opacity-50": !l.value
        }]),
        type: "button",
        onClick: f
      }, [
        y(u(Ct))
      ], 2),
      x("ul", Sa, [
        ($(!0), k(ae, null, he(s.value, (M, S) => ($(), k("li", {
          key: M || S
        }, [
          ($(), _(Oe(M ? "a" : "span"), {
            class: z(["rounded-md border py-[0.5em] text-sm font-highlighted leading-none transition-colors duration-200", {
              "text-brand": M === C.page,
              "border-[transparent] text-grey-300": M !== C.page,
              "lg:hover:border-grey-stroke lg:hover:text-grey-400": C.page && M !== C.page,
              "focusable px-3": C.page
            }]),
            href: `page=${M}`,
            onClick: Qe((L) => M && m(M), ["prevent"])
          }, {
            default: b(() => [
              x("span", null, E(M || "..."), 1)
            ]),
            _: 2
          }, 1032, ["class", "href", "onClick"]))
        ]))), 128))
      ]),
      x("button", {
        "aria-label": "Další stránka",
        class: z(["focusable hidden rounded-md px-2 text-lg text-brand md:block", {
          "cursor-not-allowed opacity-50": !i.value
        }]),
        type: "button",
        onClick: p
      }, [
        y(u(D1))
      ], 2),
      d.goToPage ? ($(), _(n1, {
        key: 0,
        modelValue: n.value,
        "onUpdate:modelValue": v[0] || (v[0] = (M) => n.value = M),
        class: "max-w-[130px]",
        placeholder: "Přejít na stránku:",
        "transform-to-comma-delimiter": !1,
        type: "number",
        onBlur: h,
        onKeyup: m1(h, ["enter"])
      }, null, 8, ["modelValue"])) : P("", !0)
    ]));
  }
}), Ta = { class: "cfg-radio flex gap-x-3" }, La = ["for"], Aa = ["id", "checked", "disabled"], Da = ["for"], Ia = ["innerHTML"], Ea = {
  inheritAttrs: !1
}, za = /* @__PURE__ */ X({
  ...Ea,
  __name: "CfgRadio",
  props: {
    ...Ze,
    modelValue: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const d = e, r = t, n = ud(), a = j(() => n.id || j1()), s = de();
    ot(s, {
      initialValue: d.initialFocused
    });
    function l(i) {
      var f;
      r("update:modelValue", ((f = i == null ? void 0 : i.target) == null ? void 0 : f.checked) ?? !d.modelValue);
    }
    return (i, f) => ($(), k("div", null, [
      x("div", Ta, [
        x("label", {
          class: "block",
          for: a.value
        }, [
          x("input", fe({ id: a.value }, i.$attrs, {
            ref_key: "inputRef",
            ref: s,
            checked: e.modelValue,
            class: ["focusable size-5 border-grey-stroke text-brand", {
              "!border-red": i.error
            }],
            disabled: i.disabled,
            type: "radio",
            onChange: l
          }), null, 16, Aa)
        ], 8, La),
        i.$slots.default || e.placeholder ? ($(), k("label", {
          key: 0,
          class: z(["block", {
            "text-dark-100": e.modelValue,
            "text-grey-300": !e.modelValue,
            "!text-red": i.error
          }]),
          for: a.value
        }, [
          y(O, {
            class: z({
              "opacity-40": i.disabled,
              "cursor-pointer": !i.disabled,
              "cursor-not-allowed": i.disabled,
              "text-grey-400": !i.error
            }),
            size: u(H).sm
          }, {
            default: b(() => [
              W(i.$slots, "default", {}, () => [
                x("span", { innerHTML: e.placeholder }, null, 8, Ia)
              ])
            ]),
            _: 3
          }, 8, ["class", "size"]),
          i.caption ? ($(), _(O, {
            key: 0,
            class: z(["mt-1 block", {
              "text-grey-300": !i.error
            }]),
            size: u(H).xs
          }, {
            default: b(() => [
              R(E(i.caption), 1)
            ]),
            _: 1
          }, 8, ["class", "size"])) : P("", !0)
        ], 10, Da)) : P("", !0)
      ]),
      i.error && i.errorMessage ? ($(), _(O, {
        key: 0,
        class: "mt-3 block text-red",
        size: u(H).xs
      }, {
        default: b(() => [
          R(E(i.errorMessage), 1)
        ]),
        _: 1
      }, 8, ["size"])) : i.caption && !e.placeholder ? ($(), _(O, {
        key: 1,
        class: "mt-3 block text-grey-300",
        size: u(H).xs
      }, {
        default: b(() => [
          R(E(i.caption), 1)
        ]),
        _: 1
      }, 8, ["size"])) : P("", !0)
    ]));
  }
}), Ba = /* @__PURE__ */ X({
  __name: "CfgScrollbarView",
  props: {
    as: { default: "div" }
  },
  setup(e, { expose: t }) {
    const d = de(void 0), r = de(0);
    r1(() => {
      var a;
      (a = d.value) == null || a.addEventListener("scroll", n);
    }), id(() => {
      var a;
      (a = d.value) == null || a.removeEventListener("scroll", n);
    }), t({
      scrollPositionY: r
    });
    function n() {
      var a;
      r.value = ((a = d.value) == null ? void 0 : a.scrollTop) || 0;
    }
    return (a, s) => ($(), _(Oe(a.as), {
      ref_key: "scrollbarView",
      ref: d,
      class: "cfg-scrollbar-view overflow-y-auto"
    }, {
      default: b(() => [
        W(a.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 512));
  }
}), Pa = /* @__PURE__ */ h1(Ba, [["__scopeId", "data-v-1c2ab057"]]), Q1 = /* @__PURE__ */ X({
  __name: "CfgSeparator",
  props: {
    negativeMargin: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (t, d) => ($(), k("hr", {
      class: z(["my-6 border-t-2 border-stroke-gray", {
        "max-md:-mx-5": t.negativeMargin
      }])
    }, null, 2));
  }
}), Va = { class: "sr-only" }, Oa = { class: "absolute left-0 top-0 size-full rounded-[inherit] bg-[inherit]" }, Ra = ["innerHTML"], X9 = /* @__PURE__ */ X({
  __name: "CfgSwitch",
  props: /* @__PURE__ */ ye(Fe, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, d = ze(e, "modelValue"), r = de();
    return ot(r, {
      initialValue: t.initialFocused
    }), (n, a) => ($(), _(u(br), null, {
      default: b(() => [
        x("div", {
          class: z(["flex gap-x-4 gap-y-3", {
            "flex-col": !n.placeholder,
            "cursor-pointer": !n.disabled,
            "cursor-not-allowed": n.disabled
          }])
        }, [
          y(u(yr), {
            ref_key: "inputRef",
            ref: r,
            modelValue: d.value,
            "onUpdate:modelValue": a[0] || (a[0] = (s) => d.value = s),
            class: z(["cfg-switch relative inline-flex h-[27px] w-11 shrink-0 rounded-full border-[3px] border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-brand focus:ring-offset-2", {
              "cfg-switch--selected": d.value,
              "!bg-red/10": n.error
            }]),
            disabled: n.disabled
          }, {
            default: b(() => [
              x("span", Va, E(n.placeholder), 1),
              x("span", {
                "aria-hidden": "true",
                class: z(["cfg-switch__swiper pointer-events-none mx-0 inline-block size-[calc(27px-6px)] rounded-full ring-0 transition duration-200 ease-in-out", {
                  "translate-x-4 bg-brand text-white": d.value,
                  "translate-x-0 bg-white text-grey-300": !d.value,
                  "bg-red": n.error && d.value
                }])
              }, [
                x("span", Oa, [
                  e.modelValue ? W(n.$slots, "enabled", { key: 0 }) : W(n.$slots, "disabled", { key: 1 })
                ])
              ], 2)
            ]),
            _: 3
          }, 8, ["modelValue", "class", "disabled"]),
          x("div", null, [
            n.placeholder ? ($(), _(u(xr), {
              key: 0,
              class: "flex items-center"
            }, {
              default: b(() => [
                y(O, {
                  class: z({
                    "opacity-40": n.disabled,
                    "cursor-pointer": !n.disabled,
                    "cursor-not-allowed": n.disabled,
                    "text-red": n.error,
                    "text-grey-400": !n.error
                  }),
                  size: u(H).sm
                }, {
                  default: b(() => [
                    R(E(n.placeholder), 1)
                  ]),
                  _: 1
                }, 8, ["class", "size"])
              ]),
              _: 1
            })) : P("", !0),
            n.caption || n.error && n.errorMessage ? ($(), _(u(wr), {
              key: 1,
              class: "cursor-text"
            }, {
              default: b(() => [
                n.caption && !(n.error && n.errorMessage) ? ($(), _(O, {
                  key: 0,
                  class: z(["mt-1 block cursor-text text-grey-300", { "mt-0": !n.placeholder }]),
                  size: u(H).xs
                }, {
                  default: b(() => [
                    x("span", { innerHTML: n.caption }, null, 8, Ra)
                  ]),
                  _: 1
                }, 8, ["class", "size"])) : n.errorMessage && n.error ? ($(), _(O, {
                  key: 1,
                  class: z(["mt-1 block cursor-text text-red", { "mt-0": !n.placeholder }]),
                  size: u(H).xs
                }, {
                  default: b(() => [
                    R(E(n.errorMessage), 1)
                  ]),
                  _: 1
                }, 8, ["class", "size"])) : P("", !0)
              ]),
              _: 1
            })) : P("", !0)
          ])
        ], 2)
      ]),
      _: 3
    }));
  }
}), Un = {
  required: {
    type: Boolean,
    default: !1
  },
  /**
   * Placeholder text
   */
  placeholder: {
    type: String,
    default: ""
  },
  /**
   * Field error state (will show error message if provided and set to true)
   */
  error: {
    type: Boolean,
    default: !1
  },
  /**
   * Field error message
   */
  errorMessage: {
    type: String,
    default: ""
  },
  /**
   * Caption text. Will be shown below input. Recommended length is 2-3 words, like 'Enter your name'.
   * In case of error, will be replaced with error message
   */
  caption: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  /**
   * Will set input focus on mount
   */
  initialFocused: {
    type: Boolean,
    default: !1
  },
  loading: {
    type: Boolean,
    default: !1
  }
}, Na = {
  ...Un,
  /**
   * Will make input fluid (100% width)
   */
  fluid: {
    type: Boolean,
    default: !1
  },
  readonly: {
    type: Boolean,
    default: !1
  }
}, Fa = { class: "block leading-none" }, _a = ["id", "disabled", "readonly", "tabindex", "value"], ja = {
  key: 0,
  class: "block max-w-full pt-1 text-red"
}, Ha = ["innerHTML"], Q9 = /* @__PURE__ */ X({
  __name: "CfgTextarea",
  props: /* @__PURE__ */ ye({
    ...Un,
    ...Na,
    fieldClass: {
      type: String,
      default: ""
    },
    minHeight: {
      type: Number,
      default: 100
    }
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ye(["input", "focusout", "focusin", "blur", "keydown"], ["update:modelValue"]),
  setup(e, { expose: t, emit: d }) {
    const r = e, n = d, a = j1(), s = ze(e, "modelValue"), l = j(() => !String(s.value).trim().length), { textarea: i, input: f } = W2(), { focused: p } = ot(i, {
      initialValue: r.initialFocused
    }), { height: m } = Xd(i);
    t({
      focus() {
        p.value = !0;
      }
    }), Ce(p, (v) => {
      n(v ? "focusin" : "focusout");
    });
    function h(v) {
      v && (p.value = !0);
    }
    function C(v) {
      const { value: M } = v.target;
      f.value = M, s.value = M;
    }
    return (v, M) => ($(), k("div", {
      class: z({ "w-full": v.fluid, "w-72": !v.fluid })
    }, [
      y(u($0), {
        caption: v.caption,
        class: z(["cfg-input cursor-text bg-white", { [e.fieldClass]: e.fieldClass }]),
        disabled: v.disabled,
        empty: l.value,
        error: v.error,
        fluid: !0,
        focused: u(p),
        height: `${u(m)}px`,
        loading: v.loading,
        placeholder: v.placeholder,
        "placeholder-as": "label",
        "placeholder-attrs": { for: u(a) },
        readonly: v.readonly,
        required: v.required,
        "onUpdate:focused": h
      }, {
        default: b(() => [
          x("label", Fa, [
            x("textarea", {
              id: u(a),
              ref_key: "textareaRef",
              ref: i,
              class: "w-full resize-none border-none bg-transparent p-0 outline-none focus:border-none focus:outline-none focus:ring-0 focus-visible:outline-none",
              disabled: v.disabled,
              readonly: v.readonly,
              style: Ue({ minHeight: `${e.minHeight}px` }),
              tabindex: v.readonly ? -1 : 0,
              value: s.value,
              onBlur: M[0] || (M[0] = (S) => n("blur")),
              onFocusin: M[1] || (M[1] = (S) => p.value = !0),
              onFocusout: M[2] || (M[2] = (S) => p.value = !1),
              onInput: C,
              onKeydown: M[3] || (M[3] = (S) => n("keydown", S))
            }, null, 44, _a)
          ])
        ]),
        _: 1
      }, 8, ["caption", "class", "disabled", "empty", "error", "focused", "height", "loading", "placeholder", "placeholder-attrs", "readonly", "required"]),
      v.error && v.errorMessage ? ($(), k("small", ja, E(v.errorMessage), 1)) : P("", !0),
      !(v.errorMessage && v.error) && v.caption ? ($(), k("small", {
        key: 1,
        class: "block max-w-full pt-1 text-grey-300",
        innerHTML: v.caption
      }, null, 8, Ha)) : P("", !0)
    ], 2));
  }
}), Ga = { class: "mx-auto flex max-w-[310px] shrink-0 flex-col items-center text-center sm:max-w-[360px]" }, Ua = { class: "mx-auto flex max-w-[500px] grow flex-col items-center justify-center py-10 text-center" }, Wa = ["innerHTML"], e5 = /* @__PURE__ */ X({
  __name: "CfgApplicationError",
  props: {
    header: {},
    headerClasses: {},
    statusCode: {},
    statusCodeClasses: {},
    title: {},
    titleClasses: {},
    description: {},
    descriptionClasses: {},
    buttonLabel: {},
    buttonClasses: {}
  },
  emits: ["error"],
  setup(e, { emit: t }) {
    const d = t;
    return (r, n) => ($(), k(ae, null, [
      x("header", Ga, [
        W(r.$slots, "logo"),
        r.header ? ($(), _(O, {
          key: 0,
          class: z(["mt-5 text-grey-400 md:mt-7", r.headerClasses]),
          html: r.header,
          size: u(H).h4,
          "tag-name": "p"
        }, null, 8, ["class", "html", "size"])) : P("", !0)
      ]),
      x("main", Ua, [
        x("span", {
          class: z(["text-[120px] font-highlighted leading-none text-grey-200 opacity-10 sm:text-[240px]", [r.statusCodeClasses]])
        }, E(r.statusCode), 3),
        W(r.$slots, "title", {}, () => [
          y(O, {
            class: z(["page-not-found__title -mt-[7%] sm:-mt-[12%]", [r.titleClasses]]),
            html: r.title,
            size: u(H).h1,
            "tag-name": "h1"
          }, null, 8, ["class", "html", "size"])
        ]),
        W(r.$slots, "description", {}, () => [
          y(O, {
            class: z(["mt-5 text-dark-200 md:mt-6", [r.descriptionClasses]]),
            size: u(H).md,
            "tag-name": "p"
          }, {
            default: b(() => [
              x("span", { innerHTML: r.description }, null, 8, Wa)
            ]),
            _: 1
          }, 8, ["class", "size"])
        ]),
        r.buttonLabel ? ($(), _(u(I1), {
          key: 0,
          class: z(["mt-10", [r.buttonClasses]]),
          variant: "primary",
          onClick: n[0] || (n[0] = (a) => d("error"))
        }, {
          default: b(() => [
            R(E(r.buttonLabel), 1)
          ]),
          _: 1
        }, 8, ["class"])) : P("", !0)
      ])
    ], 64));
  }
});
var R1 = /* @__PURE__ */ ((e) => (e.register = "register", e.unregister = "unregister", e.errorChanged = "error:changed", e))(R1 || {});
const Ya = /* @__PURE__ */ X({
  __name: "CfgValidationObserver",
  emits: ["error:changed", "submit"],
  setup(e, { expose: t, emit: d }) {
    const r = d, n = de([]), a = j(() => n.value.some(({ error: M }) => M)), s = de(!1), l = {
      [R1.register]: p,
      [R1.unregister]: m,
      [R1.errorChanged]: i
    };
    t({
      resetForm: C,
      async submit() {
        return f();
      }
    }), Ce(a, (M) => r("error:changed", M));
    function i(M) {
      const S = n.value.find((L) => L.name === M.name);
      S && (S.error = M.error);
    }
    async function f() {
      var S;
      return await h(), v() ? (r("submit"), !0) : ((S = n.value.find(({ error: L }) => L)) == null || S.focus(), !1);
    }
    function p(M) {
      n.value.find((S) => S.name === M.name) || n.value.push(M);
    }
    function m(M) {
      n.value = n.value.filter((S) => S.name !== M);
    }
    async function h() {
      s.value = !0, await Promise.all(n.value.map((M) => M.forceValidate())), s.value = !1;
    }
    function C() {
      n.value.forEach((M) => M.reset());
    }
    function v() {
      return !a.value;
    }
    return (M, S) => W(M.$slots, "default", {
      on: l,
      submit: f,
      validationLoading: s.value
    });
  }
}), p0 = {
  validators: {
    type: Array,
    default: () => []
  }
}, Wn = /* @__PURE__ */ X({
  __name: "CfgValidationProvider",
  props: /* @__PURE__ */ ye(p0, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ye(["error:changed", "register", "unregister"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const d = e, r = t, n = j1(), a = ze(e, "modelValue"), s = bt(a.value), l = Nd(!1), i = de(!1), f = de(!1), p = de(""), m = j(() => i.value && f.value);
    let h = null;
    const C = ed("providerRef");
    y2(() => {
      r(R1.register, {
        name: n,
        error: f.value,
        reset: L,
        async forceValidate() {
          return i.value = !0, S();
        },
        focus() {
          h == null || h.focus();
        }
      });
    }), r1(() => {
      P1(() => {
        var T;
        h = (T = C.value) == null ? void 0 : T.querySelector("input");
      });
    }), id(() => r(R1.unregister, n)), Ce(() => a.value, S, { immediate: !0, deep: !0 }), Ce(f, (T) => r(R1.errorChanged, {
      name: n,
      error: T
    }));
    function v(T) {
      a.value = T;
    }
    function M() {
      i.value = !0;
    }
    async function S() {
      let T = !1, g = "";
      const I = i.value;
      l.value = !0;
      const N = d.validators.some((Z) => Z.constructor.name === "AsyncFunction");
      N && (i.value = !1);
      for await (const Z of d.validators) {
        let Y;
        if (Z.constructor.name === "AsyncFunction" ? Y = await Z(a.value || "") : Y = Z(a.value || ""), typeof Y == "string") {
          T = !0, g = Y;
          break;
        }
      }
      return f.value = T, p.value = g, l.value = !1, N && (i.value = I), T;
    }
    function L() {
      i.value = !1, f.value = !1, p.value = "", a.value = bt(s);
    }
    return (T, g) => ($(), k("div", {
      ref_key: "providerRef",
      ref: C
    }, [
      W(T.$slots, "default", {
        attrs: {
          error: m.value,
          errorMessage: p.value,
          modelValue: a.value,
          loading: l.value
        },
        on: {
          "update:modelValue": v,
          change: M
        }
      })
    ], 512));
  }
}), Ka = {
  "aria-label": "Breadcrumb",
  class: "flex text-grey-300"
}, Za = { class: "flex items-center space-x-3 overflow-hidden" }, qa = { class: "shrink-0" }, Ja = { key: 0 }, t5 = /* @__PURE__ */ X({
  __name: "CfgBreadcrumbs",
  props: {
    pages: {
      type: Array,
      required: !0
    },
    /**
     * Text to display for the homepage link. If not provided, the home icon will be used.
     */
    homepageText: {
      type: [String, null],
      default: null
    }
  },
  emits: ["link:click"],
  setup(e, { emit: t }) {
    const d = t;
    function r(n) {
      d("link:click", n);
    }
    return (n, a) => ($(), k("nav", Ka, [
      x("ol", Za, [
        x("li", qa, [
          y(O, {
            size: u(H).sm,
            "tag-name": "div"
          }, {
            default: b(() => [
              x("a", {
                class: "lg:transition lg:hover:text-brand",
                href: "/",
                onClick: a[0] || (a[0] = Qe((s) => r("/"), ["prevent"]))
              }, [
                e.homepageText ? ($(), k("span", Ja, E(e.homepageText), 1)) : ($(), k(ae, { key: 1 }, [
                  y(u(M2), {
                    "aria-hidden": "true",
                    class: "shrink-0 text-[1.25em]"
                  }),
                  a[1] || (a[1] = x("span", { class: "sr-only" }, "Home", -1))
                ], 64))
              ])
            ]),
            _: 1
          }, 8, ["size"])
        ]),
        ($(!0), k(ae, null, he(e.pages, (s) => ($(), k("li", {
          key: s.name,
          class: "min-w-0 max-w-[50%] shrink-0 last:max-w-full last:shrink last:grow"
        }, [
          y(O, {
            class: "flex items-center",
            size: u(H).xs,
            "tag-name": "div"
          }, {
            default: b(() => [
              y(u(D1), {
                "aria-hidden": "true",
                class: "shrink-0 text-[1.3em]"
              }),
              ($(), _(Oe(s.current ? "span" : "a"), fe({ ref_for: !0 }, s.current ? {} : { href: s.path }, {
                "aria-current": s.current ? "page" : void 0,
                class: ["ml-2 truncate", {
                  "lg:transition lg:hover:text-brand": !s.current
                }],
                onClick: Qe((l) => !s.current && r(s.path), ["prevent"])
              }), {
                default: b(() => [
                  R(E(s.name), 1)
                ]),
                _: 2
              }, 1040, ["aria-current", "class", "onClick"]))
            ]),
            _: 2
          }, 1032, ["size"])
        ]))), 128))
      ])
    ]));
  }
}), Xa = { class: "hide-scrollbar mt-3 flex overflow-x-auto" }, Qa = ["onClick"], d5 = /* @__PURE__ */ X({
  __name: "CfgButtonsGroup",
  props: {
    values: {}
  },
  emits: ["input"],
  setup(e, { emit: t }) {
    const d = t, r = de("");
    function n(a) {
      d("input", a), r.value = a;
    }
    return (a, s) => ($(), k(ae, null, [
      W(a.$slots, "default", { value: r.value }),
      x("div", Xa, [
        ($(!0), k(ae, null, he(a.values, (l) => ($(), k("button", {
          key: l,
          class: "m-1 rounded-xl border border-grey-stroke px-3 py-2",
          type: "button",
          onClick: (i) => n(l)
        }, E(l), 9, Qa))), 128))
      ])
    ], 64));
  }
}), el = { class: "space-y-3" }, n5 = /* @__PURE__ */ X({
  __name: "CfgCheckboxGroup",
  props: /* @__PURE__ */ ye({
    ...Fe,
    /**
     * Name of the radio group (will be used as name attribute for all radio buttons)
     */
    name: {
      type: String,
      default: () => j1()
    },
    /**
     * Radio group items
     */
    options: {
      type: Array,
      default: () => []
    },
    layout: {
      type: String,
      default: "row"
    }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, d = ze(e, "modelValue"), r = j(() => t.options.map((a) => ({
      ...a,
      checked: d.value.includes(a.value)
    })));
    function n(a, s) {
      if (!a) {
        d.value = d.value.filter((l) => l !== s);
        return;
      }
      d.value.push(s);
    }
    return (a, s) => ($(), k("div", el, [
      x("div", null, [
        y(O, {
          class: z({
            "text-grey-200": !a.error,
            "text-red": a.error
          }),
          size: u(H).md
        }, {
          default: b(() => [
            R(E(a.placeholder), 1)
          ]),
          _: 1
        }, 8, ["class", "size"]),
        a.caption ? ($(), _(O, {
          key: 0,
          class: "mt-1 block pb-1 text-grey-300",
          size: u(H).xs
        }, {
          default: b(() => [
            R(E(a.caption), 1)
          ]),
          _: 1
        }, 8, ["size"])) : P("", !0)
      ]),
      x("div", {
        class: z({
          "flex flex-wrap gap-x-7 gap-y-4": e.layout === "row",
          "space-y-4": e.layout === "column"
        })
      }, [
        ($(!0), k(ae, null, he(r.value, (l) => ($(), k("div", {
          key: l.value
        }, [
          y(rd, {
            disabled: a.disabled || l.disabled,
            "model-value": l.checked,
            name: e.name,
            placeholder: l.label,
            value: l.value,
            "onUpdate:modelValue": (i) => n(i, l.value)
          }, null, 8, ["disabled", "model-value", "name", "placeholder", "value", "onUpdate:modelValue"])
        ]))), 128))
      ], 2),
      a.error && a.errorMessage ? ($(), _(O, {
        key: 0,
        class: "mt-3 block text-red",
        size: u(H).xs
      }, {
        default: b(() => [
          R(E(a.errorMessage), 1)
        ]),
        _: 1
      }, 8, ["size"])) : P("", !0)
    ]));
  }
}), tl = { class: "flex flex-wrap gap-2" }, dl = ["for"], nl = ["id", "aria-label", "checked", "name", "type", "value", "onChange"], r5 = /* @__PURE__ */ X({
  __name: "CfgChipsToggle",
  props: {
    id: {},
    options: {},
    isMultiple: {},
    modelValue: {},
    name: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const d = e, r = t, n = j(() => d.id || `chips-toggle-${Math.random().toString(36).substr(2, 9)}`), a = j(() => d.name || n.value), s = j(() => d.options.map((i) => ({
      ...i,
      isSelected: i.value === d.modelValue
    }))), l = j(() => d.isMultiple ? "checkbox" : "radio");
    if (d.isMultiple)
      throw new Error("Multiple chips toggle is not implemented yet");
    return (i, f) => ($(), k("div", tl, [
      ($(!0), k(ae, null, he(s.value, ({ isSelected: p, label: m, value: h }, C) => ($(), k("label", {
        key: h,
        class: z(["relative block cursor-pointer overflow-hidden rounded-full border leading-none ring-offset-4 transition duration-200 focus-within:ring focus-within:ring-brand/30 hover:-translate-y-1", {
          "border-brand bg-brand text-white": p,
          "border-grey-stroke bg-white": !p
        }]),
        for: `${n.value}-${C}`
      }, [
        y(O, {
          class: "block px-[1em] py-[0.75em]",
          size: u(H).sm,
          "tag-name": "span"
        }, {
          default: b(() => [
            W(i.$slots, "default", { label: m }, () => [
              x("input", {
                id: `${n.value}-${C}`,
                "aria-label": m,
                checked: p,
                class: "absolute -top-5 opacity-0",
                name: a.value,
                type: l.value,
                value: m,
                onChange: (v) => r("update:modelValue", h)
              }, null, 40, nl),
              R(" " + E(m), 1)
            ])
          ]),
          _: 2
        }, 1032, ["size"])
      ], 10, dl))), 128))
    ]));
  }
});
var Y1 = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e.Large = "large", e.XLarge = "xlarge", e))(Y1 || {});
const rl = { class: "fixed inset-0 z-10 overflow-y-auto" }, sl = {
  key: 0,
  class: "absolute right-3 top-3 z-20 mb-2 md:right-5 md:top-5"
}, ol = {
  key: 0,
  class: "mx-auto mb-5 flex size-[2em] items-center justify-center rounded-full bg-brand-opacity text-[1.5em] text-brand"
}, s5 = /* @__PURE__ */ X({
  __name: "CfgDialog",
  props: {
    opened: {
      type: Boolean,
      required: !0
    },
    initialFocus: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    closable: {
      type: Boolean,
      default: !0
    },
    unmount: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      default: Y1.Small
    },
    /**
     * If true, the dialog will not have a
     * padding and the close button will be moved to the top right corner.
     */
    flat: {
      type: Boolean,
      default: !1
    },
    width: {
      type: String,
      default: void 0
    },
    isFullScreen: {
      type: Boolean,
      default: !1
    },
    minimalHeader: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:opened", "close-click:button", "close-click:backdrop", "after-close-animation"],
  setup(e, { emit: t }) {
    const d = e, r = t;
    function n(a) {
      if (d.closable) {
        switch (a) {
          case "button":
            r("close-click:button");
            break;
          case "backdrop":
            r("close-click:backdrop");
            break;
        }
        r("update:opened", !1);
      }
    }
    return (a, s) => ($(), _(u(t0), {
      as: "template",
      show: e.opened
    }, {
      default: b(() => [
        y(u(d0), {
          as: "div",
          class: "relative z-modal",
          unmount: !!e.unmount,
          onClose: s[3] || (s[3] = (l) => n("backdrop"))
        }, {
          default: b(() => [
            y(u(nt), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: b(() => s[4] || (s[4] = [
                x("div", { class: "fixed inset-0 bg-dark/60 transition-opacity sm:backdrop-blur" }, null, -1)
              ])),
              _: 1
            }),
            x("div", rl, [
              e.closable && e.flat ? ($(), k("div", sl, [
                x("button", {
                  class: "flex size-11 items-center justify-center rounded-full bg-grey-100 ring-brand focus-visible:outline-brand focus-visible:ring",
                  type: "button",
                  onClick: s[0] || (s[0] = (l) => n("button"))
                }, [
                  y(u(u1))
                ])
              ])) : P("", !0),
              x("div", {
                class: z(["flex min-h-full items-center justify-center text-center sm:p-0", {
                  "p-4": !e.isFullScreen
                }])
              }, [
                y(u(nt), {
                  as: "template",
                  enter: "ease-out duration-[350ms]",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  onAfterLeave: s[2] || (s[2] = (l) => r("after-close-animation"))
                }, {
                  default: b(() => [
                    y(u(n0), {
                      class: z(["relative w-full overflow-hidden bg-white text-left shadow-base transition-all sm:my-8 sm:w-full", {
                        "sm:max-w-sm": !e.width && e.size === u(Y1).Small,
                        "sm:max-w-lg": !e.width && e.size === u(Y1).Medium,
                        "sm:max-w-3xl": !e.width && e.size === u(Y1).Large,
                        "sm:max-w-[calc(100%-40px-120px)]": !e.width && e.size === u(Y1).XLarge,
                        // 40px-120px is padding + close button width
                        "px-4 pb-4 pt-5 sm:p-6": !e.flat && !e.minimalHeader,
                        // Add padding for non-flat dialogs
                        "mt-14": e.flat && e.closable,
                        // Prevent layering window to close button,
                        "h-screen w-full": e.isFullScreen,
                        "rounded-xl": !e.isFullScreen
                      }]),
                      style: Ue(e.width ? { width: e.width } : {})
                    }, {
                      default: b(() => [
                        x("header", {
                          class: z(["", {
                            "flex items-center justify-between": e.minimalHeader,
                            "space-y-3": !e.minimalHeader,
                            "border-b border-grey-100 px-5 py-4": e.minimalHeader
                          }])
                        }, [
                          e.closable && !e.flat ? ($(), k("div", {
                            key: 0,
                            class: z(["flex items-center justify-end", {
                              "mb-2": !e.minimalHeader
                            }])
                          }, [
                            x("button", {
                              class: z(["flex items-center justify-center ring-brand focus-visible:outline-brand focus-visible:ring", {
                                "size-11 rounded-full bg-grey-100": !e.minimalHeader
                              }]),
                              type: "button",
                              onClick: s[1] || (s[1] = (l) => n("button"))
                            }, [
                              y(u(u1))
                            ], 2)
                          ], 2)) : P("", !0),
                          x("div", {
                            class: z({ "order-first flex w-full justify-between": e.minimalHeader })
                          }, [
                            W(a.$slots, "heading", {}, () => [
                              a.$slots.icon ? ($(), k("div", ol, [
                                W(a.$slots, "icon")
                              ])) : P("", !0),
                              e.title || a.$slots.title ? ($(), _(u(Cr), {
                                key: 1,
                                as: "div",
                                class: "text-dark-100"
                              }, {
                                default: b(() => [
                                  W(a.$slots, "title", {}, () => [
                                    y(O, {
                                      class: "text-center",
                                      size: u(H).h3,
                                      "tag-name": "h3"
                                    }, {
                                      default: b(() => [
                                        R(E(e.title), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["size"])
                                  ])
                                ]),
                                _: 3
                              })) : P("", !0),
                              e.description || a.$slots.description ? ($(), _(u(kr), {
                                key: 2,
                                as: "div",
                                class: "mt-3"
                              }, {
                                default: b(() => [
                                  W(a.$slots, "description", {}, () => [
                                    y(O, {
                                      class: "text-center text-sm text-grey-300",
                                      size: u(H).md,
                                      "tag-name": "p"
                                    }, {
                                      default: b(() => [
                                        R(E(e.description), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["size"])
                                  ])
                                ]),
                                _: 3
                              })) : P("", !0)
                            ])
                          ], 2)
                        ], 2),
                        x("main", {
                          class: z({
                            "mt-5": !e.flat,
                            "px-4 pb-4 sm:px-6 sm:pb-6": e.minimalHeader
                          })
                        }, [
                          W(a.$slots, "default")
                        ], 2)
                      ]),
                      _: 3
                    }, 8, ["class", "style"])
                  ]),
                  _: 3
                })
              ], 2)
            ])
          ]),
          _: 3
        }, 8, ["unmount"])
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), m0 = {
  origin: {
    type: String,
    default: "left"
  },
  openOnTriggerClick: {
    type: Boolean,
    default: !0
  },
  useTriggerContentWidth: {
    type: Boolean,
    default: !1
  },
  minWidth: {
    type: Number,
    default: 0
  },
  allowedPlacements: {
    type: Array,
    default: () => ["top", "bottom"]
  }
}, al = { class: "relative" }, ll = {
  key: 0,
  class: "fixed inset-0 z-floating-overlay bg-black/30"
}, Yn = /* @__PURE__ */ X({
  __name: "CfgFloating",
  props: /* @__PURE__ */ ye({
    ...m0,
    highlightTriggerElement: {
      type: Boolean,
      default: !1
    }
  }, {
    opened: { type: Boolean, default: !1 },
    openedModifiers: {}
  }),
  emits: ["update:opened"],
  setup(e) {
    const t = e, d = ze(e, "opened"), r = de(null), n = de(null);
    Sn(n, i);
    const { floatingStyles: a } = Qd(r, n, {
      middleware: [Dn(), In(), En(12), zn({
        allowedPlacements: t.allowedPlacements
      })],
      whileElementsMounted: e0,
      transform: !1
    }), { width: s } = St(r);
    r1(() => {
      Fd(document.documentElement, "keydown", (f) => {
        f.key === "Escape" && d.value && i();
      });
    });
    function l() {
      d.value = !0;
    }
    function i() {
      d.value = !1;
    }
    return (f, p) => ($(), k("div", al, [
      x("div", {
        ref_key: "triggerButtonRef",
        ref: r,
        class: z(["focusable relative rounded-xl border-none bg-white p-0", {
          "z-floating-trigger": d.value && !e.highlightTriggerElement,
          "z-floating-trigger-highlighted": d.value && e.highlightTriggerElement
        }]),
        tabindex: "0",
        onClick: p[0] || (p[0] = (m) => f.openOnTriggerClick && l()),
        onKeydown: p[1] || (p[1] = m1((m) => f.openOnTriggerClick && l(), ["enter"]))
      }, [
        W(f.$slots, "trigger", {
          close: i,
          opened: d.value
        })
      ], 34),
      y(N1, {
        "enter-active-class": "transition-opacity duration-200 ease-out",
        "enter-from-class": "transition-opacity opacity-0",
        "enter-to-class": "transition-opacity opacity-100",
        "leave-active-class": "transition-opacity delay-100 duration-200 ease-out",
        "leave-from-class": "transition-opacity opacity-100",
        "leave-to-class": "transition-opacity opacity-0"
      }, {
        default: b(() => [
          d.value ? ($(), k("div", ll)) : P("", !0)
        ]),
        _: 1
      }),
      ($(), _(Zd, { to: "body" }, [
        y(N1, {
          "enter-active-class": "transition duration-200 ease-out",
          "enter-from-class": "transform scale-125 translate-y-5 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100 translate-y-0",
          "leave-active-class": "transition duration-200 ease-out",
          "leave-from-class": "transform scale-100 translate-y-0 opacity-100",
          "leave-to-class": "transform scale-125 translate-y-5 opacity-0"
        }, {
          default: b(() => [
            Ge(x("div", {
              ref_key: "bodyRef",
              ref: n,
              class: z(["absolute top-[calc(var(--input-height)+5px)] z-floating-content w-max min-w-[350px] divide-y divide-grey-stroke overflow-auto rounded-xl border border-grey-stroke bg-white shadow-light focus-visible:outline-none", {
                "border-brand": d.value,
                "left-0": f.origin === "left",
                "right-0": f.origin === "right"
              }]),
              style: Ue({
                ...u(a),
                "max-width": f.useTriggerContentWidth ? "100%" : `${u(s)}px`
              })
            }, [
              W(f.$slots, "content", {
                close: i,
                opened: d.value
              })
            ], 6), [
              [cd, d.value]
            ])
          ]),
          _: 3
        })
      ]))
    ]));
  }
}), il = ["innerHTML"], et = /* @__PURE__ */ X({
  __name: "CfgHint",
  props: {
    content: { default: "" },
    hideIcon: { type: Boolean, default: !1 },
    iconPlacement: { default: "right" },
    tooltipPadding: { type: Boolean, default: !0 },
    disabled: { type: Boolean },
    offset: { default: 8 },
    contentWidth: { default: "" }
  },
  setup(e) {
    const t = e, d = ud(), r = j(() => {
      var l, i;
      return (i = (l = d.class) == null ? void 0 : l.includes) == null ? void 0 : i.call(l, "w-");
    }), n = de(!1);
    function a() {
      n.value = !1;
    }
    function s() {
      t.disabled || (n.value = !0);
    }
    return r1(() => {
      const l = Xt("contentRef"), i = Xt("triggerRef"), { isOutside: f } = G0(l), { isOutside: p } = G0(i), m = de(!1);
      let h = null;
      vn(() => {
        f.value && p.value ? h = setTimeout(() => {
          m.value = !0, n.value = !1;
        }, 0) : (h && (clearTimeout(h), h = null), m.value = !1);
      });
    }), (l, i) => ($(), k("div", {
      ref: "triggerRef",
      class: z(["flex h-max", { "w-max": !r.value }]),
      onMouseover: s
    }, [
      y(u(ir), {
        open: n.value,
        "onUpdate:open": s
      }, {
        default: b(() => [
          y(u(ur), {
            as: "div",
            class: z(["group inline-flex items-center gap-x-2", {
              "w-full": r.value,
              "flex-row-reverse": t.iconPlacement === "left",
              "cursor-help": !t.disabled
            }]),
            style: { "text-transform": "inherit" }
          }, {
            default: b(() => [
              W(l.$slots, "trigger"),
              !u(d).disabled && !t.hideIcon ? ($(), _(u(ht), {
                key: 0,
                class: z(["text-[1.1em] text-grey-200", { "transition-colors duration-200 group-hover:text-brand": !t.disabled }])
              }, null, 8, ["class"])) : P("", !0)
            ]),
            _: 3
          }, 8, ["class"]),
          y(u(cr), { to: "body" }, {
            default: b(() => [
              y(N1, { name: "cfg-hint" }, {
                default: b(() => [
                  y(u(fr), {
                    ref: "contentRef",
                    class: z(["z-toast rounded-xl bg-white text-dark-100 shadow-extra", {
                      "p-5": l.tooltipPadding,
                      "max-w-[330px]": !l.contentWidth,
                      [l.contentWidth]: l.contentWidth
                    }]),
                    "side-offset": t.offset
                  }, {
                    default: b(() => [
                      W(l.$slots, "content", { closeHint: a }, () => [
                        x("div", {
                          class: "block max-w-[200px] text-left text-sm",
                          innerHTML: t.content
                        }, null, 8, il)
                      ])
                    ]),
                    _: 3
                  }, 8, ["class", "side-offset"])
                ]),
                _: 3
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["open"])
    ], 34));
  }
}), ul = { class: "space-y-3" }, cl = ["innerHTML"], o5 = /* @__PURE__ */ X({
  __name: "CfgRadioGroup",
  props: /* @__PURE__ */ ye({
    ...Fe,
    /**
     * Name of the radio group (will be used as name attribute for all radio buttons)
     */
    name: {
      type: String,
      default: () => j1()
    },
    /**
     * Radio group items
     */
    options: {
      type: Array,
      default: () => []
    },
    layout: {
      type: String,
      default: "row"
    }
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    var a;
    const t = e, d = ze(e, "modelValue");
    d.value || (d.value = ((a = t.options[0]) == null ? void 0 : a.value) ?? "");
    const r = j(() => t.options.map((s) => ({
      ...s,
      checked: s.value === d.value
    })));
    function n(s, l) {
      s && (d.value = l);
    }
    return (s, l) => ($(), k("div", ul, [
      x("div", null, [
        y(O, {
          class: z({
            "text-grey-200": !s.error,
            "text-red": s.error
          }),
          size: u(H).md
        }, {
          default: b(() => [
            R(E(s.placeholder), 1)
          ]),
          _: 1
        }, 8, ["class", "size"]),
        s.caption ? ($(), _(O, {
          key: 0,
          class: "mt-1 block pb-1 text-grey-300",
          size: u(H).xs
        }, {
          default: b(() => [
            x("span", { innerHTML: s.caption }, null, 8, cl)
          ]),
          _: 1
        }, 8, ["size"])) : P("", !0)
      ]),
      x("div", {
        class: z({
          "flex flex-wrap gap-x-7 gap-y-4": e.layout === "row",
          "space-y-4": e.layout === "column"
        })
      }, [
        ($(!0), k(ae, null, he(r.value, (i) => ($(), k("div", {
          key: i.value
        }, [
          y(za, {
            disabled: s.disabled || i.disabled,
            "model-value": i.checked,
            name: e.name,
            placeholder: i.label,
            value: i.value,
            "onUpdate:modelValue": (f) => n(f, i.value)
          }, null, 8, ["disabled", "model-value", "name", "placeholder", "value", "onUpdate:modelValue"])
        ]))), 128))
      ], 2),
      s.error && s.errorMessage ? ($(), _(O, {
        key: 0,
        class: "mt-3 block text-red",
        size: u(H).xs
      }, {
        default: b(() => [
          R(E(s.errorMessage), 1)
        ]),
        _: 1
      }, 8, ["size"])) : P("", !0)
    ]));
  }
});
function Kn(e, t) {
  const d = j(() => Array.isArray(e.value)), r = kt(t, (i, f) => ({
    label: typeof i == "string" ? i : i.label,
    value: typeof i == "string" ? f.toString() : i.value,
    subtext: typeof i == "string" ? void 0 : i.subtext,
    original: i
  })), n = j(() => {
    if (!e.value)
      return [];
    if (Array.isArray(e.value))
      return e.value.map((f) => {
        const p = s(f);
        return {
          ...p,
          label: typeof f == "string" ? f : (p == null ? void 0 : p.label) ?? ""
        };
      }).filter(Boolean);
    let i = s(e.value);
    return typeof e.value == "object" && i && (i = {
      ...i,
      label: e.value.label || ""
    }), i ? [i] : [];
  }), a = kt(r, (i) => ({
    ...i,
    selected: l(i)
  }));
  function s(i) {
    return typeof i == "string" ? r.value.find(({ label: f }) => f === i) : r.value.find(({ value: f }) => Mt(f, i == null ? void 0 : i.value));
  }
  function l(i) {
    return !!n.value.find(({ value: f }) => i.value === f);
  }
  return {
    isMultiple: d,
    normalizedModelValue: n,
    statefullOptionsList: a,
    isOptionSelected: l,
    findOption: s
  };
}
const fl = {
  key: 0,
  class: "flex flex-col items-center justify-center gap-4 px-5 py-7"
}, $l = {
  key: 1,
  class: "max-h-[400px] divide-y divide-grey-stroke overflow-auto"
}, pl = ["onClick", "onKeydown"], ml = { class: "grow" }, gl = {
  key: 2,
  class: "flex flex-col items-center justify-center gap-4 px-5 py-7"
}, a5 = /* @__PURE__ */ X({
  __name: "CfgCombobox",
  props: /* @__PURE__ */ ye({
    ...Fe,
    options: {
      type: Array,
      default: () => []
    },
    emptyMessage: {
      type: String,
      required: !0
    },
    initialSearch: {
      type: String,
      default: ""
    },
    openOptionsOnClick: {
      type: Boolean,
      default: !0
    },
    origin: {
      type: String,
      default: "left"
    },
    compareFn: {
      type: [Function, null],
      default: null
    },
    onSearch: {
      type: Function,
      default: null
    },
    ...x1(m0, "allowedPlacements")
  }, {
    modelValue: { default: null },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    var S, L;
    const t = e, { options: d } = fd(t), r = ze(e, "modelValue"), n = de(null);
    Sn(n, C);
    const { normalizedModelValue: a, statefullOptionsList: s } = Kn(r, d), l = de(t.initialSearch || (((L = (S = a.value) == null ? void 0 : S[0]) == null ? void 0 : L.label) ?? "")), i = de(!1), f = de(!1), p = (T, g) => g.label.toLowerCase().includes(l.value.toLowerCase()), m = Y2(async () => {
      const T = t.compareFn || p;
      i.value = !0;
      const g = await er(
        s.value,
        async (I) => l.value ? T(l.value, I) : !0
      );
      return i.value = !1, g;
    }, s.value);
    function h() {
      f.value = !0;
    }
    function C() {
      f.value = !1;
    }
    function v(T) {
      T && (r.value = T.original, C());
    }
    function M(T) {
      var Y;
      if ([27, 13, 9, 16, 17, 18].includes(T.keyCode))
        return;
      const { value: g, label: I } = ((Y = a.value) == null ? void 0 : Y[0]) || {}, Z = T.key.match(/^[a-z0-9\s]+$/i) ? T.key : "";
      Z !== g && Z !== I && h();
    }
    return Ce(() => t.initialSearch, (T = "") => {
      l.value = T;
    }), Ce(r, (T) => {
      Array.isArray(T) ? l.value = T.map((g) => typeof g == "string" ? g : g.label).join(", ") : l.value = typeof T == "string" ? T : (T == null ? void 0 : T.label) ?? "";
    }), Ce(l, (T) => {
      var g;
      T !== t.initialSearch && ((g = t.onSearch) == null || g.call(t, T)), T === "" && (r.value = null);
    }), (T, g) => ($(), _(Yn, {
      opened: f.value,
      "onUpdate:opened": g[1] || (g[1] = (I) => f.value = I),
      "highlight-trigger-element": "",
      "open-on-trigger-click": e.openOptionsOnClick
    }, {
      trigger: b(() => [
        y(n1, {
          modelValue: l.value,
          "onUpdate:modelValue": g[0] || (g[0] = (I) => l.value = I),
          autocomplete: "off",
          error: T.error,
          "error-message": T.errorMessage,
          fluid: "",
          "initial-focused": f.value || T.initialFocused,
          "interect-with-icon": "",
          loading: i.value || T.loading,
          placeholder: T.placeholder,
          required: T.required,
          type: "search",
          onKeydown: M
        }, null, 8, ["modelValue", "error", "error-message", "initial-focused", "loading", "placeholder", "required"])
      ]),
      content: b(() => [
        i.value || T.loading ? ($(), k("div", fl, [
          y(It, { class: "text-[8px] text-brand" })
        ])) : u(m).length ? ($(), k("ul", $l, [
          ($(!0), k(ae, null, he(u(m), (I) => ($(), k("li", {
            key: I.label,
            class: z(["flex cursor-pointer items-center gap-x-3 p-4 hover:bg-grey-100/50", {
              "text-brand": I.selected
            }]),
            onClick: (N) => v(I),
            onKeydown: m1((N) => v(I), ["enter"])
          }, [
            W(T.$slots, "option", fe({ ref_for: !0 }, { ...I }), () => [
              I.selected ? ($(), _(u(qd), {
                key: 0,
                "aria-hidden": "true",
                class: "shrink-0 text-success"
              })) : P("", !0),
              x("span", ml, E(I.label), 1)
            ])
          ], 42, pl))), 128))
        ])) : ($(), k("div", gl, [
          y(u(T2), { class: "text-[1.3rem] text-grey-300" }),
          y(O, {
            class: "text-center",
            size: u(H).sm
          }, {
            default: b(() => [
              R(E(e.emptyMessage), 1)
            ]),
            _: 1
          }, 8, ["size"])
        ]))
      ]),
      _: 3
    }, 8, ["opened", "open-on-trigger-click"]));
  }
}), hl = {
  class: "cfg-select__button focusable block w-full rounded-xl text-left focus:border-none focus:outline-0",
  type: "button"
}, vl = {
  key: 0,
  class: "absolute right-0 text-grey-200"
}, bl = {
  key: 0,
  class: "block max-w-full pt-1 text-red"
}, yl = ["innerHTML"], xl = {
  key: 0,
  class: "fixed inset-0 z-floating-overlay bg-black/30"
}, wl = {
  key: 0,
  class: "flex flex-col items-center justify-center gap-4 px-5 py-7"
}, Cl = { key: 1 }, kl = ["innerHTML"], Sl = ["innerHTML"], g0 = /* @__PURE__ */ X({
  __name: "CfgSelect",
  props: /* @__PURE__ */ ye({
    ...Fe,
    modelValue: {
      type: [Object, Array, null],
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    origin: {
      type: String,
      default: "left"
    },
    /**
     * Controls showing overlay under other elements
     */
    overlay: {
      type: Boolean,
      default: !0
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    contentMinWidth: {
      type: String,
      default: "350px"
    }
  }, {
    modelValue: { default: null },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, d = ze(e, "modelValue"), r = de(), n = de(), a = de(), s = de(), { width: l } = St(n);
    K2(r, g);
    const { width: i } = St(a), {
      floatingStyles: f
    } = Qd(a, s, {
      whileElementsMounted: e0,
      transform: !1,
      middleware: [
        zn({
          allowedPlacements: ["top", "bottom"]
        }),
        In({ padding: 5 }),
        En(12),
        Dn()
      ]
    }), p = de(0), { options: m } = fd(t), {
      isMultiple: h,
      normalizedModelValue: C,
      statefullOptionsList: v,
      isOptionSelected: M
    } = Kn(d, m), S = j(() => p.value > l.value), L = j(() => {
      var G;
      return h.value ? C.value.map(({ value: U }) => U) : ((G = C.value[0]) == null ? void 0 : G.value) ?? "";
    }), T = j(() => ({
      label: C.value.map(({ label: G }) => G).join(", "),
      additionalLabel: S.value && C.value.length > 1 ? `(${C.value.length})` : ""
    }));
    function g() {
      var G;
      p.value = ((G = r.value) == null ? void 0 : G.getBoundingClientRect().width) ?? 0;
    }
    function I(G) {
      var te;
      let U = C.value;
      M(G) && h.value ? U = U.filter(({ value: B }) => B !== G.value) : h.value ? U.push(G) : U = [G], d.value = h.value ? U.map(({ original: B }) => B) : ((te = U[0]) == null ? void 0 : te.original) ?? null;
    }
    function N() {
      d.value = h.value ? [] : null;
    }
    const Z = j(() => d.value === null || Array.isArray(d.value) && !d.value.length);
    kn(T, g, { immediate: !0, deep: !0, debounce: 50 });
    const Y = Z2(async () => {
      try {
        return h.value ? (await Promise.resolve().then(() => Wo)).default : (await import("./CfgRadio-BxvnZyBv.js")).default;
      } catch {
        return null;
      }
    }, null);
    return (G, U) => ($(), _(u(Sr), {
      as: "div",
      class: "cfg-select relative",
      disabled: G.disabled,
      "model-value": L.value,
      multiple: u(h)
    }, {
      default: b(({ open: te }) => [
        x("div", null, [
          x("div", null, [
            y(u(Mr), {
              as: "template",
              type: "button"
            }, {
              default: b(() => [
                x("button", hl, [
                  x("span", {
                    ref_key: "triggerButtonRef",
                    ref: a,
                    class: "block"
                  }, [
                    W(G.$slots, "trigger", { isOpened: te }, () => [
                      y($0, {
                        class: z(["bg-white", {
                          "cursor-pointer": !G.disabled,
                          "cursor-not-allowed": G.disabled,
                          "relative z-floating-trigger ": te
                        }]),
                        disabled: G.disabled,
                        empty: !u(C).length,
                        error: G.error,
                        fluid: "",
                        focused: te,
                        loading: G.loading,
                        placeholder: G.placeholder,
                        readonly: "",
                        required: G.required
                      }, {
                        placeRight: b(() => [
                          e.clearable && !Z.value ? ($(), _(u(u1), {
                            key: 0,
                            class: z(["size-4 text-grey-400", {
                              "!text-brand": te
                            }]),
                            onClick: Qe(N, ["prevent"])
                          }, null, 8, ["class"])) : ($(), _(u(F1), {
                            key: 1,
                            class: z(["size-4 text-grey-400 transition duration-200", {
                              "rotate-180 !text-brand": te
                            }])
                          }, null, 8, ["class"]))
                        ]),
                        default: b(() => [
                          x("span", {
                            ref_key: "textWrapperRef",
                            ref: n,
                            class: z(["relative block min-h-[1em] truncate", {
                              "pr-5": S.value && u(h)
                            }])
                          }, [
                            x("span", {
                              ref_key: "textRef",
                              ref: r,
                              class: "h-4"
                            }, E(T.value.label), 513),
                            T.value.additionalLabel ? ($(), k("span", vl, E(T.value.additionalLabel), 1)) : P("", !0)
                          ], 2)
                        ]),
                        _: 2
                      }, 1032, ["class", "disabled", "empty", "error", "focused", "loading", "placeholder", "required"])
                    ])
                  ], 512),
                  G.error && G.errorMessage ? ($(), k("small", bl, E(G.errorMessage), 1)) : P("", !0)
                ])
              ]),
              _: 2
            }, 1024),
            !(G.error && G.errorMessage) && G.caption ? ($(), k("small", {
              key: 0,
              class: "block max-w-full pt-1 text-grey-300",
              innerHTML: G.caption
            }, null, 8, yl)) : P("", !0)
          ]),
          ($(), _(Zd, { to: "body" }, [
            e.overlay ? ($(), _(N1, {
              key: 0,
              "enter-active-class": "transition-opacity duration-200 ease-out",
              "enter-from-class": "transition-opacity opacity-0",
              "enter-to-class": "transition-opacity opacity-100",
              "leave-active-class": "transition-opacity delay-100 duration-200 ease-out",
              "leave-from-class": "transition-opacity opacity-100",
              "leave-to-class": "transition-opacity opacity-0"
            }, {
              default: b(() => [
                te ? ($(), k("div", xl)) : P("", !0)
              ]),
              _: 2
            }, 1024)) : P("", !0),
            y(u(Tr), {
              as: "template",
              static: ""
            }, {
              default: b((B) => [
                y(N1, {
                  "enter-active-class": "transition duration-200 ease-out",
                  "enter-from-class": "transform scale-125 translate-y-5 opacity-0",
                  "enter-to-class": "transform scale-100 opacity-100 translate-y-0",
                  "leave-active-class": "transition duration-200 ease-out",
                  "leave-from-class": "transform scale-100 translate-y-0 opacity-100",
                  "leave-to-class": "transform scale-125 translate-y-5 opacity-0"
                }, {
                  default: b(() => [
                    Ge(x("div", {
                      ref_key: "dropdownContent",
                      ref: s,
                      class: "cfg-select__body z-floating-content w-full divide-y divide-grey-stroke overflow-auto rounded-xl bg-white shadow-light focus-visible:outline-none",
                      style: Ue({
                        ...u(f),
                        width: `${u(i)}px`,
                        minWidth: e.contentMinWidth
                      })
                    }, [
                      B.open ? ($(), k(ae, { key: 0 }, [
                        G.loading ? ($(), k("div", wl, [
                          y(u(It), { class: "text-[8px] text-brand" })
                        ])) : ($(), k("ul", Cl, [
                          ($(!0), k(ae, null, he(u(v), (V) => ($(), _(u(Lr), {
                            key: V.value,
                            as: "li",
                            class: z(["cursor-pointer", {
                              "p-4": !G.$slots.item
                            }]),
                            value: V.label,
                            onClick: (q) => !u(h) && I(V),
                            onKeydown: [
                              m1((q) => I(V), ["enter"]),
                              m1((q) => I(V), ["space"])
                            ]
                          }, {
                            default: b(({ active: q }) => [
                              W(G.$slots, "item", {
                                focused: q,
                                isSelected: V.selected,
                                option: V,
                                toggle: I
                              }, () => [
                                ($(), _(Oe(u(Y)), {
                                  id: `cfgSelect-${V.value}`,
                                  focused: q,
                                  "initial-focused": V.selected,
                                  "model-value": !!V.selected,
                                  "onUpdate:modelValue": (J) => I(V)
                                }, Dt({
                                  default: b(() => [
                                    u(h) ? P("", !0) : W(G.$slots, "label", {
                                      key: 0,
                                      value: V
                                    }, () => [
                                      x("span", {
                                        class: z(["leading-6", { "text-brand": V.selected, "text-grey-500": !V.selected }]),
                                        innerHTML: V.label
                                      }, null, 10, Sl),
                                      V.subtext ? ($(), _(u(O), {
                                        key: 0,
                                        class: "block text-grey-300",
                                        size: u(H).xs,
                                        "tag-name": "sm"
                                      }, {
                                        default: b(() => [
                                          R(E(V.subtext), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["size"])) : P("", !0)
                                    ])
                                  ]),
                                  _: 2
                                }, [
                                  u(h) ? {
                                    name: "label",
                                    fn: b(() => [
                                      W(G.$slots, "label", { value: V }, () => [
                                        x("span", {
                                          class: z(["leading-6", { "text-brand": V.selected, "text-grey-500": !V.selected }]),
                                          innerHTML: V.label
                                        }, null, 10, kl),
                                        V.subtext ? ($(), _(u(O), {
                                          key: 0,
                                          class: "block text-grey-300",
                                          size: u(H).xs,
                                          "tag-name": "sm"
                                        }, {
                                          default: b(() => [
                                            R(E(V.subtext), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["size"])) : P("", !0)
                                      ])
                                    ]),
                                    key: "0"
                                  } : void 0
                                ]), 1032, ["id", "focused", "initial-focused", "model-value", "onUpdate:modelValue"]))
                              ])
                            ]),
                            _: 2
                          }, 1032, ["class", "value", "onClick", "onKeydown"]))), 128))
                        ]))
                      ], 64)) : P("", !0)
                    ], 4), [
                      [cd, B.open]
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]))
        ])
      ]),
      _: 3
    }, 8, ["disabled", "model-value", "multiple"]));
  }
}), Ml = { class: "cfg-slider" }, Tl = {
  key: 1,
  class: "mx-[-12px] mt-6"
}, Ll = { class: "inputs flex justify-between" }, Al = {
  key: 2,
  class: "block max-w-full pt-3 text-warning"
}, Dl = {
  key: 3,
  class: "block max-w-full pt-3 text-grey-300"
}, l5 = /* @__PURE__ */ X({
  __name: "CfgSlider",
  props: {
    ...Fe,
    modelValue: {
      type: [Number, Array],
      required: !0
    },
    step: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      required: !0
    },
    max: {
      type: Number,
      required: !0
    },
    tipSuffix: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    coloredMode: {
      type: String,
      default: "default"
    },
    useInputs: {
      type: Boolean,
      default: !1
    },
    inputsWidth: {
      type: String,
      default: "80px"
    },
    tooltips: {
      type: Boolean,
      default: !0
    },
    snap: {
      type: Boolean,
      default: !1
    },
    lazy: {
      type: Boolean,
      default: !0
    },
    range: {
      type: Object,
      default: void 0
    },
    connect: {
      type: [String, Boolean],
      default: !0
    }
  },
  emits: ["update:modelValue", "apply", "drag:end"],
  async setup(e, { emit: t }) {
    let d, r;
    const n = e, a = t, s = de(n.modelValue), { default: l } = ([d, r] = ld(() => import("@vueform/slider")), d = await d, r(), d), i = j(() => {
      const m = {
        snap: n.snap,
        connect: n.connect,
        range: n.range || { min: n.min, max: n.max }
      };
      return n.lazy ? m : {};
    });
    Ce(
      () => n.modelValue,
      () => {
        Mt(s.value, n.modelValue) || (s.value = n.modelValue);
      },
      { deep: !0, immediate: !0 }
    ), Ce(
      s,
      () => {
        n.lazy || Mt(s.value, n.modelValue) || a("update:modelValue", s.value);
      },
      { deep: !0, immediate: !0 }
    );
    async function f(m, h) {
      const C = Array.isArray(s.value) && h === 1 ? s.value[0] : n.min;
      let v = Array.isArray(s.value) && h === 0 ? s.value[1] : n.max;
      h === 0 && Array.isArray(s.value) && (v = s.value[1]);
      let M = Number(m);
      M < C ? M = C : M > v && (M = v), M = Math.round(M / n.step) * n.step, P1(() => {
        s.value[h] = M, s.value = [...s.value], p(s.value);
      });
    }
    function p(m) {
      a("update:modelValue", m), a("apply", m);
    }
    return (m, h) => ($(), k("div", Ml, [
      m.placeholder ? ($(), _(O, {
        key: 0,
        class: "mb-5 block text-grey-300",
        size: u(H).md
      }, {
        default: b(() => [
          R(E(m.placeholder), 1)
        ]),
        _: 1
      }, 8, ["size"])) : P("", !0),
      y(u(l), {
        modelValue: s.value,
        "onUpdate:modelValue": h[0] || (h[0] = (C) => s.value = C),
        class: z(["core-slider cfg-slider__slider w-full", { [`cfg-slider__slider--colored-mode__${e.coloredMode}`]: !0 }]),
        disabled: e.disabled || m.loading,
        lazy: e.lazy,
        max: e.max,
        min: e.min,
        options: i.value,
        "show-tooltip": "drag",
        step: e.step,
        tooltips: e.tooltips,
        onEnd: h[1] || (h[1] = (C) => m.$emit("drag:end")),
        onUpdate: p
      }, null, 8, ["modelValue", "class", "disabled", "lazy", "max", "min", "options", "step", "tooltips"]),
      e.useInputs ? ($(), k("div", Tl, [
        x("div", Ll, [
          y(sn, {
            max: e.max,
            min: s.value[0],
            "model-value": String(s.value[0]),
            step: e.step,
            style: Ue({
              width: e.inputsWidth
            }),
            suffix: e.tipSuffix,
            type: "number",
            onBlur: h[2] || (h[2] = (C) => f(C, 0))
          }, null, 8, ["max", "min", "model-value", "step", "style", "suffix"]),
          y(sn, {
            max: e.max,
            min: s.value[0],
            "model-value": String(s.value[1]),
            step: e.step,
            style: Ue({
              width: e.inputsWidth
            }),
            suffix: e.tipSuffix,
            type: "number",
            onBlur: h[3] || (h[3] = (C) => f(C, 1))
          }, null, 8, ["max", "min", "model-value", "step", "style", "suffix"])
        ])
      ])) : P("", !0),
      m.error && m.errorMessage ? ($(), k("small", Al, E(m.errorMessage), 1)) : P("", !0),
      !(m.error && m.errorMessage) && m.caption ? ($(), k("small", Dl, E(m.caption), 1)) : P("", !0)
    ]));
  }
}), i5 = /* @__PURE__ */ X({
  __name: "CfgTab",
  props: {
    as: { default: "button" },
    disabled: { type: Boolean }
  },
  setup(e) {
    const d = bn("getTabsTabIndex", () => 0)();
    return (r, n) => ($(), _(u(Mn), {
      as: r.as,
      class: "relative translate-y-px px-3 pb-4 leading-none transition duration-200 focus:outline-0 data-[disabled]:cursor-not-allowed data-[state=active]:text-brand",
      disabled: r.disabled,
      value: u(d)
    }, {
      default: b(() => [
        W(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "disabled", "value"]));
  }
}), u5 = /* @__PURE__ */ X({
  __name: "CfgTabPanel",
  setup(e) {
    const d = bn("getTabsPanelIndex", () => 0)();
    return (r, n) => ($(), _(u(Tn), { value: u(d) }, {
      default: b(() => [
        W(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["value"]));
  }
}), c5 = /* @__PURE__ */ X({
  __name: "CfgTabs",
  props: /* @__PURE__ */ ye({
    as: { default: "div" }
  }, {
    selectedTab: { default: 0 },
    selectedTabModifiers: {}
  }),
  emits: ["update:selectedTab"],
  setup(e) {
    const t = ze(e, "selectedTab"), d = Kd({
      tab: 0,
      panel: 0
    });
    function r(n) {
      const a = d[n];
      return d[n] += 1, a;
    }
    return H0("getTabsTabIndex", () => r("tab")), H0("getTabsPanelIndex", () => r("panel")), (n, a) => ($(), _(u(Ln), {
      modelValue: t.value,
      "onUpdate:modelValue": a[0] || (a[0] = (s) => t.value = s),
      as: n.as
    }, {
      default: b(() => [
        y(u(An), { class: "relative flex shrink-0 border-b border-b-grey-stroke" }, {
          default: b(() => [
            y(u($r), { class: "absolute bottom-0 left-0 h-px w-[--reka-tabs-indicator-size] translate-x-[--reka-tabs-indicator-position] translate-y-px rounded-full bg-brand px-8 transition-[width,transform] duration-300" }),
            W(n.$slots, "tabs")
          ]),
          _: 3
        }),
        W(n.$slots, "panels")
      ]),
      _: 3
    }, 8, ["modelValue", "as"]));
  }
}), Ve = {
  default: "brand",
  success: "success",
  warning: "warning",
  danger: "red",
  neutral: "neutral"
}, Il = { class: "timeline-item relative z-0 grid grid-cols-[2.75rem_1fr] gap-4 before:absolute before:left-[1.375rem] before:top-1/2 before:-z-10 before:h-full before:w-px before:bg-grey-100" }, El = { class: "flex h-11 items-center justify-center" }, zl = {
  key: 1,
  class: "size-3 rounded-full bg-grey-100"
}, Bl = { class: "flex flex-col items-start justify-center gap-y-0.5" }, Pl = /* @__PURE__ */ X({
  __name: "CfgTimelineItem",
  props: {
    color: { default: Ve.default },
    icon: { default: void 0 },
    title: { default: void 0 },
    text: { default: void 0 },
    hasPingAnimation: { type: Boolean, default: !1 },
    id: { default: void 0 },
    tooltip: { type: Boolean },
    meta: { default: void 0 }
  },
  setup(e) {
    const t = e, d = j(() => jd(t.icon) ? void 0 : x2[t.icon]), r = j(() => ({
      background: {
        "bg-brand": t.color === Ve.default,
        "bg-grey-300": t.color === Ve.neutral,
        "bg-success": t.color === Ve.success,
        "bg-warning": t.color === Ve.warning,
        "bg-red": t.color === Ve.danger
      },
      backgroundLight: {
        "bg-brand/30": t.color === Ve.default,
        "bg-grey-300/30": t.color === Ve.neutral,
        "bg-success/30": t.color === Ve.success,
        "bg-warning/30": t.color === Ve.warning,
        "bg-red/30": t.color === Ve.danger
      },
      ring: {
        "ring-brand/30": t.color === Ve.default,
        "ring-success/30": t.color === Ve.success,
        "ring-warning/30": t.color === Ve.warning,
        "ring-red/30": t.color === Ve.danger,
        "ring-grey-300/30": t.color === Ve.neutral
      },
      text: {
        "text-dark": t.color === Ve.success || t.color === Ve.neutral || t.color === Ve.default,
        "text-warning": t.color === Ve.warning,
        "text-red": t.color === Ve.danger
      }
    }));
    return (n, a) => ($(), k("div", Il, [
      x("div", El, [
        !u(jd)(d.value) || n.$slots.icon ? ($(), k(ae, { key: 0 }, [
          x("span", {
            class: z(["flex size-[30px] items-center justify-center rounded-full text-white ring-[7px] [&>*]:size-4", { ...r.value.ring, ...r.value.background }])
          }, [
            W(n.$slots, "icon", {}, () => [
              ($(), _(Oe(d.value)))
            ])
          ], 2),
          n.hasPingAnimation ? ($(), k("span", {
            key: 0,
            class: z(["absolute inline-flex size-[33px] animate-ping rounded-full", r.value.backgroundLight])
          }, null, 2)) : P("", !0)
        ], 64)) : ($(), k("span", zl))
      ]),
      x("div", Bl, [
        W(n.$slots, "content", {
          text: n.text,
          title: n.title
        }, () => [
          u(U0)(n.title) ? P("", !0) : ($(), _(u(O), {
            key: 0,
            class: z(r.value.text),
            size: u(H).sm
          }, {
            default: b(() => [
              W(n.$slots, "title", { title: n.title }, () => [
                R(E(n.title), 1)
              ])
            ]),
            _: 3
          }, 8, ["class", "size"])),
          u(U0)(n.text) ? P("", !0) : ($(), _(u(O), {
            key: 1,
            class: "text-sm text-grey-300",
            size: u(H).sm
          }, {
            default: b(() => [
              W(n.$slots, "text", { text: n.text }, () => [
                R(E(n.text), 1)
              ])
            ]),
            _: 3
          }, 8, ["size"]))
        ])
      ])
    ]));
  }
}), f5 = /* @__PURE__ */ X({
  __name: "CfgTimeline",
  props: {
    items: {}
  },
  setup(e) {
    return (t, d) => ($(), k("div", null, [
      W(t.$slots, "prependItems", { attrs: { class: "timeline-item-wrapper" } }),
      ($(!0), k(ae, null, he(t.items, (r, n) => ($(), k("div", {
        key: n,
        class: "timeline-item-wrapper"
      }, [
        y(et, {
          class: "w-full max-w-full [&>*]:max-w-full",
          disabled: !r.tooltip,
          "hide-icon": ""
        }, {
          trigger: b(() => [
            y(Pl, fe({ ref_for: !0 }, r), null, 16)
          ]),
          content: b(() => [
            W(t.$slots, "tooltip", { item: r })
          ]),
          _: 2
        }, 1032, ["disabled"])
      ]))), 128)),
      W(t.$slots, "appendItems", { attrs: { class: "timeline-item-wrapper" } })
    ]));
  }
});
var d1 = /* @__PURE__ */ ((e) => (e.Success = "success", e.Error = "error", e.Warning = "warning", e.Info = "info", e))(d1 || {});
const Vl = { class: "p-4" }, Ol = { class: "flex items-center" }, Rl = { class: "shrink-0" }, Nl = { class: "ml-4 w-0 flex-1 pt-0.5" }, Fl = ["innerHTML"], _l = { class: "ml-5 flex shrink-0 self-center" }, $5 = /* @__PURE__ */ X({
  __name: "CfgToastNotification",
  props: {
    type: {},
    title: {},
    message: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const d = e, r = t, n = j(() => d.type === d1.Info ? Qt : d.type === d1.Success ? qd : d.type === d1.Warning ? L2 : d.type === d1.Error ? u1 : Qt);
    return (a, s) => ($(), k("div", {
      class: z(["pointer-events-auto w-full max-w-sm overflow-hidden rounded-xl border-l-4 bg-white shadow-base ring-1 ring-dark-100/5", {
        "border-none": a.type === u(d1).Info,
        "border-success": a.type === u(d1).Success,
        "border-yellow": a.type === u(d1).Warning,
        "border-warning": a.type === u(d1).Error
      }])
    }, [
      x("div", Vl, [
        x("div", Ol, [
          x("div", Rl, [
            W(a.$slots, "icon", {}, () => [
              x("div", {
                class: z(["mt-1 rounded-xl p-2", {
                  "bg-grey-100/50 text-grey-200": a.type === u(d1).Info,
                  "bg-success-light text-success": a.type === u(d1).Success,
                  "bg-yellow-light text-yellow": a.type === u(d1).Warning,
                  "bg-warning-light text-warning": a.type === u(d1).Error
                }])
              }, [
                ($(), _(Oe(n.value), {
                  "aria-hidden": "true",
                  class: "text-lg"
                }))
              ], 2)
            ])
          ]),
          x("div", Nl, [
            y(O, {
              class: "text-dark-300 text-[18px] leading-[1.15]",
              "tag-name": "h4"
            }, {
              default: b(() => [
                R(E(a.title), 1)
              ]),
              _: 1
            }),
            a.message ? ($(), k("p", {
              key: 0,
              class: "mt-2 text-sm text-grey-400",
              innerHTML: a.message
            }, null, 8, Fl)) : P("", !0)
          ]),
          x("div", _l, [
            x("button", {
              class: "focusable inline-flex rounded-xl bg-white text-grey-300 hover:text-grey-500",
              type: "button",
              onClick: s[0] || (s[0] = (l) => r("close"))
            }, [
              s[1] || (s[1] = x("span", { class: "sr-only" }, "Close", -1)),
              y(u(u1), {
                "aria-hidden": "true",
                class: "text-lg"
              })
            ])
          ])
        ])
      ])
    ], 2));
  }
}), jl = { class: "flex flex-col gap-5" }, Hl = { class: "flex gap-x-2" }, Gl = { class: "grow" }, p5 = /* @__PURE__ */ X({
  __name: "CfgAddressDetailsField",
  props: {
    ...Fe,
    ...Ze,
    modelValue: {
      type: [Object, null],
      required: !0
    },
    translates: {
      type: Object,
      required: !0
    },
    zipLengthErrorMessage: {
      type: String,
      required: !0
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const d = e, r = t, n = j({
      get() {
        const s = {
          firstLine: "",
          secondLine: "",
          zip: "",
          state: ""
        };
        return d.modelValue || s;
      },
      set(s) {
        r("update:modelValue", s);
      }
    }), a = j(() => {
      const s = {
        firstLine: "",
        secondLine: "",
        zip: "",
        state: ""
      };
      return d.error && n.value && Object.entries(n.value).forEach(([l, i]) => {
        i || (s[l] = d.errorMessage);
      }), n.value.zip.length > 5 && (s.zip = d.zipLengthErrorMessage), s;
    });
    return (s, l) => {
      var i, f, p, m;
      return $(), k("div", jl, [
        y(n1, {
          caption: e.translates.captions.firstLine,
          error: !!a.value.firstLine,
          "error-message": a.value.firstLine,
          fluid: !0,
          "initial-focused": s.initialFocused,
          "model-value": (i = n.value) == null ? void 0 : i.firstLine,
          placeholder: e.translates.placeholders.firstLine,
          required: s.required,
          "onUpdate:modelValue": l[0] || (l[0] = (h) => {
            n.value = {
              ...n.value,
              firstLine: h.toString()
            };
          })
        }, null, 8, ["caption", "error", "error-message", "initial-focused", "model-value", "placeholder", "required"]),
        x("div", Hl, [
          y(n1, {
            caption: e.translates.captions.secondLine,
            error: !!a.value.secondLine,
            "error-message": a.value.secondLine,
            fluid: !0,
            "model-value": (f = n.value) == null ? void 0 : f.secondLine,
            placeholder: e.translates.placeholders.secondLine,
            required: s.required,
            "onUpdate:modelValue": l[1] || (l[1] = (h) => {
              n.value = {
                ...n.value,
                secondLine: h.toString()
              };
            })
          }, null, 8, ["caption", "error", "error-message", "model-value", "placeholder", "required"]),
          x("div", Gl, [
            y(n1, {
              caption: e.translates.captions.zip,
              class: "w-[100px]",
              error: !!a.value.zip,
              "error-message": a.value.zip,
              fluid: !0,
              "model-value": (p = n.value) == null ? void 0 : p.zip,
              placeholder: e.translates.placeholders.zip,
              required: s.required,
              "onUpdate:modelValue": l[2] || (l[2] = (h) => {
                n.value = {
                  ...n.value,
                  zip: h.toString()
                };
              })
            }, null, 8, ["caption", "error", "error-message", "model-value", "placeholder", "required"])
          ])
        ]),
        y(n1, {
          caption: e.translates.captions.state,
          error: !!a.value.state,
          "error-message": a.value.state,
          fluid: !0,
          "model-value": (m = n.value) == null ? void 0 : m.state,
          placeholder: e.translates.placeholders.state,
          required: s.required,
          "onUpdate:modelValue": l[3] || (l[3] = (h) => {
            n.value = {
              ...n.value,
              state: h.toString()
            };
          })
        }, null, 8, ["caption", "error", "error-message", "model-value", "placeholder", "required"])
      ]);
    };
  }
}), an = 450, m5 = /* @__PURE__ */ X({
  __name: "CfgBankAccountField",
  props: {
    ...Fe,
    ...Ze,
    modelValue: {
      type: Object,
      default: () => ({
        accountNumber: "",
        bankCode: ""
      })
    },
    codePlaceholder: {
      type: String,
      required: !0
    },
    errorTranslations: {
      type: Object,
      required: !0
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const d = e, r = t, n = de(), { width: a } = Xd(n), s = j(() => x1(d, Object.keys($d({ ...Fe, ...Ze }, "modelValue")))), l = Object.entries(Ed).map((h) => {
      const [C, v] = h;
      return {
        value: Ed[C],
        label: `${v} - ${tr[`${Ed[C]}`]}`
      };
    }), i = j({
      get() {
        return d.modelValue || { accountNumber: "", bankCode: "" };
      },
      set(h) {
        r("update:modelValue", h);
      }
    }), f = j({
      get() {
        var h, C;
        if ((h = i.value) != null && h.bankCode) {
          const v = (C = l.find((M) => M.value === i.value.bankCode)) == null ? void 0 : C.value;
          if (v)
            return {
              label: v,
              value: v
            };
        }
        return null;
      },
      set(h) {
        h && (i.value = {
          ...i.value || {},
          bankCode: h.value
        });
      }
    }), p = j(() => {
      const h = {
        accountNumber: "",
        bankCode: ""
      };
      return d.error && (i.value.accountNumber || (h.accountNumber = d.errorTranslations.accountNumber.required), i.value.bankCode || (h.bankCode = d.errorTranslations.bankCode), i.value.accountNumber && !i.value.bankCode && (h.accountNumber = ""), i.value.accountNumber && i.value.bankCode && (h.accountNumber = d.errorTranslations.accountNumber.invalid)), h;
    });
    function m(h) {
      i.value = { ...i.value, accountNumber: h };
    }
    return (h, C) => {
      var v;
      return $(), k("div", {
        ref_key: "rootElRef",
        ref: n,
        class: z(["flex gap-2", {
          "flex-col": u(a) < an
        }])
      }, [
        y(n1, fe({
          ...s.value,
          modelValue: ((v = i.value) == null ? void 0 : v.accountNumber) || ""
        }, {
          class: "relative grow cursor-pointer",
          error: !!p.value.accountNumber,
          "error-message": p.value.accountNumber,
          fluid: "",
          required: "",
          "onUpdate:modelValue": C[0] || (C[0] = (M) => m(String(M)))
        }), null, 16, ["error", "error-message"]),
        y(g0, {
          modelValue: f.value,
          "onUpdate:modelValue": C[1] || (C[1] = (M) => f.value = M),
          class: z(["w-1/4 min-w-[180px]", {
            "max-w-[300px]": u(a) >= an
          }]),
          disabled: d.disabled,
          error: !!p.value.bankCode,
          "error-message": p.value.bankCode,
          options: u(l),
          origin: "right",
          placeholder: e.codePlaceholder,
          required: "",
          style: { "--max-height": "400px" }
        }, null, 8, ["modelValue", "class", "disabled", "error", "error-message", "options", "placeholder"])
      ], 2);
    };
  }
}), Ul = { class: "w-[340px] rounded-xl bg-white px-8 pb-6 pt-7 sm:w-[375px]" }, Wl = /* @__PURE__ */ X({
  __name: "CfgDateField",
  props: /* @__PURE__ */ ye({
    ...Fe,
    ...Ze,
    ..._n,
    allowedPlacements: {
      type: m0.allowedPlacements.type,
      default: () => ["bottom"]
    }
  }, {
    modelValue: { default: null },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, d = j(() => x1(t, Object.keys({ ...Fe, ...Ze }))), r = ze(e, "modelValue"), n = j(() => r.value ? Te(r.value).format("D. M. YYYY") : ""), a = de(!1);
    function s() {
      P1(() => {
        a.value = !1;
      });
    }
    return (l, i) => ($(), _(Yn, {
      opened: a.value,
      "onUpdate:opened": i[1] || (i[1] = (f) => a.value = f),
      "allowed-placements": e.allowedPlacements,
      "min-width": 340,
      "use-trigger-content-width": !0
    }, {
      trigger: b(() => [
        y(n1, fe({
          ...d.value,
          modelValue: n.value,
          readonly: !0,
          fluid: !0
        }, {
          class: "relative cursor-pointer",
          "field-class": "!bg-white"
        }), {
          icon: b(() => [
            y(u(Jd), {
              class: z(["text-[1.5rem] transition-colors duration-200", { "text-brand": a.value, "text-grey-300": !a.value }])
            }, null, 8, ["class"])
          ]),
          _: 1
        }, 16)
      ]),
      content: b(() => [
        x("div", Ul, [
          y(ks, {
            modelValue: r.value,
            "onUpdate:modelValue": i[0] || (i[0] = (f) => r.value = f),
            "max-date": l.maxDate,
            "min-date": l.minDate,
            onSelectDate: s
          }, null, 8, ["modelValue", "max-date", "min-date"])
        ])
      ]),
      _: 1
    }, 8, ["opened", "allowed-placements"]));
  }
}), Yl = { class: "grow" }, ln = 450, g5 = /* @__PURE__ */ X({
  __name: "CfgBirthNumberField",
  props: /* @__PURE__ */ ye({
    ...Fe,
    ...Ze,
    translates: {
      type: Object,
      required: !0
    }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, d = j(() => x1(t, Object.keys({ ...Fe, ...Ze }))), r = ze(e, "modelValue"), n = de(), { width: a } = Xd(n), s = j({
      get() {
        var p;
        return ((p = r.value) == null ? void 0 : p.birthDate) || null;
      },
      set(p) {
        p && f({
          birthDate: p
        });
      }
    });
    function l(p) {
      f({ birthNumber: p });
    }
    function i() {
      var p;
      (p = r.value) != null && p.birthNumber && dr.validateBirthNumber(r.value.birthNumber) && f({
        birthDate: nr(r.value.birthNumber)
      });
    }
    function f(p) {
      r.value = {
        ...r.value || { birthDate: null, birthNumber: "" },
        ...p
      };
    }
    return (p, m) => {
      var h;
      return $(), k("div", {
        ref_key: "rootElRef",
        ref: n,
        class: z(["flex gap-2", { "flex-col": u(a) < ln }])
      }, [
        x("div", Yl, [
          y(n1, fe({
            ...d.value,
            modelValue: ((h = r.value) == null ? void 0 : h.birthNumber) || "",
            placeholder: e.translates.birthNumberPlaceholder,
            fluid: !0
          }, {
            class: "relative cursor-pointer",
            required: "",
            onBlur: i,
            "onUpdate:modelValue": m[0] || (m[0] = (C) => l(C.toString()))
          }), null, 16)
        ]),
        y(Wl, {
          modelValue: s.value,
          "onUpdate:modelValue": m[1] || (m[1] = (C) => s.value = C),
          class: z({ "w-[240px]": u(a) >= ln }),
          disabled: t.disabled,
          placeholder: e.translates.birthDatePlaceholder
        }, null, 8, ["modelValue", "class", "disabled", "placeholder"])
      ], 2);
    };
  }
}), Kl = { class: "relative flex h-6 items-center" }, Zl = { class: "flex h-full items-center gap-1" }, Zn = /* @__PURE__ */ X({
  __name: "Collaterals",
  props: {
    label: {},
    moreLabel: {},
    slideOverTitle: {},
    slideOverSubtitle: {},
    collaterals: {},
    moreTypesLabel: {},
    tooltipButtonLabel: {},
    isMobile: { type: Boolean },
    isPublic: { type: Boolean }
  },
  emits: ["showDetails"],
  setup(e) {
    return (t, d) => {
      const r = g1("ripple");
      return $(), k("div", Kl, [
        x("div", Zl, [
          ($(!0), k(ae, null, he(t.collaterals.length, (n) => ($(), k("div", {
            key: n,
            class: "h-[9.5px] w-[12px] shrink-0 rounded-full bg-brand"
          }))), 128))
        ]),
        t.collaterals.length ? ($(), _(u(O), {
          key: 0,
          class: "ml-3 line-clamp-1 text-left",
          size: u(H).sm
        }, {
          default: b(() => [
            R(E(t.moreTypesLabel), 1)
          ]),
          _: 1
        }, 8, ["size"])) : P("", !0),
        Ge(($(), k("button", {
          class: "ml-1 size-10 -translate-x-1.5 pl-1.5 hover:opacity-60",
          onClick: d[0] || (d[0] = Qe((n) => t.$emit("showDetails"), ["prevent", "stop"]))
        }, [
          t.collaterals.length ? ($(), _(u(O), {
            key: 0,
            class: "line-clamp-1 text-left !font-medium text-orange underline",
            size: u(H).sm
          }, {
            default: b(() => d[1] || (d[1] = [
              R(" více ")
            ])),
            _: 1
          }, 8, ["size"])) : P("", !0)
        ])), [
          [r]
        ])
      ]);
    };
  }
}), od = /* @__PURE__ */ X({
  __name: "RatingChip",
  props: {
    rating: {},
    ratingLabel: {}
  },
  setup(e) {
    const t = j(() => {
      switch (e.rating) {
        case "A":
          return "!bg-[#27AE60]";
        case "B":
          return "!bg-[#70CC2D]";
        case "C":
          return "!bg-[#9CBD08]";
        case "D":
          return "!bg-[#E9BB00]";
        case "E":
          return "!bg-[#F28500]";
        default:
          return "!bg-success-200 !text-success";
      }
    });
    return (d, r) => ($(), _(u(sd), {
      class: z(["!rounded-lg !text-white [&_span]:!text-[13px] [&_span]:!font-medium", t.value])
    }, {
      default: b(() => [
        R(E(d.rating) + " " + E(d.ratingLabel), 1)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), ql = { class: "relative flex h-[187px] w-full items-start justify-end gap-2 p-3 pb-0" }, Jl = ["src"], Xl = {
  key: 1,
  class: "absolute inset-0 size-full rounded-t-xl bg-grey"
}, Ql = /* @__PURE__ */ X({
  __name: "Header",
  props: {
    tags: {},
    rating: {},
    imageUrl: {}
  },
  setup(e) {
    return (t, d) => ($(), k("div", ql, [
      t.imageUrl ? ($(), k("img", {
        key: 0,
        class: "absolute inset-0 size-full rounded-t-xl object-cover",
        draggable: "false",
        loading: "lazy",
        src: t.imageUrl
      }, null, 8, Jl)) : ($(), k("div", Xl)),
      y(od, fe({ class: "absolute bottom-0 left-5 translate-y-1/2" }, t.rating), null, 16),
      ($(!0), k(ae, null, he(t.tags, (r, n) => ($(), _(u(sd), {
        key: n,
        class: z(["relative !rounded-lg [&_span]:!font-medium", {
          "!bg-brand text-white": n === 0,
          "!bg-stroke-gray !text-black": n === 1
        }])
      }, {
        default: b(() => [
          R(E(r), 1)
        ]),
        _: 2
      }, 1032, ["class"]))), 128))
    ]));
  }
}), e3 = { class: "flex items-center" }, t3 = /* @__PURE__ */ X({
  __name: "Info",
  props: {
    minimumInvestmentLabel: {},
    minimumInvestmentValue: {},
    periodicityLabel: {},
    periodicityValue: {},
    maturityDateLabel: {},
    maturityDateValue: {},
    investorCountLabel: {},
    investorCountValue: {},
    desktop: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = Xt("target"), d = de(!1);
    if (typeof window < "u" && "IntersectionObserver" in window) {
      let p = function() {
        t.value && t.value instanceof HTMLElement && h.observe(t.value);
      }, m = function() {
        h.disconnect();
      };
      const h = new IntersectionObserver((C) => {
        C.forEach((v) => {
          d.value = v.isIntersecting;
        });
      }, { threshold: 1 });
      r1(p), id(m);
    } else
      d.value = !0;
    const n = de(0), a = de("initial");
    function s(p, m = 10, h = 25, C = 1.6, v = 2) {
      const M = Math.log(p / h) / Math.log(m);
      return Math.min(v, Math.max(C, M));
    }
    async function l() {
      const p = (await import("gsap")).default, m = { val: 0 };
      return new Promise((h) => {
        p.to(m, {
          ease: "power1.inOut",
          val: e.investorCountValue,
          delay: 0.3,
          duration: s(e.investorCountValue),
          onStart() {
            n.value = 0, a.value = "running";
          },
          onComplete() {
            n.value = e.investorCountValue, a.value = "finished", h();
          },
          onUpdate() {
            n.value = Math.round(m.val);
          }
        });
      });
    }
    Ce(d, (p) => {
      p && a.value === "initial" && l();
    });
    const i = j(() => ({
      minimumInvestment: {
        icon: xn,
        label: e.minimumInvestmentLabel,
        value: e.minimumInvestmentValue
      },
      periodicity: {
        icon: wn,
        label: e.periodicityLabel,
        value: e.periodicityValue
      },
      investorCount: {
        icon: A2,
        label: e.investorCountLabel,
        value: n.value
      }
    })), f = j(
      () => e.desktop ? {
        wrapper: "grid-cols-3 divide-x",
        item: "flex-col items-start",
        icon: "",
        label: "lg:!text-grey",
        value: "!font-extrabold mt-1.5"
      } : {
        wrapper: "gap-3",
        item: "items-center",
        icon: "",
        label: "",
        value: "!font-semibold ml-auto"
      }
    );
    return (p, m) => ($(), k("div", {
      ref_key: "target",
      ref: t,
      class: z(["grid place-items-start divide-stroke-gray", f.value.wrapper])
    }, [
      ($(!0), k(ae, null, he(i.value, (h, C, v) => ($(), k("div", {
        key: C,
        class: z(["flex w-full items-start justify-between", [f.value.item, p.desktop && v !== 0 && "pl-12"]])
      }, [
        x("div", e3, [
          p.desktop ? P("", !0) : ($(), _(Oe(h.icon), {
            key: 0,
            class: z(["mr-3 inline-block shrink-0 text-[24px] text-grey", f.value.icon])
          }, null, 8, ["class"])),
          y(u(O), {
            class: z([f.value.label]),
            size: u(H).sm
          }, {
            default: b(() => [
              R(E(h.label), 1)
            ]),
            _: 2
          }, 1032, ["class", "size"])
        ]),
        y(u(O), {
          class: z(["transition-colors delay-300 duration-300", [
            f.value.value,
            C === "investorCount" && a.value !== "finished" && "text-brand"
          ]]),
          size: p.desktop ? u(H).h5 : u(H).sm
        }, {
          default: b(() => [
            R(E(h.value), 1)
          ]),
          _: 2
        }, 1032, ["class", "size"])
      ], 2))), 128))
    ], 2));
  }
}), d3 = ["href"], n3 = { class: "flex h-full flex-col rounded-xl bg-white p-0 shadow-card" }, r3 = { class: "flex w-full grow flex-col items-stretch p-5 pt-6" }, s3 = { class: "flex items-start justify-between gap-2" }, o3 = /* @__PURE__ */ X({
  __name: "Card",
  props: {
    name: {},
    interestRateFormatted: {},
    buttonLabel: {},
    issueUrl: {},
    header: {},
    info: {},
    collaterals: {},
    progress: {},
    monthsUntilMaturity: {},
    maturityLabel: {}
  },
  emits: ["openCalculator", "openIssue"],
  setup(e) {
    const t = de(!1);
    return (d, r) => {
      const n = g1("ripple");
      return $(), k(ae, null, [
        Ge(($(), k("a", {
          class: "outline-primary focus-visible:outline-primary h-full rounded-xl outline-offset-4 focus:outline-none",
          href: d.issueUrl,
          onClick: r[2] || (r[2] = Qe((a) => d.$emit("openIssue"), ["prevent"]))
        }, [
          x("div", n3, [
            y(Ql, A1(X1(d.header)), null, 16),
            x("div", r3, [
              x("div", s3, [
                y(u(O), {
                  class: "relative line-clamp-2 text-balance text-left !font-extrabold",
                  size: u(H).h5
                }, {
                  default: b(() => [
                    R(E(d.name), 1)
                  ]),
                  _: 1
                }, 8, ["size"]),
                d.interestRateFormatted ? ($(), _(u(O), {
                  key: 0,
                  class: "shrink-0 !font-extrabold text-brand",
                  size: u(H).h3
                }, {
                  default: b(() => [
                    R(E(d.interestRateFormatted) + " ", 1),
                    r[5] || (r[5] = x("span", { class: "text-[13px] !font-medium text-brand" }, " p.a. ", -1))
                  ]),
                  _: 1
                }, 8, ["size"])) : P("", !0)
              ]),
              y(Zn, fe(d.collaterals, {
                class: "mt-2",
                onShowDetails: r[0] || (r[0] = (a) => t.value = !0)
              }), null, 16),
              y(t3, fe({ class: "mt-5" }, d.info), null, 16),
              r[6] || (r[6] = x("div", { class: "grow" }, null, -1)),
              y(u(I1), {
                class: "issue-card-button relative z-0 mt-7 w-full rounded-full",
                stroke: "",
                variant: "orange",
                onClick: r[1] || (r[1] = (a) => d.$emit("openIssue"))
              }, {
                icon: b(() => [
                  y(u(D1), { class: "text-[24px]" })
                ]),
                default: b(() => [
                  y(u(O), {
                    class: "!font-semibold",
                    size: u(H).md
                  }, {
                    default: b(() => [
                      R(E(d.buttonLabel), 1)
                    ]),
                    _: 1
                  }, 8, ["size"])
                ]),
                _: 1
              }),
              y(u(O), {
                class: "mt-4 text-center !text-[13px] !font-medium text-secondary",
                "tag-name": "div"
              }, {
                default: b(() => [
                  R(E(d.maturityLabel) + " " + E(d.monthsUntilMaturity), 1)
                ]),
                _: 1
              })
            ])
          ])
        ], 8, d3)), [
          [n]
        ]),
        y(u(hi), fe({
          "is-opened": t.value,
          "onUpdate:isOpened": r[3] || (r[3] = (a) => t.value = a)
        }, d.collaterals, {
          onOpenCalculator: r[4] || (r[4] = (a) => d.$emit("openCalculator"))
        }), {
          collateralsCta: b(() => [
            W(d.$slots, "collateralsCta", {}, void 0, !0)
          ]),
          _: 3
        }, 16, ["is-opened"])
      ], 64);
    };
  }
}), h5 = /* @__PURE__ */ h1(o3, [["__scopeId", "data-v-e19ef9d4"]]), a3 = { class: "flex grow items-start justify-between" }, l3 = { class: "flex shrink-0 justify-between" }, i3 = {
  key: 1,
  class: "relative size-6 items-center"
}, qn = /* @__PURE__ */ X({
  inheritAttrs: !1,
  __name: "CfgOverlayPanelContent",
  props: {
    title: {},
    description: {},
    flat: { type: Boolean },
    closable: { type: Boolean, default: !0 },
    isBackAllowed: { type: Boolean },
    renderClose: { type: Boolean, default: !0 },
    disableBottomPadding: { type: Boolean },
    closeButtonClasses: {},
    fullHeight: { type: Boolean },
    minimalHeader: { type: Boolean },
    headerClasses: {},
    disableMainPadding: { type: Boolean }
  },
  emits: ["close", "back"],
  setup(e) {
    const t = e, d = ["px-", "pr-", "pl"], r = ud(), n = de(null), a = j(() => r.class ?? ""), s = j(() => t.closeButtonClasses), l = j(() => t.flat ? !1 : !d.some((f) => a.value.includes(f))), i = j(
      () => t.minimalHeader ? "w-8 h-7" : "bg-grey-100 rounded-full size-11"
    );
    return (f, p) => {
      const m = g1("ripple");
      return $(), _(u(Pa), {
        ref_key: "scrollbarView",
        ref: n,
        class: z(["shadow-xl flex h-full flex-col rounded-t-xl bg-white", {
          [a.value]: !0,
          "pb-6 ": !f.disableBottomPadding
        }])
      }, {
        default: b(() => {
          var h;
          return [
            f.title || f.description || f.$slots.head ? ($(), k("header", {
              key: 0,
              class: z(["z-sticky flex border-b border-b-grey-100 bg-white transition-shadow duration-200", {
                "px-5 sm:px-9": l.value && !f.minimalHeader,
                "shadow-light": (((h = n.value) == null ? void 0 : h.scrollPositionY) || 0) > 0 && (f.title || f.description),
                "sticky top-0": f.title || f.description,
                "px-5 py-4": f.minimalHeader,
                "py-5": !f.minimalHeader
              }]),
              name: "head"
            }, [
              x("div", a3, [
                x("div", {
                  class: z(["w-full", {
                    "flex flex-col max-lg:ml-8 max-lg:items-center": f.minimalHeader,
                    [f.headerClasses]: !0
                  }])
                }, [
                  W(f.$slots, "head", {}, () => [
                    f.title ? ($(), _(u(O), {
                      key: 0,
                      size: u(H).h2,
                      "tag-name": "h3"
                    }, {
                      default: b(() => [
                        R(E(f.title), 1)
                      ]),
                      _: 1
                    }, 8, ["size"])) : P("", !0),
                    f.description ? ($(), _(u(O), {
                      key: 1,
                      class: "mt-2 text-grey-300",
                      size: u(H).sm,
                      "tag-name": "p"
                    }, {
                      default: b(() => [
                        R(E(f.description), 1)
                      ]),
                      _: 1
                    }, 8, ["size"])) : P("", !0)
                  ])
                ], 2)
              ]),
              x("div", l3, [
                f.isBackAllowed ? ($(), k("button", {
                  key: 0,
                  class: z(["flex items-center justify-center ring-brand focus-visible:outline-brand focus-visible:ring", {
                    "size-10": f.minimalHeader,
                    "size-11 rounded-full bg-grey-100": !f.minimalHeader
                  }]),
                  type: "button",
                  onClick: p[0] || (p[0] = (C) => f.$emit("back"))
                }, [
                  y(u(D2))
                ], 2)) : P("", !0),
                f.closable && f.renderClose ? ($(), k("div", i3, [
                  Ge(($(), k("button", {
                    class: z(["flex -translate-x-4 -translate-y-1 items-center justify-center ring-brand focus-visible:outline-brand focus-visible:ring", s.value ?? i.value]),
                    type: "button",
                    onClick: p[1] || (p[1] = (C) => f.$emit("close"))
                  }, [
                    y(u(u1), {
                      class: z({ "text-[19px] lg:text-[24px]": f.minimalHeader })
                    }, null, 8, ["class"])
                  ], 2)), [
                    [m]
                  ])
                ])) : P("", !0)
              ])
            ], 2)) : P("", !0),
            x("main", {
              class: z(["relative flex flex-1 [&>*]:flex-1", {
                "px-5 first-of-type:mt-5 sm:px-9 lg:first-of-type:mt-8 ": l.value && !f.disableMainPadding
              }])
            }, [
              W(f.$slots, "default")
            ], 2)
          ];
        }),
        _: 3
      }, 8, ["class"]);
    };
  }
}), u3 = { class: "fixed inset-0 overflow-hidden" }, c3 = { class: "pointer-events-none fixed inset-x-0 bottom-0 flex size-full" }, f3 = /* @__PURE__ */ X({
  inheritAttrs: !1,
  __name: "CfgBottomSheet",
  props: {
    opened: { type: Boolean },
    unmount: { type: Boolean },
    onBack: { type: Function, default: void 0 },
    dialogClasses: {},
    panelClasses: {},
    title: { default: "" },
    description: { default: "" },
    flat: { type: Boolean },
    closable: { type: Boolean, default: !0 },
    renderClose: { type: Boolean, default: !0 },
    disableBottomPadding: { type: Boolean },
    closeButtonClasses: {},
    fullHeight: { type: Boolean },
    minimalHeader: { type: Boolean },
    headerClasses: {},
    disableMainPadding: { type: Boolean }
  },
  emits: ["update:opened"],
  setup(e, { emit: t }) {
    const d = e, r = t, n = j(() => $d(d, ["opened", "unmount", "onBack"]));
    function a() {
      !d.closable && d.onBack && d.onBack(), d.closable && r("update:opened", !1);
    }
    return (s, l) => ($(), _(u(t0), {
      as: "template",
      show: s.opened
    }, {
      default: b(() => [
        y(u(d0), {
          as: "div",
          class: z(["relative z-modal", s.dialogClasses]),
          unmount: s.unmount ?? !1,
          onClose: a
        }, {
          default: b(() => [
            y(u(nt), {
              as: "template",
              enter: "ease-in-out duration-500",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in-out duration-500",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: b(() => l[0] || (l[0] = [
                x("div", { class: "fixed inset-0 bg-dark/30 transition-opacity" }, null, -1)
              ])),
              _: 1
            }),
            x("div", u3, [
              x("div", {
                class: "absolute inset-0",
                onClose: a
              }, [
                x("div", c3, [
                  y(u(nt), {
                    as: "template",
                    enter: "transform transition ease-in-out duration-500 sm:duration-700",
                    "enter-from": "translate-y-full",
                    "enter-to": "translate-y-0",
                    leave: "transform transition ease-in-out duration-500 sm:duration-700",
                    "leave-from": "translate-y-0",
                    "leave-to": "translate-y-full"
                  }, {
                    default: b(() => [
                      y(u(n0), {
                        class: z(["pointer-events-auto h-[calc(100%-70px)] w-full self-end", s.panelClasses])
                      }, {
                        default: b(() => [
                          y(qn, fe({ ...n.value, ...s.$attrs }, {
                            "is-back-allowed": !!d.onBack,
                            onBack: d.onBack,
                            onClose: a
                          }), Dt({
                            default: b(() => [
                              W(s.$slots, "default")
                            ]),
                            _: 2
                          }, [
                            s.$slots.head ? {
                              name: "head",
                              fn: b(() => [
                                W(s.$slots, "head")
                              ]),
                              key: "0"
                            } : void 0
                          ]), 1040, ["is-back-allowed", "onBack"])
                        ]),
                        _: 3
                      }, 8, ["class"])
                    ]),
                    _: 3
                  })
                ])
              ], 32)
            ])
          ]),
          _: 3
        }, 8, ["class", "unmount"])
      ]),
      _: 3
    }, 8, ["show"]));
  }
});
var Re = /* @__PURE__ */ ((e) => (e.Input = "input", e.Textarea = "textarea", e.DateField = "dateField", e.Select = "select", e.Multiselect = "multiselect", e.Combobox = "combobox", e.Radio = "radio", e.Switch = "switch", e.Checkbox = "checkbox", e.RadioGroup = "radioGroup", e.CheckboxGroup = "checkboxGroup", e.AccountNumber = "accountNumber", e.Slider = "slider", e.RangeSlider = "rangeSlider", e.BirthNumberField = "birthNumberField", e.AddressDetailsField = "addressDetailsField", e.PasswordField = "passwordField", e.PhoneNumberField = "phoneNumberField", e))(Re || {});
function v5(e, t) {
  const d = Object.entries(e).reduce((a, [s, l]) => {
    const {
      value: i,
      cols: f = 2,
      validators: p = [],
      classNames: m,
      show: h,
      ...C
    } = l;
    return a[s] = {
      component: l.control,
      props: C,
      modelValue: i,
      validators: p,
      cols: f,
      show: h,
      _visible: !0,
      attributes: {
        classNames: m
      }
    }, a;
  }, {}), r = Kd(
    Object.fromEntries(
      Object.entries(d).map((a) => {
        const [s, l] = a;
        return [s, {
          ...bt(l),
          props: l.props
          // pass props separately to avoid loosing reactivity
        }];
      })
    )
  );
  Ce(() => t, () => {
    if (t) {
      let a = t;
      dt(t) && (a = t.value), Object.entries(a).forEach((s) => {
        const [l, i] = s;
        r[l].modelValue = bt(i);
      });
    }
  }, { deep: !0, immediate: !0 });
  const n = j(() => Jn(r));
  return vn(() => {
    Object.entries(n.value).forEach((a) => {
      const [s] = a, l = r == null ? void 0 : r[s];
      l._visible = jd(l.show) ? !0 : l.show({ state: n.value });
    });
  }), {
    results: n,
    schema: r,
    resetData() {
      Object.entries(r).forEach((a) => {
        const [s] = a;
        r[s].modelValue = t ? (dt(t) ? t.value : t)[s] : bt(e[s].value);
      });
    }
  };
}
function Jn(e) {
  return Object.entries(e).reduce(
    (t, [d, r]) => ({
      ...t,
      [d]: r.modelValue
    }),
    {}
  );
}
const $3 = {
  key: 0,
  class: "flex justify-center"
}, p3 = /* @__PURE__ */ X({
  __name: "CfgForm",
  props: {
    /**
     * The schema of the form. Can be generated useForm hook
     */
    schema: {
      type: Object,
      required: !0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    /**
     * The label of the submit button. Default button will be replaced with slot name submit. Contains onSubmit event in slot props.
     * For example: v-slot={ onSubmit }
     */
    buttonLabel: {
      type: String,
      default: "DEFAULT_BUTTON_LABEL"
    },
    /**
     * Controls whether the submit button should be rendered or not
     */
    renderSubmitButton: {
      type: Boolean,
      default: !0
    },
    /**
     * Controls whether the submit button should be hidden or not, but still rendered
     */
    hideSubmitButton: {
      type: Boolean,
      default: !1
    },
    /**
     * Shows elements placed horizontally - next to each other
     */
    horizontal: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["submit"],
  async setup(e, { expose: t, emit: d }) {
    let r, n;
    const a = e, s = d, { schema: l, loading: i } = fd(a), f = j(() => vr(l.value, (T) => (T == null ? void 0 : T._visible) !== !1)), p = de(null), m = de(null), { width: h } = St(p), C = j(() => h.value > 500), v = Object.fromEntries(Object.keys(l).map((T) => [T, null])), M = {
      [Re.Input]: async () => (await import("./CfgInput-DHXRPOo4.js")).default,
      [Re.Textarea]: async () => (await import("./CfgTextarea-DIm7nH6k.js")).default,
      [Re.DateField]: async () => (await import("./CfgDateField-BfVgmlao.js")).default,
      [Re.Select]: async () => (await import("./index-WH4ilA3X.js")).CfgSelect,
      [Re.Multiselect]: async () => (await import("./index-WH4ilA3X.js")).CfgSelect,
      [Re.Combobox]: async () => (await import("./index-WH4ilA3X.js")).CfgCombobox,
      [Re.Radio]: async () => (await import("./index-B2_xJ9nC.js")).CfgRadio,
      [Re.Switch]: async () => (await import("./index-B2_xJ9nC.js")).CfgSwitch,
      [Re.Checkbox]: async () => (await import("./index-B2_xJ9nC.js")).CfgCheckbox,
      [Re.RadioGroup]: async () => (await import("./index-WH4ilA3X.js")).CfgRadioGroup,
      [Re.CheckboxGroup]: async () => (await import("./index-WH4ilA3X.js")).CfgCheckboxGroup,
      [Re.AccountNumber]: async () => (await import("./CfgBankAccountField-B-5PxEPq.js")).default,
      [Re.Slider]: async () => (await import("./index-WH4ilA3X.js")).CfgSlider,
      [Re.RangeSlider]: async () => (await import("./index-WH4ilA3X.js")).CfgSlider,
      [Re.BirthNumberField]: async () => (await import("./CfgBirthNumberField-BRdKfdyF.js")).default,
      [Re.AddressDetailsField]: async () => (await import("./CfgAddressDetailsField-R14TQnF6.js")).default,
      [Re.PasswordField]: async () => (await import("./CfgPasswordField-e1IwjUM9.js")).default,
      [Re.PhoneNumberField]: async () => (await import("./CfgPhoneNumberField-Djbr4K9N.js")).default
    };
    t({
      resetForm() {
        var T;
        (T = m.value) == null || T.resetForm();
      },
      async submit() {
        return m.value ? m.value.submit() : !1;
      }
    }), [r, n] = ld(() => S()), await r, n();
    async function S() {
      (await Promise.all(
        Object.entries(l.value).map(async (g) => {
          const [I, N] = g, Z = await M[N.component]();
          return [I, Z];
        })
      )).forEach(([g, I]) => {
        v[g] = I;
      });
    }
    function L() {
      s("submit", Jn(l.value));
    }
    return (T, g) => ($(), k("div", null, [
      y(Ya, {
        ref_key: "validationObserverRef",
        ref: m,
        onSubmit: L
      }, {
        default: b((I) => [
          x("form", {
            ref_key: "formRoot",
            ref: p,
            class: "cfg-form space-y-4 pt-2",
            novalidate: "",
            onSubmit: g[0] || (g[0] = Qe(() => {
            }, ["prevent"]))
          }, [
            x("div", {
              class: z(["grid gap-5", e.horizontal ? "cfg-table-form-container-horizontal" : "grid-cols-2"])
            }, [
              ($(!0), k(ae, null, he(f.value, (N, Z) => ($(), k("div", {
                key: Z,
                class: z({
                  "col-span-1": N.cols === 1 && C.value,
                  "col-span-2": N.cols === 2 || !C.value,
                  [`cfg-form__field--${N.component}`]: !0,
                  [N.attributes.classNames]: !!N.attributes.classNames
                })
              }, [
                W(T.$slots, `before:${Z}`, {}, void 0, !0),
                y(Wn, fe({
                  modelValue: N.modelValue,
                  "onUpdate:modelValue": (Y) => N.modelValue = Y,
                  validators: N.validators
                }, wt(I.on)), {
                  default: b(({ on: Y, attrs: G }) => [
                    ($(), _(Oe(u(v)[Z]), fe({ ref_for: !0 }, {
                      // User's passed props
                      ...u($d)(N.props, "control"),
                      ...G,
                      loading: N.props.loading || G.loading
                    }, { class: "w-full" }, wt(Y)), null, 16))
                  ]),
                  _: 2
                }, 1040, ["modelValue", "onUpdate:modelValue", "validators"]),
                W(T.$slots, `after:${Z}`, {}, void 0, !0)
              ], 2))), 128))
            ], 2),
            e.renderSubmitButton ? ($(), k("div", $3, [
              W(T.$slots, "submit", {
                onSubmit: I.submit
              }, () => [
                y(I1, {
                  class: z(["mt-4 w-full", {
                    hidden: e.hideSubmitButton
                  }]),
                  fluid: "",
                  loading: u(i) || I.validationLoading,
                  "ripple-scale": "",
                  type: "submit",
                  onClick: I.submit
                }, {
                  default: b(() => [
                    R(E(e.buttonLabel), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "loading", "onClick"])
              ], !0)
            ])) : P("", !0)
          ], 544)
        ]),
        _: 3
      }, 512)
    ]));
  }
}), b5 = /* @__PURE__ */ h1(p3, [["__scopeId", "data-v-1625dcfc"]]), m3 = { class: "rounded-md" }, g3 = { class: "flex w-full flex-row items-center justify-between space-y-2 lg:flex-col lg:items-start lg:justify-start" }, h3 = { class: "!mt-0 flex flex-row gap-x-2 lg:!mt-2" }, v3 = ["innerHTML"], b3 = ["innerHTML"], y3 = ["innerHTML"], x3 = { class: "mt-4" }, w3 = { class: "flex items-center justify-between pb-8" }, C3 = { class: "mt-7 flex flex-wrap justify-start gap-4 lg:gap-x-20" }, k3 = { key: 0 }, S3 = { class: "space-y-1" }, M3 = ["innerHTML"], T3 = { class: "space-y-2" }, L3 = { class: "space-y-1" }, A3 = ["innerHTML"], y5 = /* @__PURE__ */ X({
  __name: "CfgInvestCalculator",
  props: /* @__PURE__ */ ye({
    /**
     * Main parameters on the top of the calculator
     */
    mainParameters: {
      type: Object,
      default: () => ({})
    },
    /**
     * Translations for calculator
     */
    translations: {
      type: Object,
      required: !0
    },
    /**
     * Minimum investment amount
     */
    minInvestment: {
      type: Number,
      required: !0
    },
    /**
     * Max investment amount
     */
    maxInvestment: {
      type: Number,
      required: !0
    },
    /**
     * Show periodic result under slider, should not show on ReturnsPeriodicityEnum.OneTime
     */
    showPeriodicResult: {
      type: Boolean,
      required: !0
    },
    /**
     * Show periodic result and whole period result
     */
    result: {
      type: [Object, null],
      default: null
    },
    /**
     * Each change on slider will increment and decrement by this value
     */
    stepValue: {
      type: Number,
      required: !0
    }
  }, {
    modelValue: { required: !0, type: Number },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ye(["slider:dragEnd"], ["update:modelValue"]),
  setup(e) {
    const t = e, d = ze(e, "modelValue"), r = de(Gt(d.value, !0)), n = j(() => t.stepValue ?? 0);
    function a(s) {
      const l = (s ?? r.value).replace(/\s/g, ""), i = rr(Number(l), {
        min: t.minInvestment,
        max: t.maxInvestment,
        step: n.value
      });
      d.value = i, r.value = Gt(i, !0);
    }
    return Ce(d, (s) => {
      const l = Gt(s, !0);
      r.value !== l && (r.value = Gt(s, !0));
    }, { deep: !0 }), (s, l) => {
      var i, f;
      return $(), k("div", m3, [
        W(s.$slots, "searchInput"),
        Object.keys(e.mainParameters).length ? ($(), k("ul", {
          key: 0,
          class: z(["mb-10 flex flex-col flex-wrap gap-y-2 lg:flex-row lg:justify-between", {
            "gap-x-5": Object.keys(e.mainParameters).length > 2,
            "gap-x-10": Object.keys(e.mainParameters).length <= 2
          }])
        }, [
          ($(!0), k(ae, null, he(e.mainParameters, ({ label: p, tooltip: m, description: h, value: C }, v) => ($(), k("li", { key: v }, [
            y(u(et), {
              class: "w-full",
              disabled: !m,
              "hide-icon": "",
              interactive: ""
            }, {
              trigger: b(() => [
                x("div", g3, [
                  W(s.$slots, `${v}:label`, { label: p }, () => [
                    y(u(O), {
                      class: "flex items-center gap-x-1.5 text-grey-300",
                      size: u(H).xs
                    }, {
                      default: b(() => [
                        R(E(p) + " ", 1),
                        m ? ($(), _(u(ht), {
                          key: 0,
                          class: "hidden text-[20px] lg:block"
                        })) : P("", !0)
                      ]),
                      _: 2
                    }, 1032, ["size"])
                  ]),
                  x("div", h3, [
                    y(u(O), {
                      class: "flex flex-col items-end !font-highlighted lg:items-start",
                      size: u(H).md,
                      "tag-name": "strong"
                    }, {
                      default: b(() => [
                        W(s.$slots, `${v}:value`, { value: C }, () => [
                          x("span", {
                            class: "block w-max",
                            innerHTML: C
                          }, null, 8, v3)
                        ]),
                        W(s.$slots, `${v}:description`, { description: h }, () => [
                          h ? ($(), k("small", {
                            key: 0,
                            class: "block text-xs font-normal text-grey-300",
                            innerHTML: h
                          }, null, 8, b3)) : P("", !0)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["size"]),
                    m ? ($(), _(u(ht), {
                      key: 0,
                      class: "text-[20px] text-grey-500 lg:hidden"
                    })) : P("", !0)
                  ])
                ])
              ]),
              content: b(() => [
                W(s.$slots, `${v}:tooltip`, { tooltip: m }, () => [
                  y(u(O), {
                    size: u(H).sm
                  }, {
                    default: b(() => [
                      x("span", { innerHTML: m }, null, 8, y3)
                    ]),
                    _: 2
                  }, 1032, ["size"])
                ])
              ]),
              _: 2
            }, 1032, ["disabled"])
          ]))), 128))
        ], 2)) : P("", !0),
        e.result ? ($(), k(ae, { key: 1 }, [
          y(u(O), {
            size: u(H).h3,
            "tag-name": "h2"
          }, {
            default: b(() => [
              R(E(e.translations.title), 1)
            ]),
            _: 1
          }, 8, ["size"]),
          x("div", x3, [
            x("div", w3, [
              y(u(O), {
                class: "grow text-grey-500",
                size: u(H).h4
              }, {
                default: b(() => [
                  R(E(e.translations.label), 1)
                ]),
                _: 1
              }, 8, ["size"]),
              x("div", null, [
                y(n1, {
                  modelValue: r.value,
                  "onUpdate:modelValue": l[0] || (l[0] = (p) => r.value = p),
                  class: "!w-44 font-highlighted",
                  "field-class": "[&>span]:!py-0 [&>span]:flex [&>span]:items-center",
                  max: e.maxInvestment,
                  min: e.minInvestment,
                  step: n.value,
                  suffix: e.translations.currency,
                  type: "text",
                  onBlur: a,
                  "onKeydown:enter": a
                }, null, 8, ["modelValue", "max", "min", "step", "suffix"])
              ])
            ]),
            y(u(pr), {
              class: "relative flex h-5 w-full touch-none select-none items-center",
              max: e.maxInvestment,
              min: e.minInvestment,
              "model-value": [d.value],
              step: n.value,
              "onUpdate:modelValue": l[1] || (l[1] = ([p] = []) => d.value = p),
              onValueCommit: l[2] || (l[2] = (p) => s.$emit("slider:dragEnd"))
            }, {
              default: b(() => [
                y(u(mr), { class: "relative h-2 grow rounded-full bg-grey-100" }, {
                  default: b(() => [
                    y(u(gr), { class: "absolute h-full rounded-full bg-brand" })
                  ]),
                  _: 1
                }),
                y(u(hr), {
                  "aria-label": "Volume",
                  class: "block size-8 cursor-pointer rounded-full bg-brand transition-colors hover:bg-brand-dark"
                })
              ]),
              _: 1
            }, 8, ["max", "min", "model-value", "step"])
          ]),
          x("div", C3, [
            e.showPeriodicResult ? ($(), k("div", k3, [
              y(u(et), {
                disabled: !((i = e.translations.result.periodic) != null && i.tooltip),
                "hide-icon": "",
                interactive: ""
              }, {
                trigger: b(() => [
                  x("div", S3, [
                    y(u(O), {
                      class: "flex items-center gap-x-1.5 text-center font-highlighted text-grey-300 sm:text-left",
                      size: u(H).sm
                    }, {
                      default: b(() => [
                        R(E(e.translations.result.periodic.label) + " ", 1),
                        e.translations.result.periodic.tooltip ? ($(), _(u(ht), {
                          key: 0,
                          class: "hidden text-[20px] sm:block"
                        })) : P("", !0)
                      ]),
                      _: 1
                    }, 8, ["size"]),
                    y(u(O), {
                      class: "block",
                      size: u(H).h3
                    }, {
                      default: b(() => [
                        R(E(e.result.periodic), 1)
                      ]),
                      _: 1
                    }, 8, ["size"])
                  ])
                ]),
                content: b(({ closeHint: p }) => [
                  W(s.$slots, "periodicResultTooltip", { closeHint: p }, () => [
                    x("span", {
                      innerHTML: e.translations.result.periodic.tooltip
                    }, null, 8, M3)
                  ])
                ]),
                _: 3
              }, 8, ["disabled"])
            ])) : P("", !0),
            x("div", T3, [
              y(u(et), {
                disabled: !((f = e.translations.result.wholePeriod) != null && f.tooltip),
                "hide-icon": "",
                interactive: ""
              }, {
                trigger: b(() => [
                  x("div", L3, [
                    y(u(O), {
                      class: "flex items-center gap-x-1.5 text-center font-highlighted text-grey-300 sm:text-left",
                      size: u(H).sm
                    }, {
                      default: b(() => [
                        R(E(e.translations.result.wholePeriod.label) + " ", 1),
                        e.translations.result.wholePeriod.tooltip ? ($(), _(u(ht), {
                          key: 0,
                          class: "hidden text-[20px] sm:block"
                        })) : P("", !0)
                      ]),
                      _: 1
                    }, 8, ["size"]),
                    y(u(O), {
                      class: "block !font-extrabold text-brand",
                      size: u(H).h3
                    }, {
                      default: b(() => [
                        R(E(e.result.wholePeriod), 1)
                      ]),
                      _: 1
                    }, 8, ["size"])
                  ])
                ]),
                content: b(({ closeHint: p }) => [
                  W(s.$slots, "wholePeriodTooltip", { closeHint: p }, () => [
                    x("span", {
                      innerHTML: e.translations.result.wholePeriod.tooltip
                    }, null, 8, A3)
                  ])
                ]),
                _: 3
              }, 8, ["disabled"])
            ])
          ])
        ], 64)) : P("", !0)
      ]);
    };
  }
}), D3 = { class: "fixed inset-0 overflow-hidden" }, I3 = {
  key: 1,
  class: "flex max-h-full w-full items-center justify-center"
}, E3 = /* @__PURE__ */ X({
  inheritAttrs: !1,
  __name: "CfgSlideOver",
  props: {
    opened: { type: Boolean },
    unmount: { type: Boolean },
    onBack: { type: Function, default: void 0 },
    renderHead: { type: Boolean, default: !0 },
    size: { default: "md" },
    renderClose: { type: Boolean, default: !0 },
    width: { default: void 0 },
    disableBottomPadding: { type: Boolean, default: !1 },
    closeButtonClass: { default: "" },
    fullHeight: { type: Boolean, default: !1 },
    bottom: { type: Boolean, default: !1 },
    topPadding: { default: void 0 },
    headerClasses: {},
    title: {},
    description: {},
    flat: { type: Boolean },
    closable: { type: Boolean, default: !0 },
    closeButtonClasses: {},
    minimalHeader: { type: Boolean },
    disableMainPadding: { type: Boolean }
  },
  emits: ["update:opened"],
  setup(e, { emit: t }) {
    const d = e, r = t, n = de(!1), a = j(() => $d(d, ["opened", "unmount", "onBack"]));
    function s() {
      !d.closable && d.onBack && d.onBack(), d.closable && r("update:opened", !1);
    }
    return (l, i) => ($(), _(u(t0), {
      as: "template",
      show: l.opened
    }, {
      default: b(() => [
        y(u(d0), {
          as: "div",
          class: "relative z-modal",
          unmount: l.unmount ?? !1,
          onClose: s
        }, {
          default: b(() => [
            y(u(nt), {
              as: "template",
              enter: "ease-in-out duration-500",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in-out duration-500",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: b(() => i[2] || (i[2] = [
                x("div", { class: "fixed inset-0 bg-dark/30 transition-opacity" }, null, -1)
              ])),
              _: 1
            }),
            x("div", D3, [
              x("div", {
                class: "absolute inset-0 overflow-hidden",
                onClose: s
              }, [
                x("div", {
                  class: z(["pointer-events-none fixed flex max-w-full", {
                    "bottom-0": l.fullHeight || !l.bottom,
                    "right-0": !l.bottom,
                    "bottom-0 w-full": l.bottom
                  }]),
                  style: Ue({
                    height: l.fullHeight ? l.topPadding ? `calc(100% - ${l.topPadding})` : "100%" : "auto"
                  })
                }, [
                  y(u(nt), {
                    as: "template",
                    enter: "transform transition ease-in-out duration-500 sm:duration-700",
                    "enter-from": l.bottom ? "translate-y-full" : "translate-x-full",
                    "enter-to": l.bottom ? "translate-y-0" : "translate-x-0",
                    leave: "transform transition ease-in-out duration-500 sm:duration-700",
                    "leave-from": l.bottom ? "translate-y-0" : "translate-x-0",
                    "leave-to": l.bottom ? "translate-y-full" : "translate-x-full",
                    onAfterEnter: i[0] || (i[0] = (f) => n.value = !0),
                    onAfterLeave: i[1] || (i[1] = (f) => n.value = !1)
                  }, {
                    default: b(() => [
                      y(u(n0), {
                        class: z(["pointer-events-auto w-screen", {
                          "max-w-sm": !l.width && l.size === "sm",
                          "max-w-xl": !l.width && l.size === "md",
                          "max-w-[700px]": !l.width && l.size === "lg",
                          "h-auto": !l.fullHeight
                        }]),
                        style: Ue(l.width ? { width: l.width } : {})
                      }, {
                        default: b(() => [
                          y(qn, fe({ ...a.value, ...l.$attrs }, {
                            "is-back-allowed": !!d.onBack,
                            onBack: d.onBack,
                            onClose: s
                          }), Dt({
                            default: b(() => [
                              n.value ? W(l.$slots, "default", { key: 0 }) : P("", !0),
                              n.value ? P("", !0) : ($(), k("div", I3, [
                                y(u(It), { class: "text-brand" })
                              ]))
                            ]),
                            _: 2
                          }, [
                            l.$slots.head ? {
                              name: "head",
                              fn: b(() => [
                                W(l.$slots, "head")
                              ]),
                              key: "0"
                            } : void 0
                          ]), 1040, ["is-back-allowed", "onBack"])
                        ]),
                        _: 3
                      }, 8, ["class", "style"])
                    ]),
                    _: 3
                  }, 8, ["enter-from", "enter-to", "leave-from", "leave-to"])
                ], 6)
              ], 32)
            ])
          ]),
          _: 3
        }, 8, ["unmount"])
      ]),
      _: 3
    }, 8, ["show"]));
  }
});
function z3(e, t, d) {
  if (!t)
    return {};
  const r = j(() => e.value.reduce((i, { rows: f }) => i + f.length, 0)), n = j(() => (t.value || []).length === r.value);
  function a(i) {
    if (!(t != null && t.value))
      return;
    if (!i) {
      d([]);
      return;
    }
    const f = [];
    e.value.forEach(({ rows: p }) => {
      p.forEach((m) => {
        var h;
        f.push({
          index: m.originalIndex,
          id: (h = m.meta) == null ? void 0 : h.id
        });
      });
    }), d(f);
  }
  function s(i, f) {
    d(
      l(i, f)
    );
  }
  function l(i, f) {
    return t != null && t.value ? f ? [...t.value, i] : t.value.filter((p) => !Mt(i, p)) : [];
  }
  return {
    toggleAllRowsSelected: a,
    toggleRowSelected: s,
    areAllRowsSelected: n
  };
}
function B3(e, t) {
  return t ? !!t.find((d) => Mt(e, d)) : !1;
}
function P3(e, t) {
  return {
    rowGroups: j(() => e.value.data.reduce((d, r, n) => {
      var i;
      let a = {
        ...r,
        originalIndex: n,
        original: r,
        isSelected: !1,
        isExpended: !1,
        cells: e.value.headers.map(({ keyName: f }) => ({
          keyName: f,
          value: r[f]
        }))
      };
      t.mapEachRow && (a = t.mapEachRow(a));
      const s = (i = e.value.groups) == null ? void 0 : i.find((f) => f.value === a.group);
      if (!s)
        return d.length ? d[0].rows.push(a) : d.push({ value: "", label: "", rows: [a] }), d;
      const l = d.find((f) => f.value === s.value);
      return l ? l.rows.push(a) : d.push({ ...s, rows: [a] }), d;
    }, []))
  };
}
var Xe = /* @__PURE__ */ ((e) => (e.left = "left", e.right = "right", e.center = "center", e))(Xe || {});
const Ut = /* @__PURE__ */ X({
  __name: "CfgTableCell",
  props: {
    flat: { type: Boolean },
    align: {},
    bgColor: {},
    cellIndex: {},
    lastIndex: { type: Boolean },
    expended: { type: Boolean },
    selected: { type: Boolean },
    compact: { type: Boolean },
    expendable: { type: Boolean },
    bulk: {},
    disableStickyHead: { type: Boolean }
  },
  setup(e) {
    return (t, d) => ($(), _(u(O), {
      class: z({
        "pr-5": !t.lastIndex,
        "pl-5 sm:pl-5": !t.flat && !t.lastIndex,
        "lg:pl-8": !t.flat && !t.lastIndex && (t.bulk ? t.cellIndex + 1 : t.cellIndex) === 0,
        "!p-2": t.compact,
        "md:py-3.5": !t.compact,
        "text-center": t.align === u(Xe).center,
        "text-right": t.align === u(Xe).right,
        [t.bgColor ?? ""]: t.bgColor
      }),
      size: u(H).sm,
      "tag-name": "td"
    }, {
      default: b(() => [
        W(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "size"]));
  }
}), Wt = /* @__PURE__ */ X({
  __name: "CfgTableHeadCell",
  props: {
    flat: { type: Boolean },
    align: {},
    bgColor: {},
    cellIndex: {},
    lastIndex: { type: Boolean },
    expended: { type: Boolean },
    selected: { type: Boolean },
    compact: { type: Boolean },
    expendable: { type: Boolean },
    bulk: {},
    disableStickyHead: { type: Boolean },
    sort: {},
    width: {},
    text: {}
  },
  emits: ["sort", "update:pagination", "click:row"],
  setup(e, { emit: t }) {
    const d = t;
    function r(n) {
      d("sort", n);
    }
    return (n, a) => ($(), k("th", {
      class: z(["text-left", {
        "px-5 sm:px-5": !n.flat && !n.lastIndex,
        "lg:px-8": !n.flat && !n.lastIndex && (n.bulk ? n.cellIndex + 1 : n.cellIndex) === 0,
        "!p-2": n.compact,
        "md:py-3.5": !n.compact,
        "text-center": n.align === u(Xe).center,
        "text-right": n.align === u(Xe).right,
        "sticky top-0 z-sticky": !n.disableStickyHead,
        [n.bgColor ?? ""]: n.bgColor,
        "bg-white/30": !n.bgColor
      }]),
      scope: "col",
      style: Ue({
        ...n.width ? { width: n.width } : {}
      })
    }, [
      ($(), _(Oe(n.sort ? "button" : "span"), fe(n.sort ? { type: "button" } : {}, wt(n.sort ? {
        click: () => r({
          ...n.sort,
          order: n.sort.order === "asc" ? "desc" : "asc"
        })
      } : {})), {
        default: b(() => {
          var s;
          return [
            x("span", {
              class: z(["flex items-center gap-x-2", {
                "justify-center": n.align === u(Xe).center,
                "justify-end": n.align === u(Xe).right
              }])
            }, [
              x("span", null, [
                y(u(O), {
                  class: z(["!font-highlighted uppercase", [(s = n.sort) != null && s.active ? "text-brand" : "text-grey-200"]]),
                  size: u(H).xs,
                  "tag-name": "span"
                }, {
                  default: b(() => [
                    W(n.$slots, "head", { text: n.text }, () => [
                      R(E(n.text), 1)
                    ])
                  ]),
                  _: 3
                }, 8, ["class", "size"])
              ]),
              n.sort ? ($(), _(u(F1), {
                key: 0,
                class: z(["shrink-0", {
                  "rotate-180": n.sort.order === "desc"
                }])
              }, null, 8, ["class"])) : P("", !0)
            ], 2)
          ];
        }),
        _: 3
      }, 16))
    ], 6));
  }
});
function V3(e) {
  if (!(e != null && e.value))
    return {};
  const t = de(null);
  function d(r) {
    t.value = t.value === r ? null : r;
  }
  return { expendedIndex: t, toggleRowExpendedHandler: d };
}
function O3(e, t) {
  if (!e)
    return {};
  const d = j({
    get() {
      var s;
      return ((s = e.value) == null ? void 0 : s.page) ?? 1;
    },
    set(s) {
      e.value && t({ ...e.value, page: s });
    }
  }), r = q2(() => {
    if (!e.value)
      return "";
    const s = e.value.page * e.value.perPage - e.value.perPage + 1, l = e.value.page * e.value.perPage;
    return `${s} - ${l > e.value.total ? e.value.total : l} / ${e.value.total}`;
  }), n = [10, 20, 50, 100].map((s) => ({ value: s, label: String(s) })), a = j({
    get() {
      var l;
      const s = ((l = e == null ? void 0 : e.value) == null ? void 0 : l.perPage) || 0;
      return { value: s, label: String(s) };
    },
    set({ value: s }) {
      e.value && t({ ...e.value, perPage: s });
    }
  });
  return {
    paginationPage: d,
    paginationSubtext: r,
    paginationPerPageOptions: n,
    selectedPerPage: a
  };
}
const R3 = { class: "max-w-full overflow-y-hidden" }, N3 = { class: "inline-block min-w-full" }, F3 = { class: "w-max" }, _3 = { class: "block text-md" }, j3 = { class: "w-max" }, H3 = ["colspan"], G3 = ["onClick"], U3 = { class: "ml-auto block px-3 py-2" }, W3 = ["onClick", "onKeypress"], Y3 = { class: "overlow-hidden" }, K3 = {
  class: "focusable -my-2 min-w-max p-4",
  type: "button"
}, Z3 = { key: 0 }, q3 = ["colspan"], J3 = {
  key: 0,
  class: "border-t border-grey-stroke/50"
}, X3 = { class: "flex items-center gap-x-3" }, Q3 = { class: "flex w-full justify-center lg:grow" }, ei = { class: "min-w-[200px] shrink-0" }, h0 = /* @__PURE__ */ X({
  __name: "CfgTable",
  props: {
    actionColumnTitle: {},
    dataSources: {},
    allowSelectPerPage: { type: Boolean, default: !0 },
    pagination: {},
    bulk: {},
    expendable: { type: Boolean },
    interactive: { type: Boolean },
    fixed: { type: Boolean },
    flatFirtsCell: { type: Boolean },
    compact: { type: Boolean },
    hideHeader: { type: Boolean },
    goToPage: { type: Boolean, default: !1 },
    disableStickyHead: { type: Boolean, default: !1 },
    bgColor: {}
  },
  emits: ["sort", "update:pagination", "update:bulk", "click:row"],
  setup(e, { emit: t }) {
    const d = e, r = t, n = hn(), {
      pagination: a,
      bulk: s,
      expendable: l,
      dataSources: i
    } = fd(d), f = j(() => x1(d, ["compact", "expendable", "bulk", "disableStickyHead", "bgColor"])), p = kt(i.value.headers, (K) => {
      var ne;
      const re = (ne = d.dataSources.sort) == null ? void 0 : ne.find((ce) => ce.key === K.keyName);
      return {
        ...K,
        sort: re,
        keyName: String(K.keyName)
      };
    }), m = j(() => p.value.every((K) => {
      var re, ne;
      return !((ne = (re = K.text) == null ? void 0 : re.trim()) != null && ne.length);
    })), h = j(() => Object.keys(n).some((K) => K.startsWith("head:"))), C = j(() => !d.hideHeader && (!m.value || !!(s != null && s.value) || h.value)), v = de(null), { height: M } = St(v), { expendedIndex: S, toggleRowExpendedHandler: L } = V3(l), {
      paginationPage: T,
      selectedPerPage: g,
      paginationSubtext: I,
      paginationPerPageOptions: N
    } = O3(
      a,
      (K) => r("update:pagination", K)
    ), { rowGroups: Z } = P3(i, {
      mapEachRow(K) {
        var re;
        return {
          ...K,
          isSelected: B3({ index: K.originalIndex, id: (re = K.meta) == null ? void 0 : re.id }, (s == null ? void 0 : s.value) || []),
          isExpended: ((S == null ? void 0 : S.value) ?? -1) === K.originalIndex
        };
      }
    }), { areAllRowsSelected: Y, toggleAllRowsSelected: G, toggleRowSelected: U } = z3(Z, s, (K) => r("update:bulk", K)), te = j(() => d.dataSources.headers.map(({ footerValue: K, align: re, keyName: ne }) => ({
      value: K,
      align: re,
      keyName: String(ne)
    }))), B = j(() => te.value.some(({ value: K }) => K)), V = j(() => !!n["body:actions"]), q = [
      s,
      l,
      V
    ], J = j(() => q.map((K) => K == null ? void 0 : K.value).filter(Boolean).length);
    function ee(K) {
      r("sort", K);
    }
    function le(K, re, ne) {
      L && L(ne), d.interactive && r("click:row", { item: K, e: re });
    }
    return (K, re) => ($(), k("div", R3, [
      x("div", {
        class: z(["-mt-5 max-w-full pt-5", { "overflow-x-auto": !K.fixed }])
      }, [
        x("div", N3, [
          x("table", {
            class: z(["min-w-full max-w-full border-spacing-0", {
              "w-max": !K.fixed,
              "w-full table-fixed": K.fixed
            }]),
            style: Ue({
              // Hide head if all headers are hidden.
              // Display none doesn't work because table cells will wrong calculate width without rendered table head
              ...C.value ? {} : { marginTop: `-${u(M)}px` }
            })
          }, [
            x("thead", {
              ref_key: "headRef",
              ref: v,
              class: z(["shadow-none", {
                invisible: !C.value
              }])
            }, [
              x("tr", F3, [
                u(s) ? ($(), _(Wt, fe({
                  key: 0,
                  "cell-index": 0,
                  "key-name": "bulk",
                  text: ""
                }, f.value, { width: "80px" }), {
                  head: b(() => [
                    x("span", _3, [
                      y(u(rd), {
                        class: "text-md",
                        "model-value": u(Y),
                        "onUpdate:modelValue": u(G)
                      }, null, 8, ["model-value", "onUpdate:modelValue"])
                    ])
                  ]),
                  _: 1
                }, 16)) : P("", !0),
                ($(!0), k(ae, null, he(u(p), ({
                  keyName: ne,
                  text: ce,
                  sort: ie,
                  align: ve,
                  width: se
                }, be) => ($(), _(Wt, fe({
                  key: `head-${ne}`,
                  ref_for: !0
                }, f.value, {
                  align: ve,
                  "cell-index": u(s) ? be + 1 : be,
                  compact: K.compact,
                  "key-name": ne,
                  "last-index": be === u(p).length - 1,
                  sort: ie,
                  text: ce,
                  width: se,
                  onSort: ee
                }), {
                  head: b(() => [
                    W(K.$slots, `head:${ne}`, {
                      keyName: ne,
                      text: ce
                    }, () => [
                      R(E(ce), 1)
                    ])
                  ]),
                  _: 2
                }, 1040, ["align", "cell-index", "compact", "key-name", "last-index", "sort", "text", "width"]))), 128)),
                K.$slots["body:actions"] ? ($(), _(Wt, {
                  key: "action",
                  align: u(Xe).center,
                  "cell-index": u(p).length + 1,
                  class: z(["text-end", {
                    "pr-10": !u(l)
                  }]),
                  compact: K.compact,
                  "key-name": "action",
                  text: K.actionColumnTitle || "",
                  width: "70px"
                }, null, 8, ["align", "cell-index", "class", "compact", "text"])) : P("", !0),
                u(l) ? ($(), _(Wt, fe({
                  key: 2,
                  "cell-index": u(p).length + (V.value ? 2 : 1)
                }, f.value, {
                  class: "pr-10",
                  width: "70px"
                }), null, 16, ["cell-index"])) : P("", !0)
              ])
            ], 2),
            x("tbody", j3, [
              ($(!0), k(ae, null, he(u(Z), ({ rows: ne, value: ce, label: ie }, ve) => ($(), k(ae, null, [
                ie || ce ? ($(), k("tr", {
                  key: `group-${ve}`
                }, [
                  x("th", {
                    class: z(["px-5 pb-2 text-left text-grey-300 lg:px-8", { "pt-2": K.compact, "pt-5": !K.compact }]),
                    colspan: ne[0].cells.length || 0,
                    scope: "colgroup"
                  }, [
                    W(K.$slots, "group", {
                      group: { rows: ne, value: ce, label: ie }
                    }, () => [
                      y(u(O), {
                        class: "font-highlighted",
                        size: u(H).sm
                      }, {
                        default: b(() => [
                          R(E(ie || ce), 1)
                        ]),
                        _: 2
                      }, 1032, ["size"])
                    ])
                  ], 10, H3)
                ])) : P("", !0),
                ($(!0), k(ae, null, he(ne, (se, be) => ($(), k(ae, {
                  key: `row-${be}-${ve}`
                }, [
                  x("tr", {
                    class: z(["row last-child:!border-b-none", {
                      "cursor-pointer transition-colors duration-200": K.interactive || u(l),
                      "hover:bg-grey-100/50": K.interactive,
                      "border-b border-b-grey-stroke": !se.isExpended && !se.isSelected && be !== ne.length - 1,
                      "border-b border-b-brand/20": !se.isExpended && se.isSelected && be !== ne.length - 1,
                      "border-b border-b-white": se.isExpended && be !== ne.length - 1,
                      "hover:bg-brand/10": u(l),
                      "expended-row bg-brand/10": se.isExpended || se.isSelected
                    }]),
                    onClick: (Ae) => le(se.original, Ae, se.originalIndex)
                  }, [
                    u(s) ? ($(), _(Ut, fe({
                      key: 0,
                      "cell-index": 0,
                      expended: se.isExpended,
                      ref_for: !0
                    }, f.value, {
                      "row-index": be,
                      selected: se.isSelected
                    }), {
                      default: b(() => [
                        y(u(rd), {
                          class: "text-md",
                          "model-value": se.isSelected,
                          onClick: re[0] || (re[0] = Qe(() => {
                          }, ["stop"])),
                          "onUpdate:modelValue": (Ae) => {
                            var $e;
                            u(U) && u(U)({
                              index: se.originalIndex,
                              id: ($e = se.meta) == null ? void 0 : $e.id
                            }, Ae);
                          }
                        }, null, 8, ["model-value", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1040, ["expended", "row-index", "selected"])) : P("", !0),
                    ($(!0), k(ae, null, he(se.cells, (Ae, $e) => ($(), _(Ut, fe({
                      key: `cell-${Ae.keyName}-${be}-${ve}`,
                      ref_for: !0
                    }, f.value, {
                      align: u(i).headers[$e].align,
                      "cell-index": u(s) ? $e + 1 : $e,
                      expended: se.isExpended,
                      flat: K.flatFirtsCell && $e === 0 && !u(s),
                      "last-index": $e === Object.values(se.cells).length - 1,
                      "row-index": be,
                      selected: se.isSelected
                    }), {
                      default: b(() => [
                        K.$slots[`body:${Ae.keyName}`] ? W(K.$slots, `body:${Ae.keyName}`, {
                          key: 0,
                          item: u(i).data[be],
                          value: Ae.value
                        }) : W(K.$slots, "body:item", {
                          key: 1,
                          item: u(i).data[be],
                          keyName: Ae.keyName,
                          value: Ae.value
                        }, () => [
                          R(E(Ae.value || "-"), 1)
                        ])
                      ]),
                      _: 2
                    }, 1040, ["align", "cell-index", "expended", "flat", "last-index", "row-index", "selected"]))), 128)),
                    V.value ? ($(), _(Ut, fe({
                      key: 1,
                      "cell-index": se.cells.length + 1,
                      expended: se.isExpended,
                      "row-index": be,
                      selected: se.isSelected,
                      ref_for: !0
                    }, f.value, {
                      onClick: re[1] || (re[1] = Qe(() => {
                      }, ["stop"]))
                    }), {
                      default: b(() => [
                        y(ta, {
                          class: "mx-auto",
                          "origin-x": "right",
                          overlay: ""
                        }, {
                          trigger: b(() => [
                            x("span", U3, [
                              y(u(I2), { class: "text-grey-300" })
                            ])
                          ]),
                          default: b(({ close: Ae }) => {
                            var $e, Pe;
                            return [
                              x("span", {
                                class: "block min-w-max px-6 py-4",
                                onClick: Ae,
                                onKeypress: m1(Ae, ["enter"])
                              }, [
                                W(K.$slots, "body:actions", {
                                  index: be,
                                  row: (Pe = ($e = u(Z)[ve]) == null ? void 0 : $e.rows) == null ? void 0 : Pe[be]
                                })
                              ], 40, W3)
                            ];
                          }),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1040, ["cell-index", "expended", "row-index", "selected"])) : P("", !0),
                    u(l) ? ($(), _(Ut, fe({
                      key: 2,
                      "cell-index": se.cells.length + (V.value ? 2 : 1),
                      expended: se.isExpended,
                      "row-index": be,
                      selected: se.isSelected,
                      ref_for: !0
                    }, f.value), {
                      default: b(() => [
                        x("div", Y3, [
                          x("button", K3, [
                            y(u(F1), {
                              class: z(["size-5 transition duration-200", {
                                "rotate-180 text-brand": se.isExpended
                              }])
                            }, null, 8, ["class"])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1040, ["cell-index", "expended", "row-index", "selected"])) : P("", !0)
                  ], 10, G3),
                  u(l) ? ($(), k("tr", Z3, [
                    x("td", {
                      class: z(["p-0", {
                        "pt-px": se.isExpended
                      }]),
                      colspan: se.cells.length + J.value
                    }, [
                      y(Bn, {
                        class: "border-transparent bg-brand/10",
                        opened: se.isExpended
                      }, {
                        default: b(() => [
                          x("div", null, [
                            x("div", {
                              class: z(["lg:px-8", { "p-3": K.compact, "p-5": !K.compact }])
                            }, [
                              W(K.$slots, "row:expended", {
                                index: se.originalIndex,
                                row: se.original
                              })
                            ], 2)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["opened"])
                    ], 10, q3)
                  ])) : P("", !0)
                ], 64))), 128))
              ], 64))), 256))
            ]),
            B.value ? ($(), k("tfoot", J3, [
              x("tr", null, [
                u(s) ? ($(), k("td", {
                  key: 0,
                  class: z(["py-3 pl-5 pr-7 text-center text-xs sm:pl-6 lg:pl-8 xl:text-[15px]", {
                    "md:py-5": !K.compact,
                    "md:py-3": K.compact
                  }]),
                  onClick: re[2] || (re[2] = Qe(() => {
                  }, ["stop"]))
                }, null, 2)) : P("", !0),
                ($(!0), k(ae, null, he(te.value, ({ value: ne, align: ce, keyName: ie }, ve) => ($(), k("td", {
                  key: `footer-${ve}`
                }, [
                  x("span", {
                    class: z(["flex w-full py-3 pr-5", {
                      "justify-center text-center": ce === u(Xe).center,
                      "justify-end text-right": ce === u(Xe).right,
                      "pl-5 sm:pl-5": !K.flatFirtsCell
                    }])
                  }, [
                    ne ? W(K.$slots, `footer:${ie}`, {
                      key: 0,
                      item: u(i).data[ve],
                      value: ne
                    }, () => [
                      y(u(O), {
                        class: "font-highlighted",
                        html: String(ne),
                        size: u(H).md
                      }, null, 8, ["html", "size"])
                    ]) : P("", !0)
                  ], 2)
                ]))), 128))
              ])
            ])) : P("", !0)
          ], 6)
        ])
      ], 2),
      u(a) && u(T) ? ($(), k("div", {
        key: 0,
        class: z(["mt-0 block w-full border-t border-grey-stroke/50 p-5 lg:px-8", {
          "pt-10": !K.allowSelectPerPage
        }]),
        style: { "--cfg-select-min-width": "150px" }
      }, [
        x("div", X3, [
          y(u(O), {
            class: "shrink-0 text-grey-300",
            size: u(H).sm
          }, {
            default: b(() => [
              R(E(u(I)), 1)
            ]),
            _: 1
          }, 8, ["size"]),
          x("div", Q3, [
            y(Ma, {
              page: u(T),
              "onUpdate:page": re[3] || (re[3] = (ne) => dt(T) ? T.value = ne : null),
              class: "w-full lg:w-max",
              "go-to-page": d.goToPage,
              "items-per-page": u(a).perPage,
              "total-items": u(a).total
            }, null, 8, ["page", "go-to-page", "items-per-page", "total-items"])
          ]),
          x("div", ei, [
            K.allowSelectPerPage ? ($(), _(g0, {
              key: 0,
              modelValue: u(g),
              "onUpdate:modelValue": re[4] || (re[4] = (ne) => dt(g) ? g.value = ne : null),
              "content-min-width": "150px",
              options: u(N),
              placeholder: "Řádků na stránku:"
            }, null, 8, ["modelValue", "options"])) : P("", !0)
          ])
        ])
      ], 2)) : P("", !0)
    ]));
  }
}), ti = {
  key: 0,
  class: "flex items-center text-[1.2em]"
}, x5 = /* @__PURE__ */ X({
  __name: "CfgTableMenuItem",
  props: {
    as: {
      type: String,
      default: "button"
    }
  },
  setup(e) {
    return (t, d) => ($(), _(u(O), {
      class: "flex items-center gap-x-3 px-3 py-2 transition duration-200 hover:opacity-70",
      size: u(H).md,
      "tag-name": e.as
    }, {
      default: b(() => [
        t.$slots.icon ? ($(), k("div", ti, [
          W(t.$slots, "icon")
        ])) : P("", !0),
        x("div", null, [
          W(t.$slots, "body")
        ])
      ]),
      _: 3
    }, 8, ["size", "tag-name"]));
  }
}), di = { class: "mb-4 flex flex-col gap-y-5" }, ni = {
  key: 1,
  class: "size-[24px] shrink-0"
}, ri = { class: "flex w-[calc(100%-36px)] flex-col gap-y-1" }, si = { key: 0 }, oi = {
  key: 2,
  class: "my-4 flex flex-col gap-y-2"
}, ai = ["href"], li = { class: "truncate whitespace-pre underline" }, ii = /* @__PURE__ */ X({
  __name: "CollateralsSheetGroup",
  props: {
    title: {},
    group: {},
    isMobile: { type: Boolean },
    isPublic: { type: Boolean, default: !1 }
  },
  setup(e) {
    function t(d) {
      var r;
      if (d.customFilename)
        return d.customFilename;
      if (d.filename)
        return d.filename;
      if (!e.isPublic && ((r = d.file) != null && r.url))
        return d.file.url.replace("https://static.dluhopisomat.cz/files/", "");
    }
    return (d, r) => ($(), k("div", di, [
      y(u(O), {
        class: "!font-extrabold",
        size: u(H).h5
      }, {
        default: b(() => [
          R(E(d.title), 1)
        ]),
        _: 1
      }, 8, ["size"]),
      ($(!0), k(ae, null, he(d.group, (n) => ($(), k("div", {
        key: n.type,
        class: z(["flex items-start", {
          "gap-3": !d.isMobile,
          "gap-2": d.isMobile
        }])
      }, [
        n.icon ? ($(), _(Oe(n.icon), {
          key: 0,
          class: "shrink-0 text-[24px] text-grey"
        })) : ($(), k("div", ni)),
        x("div", ri, [
          y(u(O), {
            class: "mr-auto !font-semibold",
            "tag-name": "div"
          }, {
            default: b(() => [
              R(E((n == null ? void 0 : n.possessiveLabel) || n.type) + " ", 1),
              n.amountFormatted ? ($(), k("span", si, E(n.amountFormatted), 1)) : P("", !0)
            ]),
            _: 2
          }, 1024),
          n.info ? ($(), _(u(O), {
            key: 0,
            html: n.info
          }, null, 8, ["html"])) : P("", !0),
          n.description ? ($(), _(u(O), {
            key: 1,
            html: n.description
          }, null, 8, ["html"])) : P("", !0),
          n.files && n.files.length ? ($(), k("div", oi, [
            ($(!0), k(ae, null, he(n.files, (a, s) => {
              var l;
              return $(), k("a", {
                key: s,
                class: z(["flex items-center justify-start", {
                  "font-highlighted text-orange": !d.isPublic,
                  "cursor-not-allowed font-light text-grey": d.isPublic
                }]),
                href: ((l = a.file) == null ? void 0 : l.url) ?? void 0,
                target: "_blank"
              }, [
                y(u(E2), { class: "mr-2 text-[24px]" }),
                x("span", li, E(t(a)) + " " + E(a.year), 1)
              ], 10, ai);
            }), 128))
          ])) : P("", !0)
        ])
      ], 2))), 128))
    ]));
  }
}), w5 = {
  "Agent pro zajištění": z2,
  Movitosti: B2,
  Nemovitosti: P2,
  "Ručitelské prohlášení majitele": V2,
  "Ručitelské prohlášení právnické osoby": O2,
  "Notářský zápis": R2,
  Žádná: void 0
};
var B1 = /* @__PURE__ */ ((e) => (e.enhancements = "enhancements", e.collaterals = "collaterals", e))(B1 || {});
const W1 = {
  "Agent pro zajištění": "enhancements",
  "Notářský zápis": "enhancements",
  Movitosti: "collaterals",
  Nemovitosti: "collaterals",
  "Ručitelské prohlášení majitele": "collaterals",
  "Ručitelské prohlášení právnické osoby": "collaterals",
  Žádná: void 0
}, ui = { class: "relative flex w-full items-center justify-between" }, ci = { class: "item-stretch flex w-full max-w-[765px] flex-col lg:-mt-2" }, fi = { class: "mb-6 flex w-full flex-col gap-5" }, $i = {
  key: 0,
  class: "sticky inset-x-0 bottom-0 z-10 transition-all"
}, pi = {
  key: 1,
  class: "sticky inset-x-0 bottom-0 z-10"
}, mi = "Spočítat si výnos", gi = /* @__PURE__ */ X({
  __name: "CollateralsSheet",
  props: /* @__PURE__ */ ye({
    label: {},
    moreLabel: {},
    slideOverTitle: {},
    slideOverSubtitle: {},
    collaterals: {},
    moreTypesLabel: {},
    tooltipButtonLabel: {},
    isMobile: { type: Boolean },
    isPublic: { type: Boolean }
  }, {
    isOpened: { type: Boolean, type: Boolean, default: !1 },
    isOpenedModifiers: {}
  }),
  emits: /* @__PURE__ */ ye(["openCalculator"], ["update:isOpened"]),
  setup(e, { emit: t }) {
    const d = t, r = ze(e, "isOpened"), n = j(
      () => e.collaterals.filter(({ type: p }) => p)
    ), a = j(
      () => n.value.filter(({ type: p }) => (W1 == null ? void 0 : W1[p]) === B1.enhancements)
    ), s = j(
      () => n.value.filter(({ type: p }) => (W1 == null ? void 0 : W1[p]) === B1.collaterals)
    ), l = j(() => ({
      [B1.collaterals]: s.value,
      [B1.enhancements]: a.value
    })), i = {
      [B1.collaterals]: "Položky zajištění",
      [B1.enhancements]: "Prvky posilující zajištění"
    };
    function f() {
      r.value = !1, d("openCalculator");
    }
    return (p, m) => {
      const h = g1("ripple");
      return $(), _(u(E3), {
        opened: r.value,
        "onUpdate:opened": m[1] || (m[1] = (C) => r.value = C),
        bottom: p.isMobile,
        class: z(["relative [&_header]:!py-4", {
          "!rounded-none": !p.isMobile
        }]),
        closable: "",
        "full-height": "",
        "render-close": !1,
        size: "lg"
      }, {
        head: b(() => [
          x("div", ui, [
            x("div", {
              class: z(["flex flex-col", {
                "gap-2": !p.isMobile,
                "gap-1": p.isMobile
              }])
            }, [
              y(u(O), {
                class: "!font-extrabold",
                size: u(H).h3
              }, {
                default: b(() => [
                  R(E(p.slideOverTitle), 1)
                ]),
                _: 1
              }, 8, ["size"]),
              y(u(O), { class: "!text-[13px] !font-medium text-secondary" }, {
                default: b(() => [
                  R(E(p.slideOverSubtitle), 1)
                ]),
                _: 1
              })
            ], 2),
            Ge(($(), k("button", {
              class: z(["flex items-center justify-center ring-brand focus-visible:outline-brand focus-visible:ring", {
                "size-[70px]": !p.isMobile,
                "size-[40px] -translate-y-3 translate-x-4 self-start": p.isMobile
              }]),
              type: "button",
              onClick: m[0] || (m[0] = (C) => r.value = !1)
            }, [
              y(u(u1), {
                class: z({
                  "text-[33px]": !p.isMobile,
                  "text-[19px]": p.isMobile
                })
              }, null, 8, ["class"])
            ], 2)), [
              [h]
            ])
          ])
        ]),
        default: b(() => [
          x("div", ci, [
            x("div", fi, [
              ($(!0), k(ae, null, he(l.value, (C, v) => ($(), k(ae, {
                key: `group-${v}`
              }, [
                C.length ? ($(), _(ii, {
                  key: 0,
                  group: C,
                  "is-mobile": p.isMobile,
                  "is-public": p.isPublic,
                  title: i[v]
                }, null, 8, ["group", "is-mobile", "is-public", "title"])) : P("", !0)
              ], 64))), 128))
            ]),
            m[3] || (m[3] = x("div", { class: "grow" }, null, -1)),
            p.isPublic ? p.isPublic ? ($(), k("div", pi, [
              W(p.$slots, "collateralsCta", {}, void 0, !0)
            ])) : P("", !0) : ($(), k("div", $i, [
              m[2] || (m[2] = x("div", { class: "button-background pointer-events-none absolute inset-0" }, null, -1)),
              y(u(I1), {
                class: "w-full rounded-full",
                small: "",
                variant: "orange",
                onClick: f
              }, {
                icon: b(() => [
                  y(u(D1), { class: "text-[24px]" })
                ]),
                default: b(() => [
                  y(u(O), {
                    class: "!font-extrabold",
                    size: u(H).md
                  }, {
                    default: b(() => [
                      R(E(mi))
                    ]),
                    _: 1
                  }, 8, ["size"])
                ]),
                _: 1
              })
            ]))
          ])
        ]),
        _: 3
      }, 8, ["opened", "bottom", "class"]);
    };
  }
}), hi = /* @__PURE__ */ h1(gi, [["__scopeId", "data-v-b12cd30e"]]), vi = { class: "flex flex-col gap-2" }, bi = /* @__PURE__ */ X({
  __name: "About",
  props: {
    issuerName: {},
    companyWebsiteLabel: {},
    companyWebsiteUrl: {},
    description: {}
  },
  setup(e) {
    const t = e;
    function d() {
      window.open(t.companyWebsiteUrl, "_blank");
    }
    return (r, n) => ($(), k("div", vi, [
      y(u(O), {
        class: "!font-extrabold",
        size: u(H).h3
      }, {
        default: b(() => [
          R(E(r.issuerName), 1)
        ]),
        _: 1
      }, 8, ["size"]),
      r.description ? ($(), _(u(O), {
        key: 0,
        class: "prose prose-h1:text-lg prose-h1:first-of-type:!mt-4",
        html: r.description
      }, null, 8, ["html"])) : P("", !0),
      r.companyWebsiteUrl ? ($(), _(u(I1), {
        key: 1,
        class: "!mt-4 self-start",
        small: "",
        target: "_blank",
        text: "",
        variant: "orange",
        onClick: d
      }, {
        icon: b(() => [
          y(u(D1), { class: "text-lg" })
        ]),
        default: b(() => [
          y(u(O), { class: "!font-highlighted" }, {
            default: b(() => [
              R(E(r.companyWebsiteLabel), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })) : P("", !0)
    ]));
  }
}), yi = { class: "mb-2 mt-3 md:my-0" }, xi = /* @__PURE__ */ X({
  __name: "Info",
  props: {
    label: {},
    establishedLabel: {},
    establishedValue: {},
    legalFormLabel: {},
    legalFormValue: {},
    icoLabel: {},
    icoValue: {},
    businessTypeLabel: {},
    businessTypeValue: {}
  },
  setup(e) {
    const t = j(() => ({
      headers: [
        { keyName: "key", text: "", width: "50%" },
        { keyName: "value", text: "", width: "50%", align: Xe.right }
      ],
      data: [
        {
          key: e.establishedLabel,
          value: e.establishedValue
        },
        {
          key: e.legalFormLabel,
          value: e.legalFormValue
        },
        {
          key: e.icoLabel,
          value: e.icoValue
        },
        {
          key: e.businessTypeLabel,
          value: e.businessTypeValue
        }
      ]
    }));
    return (d, r) => ($(), k(ae, null, [
      y(u(O), {
        class: "!font-extrabold",
        size: u(H).h3
      }, {
        default: b(() => [
          R(E(d.label), 1)
        ]),
        _: 1
      }, 8, ["size"]),
      y(u(h0), {
        class: "mb-2 lg:mb-0 [&_tr]:border-stroke-gray",
        "data-sources": t.value,
        "disable-sticky-head": "",
        fixed: "",
        "flat-firts-cell": "",
        "hide-header": ""
      }, {
        "body:key": b(({ item: { key: n } }) => [
          x("div", yi, [
            y(u(O), {
              class: "max-w-full",
              size: u(H).sm
            }, {
              default: b(() => [
                R(E(n), 1)
              ]),
              _: 2
            }, 1032, ["size"])
          ])
        ]),
        "body:value": b(({ item: { value: n } }) => [
          y(u(O), {
            class: "!font-semibold",
            size: u(H).sm
          }, {
            default: b(() => [
              R(E(n), 1)
            ]),
            _: 2
          }, 1032, ["size"])
        ]),
        _: 1
      }, 8, ["data-sources"])
    ], 64));
  }
}), wi = { class: "mt-6 flex gap-4" }, Ci = ["src"], ki = {
  key: 1,
  class: "flex size-16 items-center justify-center rounded-full bg-brand-light"
}, Si = { class: "flex flex-col justify-center gap-y-1" }, Mi = /* @__PURE__ */ X({
  __name: "People",
  props: {
    label: {},
    people: {}
  },
  setup(e) {
    function t(d) {
      if (!d)
        return "UK";
      const [r, n] = d.split(" ");
      return `${(r == null ? void 0 : r[0]) || ""}${(n == null ? void 0 : n[0]) || ""}`;
    }
    return (d, r) => ($(), k("div", null, [
      y(u(O), {
        class: "!font-extrabold",
        size: u(H).h3
      }, {
        default: b(() => [
          R(E(d.label), 1)
        ]),
        _: 1
      }, 8, ["size"]),
      ($(!0), k(ae, null, he(d.people, (n) => ($(), k(ae, {
        key: n.name
      }, [
        x("div", wi, [
          n.pictureUrl ? ($(), k("img", {
            key: 0,
            alt: "Person",
            class: "aspect-square h-16 rounded-full object-cover object-center",
            src: n.pictureUrl
          }, null, 8, Ci)) : ($(), k("div", ki, [
            y(u(O), {
              class: "font-nunito !font-bold text-brand-dark",
              size: u(H).subtitle
            }, {
              default: b(() => [
                R(E(t(n == null ? void 0 : n.name)), 1)
              ]),
              _: 2
            }, 1032, ["size"])
          ])),
          x("div", Si, [
            y(u(O), {
              class: "font-nunito !font-extrabold",
              size: u(H).subtitle
            }, {
              default: b(() => [
                R(E(n.name), 1)
              ]),
              _: 2
            }, 1032, ["size"]),
            y(u(O), {
              class: "!font-light text-secondary",
              size: u(H).sm
            }, {
              default: b(() => [
                R(E(n.position), 1)
              ]),
              _: 2
            }, 1032, ["size"])
          ])
        ]),
        n.description ? ($(), _(u(O), {
          key: 0,
          class: "prose !mt-4 !font-light",
          html: n.description,
          size: u(H).md,
          "tag-name": "div"
        }, null, 8, ["html", "size"])) : P("", !0)
      ], 64))), 128))
    ]));
  }
}), Ti = { class: "normal-case" }, Li = { class: "mb-2 mt-3 md:my-0" }, Ai = { key: 0 }, Di = {
  key: 1,
  class: "text-red"
}, Ii = {
  key: 2,
  class: "text-brand"
}, Ei = /* @__PURE__ */ X({
  __name: "Results",
  props: {
    label: {},
    statements: {},
    statementPropertyLabels: {},
    shortDescription: {},
    formatNumberFn: { type: Function },
    formatPercentFn: { type: Function }
  },
  setup(e) {
    const t = j(
      () => e.statements.filter(({ year: a }) => a).toSorted(({ year: a }, { year: s }) => a - s).slice(0, 3)
    );
    function d(a, s) {
      const [l, i] = a.map((f) => Number(f[s])).slice(-2);
      return !i || !l ? null : String((i - l) / l);
    }
    function r(a) {
      const s = d(t.value, a);
      return {
        key: e.statementPropertyLabels[a],
        ...Object.fromEntries(t.value.map(
          (l, i) => [
            `year${i + 1}`,
            l[a] ? e.formatNumberFn(Number(l[a])) : "-"
          ]
        )),
        yearOnYear: s !== null ? s : "-"
      };
    }
    const n = j(() => ({
      headers: [
        { keyName: "key", text: "", width: "50%" },
        ...t.value.map(({ year: a }, s) => ({
          keyName: `year${s + 1}`,
          text: a.toString(),
          width: "30%",
          align: Xe.right
        })),
        { keyName: "yearOnYear", text: e.statementPropertyLabels.yearOnYear, width: "30%", align: Xe.right }
      ],
      data: [
        r("revenues"),
        r("incomeTradingBeforeTax"),
        r("assets"),
        r("equity")
      ]
    }));
    return (a, s) => ($(), k(ae, null, [
      y(u(O), {
        class: "!font-extrabold",
        size: u(H).h3
      }, {
        default: b(() => [
          R(E(a.label), 1)
        ]),
        _: 1
      }, 8, ["size"]),
      y(u(h0), {
        class: "mb-2 lg:mb-0 [&_tr]:border-stroke-gray",
        compact: "",
        "data-sources": n.value,
        "disable-sticky-head": "",
        fixed: "",
        flat: "",
        "flat-firts-cell": ""
      }, {
        "head:yearOnYear": b(({ text: l }) => [
          x("span", Ti, E(l), 1)
        ]),
        "body:key": b(({ item: { key: l } }) => [
          x("div", Li, [
            y(u(O), {
              class: "max-w-full text-grey",
              html: l,
              size: u(H).sm
            }, null, 8, ["html", "size"])
          ])
        ]),
        "body:yearOnYear": b(({ item: { yearOnYear: l } }) => [
          l === "-" ? ($(), k("span", Ai, E(l), 1)) : Number(l) < 0 ? ($(), k("span", Di, E(a.formatPercentFn(Number(l))), 1)) : ($(), k("span", Ii, E(a.formatPercentFn(Number(l))), 1))
        ]),
        _: 1
      }, 8, ["data-sources"]),
      a.shortDescription ? ($(), _(u(O), {
        key: 0,
        class: "mt-5",
        html: a.shortDescription,
        size: u(H).md,
        "tag-name": "div"
      }, null, 8, ["html", "size"])) : P("", !0)
    ], 64));
  }
}), C5 = /* @__PURE__ */ X({
  __name: "Company",
  props: {
    about: {},
    people: {},
    info: {},
    results: {}
  },
  setup(e) {
    return (t, d) => ($(), k(ae, null, [
      y(bi, A1(X1(t.about)), null, 16),
      t.people && t.people.people.length ? ($(), _(Mi, fe({ key: 0 }, t.people, { class: "mt-8" }), null, 16)) : P("", !0),
      y(u(Q1)),
      y(xi, A1(X1(t.info)), null, 16),
      y(u(Q1)),
      y(Ei, A1(X1(t.results)), null, 16)
    ], 64));
  }
}), zi = { class: "flex items-center" }, Bi = /* @__PURE__ */ X({
  __name: "Info",
  props: {
    minimumInvestmentLabel: {},
    minimumInvestmentValue: {},
    periodicityLabel: {},
    periodicityValue: {},
    maturityDateLabel: {},
    maturityDateValue: {},
    investorCountLabel: {},
    investorCountValue: {},
    desktop: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = j(() => ({
      minimumInvestment: {
        icon: xn,
        label: e.minimumInvestmentLabel,
        value: e.minimumInvestmentValue
      },
      periodicity: {
        icon: wn,
        label: e.periodicityLabel,
        value: e.periodicityValue
      },
      maturityDate: {
        icon: N2,
        label: e.maturityDateLabel,
        value: e.maturityDateValue
      }
    })), d = j(
      () => e.desktop ? {
        wrapper: "grid-cols-3 divide-x",
        item: "flex-col items-start",
        icon: "",
        label: "lg:!text-grey",
        value: "!font-extrabold mt-1.5"
      } : {
        wrapper: "gap-3",
        item: "items-center",
        icon: "",
        label: "",
        value: "!font-semibold ml-auto"
      }
    );
    return (r, n) => ($(), k("div", {
      class: z(["grid place-items-start divide-stroke-gray", d.value.wrapper])
    }, [
      ($(!0), k(ae, null, he(t.value, (a, s, l) => ($(), k("div", {
        key: s,
        class: z(["flex w-full items-start justify-between", [d.value.item, r.desktop && l !== 0 && "pl-12"]])
      }, [
        x("div", zi, [
          r.desktop ? P("", !0) : ($(), _(Oe(a.icon), {
            key: 0,
            class: z(["mr-3 inline-block shrink-0 text-[20px] text-grey", d.value.icon])
          }, null, 8, ["class"])),
          y(u(O), {
            class: z(d.value.label),
            size: u(H).sm
          }, {
            default: b(() => [
              R(E(a.label), 1)
            ]),
            _: 2
          }, 1032, ["class", "size"])
        ]),
        y(u(O), {
          class: z(d.value.value),
          size: r.desktop ? u(H).h5 : u(H).sm
        }, {
          default: b(() => [
            R(E(a.value), 1)
          ]),
          _: 2
        }, 1032, ["class", "size"])
      ], 2))), 128))
    ], 2));
  }
}), Pi = { class: "overflow-hidden px-6 pb-10 pt-5" }, Vi = { key: 0 }, Oi = { class: "mt-5 flex gap-x-4" }, Ri = ["src"], Ni = { class: "relative" }, un = /* @__PURE__ */ X({
  __name: "Comment",
  props: {
    commentText: {},
    expertImageSrc: {},
    hintText: {}
  },
  setup(e) {
    return (t, d) => ($(), k("div", Pi, [
      t.commentText ? ($(), k("div", Vi, [
        y(O, {
          class: "!font-semibold",
          size: u(H).md
        }, {
          default: b(() => d[0] || (d[0] = [
            R(" Co říká náš expert ")
          ])),
          _: 1
        }, 8, ["size"]),
        x("div", Oi, [
          x("img", {
            class: "size-[46px] shrink-0 rounded-full object-cover",
            src: t.expertImageSrc
          }, null, 8, Ri),
          y(O, {
            class: "flex flex-col",
            size: u(H).md
          }, {
            default: b(() => d[1] || (d[1] = [
              x("span", { class: "font-semibold" }, "Martin Měřička", -1),
              x("span", { class: "text-[13px] font-medium text-secondary" }, "Senior finanční analytik", -1)
            ])),
            _: 1
          }, 8, ["size"])
        ]),
        x("div", Ni, [
          d[2] || (d[2] = x("svg", {
            class: "absolute -top-3 right-full mt-3",
            fill: "none",
            height: "33",
            viewBox: "0 0 33 33",
            width: "33",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            x("path", {
              d: "M13.909 22.4219C13.909 23.7378 13.4485 24.8399 12.5273 25.7281C11.6062 26.6163 10.4548 27.0604 9.07313 27.0604C7.75725 27.0604 6.63874 26.5505 5.71762 25.5307C4.7965 24.5109 4.33594 23.2279 4.33594 21.6817C4.33594 20.5632 4.58267 19.3296 5.07612 17.9808C5.60248 16.632 6.27687 15.2668 7.0993 13.8851C7.95463 12.5034 8.90865 11.1382 9.96136 9.7894C11.047 8.40772 12.1326 7.12473 13.2182 5.94043L14.5505 7.02604C13.0701 8.76959 11.8365 10.5296 10.8496 12.306C9.86267 14.0825 9.27052 15.826 9.07313 17.5367C10.389 17.6354 11.524 18.1288 12.478 19.0171C13.432 19.9053 13.909 21.0402 13.909 22.4219ZM28.0713 22.4219C28.0713 23.7378 27.6107 24.8399 26.6896 25.7281C25.7685 26.6163 24.6171 27.0604 23.2354 27.0604C21.9195 27.0604 20.801 26.5505 19.8799 25.5307C18.9587 24.5109 18.4982 23.2279 18.4982 21.6817C18.4982 20.5632 18.7449 19.3296 19.2384 17.9808C19.7647 16.632 20.4391 15.2668 21.2615 13.8851C22.1169 12.5034 23.0709 11.1382 24.1236 9.7894C25.2092 8.40772 26.2948 7.12473 27.3804 5.94043L28.6634 7.02604C27.183 8.76959 25.9494 10.5296 24.9625 12.306C24.0085 14.0825 23.4328 15.826 23.2354 17.5367C24.5513 17.6354 25.6862 18.1288 26.6402 19.0171C27.5943 19.9053 28.0713 21.0402 28.0713 22.4219Z",
              fill: "#F2994A",
              opacity: "0.25"
            })
          ], -1)),
          y(O, {
            class: "pt-3",
            size: u(H).sm,
            "tag-name": "p"
          }, {
            default: b(() => [
              R(E(t.commentText), 1)
            ]),
            _: 1
          }, 8, ["size"])
        ]),
        y(Q1, { class: "!my-4 -mx-6" })
      ])) : P("", !0),
      y(O, {
        class: "flex gap-x-2 !font-medium text-secondary",
        size: u(H).sm
      }, {
        default: b(() => [
          y(u(Qt), { class: "mt-[0.5px] shrink-0 text-[20px]" }),
          R(" " + E(t.hintText), 1)
        ]),
        _: 1
      }, 8, ["size"])
    ]));
  }
}), Fi = { class: "bg-brand-light px-10 py-5 pb-10" }, _i = { class: "relative flex w-full flex-col items-center justify-center" }, ji = ["src"], Hi = { class: "absolute bottom-0 flex flex-col items-center justify-center" }, cn = /* @__PURE__ */ X({
  __name: "Tachometer",
  props: {
    rating: {},
    tachometerLabel: {},
    tachometerImageSrc: {}
  },
  setup(e) {
    return (t, d) => ($(), k("div", Fi, [
      x("div", _i, [
        x("img", {
          alt: "Score",
          loading: "lazy",
          src: t.tachometerImageSrc,
          width: "300px"
        }, null, 8, ji),
        x("div", Hi, [
          y(od, {
            class: "h-[36px] w-[48px]",
            rating: t.rating
          }, null, 8, ["rating"]),
          y(O, {
            class: "mt-3 text-center !font-extrabold",
            size: u(H).subtitle
          }, {
            default: b(() => [
              R(E(t.tachometerLabel), 1)
            ]),
            _: 1
          }, 8, ["size"])
        ])
      ])
    ]));
  }
}), Gi = { class: "flex flex-col gap-y-2" }, Ui = { class: "relative flex h-full flex-col" }, Wi = { class: "sticky bottom-0 w-full px-6 pb-5" }, Yi = /* @__PURE__ */ X({
  __name: "RatingChip",
  props: {
    buttonLabel: {},
    bottomSheetLabel: {},
    rating: {},
    ratingLabel: {},
    tachometerLabel: {},
    tachometerImageSrc: {},
    commentText: {},
    expertImageSrc: {},
    hintText: {},
    issueName: {}
  },
  emits: ["ratingButtonClick"],
  setup(e) {
    const t = de(!1);
    r1(() => {
      const { width: r } = J2();
      t.value = r.value <= 1024;
    });
    const d = de(!1);
    return (r, n) => {
      const a = g1("ripple");
      return t.value ? ($(), k(ae, { key: 1 }, [
        Ge(y(od, {
          class: "underline decoration-dotted underline-offset-1",
          rating: r.rating,
          "rating-label": r.ratingLabel,
          onClick: n[0] || (n[0] = (s) => d.value = !d.value)
        }, null, 8, ["rating", "rating-label"]), [
          [a]
        ]),
        y(f3, {
          opened: d.value,
          "onUpdate:opened": n[2] || (n[2] = (s) => d.value = s),
          "close-button-classes": "rounded-full size-11",
          "disable-bottom-padding": "",
          "disable-main-padding": ""
        }, {
          head: b(() => [
            x("div", Gi, [
              y(O, {
                class: "!font-extrabold",
                size: u(H).h3
              }, {
                default: b(() => [
                  R(E(r.bottomSheetLabel), 1)
                ]),
                _: 1
              }, 8, ["size"]),
              y(O, {
                class: "!text-[13px] !font-medium text-secondary",
                size: u(H).xs
              }, {
                default: b(() => [
                  R(E(r.issueName), 1)
                ]),
                _: 1
              }, 8, ["size"])
            ])
          ]),
          default: b(() => [
            x("div", Ui, [
              y(cn, {
                rating: r.rating,
                "tachometer-image-src": r.tachometerImageSrc,
                "tachometer-label": r.tachometerLabel
              }, null, 8, ["rating", "tachometer-image-src", "tachometer-label"]),
              y(un, {
                "comment-text": r.commentText,
                "expert-image-src": r.expertImageSrc,
                "hint-text": r.hintText
              }, null, 8, ["comment-text", "expert-image-src", "hint-text"]),
              x("div", Wi, [
                y(I1, {
                  class: "w-full",
                  small: "",
                  variant: "orange",
                  onClick: n[1] || (n[1] = (s) => {
                    r.$emit("ratingButtonClick"), d.value = !1;
                  })
                }, {
                  icon: b(() => [
                    y(u(D1), { class: "text-[24px] text-white" })
                  ]),
                  default: b(() => [
                    R(" " + E(r.buttonLabel), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["opened"])
      ], 64)) : ($(), _(et, {
        key: 0,
        "content-width": "max-w-[400px]",
        "hide-icon": "",
        "tooltip-padding": !1
      }, {
        trigger: b(() => [
          y(od, {
            class: "underline decoration-dotted underline-offset-1",
            rating: r.rating,
            "rating-label": r.ratingLabel
          }, null, 8, ["rating", "rating-label"])
        ]),
        content: b(() => [
          y(cn, {
            rating: r.rating,
            "tachometer-image-src": r.tachometerImageSrc,
            "tachometer-label": r.tachometerLabel
          }, null, 8, ["rating", "tachometer-image-src", "tachometer-label"]),
          y(un, {
            "comment-text": r.commentText,
            "expert-image-src": r.expertImageSrc,
            "hint-text": r.hintText
          }, null, 8, ["comment-text", "expert-image-src", "hint-text"])
        ]),
        _: 1
      }));
    };
  }
}), Ki = { class: "grid gap-x-8 rounded-xl bg-white shadow-card max-lg:!rounded-none lg:grid-cols-12 lg:p-10" }, Zi = { class: "relative col-span-6 flex h-56 items-start justify-end gap-2 p-5 max-lg:pt-4 lg:h-full" }, qi = ["src"], Ji = {
  key: 1,
  class: "absolute inset-0 size-full bg-grey lg:rounded-xl"
}, Xi = { class: "relative col-span-6 max-lg:-mt-9 max-lg:p-5" }, Qi = { class: "mt-4 flex items-start justify-between gap-1" }, e4 = { class: "mt-6 flex items-center justify-center gap-5 rounded-xl bg-brand-light p-5" }, k5 = /* @__PURE__ */ X({
  __name: "Header",
  props: {
    collaterals: {},
    issuesInfo: {},
    progress: {},
    newProjectChip: {},
    name: {},
    interestRateFormatted: {},
    isMobile: { type: Boolean },
    tags: {},
    rating: {},
    imageUrl: {}
  },
  emits: ["back", "showDetails", "ratingButtonClick"],
  setup(e, { emit: t }) {
    const d = t;
    return (r, n) => {
      const a = g1("ripple");
      return $(), k("div", Ki, [
        x("div", Zi, [
          r.imageUrl ? ($(), k("img", {
            key: 0,
            class: "absolute inset-0 size-full object-cover lg:rounded-xl",
            draggable: "false",
            src: r.imageUrl
          }, null, 8, qi)) : ($(), k("div", Ji)),
          Ge(($(), k("button", {
            class: "relative -mt-1 mr-auto flex size-9 items-center justify-center rounded-full bg-white lg:hidden",
            onClick: n[0] || (n[0] = (s) => d("back"))
          }, [
            y(u(Ct), { class: "text-[24px] text-black" })
          ])), [
            [a]
          ]),
          ($(!0), k(ae, null, he(r.tags, (s, l) => ($(), _(u(sd), {
            key: l,
            class: z(["relative !rounded-lg [&_span]:!font-medium", {
              "!bg-brand text-white": l === 0,
              "!bg-stroke-gray !text-black": l === 1
            }])
          }, {
            default: b(() => [
              R(E(s), 1)
            ]),
            _: 2
          }, 1032, ["class"]))), 128))
        ]),
        x("div", Xi, [
          y(Yi, fe(r.rating, {
            class: "mr-auto underline decoration-dotted",
            "issue-name": r.name,
            onRatingButtonClick: n[1] || (n[1] = (s) => d("ratingButtonClick"))
          }), null, 16, ["issue-name"]),
          x("div", Qi, [
            y(u(O), {
              class: "relative !font-extrabold",
              size: u(H).h1
            }, {
              default: b(() => [
                R(E(r.name), 1)
              ]),
              _: 1
            }, 8, ["size"]),
            y(u(O), {
              class: "text-primary !font-extrabold",
              size: u(H).h2
            }, {
              default: b(() => [
                R(E(r.interestRateFormatted) + " ", 1),
                n[3] || (n[3] = x("span", { class: "text-primary text-[20px] !font-medium" }, " p.a. ", -1))
              ]),
              _: 1
            }, 8, ["size"])
          ]),
          y(Zn, fe(r.collaterals, {
            class: "my-2",
            onShowDetails: n[2] || (n[2] = (s) => r.$emit("showDetails"))
          }), null, 16),
          y(Bi, fe({
            class: "mt-5",
            desktop: !r.isMobile
          }, r.issuesInfo), null, 16, ["desktop"]),
          x("div", e4, [
            y(u(sd), { class: "relative shrink-0 !rounded !bg-brand text-[13px] text-white [&_span]:!font-medium" }, {
              default: b(() => [
                R(E(r.newProjectChip), 1)
              ]),
              _: 1
            }),
            y(u(O), { class: "!font-extrabold" }, {
              default: b(() => [
                R(E(r.progress.investorsCountLabel), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]);
    };
  }
}), t4 = { class: "flex flex-col gap-4" }, d4 = /* @__PURE__ */ X({
  __name: "About",
  props: {
    title: {},
    name: {},
    tagline: {},
    purpose: {},
    moneyUsagePlan: {},
    moneyUsagePlanLabel: {}
  },
  setup(e) {
    return (t, d) => ($(), k("div", t4, [
      y(u(O), {
        class: "!font-extrabold",
        size: u(H).h2
      }, {
        default: b(() => [
          R(E(t.title) + " " + E(t.name), 1)
        ]),
        _: 1
      }, 8, ["size"]),
      t.tagline ? ($(), _(u(O), {
        key: 0,
        html: t.tagline
      }, null, 8, ["html"])) : P("", !0),
      t.purpose ? ($(), _(u(O), {
        key: 1,
        class: "prose",
        html: t.purpose
      }, null, 8, ["html"])) : P("", !0),
      t.moneyUsagePlan ? ($(), _(u(O), {
        key: 2,
        class: "!font-extrabold"
      }, {
        default: b(() => [
          R(E(t.moneyUsagePlanLabel), 1)
        ]),
        _: 1
      })) : P("", !0),
      t.moneyUsagePlan ? ($(), _(u(O), {
        key: 3,
        class: "prose",
        html: t.moneyUsagePlan
      }, null, 8, ["html"])) : P("", !0)
    ]));
  }
}), n4 = { class: "mb-6 mt-4 flex w-full flex-col gap-4" }, r4 = { class: "flex items-start gap-3" }, s4 = {
  key: 1,
  class: "size-[24px] shrink-0"
}, o4 = /* @__PURE__ */ X({
  __name: "Collaterals",
  props: {
    label: {},
    moreLabel: {},
    slideOverTitle: {},
    slideOverSubtitle: {},
    collaterals: {},
    moreTypesLabel: {},
    tooltipButtonLabel: {},
    isMobile: { type: Boolean },
    isPublic: { type: Boolean }
  },
  emits: ["openCalculator", "openCollateralsDetail"],
  setup(e) {
    const t = j(
      () => e.collaterals.filter(({ type: d }) => d)
    );
    return (d, r) => {
      const n = g1("ripple");
      return $(), k(ae, null, [
        y(u(O), {
          class: "!font-extrabold",
          size: u(H).h3
        }, {
          default: b(() => [
            R(E(d.label), 1)
          ]),
          _: 1
        }, 8, ["size"]),
        x("div", n4, [
          ($(!0), k(ae, null, he(t.value, (a) => ($(), k("ul", {
            key: a.type,
            class: "flex items-center gap-3 marker:text-grey-100"
          }, [
            x("li", r4, [
              a.icon ? ($(), _(Oe(a.icon), {
                key: 0,
                class: "shrink-0 text-[24px] text-grey"
              })) : ($(), k("div", s4)),
              y(u(O), null, {
                default: b(() => [
                  R(E(a.type), 1)
                ]),
                _: 2
              }, 1024)
            ])
          ]))), 128))
        ]),
        Ge(($(), k("button", {
          class: "order-2 font-semibold text-orange hover:cursor-pointer",
          onClick: r[0] || (r[0] = (a) => d.$emit("openCollateralsDetail"))
        }, [
          R(E(d.moreLabel) + " ", 1),
          y(u(F2), { class: "inline-block text-[24px]" })
        ])), [
          [n]
        ])
      ], 64);
    };
  }
}), a4 = { class: "font-semibold" }, l4 = { class: "font-semibold" }, i4 = { class: "font-semibold" }, u4 = { class: "font-semibold" }, c4 = { class: "font-semibold" }, f4 = { class: "font-semibold" }, $4 = { class: "font-semibold" }, p4 = { class: "font-semibold" }, m4 = { class: "font-semibold" }, g4 = { class: "font-semibold" }, h4 = /* @__PURE__ */ X({
  __name: "Example",
  props: {
    maturityYears: {},
    label: {},
    purchaseIntro: {},
    purchaseBonds: {},
    purchaseTotalValue: {},
    purchaseMaturity: {},
    purchaseYears: {},
    paymentsPeriod: {},
    paymentsToYourAccount: {},
    paymentsAutomatic: {},
    paymentsTaxNote: {},
    maturityAfter: {},
    maturityRepayment: {},
    maturityAutomatic: {},
    profitIntro: {},
    profitYears: {},
    profitTaxNote: {},
    calculateIntro: {},
    calculateRest: {},
    totalInvestmentFormatted: {},
    periodPayoutFormatted: {},
    totalProfitFormatted: {}
  },
  setup(e) {
    return (t, d) => ($(), k(ae, null, [
      y(u(O), {
        class: "!font-extrabold",
        size: u(H).h3
      }, {
        default: b(() => [
          R(E(t.label), 1)
        ]),
        _: 1
      }, 8, ["size"]),
      y(u(O), {
        class: "my-4 text-pretty",
        "tag-name": "div"
      }, {
        default: b(() => [
          x("p", null, [
            R(E(t.purchaseIntro) + " ", 1),
            x("span", a4, E(t.purchaseBonds), 1),
            R(" " + E(t.purchaseTotalValue) + " ", 1),
            x("span", l4, E(t.totalInvestmentFormatted), 1),
            R(" " + E(t.purchaseMaturity) + " ", 1),
            x("span", i4, E(t.maturityYears) + " " + E(t.purchaseYears), 1),
            d[0] || (d[0] = R(". "))
          ]),
          x("p", null, [
            x("span", u4, E(t.paymentsPeriod), 1),
            R(" " + E(t.paymentsToYourAccount) + " ", 1),
            x("span", c4, E(t.paymentsAutomatic) + " " + E(t.periodPayoutFormatted), 1),
            R(" " + E(t.paymentsTaxNote), 1)
          ]),
          x("p", null, [
            R(E(t.maturityAfter) + " ", 1),
            x("span", f4, E(t.maturityYears) + " " + E(t.purchaseYears), 1),
            R(" " + E(t.maturityRepayment) + " ", 1),
            x("span", $4, E(t.maturityAutomatic) + " " + E(t.totalInvestmentFormatted), 1),
            d[1] || (d[1] = R(". "))
          ]),
          x("p", null, [
            x("span", p4, E(t.profitIntro), 1),
            R(" " + E(t.profitYears) + " ", 1),
            x("span", m4, E(t.totalProfitFormatted), 1),
            R(" " + E(t.profitTaxNote), 1)
          ]),
          x("p", null, [
            x("span", g4, E(t.calculateIntro), 1),
            R(" " + E(t.calculateRest), 1)
          ])
        ]),
        _: 1
      })
    ], 64));
  }
}), v4 = { class: "mb-2 mt-3 md:my-0" }, b4 = /* @__PURE__ */ X({
  __name: "InfoTable",
  props: {
    label: {},
    issuerLabel: {},
    issuerValue: {},
    nameLabel: {},
    nameValue: {},
    issueDateLabel: {},
    issueDateValue: {},
    maturityDateLabel: {},
    maturityDateValue: {},
    nominalValueLabel: {},
    nominalValueValue: {},
    interestRateLabel: {},
    interestRateValue: {},
    returnsPeriodicityLabel: {},
    returnsPeriodicityValue: {},
    bondResemblanceLabel: {},
    bondResemblanceValue: {},
    bondFormLabel: {},
    bondFormValue: {},
    totalAmountLabel: {},
    totalAmountValue: {},
    investedAmountLabel: {},
    investedAmountValue: {},
    isinLabel: {},
    isinValue: {}
  },
  setup(e) {
    const t = j(() => [
      { keyName: "key", text: "", width: "50%" },
      // Headers are not displayed
      { keyName: "value", text: "", width: "50%", align: Xe.right }
      // Headers are not displayed
    ]), d = j(() => ({
      headers: t.value,
      data: [
        {
          key: e.issuerLabel,
          value: e.issuerValue || "-"
        },
        {
          key: e.nameLabel,
          value: e.nameValue || "-"
        },
        {
          key: e.issueDateLabel,
          value: e.issueDateValue || "-"
        },
        {
          key: e.maturityDateLabel,
          value: e.maturityDateValue || "-"
        },
        {
          key: e.nominalValueLabel,
          value: e.nominalValueValue || "-"
        },
        {
          key: e.interestRateLabel,
          value: e.interestRateValue || "-"
        },
        {
          key: e.returnsPeriodicityLabel,
          value: e.returnsPeriodicityValue || "-"
        },
        {
          key: e.bondResemblanceLabel,
          value: e.bondResemblanceValue || "-"
        },
        {
          key: e.bondFormLabel,
          value: e.bondFormValue || "-"
        },
        {
          key: e.totalAmountLabel,
          value: e.totalAmountValue || "-"
        },
        {
          key: e.investedAmountLabel,
          value: e.investedAmountValue || "-"
        },
        {
          key: e.isinLabel,
          value: e.isinValue || "-"
        }
      ]
    }));
    return (r, n) => ($(), k(ae, null, [
      y(u(O), {
        class: "!font-extrabold",
        size: u(H).h3
      }, {
        default: b(() => [
          R(E(r.label), 1)
        ]),
        _: 1
      }, 8, ["size"]),
      y(u(h0), {
        class: "mb-2 lg:mb-0 [&_tr]:border-stroke-gray",
        "data-sources": d.value,
        "disable-sticky-head": "",
        fixed: "",
        "flat-firts-cell": "",
        "hide-header": ""
      }, {
        "body:key": b(({ item: { key: a } }) => [
          x("div", v4, [
            y(u(O), {
              class: "max-w-full",
              size: u(H).sm
            }, {
              default: b(() => [
                R(E(a), 1)
              ]),
              _: 2
            }, 1032, ["size"])
          ])
        ]),
        "body:value": b(({ item: { value: a } }) => [
          y(u(O), {
            class: "!font-semibold",
            size: u(H).sm
          }, {
            default: b(() => [
              R(E(a), 1)
            ]),
            _: 2
          }, 1032, ["size"])
        ]),
        _: 1
      }, 8, ["data-sources"])
    ], 64));
  }
}), y4 = ["src"], x4 = /* @__PURE__ */ X({
  __name: "Motivation",
  props: {
    label: {},
    reasonsToInvest: {}
  },
  setup(e) {
    return (t, d) => ($(), k("div", null, [
      y(u(O), {
        class: "!font-extrabold",
        size: u(H).h3
      }, {
        default: b(() => [
          R(E(t.label), 1)
        ]),
        _: 1
      }, 8, ["size"]),
      x("ul", null, [
        ($(!0), k(ae, null, he(t.reasonsToInvest, (r, n) => ($(), k("li", {
          key: n,
          class: "mt-4 flex gap-3 first:mt-6"
        }, [
          r.iconUrl ? ($(), k("img", {
            key: 0,
            alt: "Person",
            class: "aspect-square h-6 object-cover object-center",
            src: r.iconUrl
          }, null, 8, y4)) : P("", !0),
          x("div", {
            class: z({ "ml-9": !r.iconUrl })
          }, [
            y(u(O), {
              class: "!font-semibold",
              size: u(H).md
            }, {
              default: b(() => [
                R(E(r.title), 1)
              ]),
              _: 2
            }, 1032, ["size"]),
            r.description ? ($(), _(u(O), {
              key: 0,
              class: "prose mt-1 !font-light",
              html: r.description,
              size: u(H).md,
              "tag-name": "div"
            }, null, 8, ["html", "size"])) : P("", !0)
          ], 2)
        ]))), 128))
      ])
    ]));
  }
}), w4 = {
  key: 0,
  class: "flex flex-col items-center gap-4"
}, C4 = ["src"], k4 = ["src"], S4 = /* @__PURE__ */ X({
  __name: "Video",
  props: {
    youtubeUrl: {},
    videoUrl: {},
    videoCaptionLabel: {}
  },
  setup(e) {
    return (t, d) => {
      const r = g1("ripple");
      return t.youtubeUrl || t.videoUrl ? ($(), k("div", w4, [
        t.videoUrl ? Ge(($(), k("video", {
          key: 0,
          class: "w-full rounded-xl",
          controls: "",
          playsinline: "",
          preload: "metadata",
          src: t.videoUrl
        }, null, 8, C4)), [
          [r]
        ]) : t.youtubeUrl ? Ge(($(), k("iframe", {
          key: 1,
          allow: "accelerometer; autoplay; encrypted-media; picture-in-picture",
          class: "aspect-video w-full rounded-xl",
          loading: "lazy",
          referrerpolicy: "no-referrer-when-downgrade",
          sandbox: "allow-same-origin allow-scripts",
          src: t.youtubeUrl
        }, null, 8, k4)), [
          [r]
        ]) : P("", !0),
        y(u(O), {
          class: "text-grey",
          size: u(H).sm
        }, {
          default: b(() => [
            R(E(t.videoCaptionLabel), 1)
          ]),
          _: 1
        }, 8, ["size"])
      ])) : P("", !0);
    };
  }
}), S5 = /* @__PURE__ */ X({
  __name: "Project",
  props: {
    video: {},
    motivation: {},
    infoTable: {},
    example: {},
    collaterals: {},
    about: {},
    periodicityFraction: {},
    hideExample: { type: Boolean }
  },
  emits: ["openCalculator", "openCollateralsDetail"],
  setup(e) {
    return (t, d) => ($(), k(ae, null, [
      y(d4, A1(X1(t.about)), null, 16),
      y(S4, fe({ class: "mt-8" }, t.video), null, 16),
      t.motivation && t.motivation.reasonsToInvest.length ? ($(), _(x4, fe({
        key: 0,
        class: "mt-8"
      }, t.motivation), null, 16)) : P("", !0),
      y(u(Q1)),
      y(o4, fe(t.collaterals, {
        onOpenCalculator: d[0] || (d[0] = (r) => t.$emit("openCalculator")),
        onOpenCollateralsDetail: d[1] || (d[1] = (r) => t.$emit("openCollateralsDetail"))
      }), null, 16),
      y(u(Q1)),
      t.hideExample ? P("", !0) : ($(), _(h4, A1(fe({ key: 1 }, t.example)), null, 16)),
      t.hideExample ? P("", !0) : ($(), _(u(Q1), { key: 2 })),
      y(b4, A1(X1(t.infoTable)), null, 16)
    ], 64));
  }
});
function Xn(e) {
  var t, d, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (d = Xn(e[t])) && (r && (r += " "), r += d);
  } else for (d in e) e[d] && (r && (r += " "), r += d);
  return r;
}
function Qn() {
  for (var e, t, d = 0, r = "", n = arguments.length; d < n; d++) (e = arguments[d]) && (t = Xn(e)) && (r && (r += " "), r += t);
  return r;
}
var M4 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function T4(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var e2 = { exports: {} };
(function(e, t) {
  (function(d, r) {
    e.exports = r();
  })(M4, function() {
    var d = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, r = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, a = /\d\d/, s = /\d\d?/, l = /\d*[^-_:/,()\s\d]+/, i = {}, f = function(S) {
      return (S = +S) + (S > 68 ? 1900 : 2e3);
    }, p = function(S) {
      return function(L) {
        this[S] = +L;
      };
    }, m = [/[+-]\d\d:?(\d\d)?|Z/, function(S) {
      (this.zone || (this.zone = {})).offset = function(L) {
        if (!L || L === "Z") return 0;
        var T = L.match(/([+-]|\d\d)/g), g = 60 * T[1] + (+T[2] || 0);
        return g === 0 ? 0 : T[0] === "+" ? -g : g;
      }(S);
    }], h = function(S) {
      var L = i[S];
      return L && (L.indexOf ? L : L.s.concat(L.f));
    }, C = function(S, L) {
      var T, g = i.meridiem;
      if (g) {
        for (var I = 1; I <= 24; I += 1) if (S.indexOf(g(I, 0, L)) > -1) {
          T = I > 12;
          break;
        }
      } else T = S === (L ? "pm" : "PM");
      return T;
    }, v = { A: [l, function(S) {
      this.afternoon = C(S, !1);
    }], a: [l, function(S) {
      this.afternoon = C(S, !0);
    }], Q: [n, function(S) {
      this.month = 3 * (S - 1) + 1;
    }], S: [n, function(S) {
      this.milliseconds = 100 * +S;
    }], SS: [a, function(S) {
      this.milliseconds = 10 * +S;
    }], SSS: [/\d{3}/, function(S) {
      this.milliseconds = +S;
    }], s: [s, p("seconds")], ss: [s, p("seconds")], m: [s, p("minutes")], mm: [s, p("minutes")], H: [s, p("hours")], h: [s, p("hours")], HH: [s, p("hours")], hh: [s, p("hours")], D: [s, p("day")], DD: [a, p("day")], Do: [l, function(S) {
      var L = i.ordinal, T = S.match(/\d+/);
      if (this.day = T[0], L) for (var g = 1; g <= 31; g += 1) L(g).replace(/\[|\]/g, "") === S && (this.day = g);
    }], w: [s, p("week")], ww: [a, p("week")], M: [s, p("month")], MM: [a, p("month")], MMM: [l, function(S) {
      var L = h("months"), T = (h("monthsShort") || L.map(function(g) {
        return g.slice(0, 3);
      })).indexOf(S) + 1;
      if (T < 1) throw new Error();
      this.month = T % 12 || T;
    }], MMMM: [l, function(S) {
      var L = h("months").indexOf(S) + 1;
      if (L < 1) throw new Error();
      this.month = L % 12 || L;
    }], Y: [/[+-]?\d+/, p("year")], YY: [a, function(S) {
      this.year = f(S);
    }], YYYY: [/\d{4}/, p("year")], Z: m, ZZ: m };
    function M(S) {
      var L, T;
      L = S, T = i && i.formats;
      for (var g = (S = L.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(te, B, V) {
        var q = V && V.toUpperCase();
        return B || T[V] || d[V] || T[q].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(J, ee, le) {
          return ee || le.slice(1);
        });
      })).match(r), I = g.length, N = 0; N < I; N += 1) {
        var Z = g[N], Y = v[Z], G = Y && Y[0], U = Y && Y[1];
        g[N] = U ? { regex: G, parser: U } : Z.replace(/^\[|\]$/g, "");
      }
      return function(te) {
        for (var B = {}, V = 0, q = 0; V < I; V += 1) {
          var J = g[V];
          if (typeof J == "string") q += J.length;
          else {
            var ee = J.regex, le = J.parser, K = te.slice(q), re = ee.exec(K)[0];
            le.call(B, re), te = te.replace(re, "");
          }
        }
        return function(ne) {
          var ce = ne.afternoon;
          if (ce !== void 0) {
            var ie = ne.hours;
            ce ? ie < 12 && (ne.hours += 12) : ie === 12 && (ne.hours = 0), delete ne.afternoon;
          }
        }(B), B;
      };
    }
    return function(S, L, T) {
      T.p.customParseFormat = !0, S && S.parseTwoDigitYear && (f = S.parseTwoDigitYear);
      var g = L.prototype, I = g.parse;
      g.parse = function(N) {
        var Z = N.date, Y = N.utc, G = N.args;
        this.$u = Y;
        var U = G[1];
        if (typeof U == "string") {
          var te = G[2] === !0, B = G[3] === !0, V = te || B, q = G[2];
          B && (q = G[2]), i = this.$locale(), !te && q && (i = T.Ls[q]), this.$d = function(K, re, ne, ce) {
            try {
              if (["x", "X"].indexOf(re) > -1) return new Date((re === "X" ? 1e3 : 1) * K);
              var ie = M(re)(K), ve = ie.year, se = ie.month, be = ie.day, Ae = ie.hours, $e = ie.minutes, Pe = ie.seconds, Me = ie.milliseconds, We = ie.zone, De = ie.week, xe = /* @__PURE__ */ new Date(), oe = be || (ve || se ? 1 : xe.getDate()), ge = ve || xe.getFullYear(), we = 0;
              ve && !se || (we = se > 0 ? se - 1 : xe.getMonth());
              var Le, Ne = Ae || 0, Ye = $e || 0, qe = Pe || 0, Je = Me || 0;
              return We ? new Date(Date.UTC(ge, we, oe, Ne, Ye, qe, Je + 60 * We.offset * 1e3)) : ne ? new Date(Date.UTC(ge, we, oe, Ne, Ye, qe, Je)) : (Le = new Date(ge, we, oe, Ne, Ye, qe, Je), De && (Le = ce(Le).week(De).toDate()), Le);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(Z, U, Y, T), this.init(), q && q !== !0 && (this.$L = this.locale(q).$L), V && Z != this.format(U) && (this.$d = /* @__PURE__ */ new Date("")), i = {};
        } else if (U instanceof Array) for (var J = U.length, ee = 1; ee <= J; ee += 1) {
          G[1] = U[ee - 1];
          var le = T.apply(this, G);
          if (le.isValid()) {
            this.$d = le.$d, this.$L = le.$L, this.init();
            break;
          }
          ee === J && (this.$d = /* @__PURE__ */ new Date(""));
        }
        else I.call(this, N);
      };
    };
  });
})(e2);
var L4 = e2.exports;
const A4 = /* @__PURE__ */ T4(L4), v0 = "-", D4 = (e) => {
  const t = E4(e), {
    conflictingClassGroups: d,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (s) => {
      const l = s.split(v0);
      return l[0] === "" && l.length !== 1 && l.shift(), t2(l, t) || I4(s);
    },
    getConflictingClassGroupIds: (s, l) => {
      const i = d[s] || [];
      return l && r[s] ? [...i, ...r[s]] : i;
    }
  };
}, t2 = (e, t) => {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  const d = e[0], r = t.nextPart.get(d), n = r ? t2(e.slice(1), r) : void 0;
  if (n)
    return n;
  if (t.validators.length === 0)
    return;
  const a = e.join(v0);
  return (s = t.validators.find(({
    validator: l
  }) => l(a))) == null ? void 0 : s.classGroupId;
}, fn = /^\[(.+)\]$/, I4 = (e) => {
  if (fn.test(e)) {
    const t = fn.exec(e)[1], d = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (d)
      return "arbitrary.." + d;
  }
}, E4 = (e) => {
  const {
    theme: t,
    prefix: d
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return B4(Object.entries(e.classGroups), d).forEach(([a, s]) => {
    Wd(s, r, a, t);
  }), r;
}, Wd = (e, t, d, r) => {
  e.forEach((n) => {
    if (typeof n == "string") {
      const a = n === "" ? t : $n(t, n);
      a.classGroupId = d;
      return;
    }
    if (typeof n == "function") {
      if (z4(n)) {
        Wd(n(r), t, d, r);
        return;
      }
      t.validators.push({
        validator: n,
        classGroupId: d
      });
      return;
    }
    Object.entries(n).forEach(([a, s]) => {
      Wd(s, $n(t, a), d, r);
    });
  });
}, $n = (e, t) => {
  let d = e;
  return t.split(v0).forEach((r) => {
    d.nextPart.has(r) || d.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), d = d.nextPart.get(r);
  }), d;
}, z4 = (e) => e.isThemeGetter, B4 = (e, t) => t ? e.map(([d, r]) => {
  const n = r.map((a) => typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(([s, l]) => [t + s, l])) : a);
  return [d, n];
}) : e, P4 = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, d = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const n = (a, s) => {
    d.set(a, s), t++, t > e && (t = 0, r = d, d = /* @__PURE__ */ new Map());
  };
  return {
    get(a) {
      let s = d.get(a);
      if (s !== void 0)
        return s;
      if ((s = r.get(a)) !== void 0)
        return n(a, s), s;
    },
    set(a, s) {
      d.has(a) ? d.set(a, s) : n(a, s);
    }
  };
}, d2 = "!", V4 = (e) => {
  const {
    separator: t,
    experimentalParseClassName: d
  } = e, r = t.length === 1, n = t[0], a = t.length, s = (l) => {
    const i = [];
    let f = 0, p = 0, m;
    for (let S = 0; S < l.length; S++) {
      let L = l[S];
      if (f === 0) {
        if (L === n && (r || l.slice(S, S + a) === t)) {
          i.push(l.slice(p, S)), p = S + a;
          continue;
        }
        if (L === "/") {
          m = S;
          continue;
        }
      }
      L === "[" ? f++ : L === "]" && f--;
    }
    const h = i.length === 0 ? l : l.substring(p), C = h.startsWith(d2), v = C ? h.substring(1) : h, M = m && m > p ? m - p : void 0;
    return {
      modifiers: i,
      hasImportantModifier: C,
      baseClassName: v,
      maybePostfixModifierPosition: M
    };
  };
  return d ? (l) => d({
    className: l,
    parseClassName: s
  }) : s;
}, O4 = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let d = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...d.sort(), r), d = []) : d.push(r);
  }), t.push(...d.sort()), t;
}, R4 = (e) => ({
  cache: P4(e.cacheSize),
  parseClassName: V4(e),
  ...D4(e)
}), N4 = /\s+/, F4 = (e, t) => {
  const {
    parseClassName: d,
    getClassGroupId: r,
    getConflictingClassGroupIds: n
  } = t, a = [], s = e.trim().split(N4);
  let l = "";
  for (let i = s.length - 1; i >= 0; i -= 1) {
    const f = s[i], {
      modifiers: p,
      hasImportantModifier: m,
      baseClassName: h,
      maybePostfixModifierPosition: C
    } = d(f);
    let v = !!C, M = r(v ? h.substring(0, C) : h);
    if (!M) {
      if (!v) {
        l = f + (l.length > 0 ? " " + l : l);
        continue;
      }
      if (M = r(h), !M) {
        l = f + (l.length > 0 ? " " + l : l);
        continue;
      }
      v = !1;
    }
    const S = O4(p).join(":"), L = m ? S + d2 : S, T = L + M;
    if (a.includes(T))
      continue;
    a.push(T);
    const g = n(M, v);
    for (let I = 0; I < g.length; ++I) {
      const N = g[I];
      a.push(L + N);
    }
    l = f + (l.length > 0 ? " " + l : l);
  }
  return l;
};
function _4() {
  let e = 0, t, d, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (d = n2(t)) && (r && (r += " "), r += d);
  return r;
}
const n2 = (e) => {
  if (typeof e == "string")
    return e;
  let t, d = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = n2(e[r])) && (d && (d += " "), d += t);
  return d;
};
function j4(e, ...t) {
  let d, r, n, a = s;
  function s(i) {
    const f = t.reduce((p, m) => m(p), e());
    return d = R4(f), r = d.cache.get, n = d.cache.set, a = l, l(i);
  }
  function l(i) {
    const f = r(i);
    if (f)
      return f;
    const p = F4(i, d);
    return n(i, p), p;
  }
  return function() {
    return a(_4.apply(null, arguments));
  };
}
const Ee = (e) => {
  const t = (d) => d[e] || [];
  return t.isThemeGetter = !0, t;
}, r2 = /^\[(?:([a-z-]+):)?(.+)\]$/i, H4 = /^\d+\/\d+$/, G4 = /* @__PURE__ */ new Set(["px", "full", "screen"]), U4 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, W4 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Y4 = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, K4 = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Z4 = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, y1 = (e) => tt(e) || G4.has(e) || H4.test(e), S1 = (e) => at(e, "length", n9), tt = (e) => !!e && !Number.isNaN(Number(e)), Rd = (e) => at(e, "number", tt), mt = (e) => !!e && Number.isInteger(Number(e)), q4 = (e) => e.endsWith("%") && tt(e.slice(0, -1)), me = (e) => r2.test(e), M1 = (e) => U4.test(e), J4 = /* @__PURE__ */ new Set(["length", "size", "percentage"]), X4 = (e) => at(e, J4, s2), Q4 = (e) => at(e, "position", s2), e9 = /* @__PURE__ */ new Set(["image", "url"]), t9 = (e) => at(e, e9, s9), d9 = (e) => at(e, "", r9), gt = () => !0, at = (e, t, d) => {
  const r = r2.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : d(r[2]) : !1;
}, n9 = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  W4.test(e) && !Y4.test(e)
), s2 = () => !1, r9 = (e) => K4.test(e), s9 = (e) => Z4.test(e), o9 = () => {
  const e = Ee("colors"), t = Ee("spacing"), d = Ee("blur"), r = Ee("brightness"), n = Ee("borderColor"), a = Ee("borderRadius"), s = Ee("borderSpacing"), l = Ee("borderWidth"), i = Ee("contrast"), f = Ee("grayscale"), p = Ee("hueRotate"), m = Ee("invert"), h = Ee("gap"), C = Ee("gradientColorStops"), v = Ee("gradientColorStopPositions"), M = Ee("inset"), S = Ee("margin"), L = Ee("opacity"), T = Ee("padding"), g = Ee("saturate"), I = Ee("scale"), N = Ee("sepia"), Z = Ee("skew"), Y = Ee("space"), G = Ee("translate"), U = () => ["auto", "contain", "none"], te = () => ["auto", "hidden", "clip", "visible", "scroll"], B = () => ["auto", me, t], V = () => [me, t], q = () => ["", y1, S1], J = () => ["auto", tt, me], ee = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], le = () => ["solid", "dashed", "dotted", "double", "none"], K = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], re = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], ne = () => ["", "0", me], ce = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], ie = () => [tt, me];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [gt],
      spacing: [y1, S1],
      blur: ["none", "", M1, me],
      brightness: ie(),
      borderColor: [e],
      borderRadius: ["none", "", "full", M1, me],
      borderSpacing: V(),
      borderWidth: q(),
      contrast: ie(),
      grayscale: ne(),
      hueRotate: ie(),
      invert: ne(),
      gap: V(),
      gradientColorStops: [e],
      gradientColorStopPositions: [q4, S1],
      inset: B(),
      margin: B(),
      opacity: ie(),
      padding: V(),
      saturate: ie(),
      scale: ie(),
      sepia: ne(),
      skew: ie(),
      space: V(),
      translate: V()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", me]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [M1]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": ce()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": ce()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...ee(), me]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: te()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": te()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": te()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: U()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": U()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": U()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [M]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [M]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [M]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [M]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [M]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [M]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [M]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [M]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [M]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", mt, me]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: B()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", me]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ne()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ne()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", mt, me]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [gt]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", mt, me]
        }, me]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": J()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": J()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [gt]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [mt, me]
        }, me]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": J()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": J()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", me]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", me]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [h]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [h]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [h]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...re()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...re(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...re(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [T]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [T]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [T]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [T]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [T]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [T]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [T]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [T]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [T]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [S]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [S]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [S]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [S]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [S]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [S]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [S]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [S]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [S]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [Y]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [Y]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", me, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [me, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [me, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [M1]
        }, M1]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [me, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [me, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [me, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [me, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", M1, S1]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Rd]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [gt]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", me]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", tt, Rd]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", y1, me]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", me]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", me]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [L]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [L]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...le(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", y1, S1]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", y1, me]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: V()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", me]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", me]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [L]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...ee(), Q4]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", X4]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, t9]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [v]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [v]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [v]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [C]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [C]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [C]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [l]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [l]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [l]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [l]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [l]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [l]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [l]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [l]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [l]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [L]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...le(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [l]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [l]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [L]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: le()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [n]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [n]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [n]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [n]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [n]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [n]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [n]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [n]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [n]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [n]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...le()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [y1, me]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [y1, S1]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: q()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [L]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [y1, S1]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", M1, d9]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [gt]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [L]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...K(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": K()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [d]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [i]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", M1, me]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [f]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [p]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [m]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [g]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [N]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [d]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [i]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [f]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [p]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [m]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [L]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [g]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [N]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", me]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: ie()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", me]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: ie()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", me]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [I]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [I]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [I]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [mt, me]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [G]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [G]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [Z]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [Z]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", me]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", me]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": V()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": V()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": V()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": V()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": V()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": V()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": V()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": V()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": V()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": V()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": V()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": V()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": V()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": V()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": V()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": V()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": V()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": V()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", me]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [y1, S1, Rd]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, o2 = /* @__PURE__ */ j4(o9);
var Se = /* @__PURE__ */ ((e) => (e.Future = "FUTURE", e.Next = "NEXT", e.Overdue = "OVERDUE", e.Paid = "PAID", e))(Se || {});
const Yd = /* @__PURE__ */ X({
  __name: "ItemIcon",
  props: {
    returnState: {},
    iconSize: {}
  },
  setup(e) {
    const t = e;
    function d(...s) {
      return o2(Qn(s));
    }
    const r = j(() => {
      switch (t.returnState) {
        case Se.Paid:
          return {
            component: qd,
            isFilled: !0
          };
        case Se.Overdue:
          return {
            component: u1,
            isFilled: !0
          };
        case Se.Future:
          return {
            component: Jd,
            isFilled: !1
          };
        case Se.Next:
          return {
            component: Cn,
            isFilled: !1,
            class: "text-brand"
          };
        default:
          return {
            component: _2,
            isFilled: !0
          };
      }
    }), n = j(() => {
      switch (t.returnState) {
        case Se.Paid:
          return "bg-success";
        case Se.Overdue:
          return "bg-red-200";
        default:
          return "bg-grey-500";
      }
    }), a = j(() => `${r.value.isFilled ? Number(t.iconSize) - 11 : Number(t.iconSize)}px`);
    return (s, l) => r.value.isFilled ? ($(), k("span", {
      key: 0,
      class: z(d(
        "icon-size p-1.5 flex rounded-full h-min w-fit justify-center ",
        n.value
      ))
    }, [
      ($(), _(Oe(r.value.component), {
        class: z(d("text-white", r.value.class)),
        style: Ue({
          "--stroke-width": 3,
          fontSize: a.value
        })
      }, null, 8, ["class", "style"]))
    ], 2)) : ($(), _(Oe(r.value.component), {
      key: 1,
      class: z(d("icon-size text-secondary", r.value.class)),
      style: Ue({
        fontSize: a.value
      })
    }, null, 8, ["class", "style"]));
  }
}), a9 = { class: "flex size-[70px] flex-col items-center justify-center" }, l9 = { class: "flex flex-col gap-y-1" }, i9 = { class: "flex items-start gap-2" }, u9 = /* @__PURE__ */ X({
  __name: "Item",
  props: {
    returnPeriod: {},
    returnsPeriodicity: {}
  },
  setup(e) {
    function t(...n) {
      return o2(Qn(n));
    }
    td.extend(A4);
    function d(n) {
      switch (n) {
        case Se.Paid:
          return "text-success";
        case Se.Overdue:
          return "text-red";
        case Se.Future:
          return "text-grey";
        case Se.Next:
          return "text-black";
        default:
          return "text-grey-500";
      }
    }
    function r(n) {
      switch (n) {
        case Se.Paid:
          return "bg-success-200 border-success";
        case Se.Overdue:
          return "bg-red-light border-red";
        case Se.Future:
          return "bg-white border-grey-stroke border-dotted";
        case Se.Next:
          return "border-brand bg-brand-light";
        default:
          return "bg-grey-100 border-gray";
      }
    }
    return (n, a) => {
      var s;
      return $(), _(u(et), {
        class: z(t("py-2 px-1 rounded-xl border", r((s = n.returnPeriod) == null ? void 0 : s.state))),
        "hide-icon": ""
      }, {
        trigger: b(() => {
          var l, i;
          return [
            x("div", a9, [
              y(Yd, {
                class: "mb-2",
                "icon-size": 24,
                "return-state": (l = n.returnPeriod) == null ? void 0 : l.state
              }, null, 8, ["return-state"]),
              y(u(O), {
                class: z(t("flex flex-col items-center text-center", d((i = n.returnPeriod) == null ? void 0 : i.state))),
                size: u(H).sm
              }, {
                default: b(() => {
                  var f;
                  return [
                    R(E((f = n.returnPeriod) == null ? void 0 : f.period), 1)
                  ];
                }),
                _: 1
              }, 8, ["class", "size"])
            ])
          ];
        }),
        content: b(() => {
          var l, i, f, p, m, h;
          return [
            x("div", l9, [
              x("div", i9, [
                y(Yd, {
                  class: "shrink-0",
                  "icon-size": 24,
                  "return-state": (l = n.returnPeriod) == null ? void 0 : l.state
                }, null, 8, ["return-state"]),
                y(u(O), {
                  class: z(t("block !font-highlighted", d((i = n.returnPeriod) == null ? void 0 : i.state)))
                }, {
                  default: b(() => {
                    var C, v;
                    return [
                      R(E((v = (C = n.returnPeriod) == null ? void 0 : C.translations) == null ? void 0 : v.title), 1)
                    ];
                  }),
                  _: 1
                }, 8, ["class"])
              ]),
              y(u(O), {
                class: "block text-grey-400",
                html: (p = (f = n.returnPeriod) == null ? void 0 : f.translations) == null ? void 0 : p.description,
                size: u(H).sm
              }, null, 8, ["html", "size"]),
              y(u(O), {
                class: "block text-grey-400",
                html: (h = (m = n.returnPeriod) == null ? void 0 : m.translations) == null ? void 0 : h.maturityDate,
                size: u(H).sm
              }, null, 8, ["html", "size"])
            ])
          ];
        }),
        _: 1
      }, 8, ["class"]);
    };
  }
}), c9 = { class: "my-4 flex flex-wrap gap-x-4 gap-y-2" }, f9 = { key: 0 }, $9 = /* @__PURE__ */ X({
  __name: "Legend",
  props: {
    legends: {},
    items: { default: () => [] }
  },
  setup(e) {
    const t = e, d = j(() => {
      const n = {
        [Se.Paid]: 0,
        [Se.Overdue]: 0,
        [Se.Next]: 0,
        [Se.Future]: 0
      };
      return t.items.forEach((a) => {
        a.state && n[a.state]++;
      }), n;
    }), r = j(() => {
      var n, a, s, l;
      return [
        {
          label: `${((n = t.legends) == null ? void 0 : n.paid) ?? ""}`,
          icon: j2,
          color: "text-success",
          state: Se.Paid,
          count: d.value[Se.Paid]
        },
        {
          label: `${((a = t.legends) == null ? void 0 : a.unpaid) ?? ""}`,
          icon: yn,
          color: "text-red-500",
          state: Se.Overdue,
          count: d.value[Se.Overdue]
        },
        {
          label: `${((s = t.legends) == null ? void 0 : s.pending) ?? ""}`,
          icon: Cn,
          color: "text-brand-dark",
          state: Se.Next,
          count: d.value[Se.Next]
        },
        {
          label: `${((l = t.legends) == null ? void 0 : l.future) ?? ""}`,
          icon: Jd,
          color: "text-secondary",
          state: Se.Future,
          count: d.value[Se.Future]
        }
      ];
    });
    return (n, a) => ($(), k("div", c9, [
      ($(!0), k(ae, null, he(r.value, (s, l) => ($(), k("div", {
        key: l,
        class: "inline-flex items-center gap-x-2 text-secondary"
      }, [
        s.label ? ($(), _(Yd, {
          key: 0,
          class: "flex-initial",
          "icon-size": 20,
          "return-state": s.state
        }, null, 8, ["return-state"])) : P("", !0),
        s.label ? ($(), _(u(O), {
          key: 1,
          class: "whitespace-nowrap",
          size: u(H).xs
        }, {
          default: b(() => [
            R(E(s.label) + " ", 1),
            s.state !== u(Se).Next ? ($(), k("span", f9, "(" + E(s.count) + ")", 1)) : P("", !0)
          ]),
          _: 2
        }, 1032, ["size"])) : P("", !0)
      ]))), 128))
    ]));
  }
}), p9 = { class: "flex flex-wrap gap-2" }, M5 = /* @__PURE__ */ X({
  __name: "index",
  props: {
    count: { default: 0 },
    pastItems: { default: 5 },
    futureItems: { default: 5 },
    returnsPeriodicity: {},
    items: {},
    legends: {}
  },
  setup(e) {
    const t = e, d = j(() => td()), r = j(() => {
      const n = t.items.findIndex(
        (S) => td(S.issuePeriod.startDate).isAfter(d.value)
      );
      if (n === -1)
        return [];
      const a = t.pastItems + t.futureItems, s = t.pastItems / a, l = t.count > 0 ? t.count : a, i = Math.round(l * s), f = l - i, p = n, m = t.items.length - n;
      let h = Math.min(p, i), C = Math.min(m, f);
      if (h < i && m > f) {
        const S = Math.min(
          m - f,
          i - h
        );
        C += S;
      } else if (C < f && p > i) {
        const S = Math.min(
          p - i,
          f - C
        );
        h += S;
      }
      const v = Math.max(0, n - h), M = Math.min(t.items.length, n + C);
      return t.items.slice(v, M);
    });
    return (n, a) => ($(), k(ae, null, [
      y($9, {
        items: n.items,
        legends: n.legends
      }, null, 8, ["items", "legends"]),
      x("div", p9, [
        ($(!0), k(ae, null, he(r.value, (s) => ($(), k("div", {
          key: s.issuePeriod.startDate.toISOString(),
          class: "max-w-[77px] flex-none"
        }, [
          y(u9, {
            "return-period": s,
            "returns-periodicity": n.returnsPeriodicity
          }, null, 8, ["return-period", "returns-periodicity"])
        ]))), 128))
      ])
    ], 64));
  }
}), T5 = /* @__PURE__ */ X({
  __name: "Tabs",
  props: {
    tabs: {}
  },
  setup(e) {
    const t = Xt("tabsRootRef"), { y: d } = X2(), r = de("project"), n = de(null), a = de(!1);
    Ce(r, (f) => {
      const p = new URL(window.location.href);
      p.searchParams.set("tab", f), window.history.replaceState({}, "", p.toString()), s();
    }), r1(() => {
      const p = new URL(window.location.href).searchParams.get("tab");
      p && p in e.tabs && (r.value = p);
    });
    function s() {
      var f, p;
      (p = (f = t.value) == null ? void 0 : f.$el) == null || p.scrollIntoView(!0);
    }
    function l(f) {
      if (!f)
        return !1;
      const p = f.getBoundingClientRect(), m = window.getComputedStyle(f), h = Number.parseFloat(m.top) || 0;
      return p.top === h;
    }
    const i = Q2(() => {
      n.value && (a.value = l(n.value));
    }, 500);
    return Ce(d, () => {
      i();
    }), (f, p) => {
      const m = g1("ripple");
      return $(), _(u(Ln), {
        ref_key: "tabsRootRef",
        ref: t,
        modelValue: r.value,
        "onUpdate:modelValue": p[0] || (p[0] = (h) => r.value = h),
        class: "relative",
        "default-value": "project"
      }, {
        default: b(() => [
          y(u(An), { class: "relative top-0 z-[3] flex w-full gap-3 bg-white max-md:sticky max-md:-mx-5 max-md:h-14 max-md:w-[calc(100%+2.5rem)] max-md:px-5 max-md:py-2 md:mb-5" }, {
            default: b(() => [
              ($(!0), k(ae, null, he(f.tabs, (h, C) => Ge(($(), _(u(Mn), {
                key: C,
                class: z(["rounded-full border px-3 py-2 text-sm font-semibold text-orange", {
                  "border-orange-light bg-orange-light": r.value === C,
                  "border-orange": r.value !== C
                }]),
                value: C
              }, {
                default: b(() => [
                  R(E(h.label), 1)
                ]),
                _: 2
              }, 1032, ["class", "value"])), [
                [m]
              ])), 128))
            ]),
            _: 1
          }),
          p[1] || (p[1] = x("div", { class: "absolute top-14 z-[2] -mx-5 h-4 w-full bg-white max-md:w-[calc(100%+2.5rem)] md:hidden" }, null, -1)),
          x("div", {
            ref_key: "shadowRef",
            ref: n,
            class: z(["sticky top-7 z-[1] -mx-5 -mt-7 mb-4 h-7 w-full shadow-navbar-sticky transition-opacity max-md:w-[calc(100%+2.5rem)] md:hidden", { "opacity-0": !a.value }])
          }, null, 2),
          ($(!0), k(ae, null, he(f.tabs, (h, C) => ($(), _(u(Tn), {
            key: C,
            value: C
          }, {
            default: b(() => [
              y(u(O), {
                class: "mb-2 !font-semibold text-brand-dark",
                size: u(H).h5,
                "tag-name": "div"
              }, {
                default: b(() => [
                  R(E(h.label), 1)
                ]),
                _: 2
              }, 1032, ["size"]),
              W(f.$slots, C)
            ]),
            _: 2
          }, 1032, ["value"]))), 128))
        ]),
        _: 3
      }, 8, ["modelValue"]);
    };
  }
}), m9 = { class: "flex flex-col gap-5" }, g9 = { class: "flex justify-between" }, h9 = { class: "text-primary font-semibold" }, v9 = { class: "font-semibold" }, b9 = { class: "-my-2 h-2 w-full overflow-hidden rounded-full bg-brand-light" }, y9 = { class: "font-semibold" }, L5 = /* @__PURE__ */ X({
  __name: "Progress",
  props: {
    amountLabel: {},
    amountValue: {},
    amountValueFormatted: {},
    investorsCount: {},
    investorsCountLabel: {},
    remainingAmountValue: {},
    remainingAmountLabel: {},
    remainingAmountFormatted: {}
  },
  setup(e) {
    const t = j(() => e.amountValue + e.remainingAmountValue), d = j(
      () => `${(t.value === 0 ? 100 : e.amountValue / t.value) * 100}%`
    );
    return (r, n) => ($(), k("div", m9, [
      x("div", g9, [
        y(u(O), {
          size: u(H).sm
        }, {
          default: b(() => [
            R(E(r.amountLabel) + ": ", 1),
            x("span", h9, E(r.amountValueFormatted), 1)
          ]),
          _: 1
        }, 8, ["size"]),
        y(u(O), {
          size: u(H).sm
        }, {
          default: b(() => [
            x("span", v9, E(r.investorsCount), 1),
            R(" " + E(r.investorsCountLabel), 1)
          ]),
          _: 1
        }, 8, ["size"])
      ]),
      x("div", b9, [
        x("div", {
          class: "h-full rounded-r-full bg-brand transition-all duration-300 ease-in-out",
          style: Ue({ width: d.value })
        }, null, 4)
      ]),
      y(u(O), {
        class: "text-left",
        size: u(H).sm
      }, {
        default: b(() => [
          R(E(r.remainingAmountLabel) + ": ", 1),
          x("span", y9, E(r.remainingAmountFormatted), 1)
        ]),
        _: 1
      }, 8, ["size"])
    ]));
  }
}), A5 = /* @__PURE__ */ X({
  __name: "CfgPasswordField",
  props: /* @__PURE__ */ ye({
    ...Fe,
    ...Ze
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, d = j(() => x1(t, Object.keys({ ...Fe, ...Ze }))), r = ze(e, "modelValue"), n = de(!1);
    function a() {
      n.value = !n.value;
    }
    function s(l) {
      r.value = l;
    }
    return (l, i) => ($(), k("div", null, [
      y(n1, fe({
        ...d.value,
        fluid: !0
      }, {
        "interact-with-icon": "",
        "model-value": r.value,
        type: n.value ? "text" : "password",
        "onUpdate:modelValue": s
      }), {
        icon: b(() => [
          y(u(H2), {
            class: z(["text-[1.5rem] hover:cursor-pointer", {
              "text-grey-300": !n.value,
              "text-brand": n.value
            }]),
            onClick: Qe(a, ["prevent"])
          }, null, 8, ["class"])
        ]),
        _: 1
      }, 16, ["model-value", "type"])
    ]));
  }
});
var ad = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function x9(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var qt = { exports: {} }, Jt = { exports: {} }, w9 = Jt.exports, pn;
function C9() {
  return pn || (pn = 1, function(e) {
    (function() {
      var t = this || self;
      function d(o) {
        o.ra = void 0, o.pa = function() {
          return o.ra ? o.ra : o.ra = new o();
        };
      }
      function r(o, c) {
        function w() {
        }
        w.prototype = c.prototype, o.Da = c.prototype, o.prototype = new w(), o.prototype.constructor = o, o.Ja = function(A, D, F) {
          for (var Q = Array(arguments.length - 2), pe = 2; pe < arguments.length; pe++) Q[pe - 2] = arguments[pe];
          return c.prototype[D].apply(A, Q);
        };
      }
      var n = class {
        constructor(o) {
          if (a !== a) throw Error("SafeUrl is not meant to be built directly");
          this.g = o;
        }
        toString() {
          return this.g.toString();
        }
      }, a = {};
      new n("about:invalid#zClosurez"), new n("about:blank");
      var s = {};
      class l {
        constructor() {
          if (s !== s) throw Error("SafeStyle is not meant to be built directly");
        }
        toString() {
          return "";
        }
      }
      new l();
      function i(o) {
        var c = [];
        let w = 0;
        for (var A in o) c[w++] = o[A];
        return c;
      }
      var f = {};
      class p {
        constructor() {
          if (f !== f) throw Error("SafeStyleSheet is not meant to be built directly");
        }
        toString() {
          return "";
        }
      }
      new p();
      var m = {};
      class h {
        constructor() {
          var c = t.trustedTypes && t.trustedTypes.emptyHTML || "";
          if (m !== m) throw Error("SafeHtml is not meant to be built directly");
          this.g = c;
        }
        toString() {
          return this.g.toString();
        }
      }
      new h();
      function C(o, c) {
        for (this.h = o, this.g = {}, o = 0; o < c.length; o++) {
          var w = c[o];
          this.g[w.g] = w;
        }
      }
      function v(o) {
        return o = i(o.g), o.sort(function(c, w) {
          return c.g - w.g;
        }), o;
      }
      function M(o, c) {
        switch (this.g = o, this.m = !!c.ga, this.h = c.i, this.u = c.type, this.s = !1, this.h) {
          case T:
          case g:
          case I:
          case N:
          case Z:
          case L:
          case S:
            this.s = !0;
        }
        this.j = c.defaultValue;
      }
      var S = 1, L = 2, T = 3, g = 4, I = 6, N = 16, Z = 18;
      function Y() {
        this.h = {}, this.j = this.o().g, this.g = this.m = null;
      }
      Y.prototype.has = function(o) {
        return U(this, o.g);
      }, Y.prototype.get = function(o, c) {
        return B(this, o.g, c);
      }, Y.prototype.set = function(o, c) {
        ee(this, o.g, c);
      }, Y.prototype.add = function(o, c) {
        le(this, o.g, c);
      };
      function G(o, c) {
        for (var w = v(o.o()), A = 0; A < w.length; A++) {
          var D = w[A], F = D.g;
          if (U(c, F)) {
            o.g && delete o.g[D.g];
            var Q = D.h == 11 || D.h == 10;
            if (D.m) {
              D = q(c, F);
              for (var pe = 0; pe < D.length; pe++) le(o, F, Q ? D[pe].clone() : D[pe]);
            } else D = te(c, F), Q ? (Q = te(o, F)) ? G(Q, D) : ee(o, F, D.clone()) : ee(o, F, D);
          }
        }
      }
      Y.prototype.clone = function() {
        var o = new this.constructor();
        return o != this && (o.h = {}, o.g && (o.g = {}), G(o, this)), o;
      };
      function U(o, c) {
        return o.h[c] != null;
      }
      function te(o, c) {
        var w = o.h[c];
        if (w == null) return null;
        if (o.m) {
          if (!(c in o.g)) {
            var A = o.m, D = o.j[c];
            if (w != null) if (D.m) {
              for (var F = [], Q = 0; Q < w.length; Q++) F[Q] = A.h(D, w[Q]);
              w = F;
            } else w = A.h(D, w);
            return o.g[c] = w;
          }
          return o.g[c];
        }
        return w;
      }
      function B(o, c, w) {
        var A = te(o, c);
        return o.j[c].m ? A[w || 0] : A;
      }
      function V(o, c) {
        if (U(o, c)) o = B(o, c);
        else e: {
          if (o = o.j[c], o.j === void 0) if (c = o.u, c === Boolean) o.j = !1;
          else if (c === Number) o.j = 0;
          else if (c === String) o.j = o.s ? "0" : "";
          else {
            o = new c();
            break e;
          }
          o = o.j;
        }
        return o;
      }
      function q(o, c) {
        return te(o, c) || [];
      }
      function J(o, c) {
        return o.j[c].m ? U(o, c) ? o.h[c].length : 0 : U(o, c) ? 1 : 0;
      }
      function ee(o, c, w) {
        o.h[c] = w, o.g && (o.g[c] = w);
      }
      function le(o, c, w) {
        o.h[c] || (o.h[c] = []), o.h[c].push(w), o.g && delete o.g[c];
      }
      function K(o, c) {
        var w = [], A;
        for (A in c) A != 0 && w.push(new M(A, c[A]));
        return new C(o, w);
      }
      function re() {
      }
      re.prototype.g = function(o) {
        throw new o.h(), Error("Unimplemented");
      }, re.prototype.h = function(o, c) {
        if (o.h == 11 || o.h == 10) return c instanceof Y ? c : this.g(o.u.prototype.o(), c);
        if (o.h == 14) return typeof c == "string" && ne.test(c) && (o = Number(c), 0 < o) ? o : c;
        if (!o.s) return c;
        if (o = o.u, o === String) {
          if (typeof c == "number") return String(c);
        } else if (o === Number && typeof c == "string" && (c === "Infinity" || c === "-Infinity" || c === "NaN" || ne.test(c))) return Number(c);
        return c;
      };
      var ne = /^-?[0-9]+$/;
      function ce() {
      }
      r(ce, re), ce.prototype.g = function(o, c) {
        return o = new o.h(), o.m = this, o.h = c, o.g = {}, o;
      };
      function ie() {
      }
      r(ie, ce), ie.prototype.h = function(o, c) {
        return o.h == 8 ? !!c : re.prototype.h.apply(this, arguments);
      }, ie.prototype.g = function(o, c) {
        return ie.Da.g.call(this, o, c);
      };
      function ve(o, c) {
        o != null && this.g.apply(this, arguments);
      }
      ve.prototype.h = "", ve.prototype.set = function(o) {
        this.h = "" + o;
      }, ve.prototype.g = function(o, c, w) {
        if (this.h += String(o), c != null) for (let A = 1; A < arguments.length; A++) this.h += arguments[A];
        return this;
      };
      function se(o) {
        o.h = "";
      }
      ve.prototype.toString = function() {
        return this.h;
      };
      function be() {
        Y.call(this);
      }
      r(be, Y);
      var Ae = null;
      function $e() {
        Y.call(this);
      }
      r($e, Y);
      var Pe = null;
      function Me() {
        Y.call(this);
      }
      r(Me, Y);
      var We = null;
      Me.prototype.ia = function() {
        return B(this, 10);
      }, be.prototype.o = function() {
        var o = Ae;
        return o || (Ae = o = K(be, { 0: { name: "NumberFormat", na: "i18n.phonenumbers.NumberFormat" }, 1: { name: "pattern", required: !0, i: 9, type: String }, 2: { name: "format", required: !0, i: 9, type: String }, 3: { name: "leading_digits_pattern", ga: !0, i: 9, type: String }, 4: { name: "national_prefix_formatting_rule", i: 9, type: String }, 6: { name: "national_prefix_optional_when_formatting", i: 8, defaultValue: !1, type: Boolean }, 5: { name: "domestic_carrier_code_formatting_rule", i: 9, type: String } })), o;
      }, be.o = be.prototype.o, $e.prototype.o = function() {
        var o = Pe;
        return o || (Pe = o = K($e, { 0: { name: "PhoneNumberDesc", na: "i18n.phonenumbers.PhoneNumberDesc" }, 2: { name: "national_number_pattern", i: 9, type: String }, 9: { name: "possible_length", ga: !0, i: 5, type: Number }, 10: { name: "possible_length_local_only", ga: !0, i: 5, type: Number }, 6: { name: "example_number", i: 9, type: String } })), o;
      }, $e.o = $e.prototype.o, Me.prototype.o = function() {
        var o = We;
        return o || (We = o = K(Me, {
          0: { name: "PhoneMetadata", na: "i18n.phonenumbers.PhoneMetadata" },
          1: { name: "general_desc", i: 11, type: $e },
          2: { name: "fixed_line", i: 11, type: $e },
          3: { name: "mobile", i: 11, type: $e },
          4: { name: "toll_free", i: 11, type: $e },
          5: { name: "premium_rate", i: 11, type: $e },
          6: { name: "shared_cost", i: 11, type: $e },
          7: { name: "personal_number", i: 11, type: $e },
          8: { name: "voip", i: 11, type: $e },
          21: { name: "pager", i: 11, type: $e },
          25: { name: "uan", i: 11, type: $e },
          27: { name: "emergency", i: 11, type: $e },
          28: { name: "voicemail", i: 11, type: $e },
          29: { name: "short_code", i: 11, type: $e },
          30: { name: "standard_rate", i: 11, type: $e },
          31: { name: "carrier_specific", i: 11, type: $e },
          33: { name: "sms_services", i: 11, type: $e },
          24: { name: "no_international_dialling", i: 11, type: $e },
          9: { name: "id", required: !0, i: 9, type: String },
          10: { name: "country_code", i: 5, type: Number },
          11: { name: "international_prefix", i: 9, type: String },
          17: { name: "preferred_international_prefix", i: 9, type: String },
          12: { name: "national_prefix", i: 9, type: String },
          13: { name: "preferred_extn_prefix", i: 9, type: String },
          15: {
            name: "national_prefix_for_parsing",
            i: 9,
            type: String
          },
          16: { name: "national_prefix_transform_rule", i: 9, type: String },
          18: { name: "same_mobile_and_fixed_line_pattern", i: 8, defaultValue: !1, type: Boolean },
          19: { name: "number_format", ga: !0, i: 11, type: be },
          20: { name: "intl_number_format", ga: !0, i: 11, type: be },
          22: { name: "main_country_for_code", i: 8, defaultValue: !1, type: Boolean },
          23: { name: "leading_digits", i: 9, type: String }
        })), o;
      }, Me.o = Me.prototype.o;
      function De() {
        Y.call(this);
      }
      r(De, Y);
      var xe = null;
      De.prototype.ia = function() {
        return B(this, 1);
      };
      var oe = { Ia: 0, Ha: 1, Ga: 5, Fa: 10, Ea: 20 };
      De.prototype.o = function() {
        var o = xe;
        return o || (xe = o = K(De, { 0: { name: "PhoneNumber", na: "i18n.phonenumbers.PhoneNumber" }, 1: { name: "country_code", required: !0, i: 5, type: Number }, 2: { name: "national_number", required: !0, i: 4, type: Number }, 3: { name: "extension", i: 9, type: String }, 4: { name: "italian_leading_zero", i: 8, type: Boolean }, 8: { name: "number_of_leading_zeros", i: 5, defaultValue: 1, type: Number }, 5: { name: "raw_input", i: 9, type: String }, 6: { name: "country_code_source", i: 14, defaultValue: 0, type: oe }, 7: {
          name: "preferred_domestic_carrier_code",
          i: 9,
          type: String
        } })), o;
      }, De.ctor = De, De.ctor.o = De.prototype.o;
      var ge = {
        1: "US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),
        7: ["RU", "KZ"],
        20: ["EG"],
        27: ["ZA"],
        30: ["GR"],
        31: ["NL"],
        32: ["BE"],
        33: ["FR"],
        34: ["ES"],
        36: ["HU"],
        39: ["IT", "VA"],
        40: ["RO"],
        41: ["CH"],
        43: ["AT"],
        44: ["GB", "GG", "IM", "JE"],
        45: ["DK"],
        46: ["SE"],
        47: ["NO", "SJ"],
        48: ["PL"],
        49: ["DE"],
        51: ["PE"],
        52: ["MX"],
        53: ["CU"],
        54: ["AR"],
        55: ["BR"],
        56: ["CL"],
        57: ["CO"],
        58: ["VE"],
        60: ["MY"],
        61: ["AU", "CC", "CX"],
        62: ["ID"],
        63: ["PH"],
        64: ["NZ"],
        65: ["SG"],
        66: ["TH"],
        81: ["JP"],
        82: ["KR"],
        84: ["VN"],
        86: ["CN"],
        90: ["TR"],
        91: ["IN"],
        92: ["PK"],
        93: ["AF"],
        94: ["LK"],
        95: ["MM"],
        98: ["IR"],
        211: ["SS"],
        212: ["MA", "EH"],
        213: ["DZ"],
        216: ["TN"],
        218: ["LY"],
        220: ["GM"],
        221: ["SN"],
        222: ["MR"],
        223: ["ML"],
        224: ["GN"],
        225: ["CI"],
        226: ["BF"],
        227: ["NE"],
        228: ["TG"],
        229: ["BJ"],
        230: ["MU"],
        231: ["LR"],
        232: ["SL"],
        233: ["GH"],
        234: ["NG"],
        235: ["TD"],
        236: ["CF"],
        237: ["CM"],
        238: ["CV"],
        239: ["ST"],
        240: ["GQ"],
        241: ["GA"],
        242: ["CG"],
        243: ["CD"],
        244: ["AO"],
        245: ["GW"],
        246: ["IO"],
        247: ["AC"],
        248: ["SC"],
        249: ["SD"],
        250: ["RW"],
        251: ["ET"],
        252: ["SO"],
        253: ["DJ"],
        254: ["KE"],
        255: ["TZ"],
        256: ["UG"],
        257: ["BI"],
        258: ["MZ"],
        260: ["ZM"],
        261: ["MG"],
        262: ["RE", "YT"],
        263: ["ZW"],
        264: ["NA"],
        265: ["MW"],
        266: ["LS"],
        267: ["BW"],
        268: ["SZ"],
        269: ["KM"],
        290: ["SH", "TA"],
        291: ["ER"],
        297: ["AW"],
        298: ["FO"],
        299: ["GL"],
        350: ["GI"],
        351: ["PT"],
        352: ["LU"],
        353: ["IE"],
        354: ["IS"],
        355: ["AL"],
        356: ["MT"],
        357: ["CY"],
        358: ["FI", "AX"],
        359: ["BG"],
        370: ["LT"],
        371: ["LV"],
        372: ["EE"],
        373: ["MD"],
        374: ["AM"],
        375: ["BY"],
        376: ["AD"],
        377: ["MC"],
        378: ["SM"],
        380: ["UA"],
        381: ["RS"],
        382: ["ME"],
        383: ["XK"],
        385: ["HR"],
        386: ["SI"],
        387: ["BA"],
        389: ["MK"],
        420: ["CZ"],
        421: ["SK"],
        423: ["LI"],
        500: ["FK"],
        501: ["BZ"],
        502: ["GT"],
        503: ["SV"],
        504: ["HN"],
        505: ["NI"],
        506: ["CR"],
        507: ["PA"],
        508: ["PM"],
        509: ["HT"],
        590: ["GP", "BL", "MF"],
        591: ["BO"],
        592: ["GY"],
        593: ["EC"],
        594: ["GF"],
        595: ["PY"],
        596: ["MQ"],
        597: ["SR"],
        598: ["UY"],
        599: ["CW", "BQ"],
        670: ["TL"],
        672: ["NF"],
        673: ["BN"],
        674: ["NR"],
        675: ["PG"],
        676: ["TO"],
        677: ["SB"],
        678: ["VU"],
        679: ["FJ"],
        680: ["PW"],
        681: ["WF"],
        682: ["CK"],
        683: ["NU"],
        685: ["WS"],
        686: ["KI"],
        687: ["NC"],
        688: ["TV"],
        689: ["PF"],
        690: ["TK"],
        691: ["FM"],
        692: ["MH"],
        800: ["001"],
        808: ["001"],
        850: ["KP"],
        852: ["HK"],
        853: ["MO"],
        855: ["KH"],
        856: ["LA"],
        870: ["001"],
        878: ["001"],
        880: ["BD"],
        881: ["001"],
        882: ["001"],
        883: ["001"],
        886: ["TW"],
        888: ["001"],
        960: ["MV"],
        961: ["LB"],
        962: ["JO"],
        963: ["SY"],
        964: ["IQ"],
        965: ["KW"],
        966: ["SA"],
        967: ["YE"],
        968: ["OM"],
        970: ["PS"],
        971: ["AE"],
        972: ["IL"],
        973: ["BH"],
        974: ["QA"],
        975: ["BT"],
        976: ["MN"],
        977: ["NP"],
        979: ["001"],
        992: ["TJ"],
        993: ["TM"],
        994: ["AZ"],
        995: ["GE"],
        996: ["KG"],
        998: ["UZ"]
      }, we = {
        AC: [, [
          ,
          ,
          "(?:[01589]\\d|[46])\\d{4}",
          ,
          ,
          ,
          ,
          ,
          ,
          [5, 6]
        ], [, , "6[2-467]\\d{3}", , , , "62889", , , [5]], [, , "4\\d{4}", , , , "40123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AC", 247, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:0[1-9]|[1589]\\d)\\d{4}", , , , "542011", , , [6]], , , [, , , , , , , , , [-1]]],
        AD: [
          ,
          [, , "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", , , , , , , [6, 8, 9]],
          [, , "[78]\\d{5}", , , , "712345", , , [6]],
          [, , "690\\d{6}|[356]\\d{5}", , , , "312345", , , [6, 9]],
          [, , "180[02]\\d{4}", , , , "18001234", , , [8]],
          [, , "[19]\\d{5}", , , , "912345", , , [6]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "AD",
          376,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , "1800\\d{4}", , , , , , , [8]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        AE: [
          ,
          [, , "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]],
          [, , "[2-4679][2-8]\\d{6}", , , , "22345678", , , [8], [7]],
          [, , "5[024-68]\\d{7}", , , , "501234567", , , [9]],
          [, , "400\\d{6}|800\\d{2,9}", , , , "800123456"],
          [, , "900[02]\\d{5}", , , , "900234567", , , [9]],
          [, , "700[05]\\d{5}", , , , "700012345", , , [9]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "AE",
          971,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], [, "(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , "600[25]\\d{5}", , , , "600212345", , , [9]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        AF: [, [, , "[2-7]\\d{8}", , , , , , , [9], [7]], [
          ,
          ,
          "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",
          ,
          ,
          ,
          "234567890",
          ,
          ,
          ,
          [7]
        ], [, , "7\\d{8}", , , , "701234567", , , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AF", 93, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        AG: [
          ,
          [, , "(?:268|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
          [
            ,
            ,
            "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}",
            ,
            ,
            ,
            "2684601234",
            ,
            ,
            ,
            [7]
          ],
          [, , "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}", , , , "2684641234", , , , [7]],
          [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
          [, , "900[2-9]\\d{6}", , , , "9002123456"],
          [, , , , , , , , , [-1]],
          [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
          [, , "26848[01]\\d{4}", , , , "2684801234", , , , [7]],
          "AG",
          1,
          "011",
          "1",
          ,
          ,
          "([457]\\d{6})$|1",
          "268$1",
          ,
          ,
          ,
          ,
          [, , "26840[69]\\d{4}", , , , "2684061234", , , , [7]],
          ,
          "268",
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        AI: [, [, , "(?:264|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "264(?:292|4(?:6[12]|9[78]))\\d{4}", , , , "2644612345", , , , [7]], [, , "264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}", , , , "2642351234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ], [, , , , , , , , , [-1]], "AI", 1, "011", "1", , , "([2457]\\d{6})$|1", "264$1", , , , , [, , "264724\\d{4}", , , , "2647241234", , , , [7]], , "264", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        AL: [, [, , "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", , , , , , , [6, 7, 8, 9], [5]], [, , "4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", , , , "22345678", , , [8], [5, 6, 7]], [, , "6(?:[78][2-9]|9\\d)\\d{6}", , , , "672123456", , , [9]], [, , "800\\d{4}", , , , "8001234", , , [7]], [
          ,
          ,
          "900[1-9]\\d\\d",
          ,
          ,
          ,
          "900123",
          ,
          ,
          [6]
        ], [, , "808[1-9]\\d\\d", , , , "808123", , , [6]], [, , "700[2-9]\\d{4}", , , , "70021234", , , [8]], [, , , , , , , , , [-1]], "AL", 355, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        AM: [, [
          ,
          ,
          "(?:[1-489]\\d|55|60|77)\\d{6}",
          ,
          ,
          ,
          ,
          ,
          ,
          [8],
          [5, 6]
        ], [, , "(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}", , , , "10123456", , , , [5, 6]], [, , "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}", , , , "77123456"], [, , "800\\d{5}", , , , "80012345"], [, , "90[016]\\d{5}", , , , "90012345"], [, , "80[1-4]\\d{5}", , , , "80112345"], [, , , , , , , , , [-1]], [, , "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}", , , , "60271234"], "AM", 374, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], [
          ,
          "(\\d{3})(\\d{5})",
          "$1 $2",
          ["2|3[12]"],
          "(0$1)"
        ], [, "(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        AO: [
          ,
          [, , "[29]\\d{8}", , , , , , , [9]],
          [, , "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}", , , , "222123456"],
          [, , "9[1-79]\\d{7}", , , , "923123456"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "AO",
          244,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        AR: [
          ,
          [, , "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", , , , , , , [10, 11], [6, 7, 8]],
          [
            ,
            ,
            "3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:657|9(?:54|66))|3(?:7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|3(?:02|23)|920)|3(?:4(?:46|8[27]|92)|541|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|5[3-6]|8[3-68])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|35|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
            ,
            ,
            ,
            "1123456789",
            ,
            ,
            [10],
            [6, 7, 8]
          ],
          [
            ,
            ,
            "93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|3(?:02|23)|920)|3(?:4(?:46|8[27]|92)|541|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|5[3-6]|8[3-68]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|35|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
            ,
            ,
            ,
            "91123456789",
            ,
            ,
            ,
            [6, 7, 8]
          ],
          [, , "800\\d{7,8}", , , , "8001234567"],
          [, , "60[04579]\\d{7}", , , , "6001234567", , , [10]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "AR",
          54,
          "00",
          "0",
          ,
          ,
          "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
          "9$1",
          ,
          ,
          [[, "(\\d{3})", "$1", ["0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"]], [, "(\\d{2})(\\d{4})", "$1-$2", ["[1-9]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[2-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[1-8]"]], [
            ,
            "(\\d{4})(\\d{2})(\\d{4})",
            "$1 $2-$3",
            [
              "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
              "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
              "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
              "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
            ],
            "0$1",
            ,
            1
          ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1], [
            ,
            "(\\d)(\\d{4})(\\d{2})(\\d{4})",
            "$2 15-$3-$4",
            [
              "9(?:2[2-469]|3[3-578])",
              "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
              "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
              "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
              "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
            ],
            "0$1"
          ], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1"]],
          [
            [
              ,
              "(\\d{4})(\\d{2})(\\d{4})",
              "$1 $2-$3",
              [
                "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
              ],
              "0$1",
              ,
              1
            ],
            [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1],
            [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"],
            [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1],
            [, "(\\d)(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3-$4", [
              "9(?:2[2-469]|3[3-578])",
              "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
              "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
              "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
              "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
            ]],
            [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3-$4", ["91"]],
            [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"],
            [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3-$4", ["9"]]
          ],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , "810\\d{7}", , , , , , , [10]],
          [, , "810\\d{7}", , , , "8101234567", , , [10]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        AS: [, [, , "(?:[58]\\d\\d|684|900)\\d{7}", , , , , , , [10], [7]], [, , "6846(?:22|33|44|55|77|88|9[19])\\d{4}", , , , "6846221234", , , , [7]], [, , "684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}", , , , "6847331234", , , , [7]], [
          ,
          ,
          "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "8002123456"
        ], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "AS", 1, "011", "1", , , "([267]\\d{6})$|1", "684$1", , , , , [, , , , , , , , , [-1]], , "684", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        AT: [, [
          ,
          ,
          "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
          ,
          ,
          ,
          ,
          ,
          ,
          [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
          [3]
        ], [, , "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}", , , , "1234567890", , , , [3]], [, , "6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}", , , , "664123456", , , [7, 8, 9, 10, 11, 12, 13]], [
          ,
          ,
          "800\\d{6,10}",
          ,
          ,
          ,
          "800123456",
          ,
          ,
          [9, 10, 11, 12, 13]
        ], [, , "(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", , , , "900123456", , , [9, 10, 11, 12, 13]], [, , "8(?:10|2[018])\\d{6,10}|828\\d{5}", , , , "810123456", , , [8, 9, 10, 11, 12, 13]], [, , , , , , , , , [-1]], [, , "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", , , , "780123456", , , [5, 6, 7, 8, 9, 10, 11, 12, 13]], "AT", 43, "00", "0", , , "0", , , , [
          [, "(\\d{4})", "$1", ["14"]],
          [, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"],
          [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"],
          [, "(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"],
          [, "(\\d{6})", "$1", ["[18]"]],
          [, "(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"],
          [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"],
          [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"],
          [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]
        ], [[, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], [, "(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], [
          ,
          "(\\d{3})(\\d{3,10})",
          "$1 $2",
          ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],
          "0$1"
        ], [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        AU: [
          ,
          [, , "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", , , , , , , [5, 6, 7, 8, 9, 10, 12]],
          [
            ,
            ,
            "(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
            ,
            ,
            ,
            "212345678",
            ,
            ,
            [9],
            [8]
          ],
          [, , "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", , , , "412345678", , , [9]],
          [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]],
          [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]],
          [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]],
          [, , , , , , , , , [-1]],
          [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]],
          "AU",
          61,
          "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
          "0",
          ,
          ,
          "(183[12])|0",
          ,
          "0011",
          ,
          [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["13"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["19"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["180", "1802"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["19"]], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]], [
            ,
            "(\\d{4})(\\d{4})(\\d{4})",
            "$1 $2 $3",
            ["130"]
          ]],
          [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]],
          [, , "163\\d{2,6}", , , , "1631234", , , [5, 6, 7, 8, 9]],
          1,
          ,
          [, , "1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}", , , , , , , [6, 7, 8, 10, 12]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        AW: [, [
          ,
          ,
          "(?:[25-79]\\d\\d|800)\\d{4}",
          ,
          ,
          ,
          ,
          ,
          ,
          [7]
        ], [, , "5(?:2\\d|8[1-9])\\d{4}", , , , "5212345"], [, , "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}", , , , "5601234"], [, , "800\\d{4}", , , , "8001234"], [, , "900\\d{4}", , , , "9001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:28\\d|501)\\d{4}", , , , "5011234"], "AW", 297, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        AX: [, [
          ,
          ,
          "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
          ,
          ,
          ,
          ,
          ,
          ,
          [5, 6, 7, 8, 9, 10, 11, 12]
        ], [, , "18[1-8]\\d{3,6}", , , , "181234567", , , [6, 7, 8, 9]], [, , "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]], [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AX", 358, "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "0", , , "0", , "00", , , , [, , , , , , , , , [-1]], , "18", [, , , , , , , , , [-1]], [
          ,
          ,
          "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
          ,
          ,
          ,
          "10112345"
        ], , , [, , , , , , , , , [-1]]],
        AZ: [, [, , "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", , , , , , , [9], [7]], [, , "(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}", , , , "123123456", , , , [7]], [, , "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}", , , , "401234567"], [, , "88\\d{7}", , , , "881234567"], [, , "900200\\d{3}", , , , "900200123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AZ", 994, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[1-9]"]], [
          ,
          "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["90"],
          "0$1"
        ], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], [
          ,
          "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["[13-9]"],
          "0$1"
        ]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BA: [
          ,
          [, , "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", , , , , , , [8, 9], [6]],
          [, , "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", , , , "30212345", , , [8], [6]],
          [, , "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}", , , , "61123456"],
          [, , "8[08]\\d{6}", , , , "80123456", , , [8]],
          [, , "9[0246]\\d{6}", , , , "90123456", , , [8]],
          [, , "8[12]\\d{6}", , , , "82123456", , , [8]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "BA",
          387,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{3})", "$1-$2", ["[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
          [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , "703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", , , , "70341234", , , [8]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        BB: [, [, , "(?:246|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}", , , , "2464123456", , , , [7]], [, , "246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}", , , , "2462501234", , , , [7]], [
          ,
          ,
          "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "8002123456"
        ], [, , "(?:246976|900[2-9]\\d\\d)\\d{4}", , , , "9002123456", , , , [7]], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "24631\\d{5}", , , , "2463101234", , , , [7]], "BB", 1, "011", "1", , , "([2-9]\\d{6})$|1", "246$1", , , , , [, , , , , , , , , [-1]], , "246", [, , , , , , , , , [-1]], [
          ,
          ,
          "246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}",
          ,
          ,
          ,
          "2464301234",
          ,
          ,
          ,
          [7]
        ], , , [, , , , , , , , , [-1]]],
        BD: [, [, , "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", , , , , , , [6, 7, 8, 9, 10]], [
          ,
          ,
          "(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
          ,
          ,
          ,
          "27111234"
        ], [, , "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", , , , "1812345678", , , [10]], [, , "80[03]\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}", , , , "9604123456", , , [10]], "BD", 880, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], [
          ,
          "(\\d{3})(\\d{3,7})",
          "$1-$2",
          ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],
          "0$1"
        ], [, "(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], [, "(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BE: [, [, , "4\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9]], [, , "80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", , , , "12345678", , , [8]], [, , "4[5-9]\\d{7}", , , , "470123456", , , [9]], [, , "800[1-9]\\d{4}", , , , "80012345", , , [8]], [, , "(?:70(?:2[0-57]|3[04-7]|44|6[4-69]|7[0579])|90\\d\\d)\\d{4}", , , , "90012345", , , [8]], [
          ,
          ,
          "7879\\d{4}",
          ,
          ,
          ,
          "78791234",
          ,
          ,
          [8]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BE", 32, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}", , , , "78102345", , , [8]], , , [, , , , , , , , , [-1]]],
        BF: [, [
          ,
          ,
          "[025-7]\\d{7}",
          ,
          ,
          ,
          ,
          ,
          ,
          [8]
        ], [, , "2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}", , , , "20491234"], [, , "(?:0[1-7]|5[0-8]|[67]\\d)\\d{6}", , , , "70123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BF", 226, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BG: [
          ,
          [, , "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", , , , , , , [6, 7, 8, 9, 12], [4, 5]],
          [, , "2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", , , , "2123456", , , [6, 7, 8], [4, 5]],
          [, , "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", , , , "43012345", , , [8, 9]],
          [, , "(?:00800\\d\\d|800)\\d{5}", , , , "80012345", , , [8, 12]],
          [, , "90\\d{6}", , , , "90123456", , , [8]],
          [, , "700\\d{5}", , , , "70012345", , , [8]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "BG",
          359,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{6})", "$1", ["1"]], [, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [
            ,
            "(\\d{3})(\\d{4})",
            "$1 $2",
            ["43[1-6]|70[1-9]"],
            "0$1"
          ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]],
          [[, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [
            ,
            "(\\d{3})(\\d{4})",
            "$1 $2",
            ["43[1-6]|70[1-9]"],
            "0$1"
          ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        BH: [, [, , "[136-9]\\d{7}", , , , , , , [8]], [
          ,
          ,
          "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}",
          ,
          ,
          ,
          "17001234"
        ], [, , "(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}", , , , "36001234"], [, , "8[02369]\\d{6}", , , , "80123456"], [, , "(?:87|9[0-8])\\d{6}", , , , "90123456"], [, , "84\\d{6}", , , , "84123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BH", 973, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BI: [, [, , "(?:[267]\\d|31)\\d{6}", , , , , , , [8]], [, , "(?:22|31)\\d{6}", , , , "22201234"], [
          ,
          ,
          "(?:29|[67][125-9])\\d{6}",
          ,
          ,
          ,
          "79561234"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BI", 257, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BJ: [
          ,
          [, , "[24-689]\\d{7}", , , , , , , [8]],
          [, , "2090\\d{4}|2(?:02|1[037]|2[45]|3[68]|4\\d)\\d{5}", , , , "20211234"],
          [, , "(?:4[0-8]|[56]\\d|9[013-9])\\d{6}", , , , "90011234"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "857[58]\\d{4}", , , , "85751234"],
          "BJ",
          229,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , "81\\d{6}", , , , "81123456"],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        BL: [, [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]], [, , "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}", , , , "590271234"], [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}", , , , "690001234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}",
          ,
          ,
          ,
          "976012345"
        ], "BL", 590, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BM: [, [, , "(?:441|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}", , , , "4414123456", , , , [7]], [, , "441(?:[2378]\\d|5[0-39]|9[02])\\d{5}", , , , "4413701234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ], [, , , , , , , , , [-1]], "BM", 1, "011", "1", , , "([2-9]\\d{6})$|1", "441$1", , , , , [, , , , , , , , , [-1]], , "441", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BN: [
          ,
          [, , "[2-578]\\d{6}", , , , , , , [7]],
          [, , "22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}", , , , "2345678"],
          [, , "(?:22[89]|[78]\\d\\d)\\d{4}", , , , "7123456"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "5[34]\\d{5}", , , , "5345678"],
          "BN",
          673,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        BO: [, [, , "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", , , , , , , [8, 9], [7]], [, , "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", , , , "22123456", , , [8], [7]], [, , "[67]\\d{7}", , , , "71234567", , , [8]], [, , "8001[07]\\d{4}", , , , "800171234", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          "50\\d{6}",
          ,
          ,
          ,
          "50123456",
          ,
          ,
          [8],
          [7]
        ], "BO", 591, "00(?:1\\d)?", "0", , , "0(1\\d)?", , , , [[, "(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"], , "0$CC $1"], [, "(\\d{8})", "$1", ["[67]"], , "0$CC $1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"], , "0$CC $1"]], , [, , , , , , , , , [-1]], , , [, , "8001[07]\\d{4}", , , , , , , [9]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BQ: [, [, , "(?:[34]1|7\\d)\\d{5}", , , , , , , [7]], [, , "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}", , , , "7151234"], [, , "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}", , , , "3181234"], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BQ", 599, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "[347]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BR: [, [, , "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", , , , , , , [8, 9, 10, 11]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", , , , "1123456789", , , [10], [8]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", , , , "11961234567", , , [10, 11], [8, 9]], [
          ,
          ,
          "800\\d{6,7}",
          ,
          ,
          ,
          "800123456",
          ,
          ,
          [9, 10]
        ], [, , "300\\d{6}|[59]00\\d{6,7}", , , , "300123456", , , [9, 10]], [, , "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}", , , , "40041234", , , [8, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BR", 55, "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "0", , , "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", , , [
          [, "(\\d{3,6})", "$1", ["1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"]],
          [, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]],
          [, "(\\d{4})(\\d{4})", "$1-$2", ["[2-57]", "[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"]],
          [, "(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"],
          [, "(\\d{5})(\\d{4})", "$1-$2", ["9"]],
          [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"],
          [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]
        ], [[, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], [
          ,
          "(\\d{3})(\\d{2,3})(\\d{4})",
          "$1 $2 $3",
          ["(?:[358]|90)0"],
          "0$1"
        ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [, , , , , , , , , [-1]], , , [, , "30(?:0\\d{5,7}|3\\d{7})|40(?:0\\d|20)\\d{4}|800\\d{6,7}", , , , , , , [8, 9, 10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BS: [, [, , "(?:242|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
          ,
          ,
          "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",
          ,
          ,
          ,
          "2423456789",
          ,
          ,
          ,
          [7]
        ], [, , "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}", , , , "2423591234", , , , [7]], [, , "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , , [7]], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ], [, , , , , , , , , [-1]], "BS", 1, "011", "1", , , "([3-8]\\d{6})$|1", "242$1", , , , , [, , , , , , , , , [-1]], , "242", [, , , , , , , , , [-1]], [, , "242225\\d{4}", , , , "2422250123"], , , [, , , , , , , , , [-1]]],
        BT: [, [, , "[17]\\d{7}|[2-8]\\d{6}", , , , , , , [7, 8], [6]], [, , "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", , , , "2345678", , , [7], [6]], [, , "(?:1[67]|77)\\d{6}", , , , "17123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BT", 975, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[2-7]"]], [
          ,
          "(\\d)(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["[2-68]|7[246]"]
        ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BW: [, [, , "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", , , , , , , [7, 8, 10]], [
          ,
          ,
          "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}",
          ,
          ,
          ,
          "2401234",
          ,
          ,
          [7]
        ], [, , "(?:321|7[1-8]\\d)\\d{5}", , , , "71123456", , , [8]], [, , "(?:0800|800\\d)\\d{6}", , , , "0800012345", , , [10]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "79(?:1(?:[0-2]\\d|3[0-3])|2[0-7]\\d)\\d{3}", , , , "79101234", , , [8]], "BW", 267, "00", , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["90"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], [
          ,
          "(\\d{3})(\\d{4})(\\d{3})",
          "$1 $2 $3",
          ["8"]
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BY: [, [, , "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [, , "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", , , , "152450911", , , [9], [5, 6, 7]], [
          ,
          ,
          "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
          ,
          ,
          ,
          "294911911",
          ,
          ,
          [9]
        ], [, , "800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}", , , , "8011234567"], [, , "(?:810|902)\\d{7}", , , , "9021234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "249\\d{6}", , , , "249123456", , , [9]], "BY", 375, "810", "8", , , "0|80?", , "8~10", , [[, "(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], [, "(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], [
          ,
          "(\\d{4})(\\d{2})(\\d{3})",
          "$1 $2-$3",
          ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],
          "8 0$1"
        ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , "800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BZ: [, [, , "(?:0800\\d|[2-8])\\d{6}", , , , , , , [7, 11]], [, , "(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", , , , "2221234", , , [7]], [
          ,
          ,
          "6[0-35-7]\\d{5}",
          ,
          ,
          ,
          "6221234",
          ,
          ,
          [7]
        ], [, , "0800\\d{7}", , , , "08001234123", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BZ", 501, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], [, "(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CA: [, [, , "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", , , , , , , [7, 10]], [
          ,
          ,
          "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}",
          ,
          ,
          ,
          "5062345678",
          ,
          ,
          [10],
          [7]
        ], [, , "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}", , , , "5062345678", , , [10], [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , [10]], [, , "900[2-9]\\d{6}", , , , "9002123456", , , [10]], [, , , , , , , , , [-1]], [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678",
          ,
          ,
          [10]
        ], [, , "600[2-9]\\d{6}", , , , "6002012345", , , [10]], "CA", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "310\\d{4}", , , , "3101234", , , [7]], , , [, , , , , , , , , [-1]]],
        CC: [, [, , "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10, 12]], [, , "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", , , , "891621234", , , [9], [8]], [
          ,
          ,
          "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
          ,
          ,
          ,
          "412345678",
          ,
          ,
          [9]
        ], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]], [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]], [, , , , , , , , , [-1]], [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]], "CC", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", , , "([59]\\d{7})$|0", "8$1", "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CD: [, [
          ,
          ,
          "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
          ,
          ,
          ,
          ,
          ,
          ,
          [7, 8, 9, 10]
        ], [, , "(?:(?:12|573)\\d\\d|276)\\d{5}|[1-6]\\d{6}", , , , "1234567"], [, , "88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}", , , , "991234567", , , [7, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CD", 243, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [
          ,
          "(\\d{3})(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["[89]"],
          "0$1"
        ], [, "(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CF: [, [, , "(?:[27]\\d{3}|8776)\\d{4}", , , , , , , [8]], [, , "2[12]\\d{6}", , , , "21612345"], [, , "7[024-7]\\d{6}", , , , "70012345"], [, , , , , , , , , [-1]], [, , "8776\\d{4}", , , , "87761234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CF", 236, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CG: [, [, , "222\\d{6}|(?:0\\d|80)\\d{7}", , , , , , , [9]], [, , "222[1-589]\\d{5}", , , , "222123456"], [, , "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}", , , , "061234567"], [, , , , , , , , , [-1]], [, , "80[0-2]\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CG", 242, "00", , , , , , , , [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CH: [, [
          ,
          ,
          "8\\d{11}|[2-9]\\d{8}",
          ,
          ,
          ,
          ,
          ,
          ,
          [9, 12]
        ], [, , "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", , , , "212345678", , , [9]], [, , "(?:6[89]|7[235-9])\\d{7}", , , , "781234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[016]\\d{6}", , , , "900123456", , , [9]], [, , "84[0248]\\d{6}", , , , "840123456", , , [9]], [, , "878\\d{6}", , , , "878123456", , , [9]], [, , , , , , , , , [-1]], "CH", 41, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], [
          ,
          "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4 $5",
          ["8"],
          "0$1"
        ]], , [, , "74[0248]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , "5[18]\\d{7}", , , , "581234567", , , [9]], , , [, , "860\\d{9}", , , , "860123456789", , , [12]]],
        CI: [, [, , "[02]\\d{9}", , , , , , , [10]], [, , "2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}", , , , "2123456789"], [, , "0[157]\\d{8}", , , , "0123456789"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CI", 225, "00", , , , , , , , [[
          ,
          "(\\d{2})(\\d{2})(\\d)(\\d{5})",
          "$1 $2 $3 $4",
          ["2"]
        ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CK: [, [, , "[2-578]\\d{4}", , , , , , , [5]], [, , "(?:2\\d|3[13-7]|4[1-5])\\d{3}", , , , "21234"], [, , "[578]\\d{4}", , , , "71234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CK", 682, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CL: [, [
          ,
          ,
          "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
          ,
          ,
          ,
          ,
          ,
          ,
          [9, 10, 11]
        ], [, , "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", , , , "221234567", , , [9]], [
          ,
          ,
          "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
          ,
          ,
          ,
          "221234567",
          ,
          ,
          [9]
        ], [, , "(?:123|8)00\\d{6}", , , , "800123456", , , [9, 11]], [, , , , , , , , , [-1]], [, , "600\\d{7,8}", , , , "6001234567", , , [10, 11]], [, , , , , , , , , [-1]], [, , "44\\d{7}", , , , "441234567", , , [9]], "CL", 56, "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", , , , , , , 1, [
          [, "(\\d{4})", "$1", ["1(?:[03-589]|21)|[29]0|78"]],
          [, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"],
          [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]],
          [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"],
          [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]],
          [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"],
          [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]],
          [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]],
          [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]
        ], [[, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], [
          ,
          "(\\d{2})(\\d{3})(\\d{4})",
          "$1 $2 $3",
          ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],
          "($1)"
        ], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [, , , , , , , , , [-1]], , , [, , "600\\d{7,8}", , , , , , , [10, 11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CM: [
          ,
          [, , "[26]\\d{8}|88\\d{6,7}", , , , , , , [8, 9]],
          [, , "2(?:22|33)\\d{6}", , , , "222123456", , , [9]],
          [, , "(?:24[23]|6(?:[25-9]\\d|40))\\d{6}", , , , "671234567", , , [9]],
          [, , "88\\d{6,7}", , , , "88012345"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "CM",
          237,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        CN: [, [, , "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", , , , , , , [7, 8, 9, 10, 11, 12], [5, 6]], [
          ,
          ,
          "(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
          ,
          ,
          ,
          "1012345678",
          ,
          ,
          [7, 8, 9, 10, 11],
          [5, 6]
        ], [, , "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", , , , "13123456789", , , [11]], [, , "(?:(?:10|21)8|8)00\\d{7}", , , , "8001234567", , , [10, 12]], [, , "16[08]\\d{5}", , , , "16812345", , , [8]], [
          ,
          ,
          "10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
          ,
          ,
          ,
          "4001234567",
          ,
          ,
          [7, 8, 9, 10, 11],
          [5, 6]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CN", 86, "00|1(?:[12]\\d|79)\\d\\d00", "0", , , "(1(?:[12]\\d|79)\\d\\d)|0", , "00", , [
          [, "(\\d{5,6})", "$1", ["1(?:00|2[13])|9[56]", "1(?:00|2(?:1|39))|9[56]", "1(?:00|2(?:1|395))|9[56]"]],
          [, "(\\d{5,6})", "$1", ["1(?:0|23)|781|[1-9]12", "1(?:0|23)|7812|[1-9]123", "1(?:0|23(?:[0-8]|9[0-46-9]))|78123|[1-9]123"]],
          [
            ,
            "(\\d{2})(\\d{5,6})",
            "$1 $2",
            [
              "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
              "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
              "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
              "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
              "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
            ],
            "0$1",
            "$CC $1"
          ],
          [, "(\\d{3})(\\d{4})", "$1 $2", [
            "[1-9]",
            "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])",
            "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|[3-9]",
            "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))",
            "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:0(?:[0-689]|7[0-79])|1[01459]|2[0-489]|[46]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))"
          ]],
          [, "(\\d{4})(\\d{4})", "$1 $2", ["16[08]"]],
          [
            ,
            "(\\d{3})(\\d{5,6})",
            "$1 $2",
            [
              "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
              "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
              "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
              "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
            ],
            "0$1",
            "$CC $1"
          ],
          [, "(\\d{4})(\\d{4})", "$1 $2", [
            "[1-9]",
            "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[0-8]|9[0-47-9])|6)|[3-9]",
            "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|26|3(?:[0268]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23][0-8])|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:33|85[23]9)[0-46-9]|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
            "1(?:0[02-8]|[1-9])|2(?:[0-57-9][0-8]|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:10|2[0-57-9])9[0-47-9]|(?:101|58|85[23]10)[1-9]|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"
          ]],
          [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]],
          [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", "$CC $1", 1],
          [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1],
          [
            ,
            "(\\d{3})(\\d{7,8})",
            "$1 $2",
            ["9"]
          ],
          [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1],
          [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1],
          [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"],
          [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]
        ], [[
          ,
          "(\\d{2})(\\d{5,6})",
          "$1 $2",
          [
            "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
            "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
          ],
          "0$1",
          "$CC $1"
        ], [
          ,
          "(\\d{3})(\\d{5,6})",
          "$1 $2",
          [
            "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
            "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
            "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
            "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
          ],
          "0$1",
          "$CC $1"
        ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1], [
          ,
          "(\\d{3})(\\d{7,8})",
          "$1 $2",
          ["9"]
        ], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]], [, , , , , , , , , [-1]], , , [, , "(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}", , , , , , , [10, 11, 12]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CO: [, [, , "60\\d{8}|(?:1\\d|[39])\\d{9}", , , , , , , [10, 11], [7]], [
          ,
          ,
          "601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|60(?:[124-7][2-9]|8[1-9])\\d{6}",
          ,
          ,
          ,
          "6012345678",
          ,
          ,
          [10],
          [7]
        ], [, , "333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}", , , , "3211234567", , , [10]], [, , "1800\\d{7}", , , , "18001234567", , , [11]], [, , "(?:19(?:0[01]|4[78])|901)\\d{7}", , , , "19001234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CO", 57, "00(?:4(?:[14]4|56)|[579])", "0", , , "0([3579]|4(?:[14]4|56))?", , , , [[, "(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)", "0$CC $1"], [
          ,
          "(\\d{3})(\\d{7})",
          "$1 $2",
          ["3[0-357]|91"],
          ,
          "0$CC $1"
        ], [, "(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1"]], [[, "(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)", "0$CC $1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"], , "0$CC $1"], [, "(\\d)(\\d{3})(\\d{7})", "$1 $2 $3", ["1"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CR: [, [, , "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", , , , , , , [8, 10]], [, , "210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", , , , "22123456", , , [8]], [
          ,
          ,
          "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",
          ,
          ,
          ,
          "83123456",
          ,
          ,
          [8]
        ], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "90[059]\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:210[0-6]|4\\d{3}|5100)\\d{4}", , , , "40001234", , , [8]], "CR", 506, "00", , , , "(19(?:0[0-2468]|1[09]|20|66|77|99))", , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CU: [, [
          ,
          ,
          "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
          ,
          ,
          ,
          ,
          ,
          ,
          [6, 7, 8, 10],
          [4, 5]
        ], [, , "(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}", , , , "71234567", , , , [4, 5]], [, , "(?:5\\d|6[2-4])\\d{6}", , , , "51234567", , , [8]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , "807\\d{7}", , , , "8071234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CU", 53, "119", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], [, "(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], [, "(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], [
          ,
          "(\\d{3})(\\d{7})",
          "$1 $2",
          ["8"],
          "0$1"
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CV: [, [, , "(?:[2-59]\\d\\d|800)\\d{4}", , , , , , , [7]], [, , "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}", , , , "2211234"], [, , "(?:36|5[1-389]|9\\d)\\d{5}", , , , "9911234"], [, , "800\\d{4}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:3[3-5]|4[356])\\d{5}", , , , "3401234"], "CV", 238, "0", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , [, , , , , , , , , [-1]]],
        CW: [, [, , "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", , , , , , , [7, 8]], [, , "9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}", , , , "94351234"], [, , "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}", , , , "95181234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "60[0-2]\\d{4}", , , , "6001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CW", 599, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], , [
          ,
          ,
          "955\\d{5}",
          ,
          ,
          ,
          "95581234",
          ,
          ,
          [8]
        ], 1, "[69]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CX: [, [, , "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10, 12]], [, , "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", , , , "891641234", , , [9], [8]], [
          ,
          ,
          "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
          ,
          ,
          ,
          "412345678",
          ,
          ,
          [9]
        ], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]], [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]], [, , , , , , , , , [-1]], [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]], "CX", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", , , "([59]\\d{7})$|0", "8$1", "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CY: [, [, , "(?:[279]\\d|[58]0)\\d{6}", , , , , , , [8]], [
          ,
          ,
          "2[2-6]\\d{6}",
          ,
          ,
          ,
          "22345678"
        ], [, , "9(?:10|[4-79]\\d)\\d{5}", , , , "96123456"], [, , "800\\d{5}", , , , "80001234"], [, , "90[09]\\d{5}", , , , "90012345"], [, , "80[1-9]\\d{5}", , , , "80112345"], [, , "700\\d{5}", , , , "70012345"], [, , , , , , , , , [-1]], "CY", 357, "00", , , , , , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:50|77)\\d{6}", , , , "77123456"], , , [, , , , , , , , , [-1]]],
        CZ: [
          ,
          [, , "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", , , , , , , [9, 10, 11, 12]],
          [, , "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}", , , , "212345678", , , [9]],
          [
            ,
            ,
            "(?:60[1-8]\\d|7(?:0(?:[2-5]\\d|60)|19[01]|[2379]\\d\\d))\\d{5}",
            ,
            ,
            ,
            "601123456",
            ,
            ,
            [9]
          ],
          [, , "800\\d{6}", , , , "800123456", , , [9]],
          [, , "9(?:0[05689]|76)\\d{6}", , , , "900123456", , , [9]],
          [, , "8[134]\\d{7}", , , , "811234567", , , [9]],
          [, , "70[01]\\d{6}", , , , "700123456", , , [9]],
          [, , "9[17]0\\d{6}", , , , "910123456", , , [9]],
          "CZ",
          420,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , "9(?:5\\d|7[2-4])\\d{6}", , , , "972123456", , , [9]],
          ,
          ,
          [, , "9(?:3\\d{9}|6\\d{7,10})", , , , "93123456789"]
        ],
        DE: [, [, , "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [2, 3]], [
          ,
          ,
          "32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
          ,
          ,
          ,
          "30123456",
          ,
          ,
          [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
          [2, 3, 4]
        ], [, , "15310\\d{6}|1(?:6[023]|7[0-57-9])\\d{7,8}|1(?:5[0-25-9]|76)\\d{8}", , , , "15123456789", , , [10, 11]], [, , "800\\d{7,12}", , , , "8001234567890", , , [10, 11, 12, 13, 14, 15]], [, , "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", , , , "9001234567", , , [10, 11]], [, , "180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", , , , "18012345", , , [7, 8, 9, 10, 11, 12, 13, 14]], [, , "700\\d{8}", , , , "70012345678", , , [11]], [, , , , , , , , , [-1]], "DE", 49, "00", "0", , , "0", , , , [
          [
            ,
            "(\\d{2})(\\d{3,13})",
            "$1 $2",
            ["3[02]|40|[68]9"],
            "0$1"
          ],
          [, "(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"],
          [
            ,
            "(\\d{4})(\\d{2,11})",
            "$1 $2",
            ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
            "0$1"
          ],
          [, "(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"],
          [, "(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"],
          [, "(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"],
          [, "(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"],
          [, "(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"],
          [, "(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"],
          [, "(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"],
          [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
          [, "(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"],
          [, "(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"],
          [, "(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"],
          [, "(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"],
          [, "(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"],
          [, "(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"],
          [, "(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]
        ], , [, , "16(?:4\\d{1,10}|[89]\\d{1,11})", , , , "16412345", , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]], [, , "18(?:1\\d{5,11}|[2-9]\\d{8})", , , , "18500123456", , , [8, 9, 10, 11, 12, 13, 14]], , , [
          ,
          ,
          "1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
          ,
          ,
          ,
          "177991234567",
          ,
          ,
          [12, 13]
        ]],
        DJ: [, [, , "(?:2\\d|77)\\d{6}", , , , , , , [8]], [, , "2(?:1[2-5]|7[45])\\d{5}", , , , "21360003"], [, , "77\\d{6}", , , , "77831001"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DJ", 253, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        DK: [, [, , "[2-9]\\d{7}", , , , , , , [8]], [
          ,
          ,
          "(?:(?:2\\d|9[1-46-9])\\d|3(?:[0-37]\\d|4[013]|5[0-58]|6[01347-9]|8[0-8]|9[0-79])|4(?:[0-25]\\d|[34][02-9]|6[013-579]|7[013579]|8[0-47]|9[0-27])|5(?:[0-36]\\d|4[0146-9]|5[03-57-9]|7[0568]|8[0-358]|9[0-69])|6(?:[013578]\\d|2[0-68]|4[02-8]|6[01689]|9[015689])|7(?:[0-69]\\d|7[03-9]|8[0147])|8(?:[16-9]\\d|2[0-58]))\\d{5}",
          ,
          ,
          ,
          "32123456"
        ], [, , "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}", , , , "34412345"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DK", 45, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        DM: [, [, , "(?:[58]\\d\\d|767|900)\\d{7}", , , , , , , [10], [7]], [, , "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}", , , , "7674201234", , , , [7]], [
          ,
          ,
          "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}",
          ,
          ,
          ,
          "7672251234",
          ,
          ,
          ,
          [7]
        ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "DM", 1, "011", "1", , , "([2-7]\\d{6})$|1", "767$1", , , , , [, , , , , , , , , [-1]], , "767", [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , [, , , , , , , , , [-1]]],
        DO: [
          ,
          [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
          [, , "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}", , , , "8092345678", , , , [7]],
          [
            ,
            ,
            "8[024]9[2-9]\\d{6}",
            ,
            ,
            ,
            "8092345678",
            ,
            ,
            ,
            [7]
          ],
          [, , "8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}", , , , "8002123456"],
          [, , "900[2-9]\\d{6}", , , , "9002123456"],
          [, , , , , , , , , [-1]],
          [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
          [, , , , , , , , , [-1]],
          "DO",
          1,
          "011",
          "1",
          ,
          ,
          "1",
          ,
          ,
          ,
          ,
          ,
          [, , , , , , , , , [-1]],
          ,
          "8001|8[024]9",
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        DZ: [, [, , "(?:[1-4]|[5-79]\\d|80)\\d{7}", , , , , , , [8, 9]], [, , "9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}", , , , "12345678"], [, , "(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", , , , "551234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "80[3-689]1\\d{5}", , , , "808123456", , , [9]], [, , "80[12]1\\d{5}", , , , "801123456", , , [9]], [, , , , , , , , , [-1]], [, , "98[23]\\d{6}", , , , "983123456", , , [9]], "DZ", 213, "00", "0", , , "0", , , , [[
          ,
          "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["[1-4]"],
          "0$1"
        ], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        EC: [, [, , "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", , , , , , , [8, 9, 10, 11], [7]], [, , "[2-7][2-7]\\d{6}", , , , "22123456", , , [8], [7]], [, , "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", , , , "991234567", , , [9]], [, , "1800\\d{7}|1[78]00\\d{6}", , , , "18001234567", , , [10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , "[2-7]890\\d{4}", , , , "28901234", , , [8]], "EC", 593, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-7]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-7]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        EE: [
          ,
          [, , "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", , , , , , , [7, 8, 10]],
          [, , "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", , , , "3212345", , , [7]],
          [, , "(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", , , , "51234567", , , [7, 8]],
          [
            ,
            ,
            "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}",
            ,
            ,
            ,
            "80012345"
          ],
          [, , "(?:40\\d\\d|900)\\d{4}", , , , "9001234", , , [7, 8]],
          [, , , , , , , , , [-1]],
          [, , "70[0-2]\\d{5}", , , , "70012345", , , [8]],
          [, , , , , , , , , [-1]],
          "EE",
          372,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]],
          ,
          [
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [-1]
          ],
          ,
          ,
          [, , "800[2-9]\\d{3}", , , , , , , [7]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        EG: [, [, , "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", , , , , , , [8, 9, 10], [6, 7]], [, , "13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", , , , "234567890", , , [8, 9], [6, 7]], [, , "1[0-25]\\d{8}", , , , "1001234567", , , [10]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "EG", 20, "00", "0", , , "0", , , , [[
          ,
          "(\\d)(\\d{7,8})",
          "$1 $2",
          ["[23]"],
          "0$1"
        ], [, "(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        EH: [, [, , "[5-8]\\d{8}", , , , , , , [9]], [, , "528[89]\\d{5}", , , , "528812345"], [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}", , , , "650123456"], [, , "80[0-7]\\d{6}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}", , , , "592401234"], "EH", 212, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , "528[89]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        ER: [, [, , "[178]\\d{6}", , , , , , , [7], [6]], [, , "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}", , , , "8370362", , , , [6]], [, , "(?:17[1-3]|7\\d\\d)\\d{4}", , , , "7123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ER", 291, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        ES: [
          ,
          [, , "[5-9]\\d{8}", , , , , , , [9]],
          [, , "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}", , , , "810123456"],
          [, , "(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}", , , , "612345678"],
          [, , "[89]00\\d{6}", , , , "800123456"],
          [, , "80[367]\\d{6}", , , , "803123456"],
          [, , "90[12]\\d{6}", , , , "901123456"],
          [, , "70\\d{7}", , , , "701234567"],
          [, , , , , , , , , [-1]],
          "ES",
          34,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{4})", "$1", ["905"]], [, "(\\d{6})", "$1", ["[79]9"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]],
          [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , "51\\d{7}", , , , "511234567"],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        ET: [, [, , "(?:11|[2-579]\\d)\\d{7}", , , , , , , [9], [7]], [
          ,
          ,
          "11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8]|7\\d)|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
          ,
          ,
          ,
          "111112345",
          ,
          ,
          ,
          [7]
        ], [, , "700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}", , , , "911234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ET", 251, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        FI: [, [, , "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]], [
          ,
          ,
          "1[35-7][1-8]\\d{3,6}|(?:1[49][1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}",
          ,
          ,
          ,
          "131234567",
          ,
          ,
          [5, 6, 7, 8, 9]
        ], [, , "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]], [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FI", 358, "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "0", , , "0", , "00", , [[, "(\\d{5})", "$1", ["75[12]"], "0$1"], [, "(\\d{5})", "$1", ["20[2-59]"], "0$1"], [, "(\\d{6})", "$1", ["11"]], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], [
          ,
          "(\\d{2})(\\d{4,8})",
          "$1 $2",
          ["[14]|2[09]|50|7[135]"],
          "0$1"
        ], [, "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], [, "(\\d)(\\d{4,9})", "$1 $2", ["(?:1[49]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], [[, "(\\d{5})", "$1", ["20[2-59]"], "0$1"], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], [, "(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], [, "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], [, "(\\d)(\\d{4,9})", "$1 $2", ["(?:1[49]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], [, , , , , , , , , [-1]], 1, "1[03-79]|[2-9]", [
          ,
          ,
          "20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"
        ], [, , "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}", , , , "10112345"], , , [, , , , , , , , , [-1]]],
        FJ: [, [, , "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", , , , , , , [7, 11]], [, , "603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", , , , "3212345", , , [7]], [
          ,
          ,
          "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",
          ,
          ,
          ,
          "7012345",
          ,
          ,
          [7]
        ], [, , "0800\\d{7}", , , , "08001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FJ", 679, "0(?:0|52)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        FK: [
          ,
          [, , "[2-7]\\d{4}", , , , , , , [5]],
          [, , "[2-47]\\d{4}", , , , "31234"],
          [, , "[56]\\d{4}", , , , "51234"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "FK",
          500,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        FM: [, [, , "(?:[39]\\d\\d|820)\\d{4}", , , , , , , [7]], [, , "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}", , , , "3201234"], [, , "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}", , , , "3501234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FM", 691, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], , [, , , , , , , , , [-1]], , , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        FO: [, [, , "[2-9]\\d{5}", , , , , , , [6]], [, , "(?:20|[34]\\d|8[19])\\d{4}", , , , "201234"], [, , "(?:[27][1-9]|5\\d|9[16])\\d{4}", , , , "211234"], [, , "80[257-9]\\d{3}", , , , "802123"], [, , "90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d", , , , "901123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:6[0-36]|88)\\d{4}", , , , "601234"], "FO", 298, "00", , , , "(10(?:01|[12]0|88))", , , , [[, "(\\d{6})", "$1", ["[2-9]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        FR: [, [
          ,
          ,
          "[1-9]\\d{8}",
          ,
          ,
          ,
          ,
          ,
          ,
          [9]
        ], [, , "(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}", , , , "123456789"], [, , "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}", , , , "612345678"], [, , "80[0-5]\\d{6}", , , , "801234567"], [, , "836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}", , , , "891123456"], [, , "8(?:1[01]|2[0156]|4[024]|84)\\d{6}", , , , "884012345"], [, , , , , , , , , [-1]], [, , "9\\d{8}", , , , "912345678"], "FR", 33, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["10"]], [
          ,
          "(\\d{3})(\\d{3})",
          "$1 $2",
          ["1"]
        ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "80[6-9]\\d{6}", , , , "806123456"], , , [, , , , , , , , , [-1]]],
        GA: [, [, , "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", , , , , , , [7, 8]], [, , "[01]1\\d{6}", , , , "01441234", , , [8]], [
          ,
          ,
          "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}",
          ,
          ,
          ,
          "06031234"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GA", 241, "00", , , , "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", , , [[, "(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        GB: [, [
          ,
          ,
          "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
          ,
          ,
          ,
          ,
          ,
          ,
          [7, 9, 10],
          [4, 5, 6, 8]
        ], [
          ,
          ,
          "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
          ,
          ,
          ,
          "1212345678",
          ,
          ,
          [9, 10],
          [4, 5, 6, 7, 8]
        ], [, , "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", , , , "7400123456", , , [10]], [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"], [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [
          ,
          ,
          "56\\d{8}",
          ,
          ,
          ,
          "5612345678",
          ,
          ,
          [10]
        ], "GB", 44, "00", "0", " x", , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", [
          "[25]|7(?:0|6[02-9])",
          "[25]|7(?:0|6(?:[03-9]|2[356]))"
        ], "0$1"], [, "(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], , [, , "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456", , , [10]], 1, , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]],
        GD: [, [, , "(?:473|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
          ,
          ,
          "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[579]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
          ,
          ,
          ,
          "4732691234",
          ,
          ,
          ,
          [7]
        ], [, , "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[68])|5(?:2[01]|3[3-8])|901)\\d{4}", , , , "4734031234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], "GD", 1, "011", "1", , , "([2-9]\\d{6})$|1", "473$1", , , , , [, , , , , , , , , [-1]], , "473", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        GE: [, [, , "(?:[3-57]\\d\\d|800)\\d{6}", , , , , , , [9], [6, 7]], [, , "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}", , , , "322123456", , , , [6, 7]], [
          ,
          ,
          "5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|111|22[02]|77\\d)|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-4])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}",
          ,
          ,
          ,
          "555123456"
        ], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70[67]\\d{6}", , , , "706123456"], "GE", 995, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "70[67]\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        GF: [, [
          ,
          ,
          "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
          ,
          ,
          ,
          ,
          ,
          ,
          [9]
        ], [, , "594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}", , , , "594101234"], [, , "694(?:[0-249]\\d|3[0-8])\\d{4}", , , , "694201234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:396|76\\d)\\d|476[0-5])\\d{4}", , , , "976012345"], "GF", 594, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        GG: [, [, , "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", , , , , , , [7, 9, 10], [6]], [, , "1481[25-9]\\d{5}", , , , "1481256789", , , [10], [6]], [, , "7(?:(?:781|839)\\d|911[17])\\d{5}", , , , "7781123456", , , [10]], [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"], [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , "56\\d{8}", , , , "5612345678", , , [10]], "GG", 44, "00", "0", , , "([25-9]\\d{5})$|0", "1481$1", , , , , [
          ,
          ,
          "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
          ,
          ,
          ,
          "7640123456",
          ,
          ,
          [10]
        ], , , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]],
        GH: [, [, , "(?:[235]\\d{3}|800)\\d{5}", , , , , , , [8, 9], [7]], [, , "3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", , , , "302345678", , , [9], [7]], [, , "(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", , , , "231234567", , , [9]], [
          ,
          ,
          "800\\d{5}",
          ,
          ,
          ,
          "80012345",
          ,
          ,
          [8]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GH", 233, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[237]|8[0-2]"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [[, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "800\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        GI: [, [, , "(?:[25]\\d|60)\\d{6}", , , , , , , [8]], [
          ,
          ,
          "2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}",
          ,
          ,
          ,
          "20012345"
        ], [, , "5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}", , , , "57123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GI", 350, "00", , , , , , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["2"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        GL: [
          ,
          [, , "(?:19|[2-689]\\d|70)\\d{4}", , , , , , , [6]],
          [, , "(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}", , , , "321000"],
          [, , "[245]\\d{5}", , , , "221234"],
          [, , "80\\d{4}", , , , "801234"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "3[89]\\d{4}", , , , "381234"],
          "GL",
          299,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        GM: [
          ,
          [, , "[2-9]\\d{6}", , , , , , , [7]],
          [, , "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}", , , , "5661234"],
          [, , "(?:[23679]\\d|4[015]|5[0-489])\\d{5}", , , , "3012345"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "GM",
          220,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        GN: [, [, , "722\\d{6}|(?:3|6\\d)\\d{7}", , , , , , , [8, 9]], [, , "3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", , , , "30241234", , , [8]], [, , "6[0-356]\\d{7}", , , , "601123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "722\\d{6}", , , , "722123456", , , [9]], "GN", 224, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], [
          ,
          "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["[67]"]
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        GP: [
          ,
          [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]],
          [, , "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}", , , , "590201234"],
          [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}", , , , "690001234"],
          [, , "80[0-5]\\d{6}", , , , "800012345"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}", , , , "976012345"],
          "GP",
          590,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],
          ,
          [, , , , , , , , , [-1]],
          1,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        GQ: [, [, , "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", , , , , , , [9]], [, , "33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}", , , , "333091234"], [, , "(?:222|55\\d)\\d{6}", , , , "222123456"], [, , "80\\d[1-9]\\d{5}", , , , "800123456"], [, , "90\\d[1-9]\\d{5}", , , , "900123456"], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , , , , , , , , [-1]], "GQ", 240, "00", , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        GR: [, [, , "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", , , , , , , [10, 11, 12]], [
          ,
          ,
          "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
          ,
          ,
          ,
          "2123456789",
          ,
          ,
          [10]
        ], [, , "68[57-9]\\d{7}|(?:69|94)\\d{8}", , , , "6912345678", , , [10]], [, , "800\\d{7,9}", , , , "8001234567"], [, , "90[19]\\d{7}", , , , "9091234567", , , [10]], [, , "8(?:0[16]|12|[27]5|50)\\d{7}", , , , "8011234567", , , [10]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , , , , , , , , [-1]], "GR", 30, "00", , , , , , , , [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], [
          ,
          "(\\d{3})(\\d{3,4})(\\d{5})",
          "$1 $2 $3",
          ["8"]
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "5005000\\d{3}", , , , "5005000123", , , [10]], , , [, , , , , , , , , [-1]]],
        GT: [, [, , "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", , , , , , , [8, 11]], [, , "[267][2-9]\\d{6}", , , , "22456789", , , [8]], [, , "(?:[3-5]\\d\\d|80[0-4])\\d{5}", , , , "51234567", , , [8]], [, , "18[01]\\d{8}", , , , "18001112222", , , [11]], [, , "19\\d{9}", , , , "19001112222", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GT", 502, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], [
          ,
          "(\\d{4})(\\d{3})(\\d{4})",
          "$1 $2 $3",
          ["1"]
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        GU: [, [, , "(?:[58]\\d\\d|671|900)\\d{7}", , , , , , , [10], [7]], [, , "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}", , , , "6713001234", , , , [7]], [
          ,
          ,
          "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
          ,
          ,
          ,
          "6713001234",
          ,
          ,
          ,
          [7]
        ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "GU", 1, "011", "1", , , "([2-9]\\d{6})$|1", "671$1", , 1, , , [, , , , , , , , , [-1]], , "671", [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , [, , , , , , , , , [-1]]],
        GW: [, [, , "[49]\\d{8}|4\\d{6}", , , , , , , [7, 9]], [, , "443\\d{6}", , , , "443201234", , , [9]], [, , "9(?:5\\d|6[569]|77)\\d{6}", , , , "955012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "40\\d{5}", , , , "4012345", , , [7]], "GW", 245, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["40"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        GY: [, [, , "(?:[2-8]\\d{3}|9008)\\d{3}", , , , , , , [7]], [
          ,
          ,
          "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}",
          ,
          ,
          ,
          "2201234"
        ], [, , "510\\d{4}|(?:6\\d|7[0-5])\\d{5}", , , , "6091234"], [, , "(?:289|8(?:00|6[28]|88|99))\\d{4}", , , , "2891234"], [, , "9008\\d{3}", , , , "9008123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "515\\d{4}", , , , "5151234"], "GY", 592, "001", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        HK: [, [, , "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", , , , , , , [5, 6, 7, 8, 9, 11]], [
          ,
          ,
          "(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-2]))|58(?:0[1-9]|1[2-9]))\\d{4}",
          ,
          ,
          ,
          "21234567",
          ,
          ,
          [8]
        ], [, , "(?:4(?:44[0-25-9]|6(?:1[0-7]|4[0-57-9]|6[0-4])|74[0-2])|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3])|70(?:7[1-8]|8[0-4])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[01]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-9]|6[02357-9]|7[05])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-49]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", , , , "51234567", , , [8]], [, , "800\\d{6}", , , , "800123456", , , [9]], [
          ,
          ,
          "900(?:[0-24-9]\\d{7}|3\\d{1,4})",
          ,
          ,
          ,
          "90012345678",
          ,
          ,
          [5, 6, 7, 8, 11]
        ], [, , , , , , , , , [-1]], [, , "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", , , , "81123456", , , [8]], [, , , , , , , , , [-1]], "HK", 852, "00(?:30|5[09]|[126-9]?)", , , , , , "00", , [[, "(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], , [
          ,
          ,
          "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",
          ,
          ,
          ,
          "71123456",
          ,
          ,
          [8]
        ], , , [, , , , , , , , , [-1]], [, , "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", , , , "30161234", , , [8]], , , [, , , , , , , , , [-1]]],
        HN: [, [, , "8\\d{10}|[237-9]\\d{7}", , , , , , , [8, 11]], [
          ,
          ,
          "2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",
          ,
          ,
          ,
          "22123456",
          ,
          ,
          [8]
        ], [, , "[37-9]\\d{7}", , , , "91234567", , , [8]], [, , "8002\\d{7}", , , , "80021234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "HN", 504, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], [, , , , , , , , , [-1]], , , [, , "8002\\d{7}", , , , , , , [11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        HR: [, [, , "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", , , , , , , [6, 7, 8, 9]], [
          ,
          ,
          "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
          ,
          ,
          ,
          "12345678",
          ,
          ,
          [8, 9],
          [6, 7]
        ], [, , "9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-7])))\\d{4}|98\\d{6}", , , , "921234567", , , [8, 9]], [, , "80\\d{5,7}", , , , "800123456", , , [7, 8, 9]], [, , "6[01459]\\d{6}|6[01]\\d{4,5}", , , , "611234", , , [6, 7, 8]], [, , , , , , , , , [-1]], [, , "7[45]\\d{6}", , , , "74123456", , , [8]], [, , , , , , , , , [-1]], "HR", 385, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], [
          ,
          "(\\d)(\\d{4})(\\d{3})",
          "$1 $2 $3",
          ["1"],
          "0$1"
        ], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "62\\d{6,7}|72\\d{6}", , , , "62123456", , , [8, 9]], , , [, , , , , , , , , [-1]]],
        HT: [, [, , "(?:[2-489]\\d|55)\\d{6}", , , , , , , [8]], [, , "2(?:2\\d|5[1-5]|81|9[149])\\d{5}", , , , "22453300"], [, , "(?:[34]\\d|55)\\d{6}", , , , "34101234"], [
          ,
          ,
          "8\\d{7}",
          ,
          ,
          ,
          "80012345"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}", , , , "98901234"], "HT", 509, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        HU: [, [, , "[235-7]\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9], [6, 7]], [, , "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", , , , "12345678", , , [8], [6, 7]], [, , "(?:[257]0|3[01])\\d{7}", , , , "201234567", , , [9]], [
          ,
          ,
          "(?:[48]0\\d|680[29])\\d{5}",
          ,
          ,
          ,
          "80123456"
        ], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "21\\d{7}", , , , "211234567", , , [9]], "HU", 36, "00", "06", , , "06", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], , [, , , , , , , , , [-1]], , , [, , "(?:[48]0\\d|680[29])\\d{5}"], [, , "38\\d{7}", , , , "381234567", , , [9]], , , [, , , , , , , , , [-1]]],
        ID: [, [
          ,
          ,
          "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
          ,
          ,
          ,
          ,
          ,
          ,
          [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
          [5, 6]
        ], [
          ,
          ,
          "2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",
          ,
          ,
          ,
          "218350123",
          ,
          ,
          [7, 8, 9, 10, 11],
          [5, 6]
        ], [, , "8[1-35-9]\\d{7,10}", , , , "812345678", , , [9, 10, 11, 12]], [, , "00(?:1803\\d{5,11}|7803\\d{7})|(?:177\\d|800)\\d{5,7}", , , , "8001234567", , , [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , "804\\d{7}", , , , "8041234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ID", 62, "00[89]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [, "(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [
          ,
          "(\\d{3})(\\d{5,8})",
          "$1 $2",
          ["[2-79]"],
          "(0$1)"
        ], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3 $4", ["001"]], [, "(\\d{2})(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [
          ,
          "(\\d{2})(\\d{5,9})",
          "$1 $2",
          ["2[124]|[36]1"],
          "(0$1)"
        ], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [, "(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "001803\\d{5,11}|(?:007803\\d|8071)\\d{6}", , , , , , , [10, 11, 12, 13, 14, 15, 16, 17]], [
          ,
          ,
          "(?:1500|8071\\d{3})\\d{3}",
          ,
          ,
          ,
          "8071123456",
          ,
          ,
          [7, 10]
        ], , , [, , , , , , , , , [-1]]],
        IE: [, [, , "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", , , , , , , [7, 8, 9, 10], [5, 6]], [, , "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}", , , , "2212345", , , , [5, 6]], [, , "8(?:22|[35-9]\\d)\\d{6}", , , , "850123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [
          ,
          ,
          "15(?:1[2-8]|[2-8]0|9[089])\\d{6}",
          ,
          ,
          ,
          "1520123456",
          ,
          ,
          [10]
        ], [, , "18[59]0\\d{6}", , , , "1850123456", , , [10]], [, , "700\\d{6}", , , , "700123456", , , [9]], [, , "76\\d{7}", , , , "761234567", , , [9]], "IE", 353, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], [, "(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [
          ,
          "(\\d{3})(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["81"],
          "(0$1)"
        ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], [, "(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "18[59]0\\d{6}", , , , , , , [10]], [, , "818\\d{6}", , , , "818123456", , , [9]], , , [, , "88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}", , , , "8551234567", , , [10]]],
        IL: [, [, , "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", , , , , , , [
          7,
          8,
          9,
          10,
          11,
          12
        ]], [, , "153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}", , , , "21234567", , , [8, 11, 12], [7]], [, , "55(?:410|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", , , , "502345678", , , [9]], [, , "1(?:255|80[019]\\d{3})\\d{3}", , , , "1800123456", , , [7, 10]], [, , "1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", , , , "1919123456", , , [8, 10]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [
          ,
          ,
          "7(?:38(?:0\\d|5[0-2569]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}",
          ,
          ,
          ,
          "771234567",
          ,
          ,
          [9]
        ], "IL", 972, "0(?:0|1[2-9])", "0", , , "0", , , , [[, "(\\d{4})(\\d{3})", "$1-$2", ["125"]], [, "(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], [, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], [, "(\\d{4})(\\d{6})", "$1-$2", ["159"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], [, "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], , [, , , , , , , , , [-1]], , , [
          ,
          ,
          "1700\\d{6}",
          ,
          ,
          ,
          ,
          ,
          ,
          [10]
        ], [, , "1599\\d{6}", , , , "1599123456", , , [10]], , , [, , "151\\d{8,9}", , , , "15112340000", , , [11, 12]]],
        IM: [
          ,
          [, , "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]],
          [, , "1624(?:230|[5-8]\\d\\d)\\d{3}", , , , "1624756789", , , , [6]],
          [, , "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}", , , , "7924123456"],
          [, , "808162\\d{4}", , , , "8081624567"],
          [, , "8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}", , , , "9016247890"],
          [, , , , , , , , , [-1]],
          [, , "70\\d{8}", , , , "7012345678"],
          [, , "56\\d{8}", , , , "5612345678"],
          "IM",
          44,
          "00",
          "0",
          ,
          ,
          "([25-8]\\d{5})$|0",
          "1624$1",
          ,
          ,
          ,
          ,
          [, , , , , , , , , [-1]],
          ,
          "74576|(?:16|7[56])24",
          [, , , , , , , , , [-1]],
          [, , "3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}", , , , "5512345678"],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        IN: [, [, , "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", , , , , , , [8, 9, 10, 11, 12, 13], [6, 7]], [
          ,
          ,
          "2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
          ,
          ,
          ,
          "7410410123",
          ,
          ,
          [10],
          [6, 7, 8]
        ], [
          ,
          ,
          "(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
          ,
          ,
          ,
          "8123456789",
          ,
          ,
          [10]
        ], [, , "000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))", , , , "1800123456"], [, , "186[12]\\d{9}", , , , "1861123456789", , , [13]], [, , "1860\\d{7}", , , , "18603451234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IN", 91, "00", "0", , , "0", , , , [[, "(\\d{7})", "$1", ["575"]], [, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], , , 1], [
          ,
          "(\\d{3})(\\d{3})(\\d{4})",
          "$1 $2 $3",
          ["140"],
          ,
          ,
          1
        ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", , 1], [
          ,
          "(\\d{3})(\\d{3})(\\d{4})",
          "$1 $2 $3",
          [
            "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
            "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
            "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
          ],
          "0$1",
          ,
          1
        ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", [
          "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
          "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
          "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
        ], "0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], , , 1], [
          ,
          "(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
          "$1 $2 $3 $4",
          ["0"]
        ], [, "(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], , , 1]], [[, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], , , 1], [
          ,
          "(\\d{2})(\\d{4})(\\d{4})",
          "$1 $2 $3",
          ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],
          "0$1",
          ,
          1
        ], [
          ,
          "(\\d{3})(\\d{3})(\\d{4})",
          "$1 $2 $3",
          [
            "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
            "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
            "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
          ],
          "0$1",
          ,
          1
        ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", [
          "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
          "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
          "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
        ], "0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], , , 1], [
          ,
          "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
          "$1 $2 $3 $4",
          ["18"],
          ,
          ,
          1
        ]], [, , , , , , , , , [-1]], , , [, , "1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"], [, , "140\\d{7}", , , , "1409305260", , , [10]], , , [, , , , , , , , , [-1]]],
        IO: [, [, , "3\\d{6}", , , , , , , [7]], [, , "37\\d{5}", , , , "3709100"], [, , "38\\d{5}", , , , "3801234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IO", 246, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        IQ: [, [
          ,
          ,
          "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
          ,
          ,
          ,
          ,
          ,
          ,
          [8, 9, 10],
          [6, 7]
        ], [, , "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", , , , "12345678", , , [8, 9], [6, 7]], [, , "7[3-9]\\d{8}", , , , "7912345678", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IQ", 964, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        IR: [
          ,
          [, , "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", , , , , , , [4, 5, 6, 7, 10], [8]],
          [, , "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}", , , , "2123456789", , , [6, 7, 10], [4, 5, 8]],
          [, , "9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", , , , "9123456789", , , [10]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "IR",
          98,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{4,5})", "$1", ["96"], "0$1"], [, "(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , "9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))", , , , , , , [4, 5, 10]],
          [
            ,
            ,
            "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
            ,
            ,
            ,
            "9601",
            ,
            ,
            [4, 5]
          ],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        IS: [, [, , "(?:38\\d|[4-9])\\d{6}", , , , , , , [7, 9]], [, , "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", , , , "4101234", , , [7]], [, , "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}", , , , "6111234"], [, , "80[0-8]\\d{4}", , , , "8001234", , , [7]], [
          ,
          ,
          "90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
          ,
          ,
          ,
          "9001234",
          ,
          ,
          [7]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "49[0-24-79]\\d{4}", , , , "4921234", , , [7]], "IS", 354, "00|1(?:0(?:01|[12]0)|100)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "809\\d{4}", , , , "8091234", , , [7]], , , [, , "(?:689|8(?:7[18]|80)|95[48])\\d{4}", , , , "6891234", , , [7]]],
        IT: [, [, , "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [
          ,
          ,
          "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
          ,
          ,
          ,
          "0212345678",
          ,
          ,
          [6, 7, 8, 9, 10, 11]
        ], [, , "3[2-9]\\d{7,8}|(?:31|43)\\d{8}", , , , "3123456789", , , [9, 10]], [, , "80(?:0\\d{3}|3)\\d{3}", , , , "800123456", , , [6, 9]], [, , "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "IT", 39, "00", , , , , , , , [
          [, "(\\d{4,5})", "$1", ["1(?:0|9[246])", "1(?:0|9(?:2[2-9]|[46]))"]],
          [, "(\\d{6})", "$1", ["1(?:1|92)"]],
          [, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]],
          [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],
          [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]],
          [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]],
          [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]],
          [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]],
          [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]],
          [, "(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]],
          [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]],
          [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]
        ], [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], [
          ,
          "(\\d{3})(\\d{3})(\\d{3,4})",
          "$1 $2 $3",
          ["1(?:44|[679])|[378]|43"]
        ], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], [, "(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], [, , , , , , , , , [-1]], 1, , [, , "848\\d{6}", , , , , , , [9]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]],
        JE: [, [, , "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]], [, , "1534[0-24-8]\\d{5}", , , , "1534456789", , , , [6]], [
          ,
          ,
          "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}",
          ,
          ,
          ,
          "7797712345"
        ], [, , "80(?:07(?:35|81)|8901)\\d{4}", , , , "8007354567"], [, , "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}", , , , "9018105678"], [, , , , , , , , , [-1]], [, , "701511\\d{4}", , , , "7015115678"], [, , "56\\d{8}", , , , "5612345678"], "JE", 44, "00", "0", , , "([0-24-8]\\d{5})$|0", "1534$1", , , , , [, , "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456"], , , [, , , , , , , , , [-1]], [
          ,
          ,
          "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
          ,
          ,
          ,
          "5512345678"
        ], , , [, , , , , , , , , [-1]]],
        JM: [, [, , "(?:[58]\\d\\d|658|900)\\d{7}", , , , , , , [10], [7]], [, , "8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}", , , , "8765230123", , , , [7]], [
          ,
          ,
          "(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
          ,
          ,
          ,
          "8762101234",
          ,
          ,
          ,
          [7]
        ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "JM", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "658|876", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        JO: [, [, , "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", , , , , , , [8, 9]], [
          ,
          ,
          "87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
          ,
          ,
          ,
          "62001234",
          ,
          ,
          [8]
        ], [, , "7(?:[78][0-25-9]|9\\d)\\d{6}", , , , "790123456", , , [9]], [, , "80\\d{6}", , , , "80012345", , , [8]], [, , "9\\d{7}", , , , "90012345", , , [8]], [, , "85\\d{6}", , , , "85012345", , , [8]], [, , "70\\d{7}", , , , "700123456", , , [9]], [, , , , , , , , , [-1]], "JO", 962, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [
          ,
          ,
          "74(?:66|77)\\d{5}",
          ,
          ,
          ,
          "746612345",
          ,
          ,
          [9]
        ], , , [, , , , , , , , , [-1]], [, , "8(?:10|8\\d)\\d{5}", , , , "88101234", , , [8]], , , [, , , , , , , , , [-1]]],
        JP: [, [, , "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", , , , , , , [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], [, , "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", , , , "312345678", , , [9]], [
          ,
          ,
          "[7-9]0[1-9]\\d{7}",
          ,
          ,
          ,
          "9012345678",
          ,
          ,
          [10]
        ], [, , "00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}", , , , "120123456"], [, , "990\\d{6}", , , , "990123456", , , [9]], [, , , , , , , , , [-1]], [, , "60\\d{7}", , , , "601234567", , , [9]], [, , "50[1-9]\\d{7}", , , , "5012345678", , , [10]], "JP", 81, "010", "0", , , "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1", , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["007", "0077", "00777", "00777[01]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [
          ,
          "(\\d{4})(\\d)(\\d{4})",
          "$1-$2-$3",
          ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],
          "0$1"
        ], [
          ,
          "(\\d{2})(\\d{3})(\\d{4})",
          "$1-$2-$3",
          ["60"],
          "0$1"
        ], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], [
          ,
          "(\\d{2})(\\d{3})(\\d{4})",
          "$1-$2-$3",
          [
            "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
            "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
            "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
          ],
          "0$1"
        ], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{4})(\\d{2})(\\d{3,4})", "$1-$2-$3", ["007", "0077"]], [, "(\\d{4})(\\d{2})(\\d{4})", "$1-$2-$3", ["008"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{5})(\\d{5,6})", "$1-$2-$3", ["0"]], [
          ,
          "(\\d{4})(\\d{6})(\\d{6,7})",
          "$1-$2-$3",
          ["0"]
        ]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [
          ,
          "(\\d{4})(\\d)(\\d{4})",
          "$1-$2-$3",
          ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],
          "0$1"
        ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], [
          ,
          "(\\d{2})(\\d{3})(\\d{4})",
          "$1-$2-$3",
          [
            "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
            "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
            "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
          ],
          "0$1"
        ], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], [, , "20\\d{8}", , , , "2012345678", , , [10]], , , [, , "00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"], [, , "570\\d{6}", , , , "570123456", , , [9]], , , [, , , , , , , , , [-1]]],
        KE: [, [, , "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", , , , , , , [7, 8, 9, 10]], [
          ,
          ,
          "(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
          ,
          ,
          ,
          "202012345",
          ,
          ,
          [7, 8, 9]
        ], [, , "(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}", , , , "712123456", , , [9]], [, , "800[02-8]\\d{5,6}", , , , "800223456", , , [9, 10]], [, , "900[02-9]\\d{5}", , , , "900223456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KE", 254, "000", "0", , , "0", , , , [[, "(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        KG: [, [
          ,
          ,
          "8\\d{9}|[235-9]\\d{8}",
          ,
          ,
          ,
          ,
          ,
          ,
          [9, 10],
          [5, 6]
        ], [, , "312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", , , , "312123456", , , [9], [5, 6]], [, , "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}", , , , "700123456", , , [9]], [, , "800\\d{6,7}", , , , "800123456"], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KG", 996, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], [, "(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        KH: [
          ,
          [, , "1\\d{9}|[1-9]\\d{7,8}", , , , , , , [8, 9, 10], [6, 7]],
          [
            ,
            ,
            "23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
            ,
            ,
            ,
            "23756789",
            ,
            ,
            [8, 9],
            [6, 7]
          ],
          [, , "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", , , , "91234567", , , [8, 9]],
          [, , "1800(?:1\\d|2[019])\\d{4}", , , , "1800123456", , , [10]],
          [, , "1900(?:1\\d|2[09])\\d{4}", , , , "1900123456", , , [10]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "KH",
          855,
          "00[14-9]",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        KI: [, [, , "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", , , , , , , [5, 8]], [, , "(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}", , , , "31234"], [
          ,
          ,
          "(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
          ,
          ,
          ,
          "72001234",
          ,
          ,
          [8]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", , , , "30010000", , , [8]], "KI", 686, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        KM: [, [, , "[3478]\\d{6}", , , , , , , [7], [4]], [, , "7[4-7]\\d{5}", , , , "7712345", , , , [4]], [, , "[34]\\d{6}", , , , "3212345"], [, , , , , , , , , [-1]], [, , "8\\d{6}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KM", 269, "00", , , , , , , , [[
          ,
          "(\\d{3})(\\d{2})(\\d{2})",
          "$1 $2 $3",
          ["[3478]"]
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        KN: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}", , , , "8692361234", , , , [7]], [, , "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}", , , , "8697652917", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ], [, , , , , , , , , [-1]], "KN", 1, "011", "1", , , "([2-7]\\d{6})$|1", "869$1", , , , , [, , , , , , , , , [-1]], , "869", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        KP: [, [, , "85\\d{6}|(?:19\\d|[2-7])\\d{7}", , , , , , , [8, 10], [6, 7]], [, , "(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}", , , , "21234567", , , , [6, 7]], [, , "19[1-3]\\d{7}", , , , "1921234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KP", 850, "00|99", "0", , , "0", , , , [[
          ,
          "(\\d{2})(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["8"],
          "0$1"
        ], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        KR: [, [, , "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", , , , , , , [5, 6, 8, 9, 10, 11, 12, 13, 14], [3, 4, 7]], [
          ,
          ,
          "(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",
          ,
          ,
          ,
          "22123456",
          ,
          ,
          [5, 6, 8, 9, 10],
          [3, 4, 7]
        ], [, , "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", , , , "1020000000", , , [9, 10]], [, , "00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}", , , , "801234567", , , [9, 11, 12, 13, 14]], [, , "60[2-9]\\d{6}", , , , "602345678", , , [9]], [, , , , , , , , , [-1]], [, , "50\\d{8,9}", , , , "5012345678", , , [10, 11]], [, , "70\\d{8}", , , , "7012345678", , , [10]], "KR", 82, "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "0", , , "0(8(?:[1-46-8]|5\\d\\d))?", , , , [[
          ,
          "(\\d{5})",
          "$1",
          ["1[016-9]1", "1[016-9]11", "1[016-9]114"],
          "0$1"
        ], [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"], [, "(\\d{5})(\\d{3})(\\d{3})", "$1 $2 $3", ["003", "0030"]], [
          ,
          "(\\d{2})(\\d{5})(\\d{4})",
          "$1-$2-$3",
          ["5"],
          "0$1",
          "0$CC-$1"
        ], [, "(\\d{5})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{5})(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [
          [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"],
          [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]],
          [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"],
          [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1", "0$CC-$1"],
          [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"],
          [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"],
          [, "(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1", "0$CC-$1"]
        ], [, , "15\\d{7,8}", , , , "1523456789", , , [9, 10]], , , [, , "00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})", , , , , , , [11, 12, 13, 14]], [, , "1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}", , , , "15441234", , , [8]], , , [, , , , , , , , , [-1]]],
        KW: [, [, , "18\\d{5}|(?:[2569]\\d|41)\\d{6}", , , , , , , [7, 8]], [, , "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", , , , "22345678", , , [8]], [
          ,
          ,
          "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
          ,
          ,
          ,
          "50012345",
          ,
          ,
          [8]
        ], [, , "18\\d{5}", , , , "1801234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KW", 965, "00", , , , , , , , [[, "(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        KY: [, [, , "(?:345|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
          ,
          ,
          "345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|[48]8)|9(?:14|4[035-9]))\\d{4}",
          ,
          ,
          ,
          "3452221234",
          ,
          ,
          ,
          [7]
        ], [, , "345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}", , , , "3453231234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "(?:345976|900[2-9]\\d\\d)\\d{4}", , , , "9002345678"], [, , , , , , , , , [-1]], [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ], [, , , , , , , , , [-1]], "KY", 1, "011", "1", , , "([2-9]\\d{6})$|1", "345$1", , , , , [, , "345849\\d{4}", , , , "3458491234"], , "345", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        KZ: [, [, , "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", , , , , , , [10, 14], [5, 6, 7]], [
          ,
          ,
          "(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
          ,
          ,
          ,
          "7123456789",
          ,
          ,
          [10],
          [5, 6, 7]
        ], [, , "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", , , , "7710009998", , , [10]], [, , "8(?:00|108\\d{3})\\d{7}", , , , "8001234567"], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567", , , [10]], [, , "751\\d{7}", , , , "7511234567", , , [10]], "KZ", 7, "810", "8", , , "8", , "8~10", , , , [, , , , , , , , , [-1]], , "33|7", [, , "751\\d{7}", , , , , , , [10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        LA: [, [, , "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", , , , , , , [8, 9, 10], [6]], [
          ,
          ,
          "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
          ,
          ,
          ,
          "21212862",
          ,
          ,
          [8],
          [6]
        ], [, , "208[78]\\d{6}|(?:20[23579]|30[24])\\d{7}", , , , "2023123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LA", 856, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "30[0135-9]\\d{6}", , , , "301234567", , , [9]], , , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        LB: [, [, , "[27-9]\\d{7}|[13-9]\\d{6}", , , , , , , [7, 8]], [, , "7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}", , , , "1123456"], [, , "793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}", , , , "71123456"], [, , , , , , , , , [-1]], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , "80\\d{6}", , , , "80123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LB", 961, "00", "0", , , "0", , , , [[
          ,
          "(\\d)(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],
          "0$1"
        ], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        LC: [
          ,
          [, , "(?:[58]\\d\\d|758|900)\\d{7}", , , , , , , [10], [7]],
          [, , "758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}", , , , "7584305678", , , , [7]],
          [, , "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}", , , , "7582845678", , , , [7]],
          [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
          [, , "900[2-9]\\d{6}", , , , "9002123456"],
          [, , , , , , , , , [-1]],
          [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
          [, , , , , , , , , [-1]],
          "LC",
          1,
          "011",
          "1",
          ,
          ,
          "([2-8]\\d{6})$|1",
          "758$1",
          ,
          ,
          ,
          ,
          [, , , , , , , , , [-1]],
          ,
          "758",
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        LI: [, [, , "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", , , , , , , [7, 9]], [
          ,
          ,
          "(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
          ,
          ,
          ,
          "2345678",
          ,
          ,
          [7]
        ], [, , "(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}", , , , "660234567"], [, , "8002[28]\\d\\d|80(?:05\\d|9)\\d{4}", , , , "8002222"], [, , "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", , , , "9002222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LI", 423, "00", "0", , , "(1001)|0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [
          ,
          "(\\d{2})(\\d{3})(\\d{4})",
          "$1 $2 $3",
          ["69"],
          ,
          "$CC $1"
        ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "870(?:28|87)\\d\\d", , , , "8702812", , , [7]], , , [, , "697(?:42|56|[78]\\d)\\d{4}", , , , "697861234", , , [9]]],
        LK: [, [, , "[1-9]\\d{8}", , , , , , , [9], [7]], [, , "(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}", , , , "112345678", , , , [7]], [, , "7(?:[0-25-8]\\d|4[0-4])\\d{6}", , , , "712345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , , , , , , , , [-1]], "LK", 94, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "1973\\d{5}", , , , "197312345"], , , [, , , , , , , , , [-1]]],
        LR: [, [, , "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", , , , , , , [7, 8, 9]], [, , "2\\d{7}", , , , "21234567", , , [8]], [, , "(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}", , , , "770123456", , , [7, 9]], [, , , , , , , , , [-1]], [
          ,
          ,
          "332(?:02|[34]\\d)\\d{4}",
          ,
          ,
          ,
          "332021234",
          ,
          ,
          [9]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LR", 231, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        LS: [, [, , "(?:[256]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "2\\d{7}", , , , "22123456"], [, , "[56]\\d{7}", , , , "50123456"], [, , "800[1256]\\d{4}", , , , "80021234"], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LS", 266, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        LT: [
          ,
          [, , "(?:[3469]\\d|52|[78]0)\\d{6}", , , , , , , [8]],
          [, , "(?:3[1478]|4[124-6]|52)\\d{6}", , , , "31234567"],
          [, , "6\\d{7}", , , , "61234567"],
          [, , "80[02]\\d{5}", , , , "80012345"],
          [, , "9(?:0[0239]|10)\\d{5}", , , , "90012345"],
          [, , "808\\d{5}", , , , "80812345"],
          [, , "70[05]\\d{5}", , , , "70012345"],
          [, , "[89]01\\d{5}", , , , "80123456"],
          "LT",
          370,
          "00",
          "0",
          ,
          ,
          "[08]",
          ,
          ,
          ,
          [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", , 1], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", , 1], [, "(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", , 1], [, "(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", , 1]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , "70[67]\\d{5}", , , , "70712345"],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        LU: [, [, , "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11]], [
          ,
          ,
          "(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",
          ,
          ,
          ,
          "27123456"
        ], [, , "6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", , , , "628123456", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "90[015]\\d{5}", , , , "90012345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , , , , , , , , [-1]], [, , "20(?:1\\d{5}|[2-689]\\d{1,7})", , , , "20201234", , , [4, 5, 6, 7, 8, 9, 10]], "LU", 352, "00", , , , "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"], , "$CC $1"], [
          ,
          "(\\d{2})(\\d{2})(\\d{2})",
          "$1 $2 $3",
          ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],
          ,
          "$CC $1"
        ], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [
          ,
          "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
          "$1 $2 $3 $4",
          ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"],
          ,
          "$CC $1"
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        LV: [, [, , "(?:[268]\\d|90)\\d{6}", , , , , , , [8]], [, , "6\\d{7}", , , , "63123456"], [, , "23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}", , , , "21234567"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , "81\\d{6}", , , , "81123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LV", 371, "00", , , , , , , , [[
          ,
          "(\\d{2})(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["[269]|8[01]"]
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        LY: [
          ,
          [, , "[2-9]\\d{8}", , , , , , , [9], [7]],
          [, , "(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}", , , , "212345678", , , , [7]],
          [, , "9[1-6]\\d{7}", , , , "912345678"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "LY",
          218,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        MA: [, [, , "[5-8]\\d{8}", , , , , , , [9]], [, , "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}", , , , "520123456"], [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}", , , , "650123456"], [, , "80[0-7]\\d{6}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}",
          ,
          ,
          ,
          "592401234"
        ], "MA", 212, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], [, "(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], [, "(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], [, "(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MC: [
          ,
          [, , "(?:[3489]|6\\d)\\d{7}", , , , , , , [8, 9]],
          [, , "(?:870|9[2-47-9]\\d)\\d{5}", , , , "99123456", , , [8]],
          [, , "4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}", , , , "612345678"],
          [, , "(?:800|90\\d)\\d{5}", , , , "90123456", , , [8]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "MC",
          377,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["87"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]],
          [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], [
            ,
            "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
            "$1 $2 $3 $4 $5",
            ["6"],
            "0$1"
          ]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , "8[07]0\\d{5}", , , , , , , [8]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        MD: [, [, , "(?:[235-7]\\d|[89]0)\\d{6}", , , , , , , [8]], [, , "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}", , , , "22212345"], [, , "562\\d{5}|(?:6\\d|7[16-9])\\d{6}", , , , "62112345"], [, , "800\\d{5}", , , , "80012345"], [, , "90[056]\\d{5}", , , , "90012345"], [, , "808\\d{5}", , , , "80812345"], [, , , , , , , , , [-1]], [, , "3[08]\\d{6}", , , , "30123456"], "MD", 373, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [
          ,
          "(\\d{2})(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["22|3"],
          "0$1"
        ], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "803\\d{5}", , , , "80312345"], , , [, , , , , , , , , [-1]]],
        ME: [, [, , "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", , , , , , , [8, 9], [6]], [, , "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}", , , , "30234567", , , [8], [6]], [, , "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", , , , "67622901", , , [8]], [, , "80(?:[0-2578]|9\\d)\\d{5}", , , , "80080002"], [
          ,
          ,
          "9(?:4[1568]|5[178])\\d{5}",
          ,
          ,
          ,
          "94515151",
          ,
          ,
          [8]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "78[1-49]\\d{5}", , , , "78108780", , , [8]], "ME", 382, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "77[1-9]\\d{5}", , , , "77273012", , , [8]], , , [, , , , , , , , , [-1]]],
        MF: [
          ,
          [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]],
          [, , "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}", , , , "590271234"],
          [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}", , , , "690001234"],
          [, , "80[0-5]\\d{6}", , , , "800012345"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}", , , , "976012345"],
          "MF",
          590,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          ,
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        MG: [, [, , "[23]\\d{8}", , , , , , , [9], [7]], [, , "2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[356]|8[268]|9[245])\\d{5}", , , , "202123456", , , , [7]], [, , "3[2-47-9]\\d{7}", , , , "321234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          "22\\d{7}",
          ,
          ,
          ,
          "221234567"
        ], "MG", 261, "00", "0", , , "([24-9]\\d{6})$|0", "20$1", , , [[, "(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MH: [
          ,
          [, , "329\\d{4}|(?:[256]\\d|45)\\d{5}", , , , , , , [7]],
          [, , "(?:247|528|625)\\d{4}", , , , "2471234"],
          [, , "(?:(?:23|54)5|329|45[35-8])\\d{4}", , , , "2351234"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "635\\d{4}", , , , "6351234"],
          "MH",
          692,
          "011",
          "1",
          ,
          ,
          "1",
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        MK: [, [, , "[2-578]\\d{7}", , , , , , , [8], [6, 7]], [, , "(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}", , , , "22012345", , , , [6, 7]], [, , "7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|6[01]|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}", , , , "72345678"], [
          ,
          ,
          "800\\d{5}",
          ,
          ,
          ,
          "80012345"
        ], [, , "5\\d{7}", , , , "50012345"], [, , "8(?:0[1-9]|[1-9]\\d)\\d{5}", , , , "80123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MK", 389, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        ML: [, [, , "[24-9]\\d{7}", , , , , , , [8]], [
          ,
          ,
          "2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}",
          ,
          ,
          ,
          "20212345"
        ], [, , "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}", , , , "65012345"], [, , "80\\d{6}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ML", 223, "00", , , , , , , , [[, "(\\d{4})", "$1", ["67[057-9]|74[045]", "67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [, , , , , , , , , [-1]], , , [, , "80\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MM: [
          ,
          [, , "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", , , , , , , [6, 7, 8, 9, 10], [5]],
          [
            ,
            ,
            "(?:1(?:(?:12|[28]\\d|3[56]|7[3-6]|9[0-6])\\d|4(?:2[29]|62|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|[26]2|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5(?:2\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:3\\d\\d|4[67]0|8(?:[01459]\\d|8))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|(?:[35]2|64)\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
            ,
            ,
            ,
            "1234567",
            ,
            ,
            [6, 7, 8, 9],
            [5]
          ],
          [, , "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", , , , "92123456", , , [7, 8, 9, 10]],
          [, , "80080(?:0[1-9]|2\\d)\\d{3}", , , , "8008001234", , , [10]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "1333\\d{4}|[12]468\\d{4}", , , , "13331234", , , [8]],
          "MM",
          95,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], [
            ,
            "(\\d{2})(\\d{2})(\\d{3})",
            "$1 $2 $3",
            ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"],
            "0$1"
          ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], [, "(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], [
            ,
            "(\\d)(\\d{5})(\\d{4})",
            "$1 $2 $3",
            ["9"],
            "0$1"
          ]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        MN: [, [, , "[12]\\d{7,9}|[5-9]\\d{7}", , , , , , , [8, 9, 10], [4, 5, 6]], [, , "[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}", , , , "53123456", , , , [4, 5, 6]], [, , "(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}", , , , "88123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          "712[0-79]\\d{4}|7(?:1[013-9]|[25-9]\\d)\\d{5}",
          ,
          ,
          ,
          "75123456",
          ,
          ,
          [8]
        ], "MN", 976, "001", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MO: [, [
          ,
          ,
          "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
          ,
          ,
          ,
          ,
          ,
          ,
          [7, 8]
        ], [, , "(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}", , , , "28212345", , , [8]], [, , "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", , , , "66123456", , , [8]], [, , "0800\\d{3}", , , , "0800501", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MO", 853, "00", , , , , , , , [[, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MP: [, [
          ,
          ,
          "[58]\\d{9}|(?:67|90)0\\d{7}",
          ,
          ,
          ,
          ,
          ,
          ,
          [10],
          [7]
        ], [, , "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", , , , "6702345678", , , , [7]], [, , "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", , , , "6702345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ], [, , , , , , , , , [-1]], "MP", 1, "011", "1", , , "([2-9]\\d{6})$|1", "670$1", , 1, , , [, , , , , , , , , [-1]], , "670", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MQ: [
          ,
          [, , "596\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]],
          [, , "596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])\\d{4}", , , , "596301234"],
          [, , "69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}", , , , "696201234"],
          [, , "80[0-5]\\d{6}", , , , "800012345"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}", , , , "976612345"],
          "MQ",
          596,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        MR: [, [, , "(?:[2-4]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "(?:25[08]|35\\d|45[1-7])\\d{5}", , , , "35123456"], [, , "[2-4][0-46-9]\\d{6}", , , , "22123456"], [, , "800\\d{5}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MR", 222, "00", , , , , , , , [[
          ,
          "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["[2-48]"]
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MS: [, [, , "(?:[58]\\d\\d|664|900)\\d{7}", , , , , , , [10], [7]], [, , "6644(?:1[0-3]|91)\\d{4}", , , , "6644912345", , , , [7]], [, , "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}", , , , "6644923456", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ], [, , , , , , , , , [-1]], "MS", 1, "011", "1", , , "([34]\\d{6})$|1", "664$1", , , , , [, , , , , , , , , [-1]], , "664", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MT: [, [, , "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}", , , , "21001234"], [, , "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}", , , , "96961234"], [, , "800(?:02|[3467]\\d)\\d{3}", , , , "80071234"], [
          ,
          ,
          "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",
          ,
          ,
          ,
          "50037123"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3550\\d{4}", , , , "35501234"], "MT", 356, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], , [, , "7117\\d{4}", , , , "71171234"], , , [, , , , , , , , , [-1]], [, , "501\\d{5}", , , , "50112345"], , , [, , , , , , , , , [-1]]],
        MU: [, [, , "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", , , , , , , [7, 8, 10]], [, , "(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8]|71)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", , , , "54480123", , , [7, 8]], [
          ,
          ,
          "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-4]|3[013]))\\d{5}",
          ,
          ,
          ,
          "52512345",
          ,
          ,
          [8]
        ], [, , "802\\d{7}|80[0-2]\\d{4}", , , , "8001234", , , [7, 10]], [, , "30\\d{5}", , , , "3012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3(?:20|9\\d)\\d{4}", , , , "3201234", , , [7]], "MU", 230, "0(?:0|[24-7]0|3[03])", , , , , , "020", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], [, "(\\d{5})(\\d{5})", "$1 $2", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MV: [, [, , "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", , , , , , , [7, 10]], [
          ,
          ,
          "(?:3(?:0[0-3]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}",
          ,
          ,
          ,
          "6701234",
          ,
          ,
          [7]
        ], [, , "(?:46[46]|[79]\\d\\d)\\d{4}", , , , "7712345", , , [7]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MV", 960, "0(?:0|19)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "4(?:0[01]|50)\\d{4}", , , , "4001234", , , [7]], , , [, , , , , , , , , [-1]]],
        MW: [, [, , "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", , , , , , , [7, 9]], [
          ,
          ,
          "(?:1[2-9]|2[12]\\d\\d)\\d{5}",
          ,
          ,
          ,
          "1234567"
        ], [, , "111\\d{6}|(?:31|77|[89][89])\\d{7}", , , , "991234567", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MW", 265, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MX: [, [, , "[2-9]\\d{9}", , , , , , , [10], [7, 8]], [
          ,
          ,
          "657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}",
          ,
          ,
          ,
          "2001234567",
          ,
          ,
          ,
          [7, 8]
        ], [, , "657[12]\\d{6}|(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}", , , , "2221234567", , , , [7, 8]], [
          ,
          ,
          "8(?:00|88)\\d{7}",
          ,
          ,
          ,
          "8001234567"
        ], [, , "900\\d{7}", , , , "9001234567"], [, , "300\\d{7}", , , , "3001234567"], [, , "500\\d{7}", , , , "5001234567"], [, , , , , , , , , [-1]], "MX", 52, "0[09]", , , , , , "00", , [[, "(\\d{5})", "$1", ["53"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MY: [, [
          ,
          ,
          "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
          ,
          ,
          ,
          ,
          ,
          ,
          [8, 9, 10],
          [6, 7]
        ], [, , "4270\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}", , , , "323856789", , , [8, 9], [6, 7]], [
          ,
          ,
          "1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}",
          ,
          ,
          ,
          "123456789",
          ,
          ,
          [9, 10]
        ], [, , "1[378]00\\d{6}", , , , "1300123456", , , [10]], [, , "1600\\d{6}", , , , "1600123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}", , , , "1546012345", , , [10]], "MY", 60, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], [
          ,
          "(\\d)(\\d{4})(\\d{4})",
          "$1-$2 $3",
          ["3"],
          "0$1"
        ], [, "(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MZ: [
          ,
          [, , "(?:2|8\\d)\\d{7}", , , , , , , [8, 9]],
          [, , "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", , , , "21123456", , , [8]],
          [, , "8[2-79]\\d{7}", , , , "821234567", , , [9]],
          [, , "800\\d{6}", , , , "800123456", , , [9]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "MZ",
          258,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        NA: [, [, , "[68]\\d{7,8}", , , , , , , [8, 9]], [
          ,
          ,
          "64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}",
          ,
          ,
          ,
          "61221234"
        ], [, , "(?:60|8[1245])\\d{7}", , , , "811234567", , , [9]], [, , "80\\d{7}", , , , "800123456", , , [9]], [, , "8701\\d{5}", , , , "870123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8(?:3\\d\\d|86)\\d{5}", , , , "88612345"], "NA", 264, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , [, , , , , , , , , [-1]]],
        NC: [, [, , "(?:050|[2-57-9]\\d\\d)\\d{3}", , , , , , , [6]], [, , "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}", , , , "201234"], [, , "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}", , , , "751234"], [, , "050\\d{3}", , , , "050012"], [, , "36\\d{4}", , , , "366711"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NC", 687, "00", , , , , , , , [[, "(\\d{3})", "$1", ["5[6-8]"]], [, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        NE: [
          ,
          [, , "[027-9]\\d{7}", , , , , , , [8]],
          [, , "2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}", , , , "20201234"],
          [, , "(?:23|7[0467]|[89]\\d)\\d{6}", , , , "93123456"],
          [, , "08\\d{6}", , , , "08123456"],
          [, , "09\\d{6}", , , , "09123456"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "NE",
          227,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        NF: [, [, , "[13]\\d{5}", , , , , , , [6], [5]], [, , "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}", , , , "106609", , , , [5]], [, , "(?:14|3[58])\\d{4}", , , , "381234", , , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NF", 672, "00", , , , "([0-258]\\d{4})$", "3$1", , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], [, "(\\d)(\\d{5})", "$1 $2", ["[13]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        NG: [, [
          ,
          ,
          "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}",
          ,
          ,
          ,
          ,
          ,
          ,
          [8, 10, 11, 12, 13, 14],
          [6, 7]
        ], [, , "(?:20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])|38)\\d{6}", , , , "2033123456", , , [8, 10], [6, 7]], [, , "(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}", , , , "8021234567", , , [10]], [, , "800\\d{7,11}", , , , "80017591759", , , [10, 11, 12, 13, 14]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NG", 234, "009", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], [
          ,
          "(\\d{3})(\\d{3})(\\d{3,4})",
          "$1 $2 $3",
          ["[7-9]"],
          "0$1"
        ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], [, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], [, "(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "700\\d{7,11}", , , , "7001234567", , , [10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]]],
        NI: [, [, , "(?:1800|[25-8]\\d{3})\\d{4}", , , , , , , [8]], [, , "2\\d{7}", , , , "21234567"], [
          ,
          ,
          "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}",
          ,
          ,
          ,
          "81234567"
        ], [, , "1800\\d{4}", , , , "18001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NI", 505, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        NL: [, [, , "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", , , , , , , [5, 6, 7, 8, 9, 10, 11]], [
          ,
          ,
          "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
          ,
          ,
          ,
          "101234567",
          ,
          ,
          [9]
        ], [, , "(?:6[1-58]|970\\d)\\d{7}", , , , "612345678", , , [9, 11]], [, , "800\\d{4,7}", , , , "8001234", , , [7, 8, 9, 10]], [, , "90[069]\\d{4,7}", , , , "9061234", , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:85|91)\\d{7}", , , , "851234567", , , [9]], "NL", 31, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["1[238]|[34]"]], [, "(\\d{2})(\\d{3,4})", "$1 $2", ["14"]], [, "(\\d{6})", "$1", ["1"]], [, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [
          ,
          "(\\d{3})(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],
          "0$1"
        ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], [[, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], [
          ,
          "(\\d{3})(\\d{3})(\\d{5})",
          "$1 $2 $3",
          ["9"],
          "0$1"
        ]], [, , "66\\d{7}", , , , "662345678", , , [9]], , , [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d", , , , , , , [5, 6]], [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", , , , "14020", , , [5, 6, 9]], , , [, , , , , , , , , [-1]]],
        NO: [, [, , "(?:0|[2-9]\\d{3})\\d{4}", , , , , , , [5, 8]], [, , "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", , , , "21234567", , , [8]], [
          ,
          ,
          "(?:4[015-8]|9\\d)\\d{6}",
          ,
          ,
          ,
          "40612345",
          ,
          ,
          [8]
        ], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "NO", 47, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], , [, , , , , , , , , [-1]], 1, "[02-689]|7[0-8]", [, , , , , , , , , [-1]], [, , "(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [
          ,
          ,
          "81[23]\\d{5}",
          ,
          ,
          ,
          "81212345",
          ,
          ,
          [8]
        ]],
        NP: [, [, , "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", , , , , , , [8, 10, 11], [6, 7]], [, , "(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", , , , "14567890", , , [8], [6, 7]], [, , "9(?:00|6[0-3]|7[024-6]|8[0-24-68])\\d{7}", , , , "9841234567", , , [10]], [, , "1(?:66001|800\\d\\d)\\d{5}", , , , "16600101234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NP", 977, "00", "0", , , "0", , , , [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [
          ,
          "(\\d{2})(\\d{6})",
          "$1-$2",
          ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],
          "0$1"
        ], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]], [, "(\\d{4})(\\d{2})(\\d{5})", "$1-$2-$3", ["1"]]], [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [, "(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        NR: [, [, , "(?:444|(?:55|8\\d)\\d|666)\\d{4}", , , , , , , [7]], [, , "444\\d{4}", , , , "4441234"], [, , "(?:55[3-9]|666|8\\d\\d)\\d{4}", , , , "5551234"], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NR", 674, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        NU: [
          ,
          [, , "(?:[4-7]|888\\d)\\d{3}", , , , , , , [4, 7]],
          [, , "[47]\\d{3}", , , , "7012", , , [4]],
          [, , "(?:[56]|888[1-9])\\d{3}", , , , "8884012"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "NU",
          683,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{4})", "$1 $2", ["8"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        NZ: [
          ,
          [, , "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", , , , , , , [5, 6, 7, 8, 9, 10]],
          [, , "240\\d{5}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", , , , "32345678", , , [8], [7]],
          [, , "2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}", , , , "211234567", , , [8, 9, 10]],
          [, , "508\\d{6,7}|80\\d{6,8}", , , , "800123456", , , [8, 9, 10]],
          [, , "(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", , , , "900123456", , , [7, 8, 9, 10]],
          [, , , , , , , , , [-1]],
          [
            ,
            ,
            "70\\d{7}",
            ,
            ,
            ,
            "701234567",
            ,
            ,
            [9]
          ],
          [, , , , , , , , , [-1]],
          "NZ",
          64,
          "0(?:0|161)",
          "0",
          ,
          ,
          "0",
          ,
          "00",
          ,
          [[, "(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , "8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}", , , , "83012378"],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        OM: [, [, , "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", , , , , , , [7, 8, 9]], [, , "2[1-6]\\d{6}", , , , "23123456", , , [8]], [, , "(?:1505|90[1-9]\\d)\\d{4}|(?:7[126-9]|9[1-9])\\d{6}", , , , "92123456", , , [8]], [, , "8007\\d{4,5}|(?:500|800[05])\\d{4}", , , , "80071234"], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "OM", 968, "00", , , , , , , , [[
          ,
          "(\\d{3})(\\d{4,6})",
          "$1 $2",
          ["[58]"]
        ], [, "(\\d{2})(\\d{6})", "$1 $2", ["2"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        PA: [, [, , "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", , , , , , , [7, 8, 10, 11]], [
          ,
          ,
          "(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[07-9]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
          ,
          ,
          ,
          "2001234",
          ,
          ,
          [7]
        ], [, , "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", , , , "61234567", , , [7, 8]], [, , "800\\d{4,5}|(?:00800|800\\d)\\d{6}", , , , "8001234"], [, , "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", , , , "8601234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PA", 507, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        PE: [, [
          ,
          ,
          "(?:[14-8]|9\\d)\\d{7}",
          ,
          ,
          ,
          ,
          ,
          ,
          [8, 9],
          [6, 7]
        ], [, , "(?:(?:(?:4[34]|5[14])[0-8]|687)\\d|7(?:173|(?:3[0-8]|55)\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[0569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", , , , "11234567", , , [8], [6, 7]], [, , "9\\d{8}", , , , "912345678", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "805\\d{5}", , , , "80512345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , "80[24]\\d{5}", , , , "80212345", , , [8]], [, , , , , , , , , [-1]], "PE", 51, "00|19(?:1[124]|77|90)00", "0", " Anexo ", , "0", , "00", , [[
          ,
          "(\\d{3})(\\d{5})",
          "$1 $2",
          ["80"],
          "(0$1)"
        ], [, "(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        PF: [
          ,
          [, , "4\\d{5}(?:\\d{2})?|8\\d{7,8}", , , , , , , [6, 8, 9]],
          [, , "4(?:0[4-689]|9[4-68])\\d{5}", , , , "40412345", , , [8]],
          [, , "8[7-9]\\d{6}", , , , "87123456", , , [8]],
          [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "499\\d{5}", , , , "49901234", , , [8]],
          "PF",
          689,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , "44\\d{4}", , , , , , , [6]],
          [, , "44\\d{4}", , , , "440123", , , [6]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        PG: [, [, , "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", , , , , , , [7, 8]], [, , "(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", , , , "3123456", , , [7]], [, , "(?:7\\d|8[1-38])\\d{6}", , , , "70123456", , , [8]], [
          ,
          ,
          "180\\d{4}",
          ,
          ,
          ,
          "1801234",
          ,
          ,
          [7]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "2(?:0[0-57]|7[568])\\d{4}", , , , "2751234", , , [7]], "PG", 675, "00|140[1-3]", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], , [, , "27[01]\\d{4}", , , , "2700123", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        PH: [, [, , "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", , , , , , , [6, 8, 9, 10, 11, 12, 13], [4, 5, 7]], [
          ,
          ,
          "(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",
          ,
          ,
          ,
          "232345678",
          ,
          ,
          [6, 8, 9, 10],
          [4, 5, 7]
        ], [, , "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", , , , "9051234567", , , [10]], [, , "1800\\d{7,9}", , , , "180012345678", , , [11, 12, 13]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PH", 63, "00", "0", , , "0", , , , [[, "(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], [
          ,
          "(\\d{4})(\\d{4,6})",
          "$1 $2",
          ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],
          "(0$1)"
        ], [, "(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        PK: [, [
          ,
          ,
          "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
          ,
          ,
          ,
          ,
          ,
          ,
          [8, 9, 10, 11, 12],
          [5, 6, 7]
        ], [, , "(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", , , , "2123456789", , , [9, 10], [5, 6, 7, 8]], [, , "3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}", , , , "3012345678", , , [10]], [, , "800\\d{5}(?:\\d{3})?", , , , "80012345", , , [8, 11]], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [
          ,
          ,
          "122\\d{6}",
          ,
          ,
          ,
          "122044444",
          ,
          ,
          [9]
        ], [, , , , , , , , , [-1]], "PK", 92, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], [, "(\\d{4})(\\d{5})", "$1 $2", ["1"]], [
          ,
          "(\\d{3})(\\d{6,7})",
          "$1 $2",
          ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],
          "(0$1)"
        ], [, "(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], [, "(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
          ,
          ,
          "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
          ,
          ,
          ,
          "21111825888",
          ,
          ,
          [11, 12]
        ], , , [, , , , , , , , , [-1]]],
        PL: [, [, , "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", , , , , , , [6, 7, 8, 9, 10]], [, , "47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", , , , "123456789", , , [7, 9]], [, , "21(?:1[013-5]|2\\d)\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", , , , "512345678", , , [9]], [, , "800\\d{6,7}", , , , "800123456", , , [9, 10]], [, , "70[01346-8]\\d{6}", , , , "701234567", , , [9]], [
          ,
          ,
          "801\\d{6}",
          ,
          ,
          ,
          "801234567",
          ,
          ,
          [9]
        ], [, , , , , , , , , [-1]], [, , "39\\d{7}", , , , "391234567", , , [9]], "PL", 48, "00", , , , , , , , [[, "(\\d{5})", "$1", ["19"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], [
          ,
          "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["1[2-8]|[2-7]|8[1-79]|9[145]"]
        ], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]], , [, , "64\\d{4,7}", , , , "641234567", , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]], [, , "804\\d{6}", , , , "804123456", , , [9]], , , [, , , , , , , , , [-1]]],
        PM: [
          ,
          [, , "[45]\\d{5}|(?:708|80\\d)\\d{6}", , , , , , , [6, 9]],
          [, , "(?:4[1-35-7]|5[01])\\d{4}", , , , "430123", , , [6]],
          [, , "(?:4[02-4]|5[056]|708[45][0-5])\\d{4}", , , , "551234"],
          [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "PM",
          508,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        PR: [, [, , "(?:[589]\\d\\d|787)\\d{7}", , , , , , , [10], [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "PR", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "787|939", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        PS: [, [, , "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", , , , , , , [8, 9, 10], [7]], [
          ,
          ,
          "(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",
          ,
          ,
          ,
          "22234567",
          ,
          ,
          [8],
          [7]
        ], [, , "5[69]\\d{7}", , , , "599123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , , , , , , , , [-1]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PS", 970, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        PT: [
          ,
          [, , "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", , , , , , , [9]],
          [, , "2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}", , , , "212345678"],
          [, , "6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}", , , , "912345678"],
          [, , "80[02]\\d{6}", , , , "800123456"],
          [, , "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}", , , , "760123456"],
          [, , "80(?:8\\d|9[1579])\\d{5}", , , , "808123456"],
          [, , "884[0-4689]\\d{5}", , , , "884123456"],
          [, , "30\\d{7}", , , , "301234567"],
          "PT",
          351,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[
            ,
            "(\\d{2})(\\d{3})(\\d{4})",
            "$1 $2 $3",
            ["2[12]"]
          ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]],
          ,
          [, , "6(?:222\\d|8988)\\d{4}", , , , "622212345"],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , "70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}", , , , "707123456"],
          ,
          ,
          [, , "600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}", , , , "600110000"]
        ],
        PW: [
          ,
          [, , "(?:[24-8]\\d\\d|345|900)\\d{4}", , , , , , , [7]],
          [, , "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}", , , , "2771234"],
          [, , "(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}", , , , "6201234"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "PW",
          680,
          "01[12]",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        PY: [, [, , "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [
          ,
          ,
          "(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
          ,
          ,
          ,
          "212345678",
          ,
          ,
          [7, 8, 9],
          [5, 6]
        ], [, , "9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}", , , , "961456789", , , [9]], [, , "9800\\d{5,7}", , , , "98000123456", , , [9, 10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8700[0-4]\\d{4}", , , , "870012345", , , [9]], "PY", 595, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], [
          ,
          "(\\d{2})(\\d{3})(\\d{3,4})",
          "$1 $2 $3",
          ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],
          "(0$1)"
        ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "[2-9]0\\d{4,7}", , , , "201234567", , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]]],
        QA: [, [, , "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", , , , , , , [7, 8, 9, 11]], [
          ,
          ,
          "4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}",
          ,
          ,
          ,
          "44123456",
          ,
          ,
          [8]
        ], [, , "[35-7]\\d{7}", , , , "33123456", , , [8]], [, , "800\\d{4}|(?:0080[01]|800)\\d{6}", , , , "8001234", , , [7, 9, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "QA", 974, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], , [, , "2[16]\\d{5}", , , , "2123456", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        RE: [, [, , "(?:26|[689]\\d)\\d{7}", , , , , , , [9]], [, , "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}", , , , "262161234"], [
          ,
          ,
          "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}",
          ,
          ,
          ,
          "692123456"
        ], [, , "80\\d{7}", , , , "801234567"], [, , "89[1-37-9]\\d{6}", , , , "891123456"], [, , "8(?:1[019]|2[0156]|84|90)\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}", , , , "939901234"], "RE", 262, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        RO: [, [, , "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", , , , , , , [6, 9]], [
          ,
          ,
          "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d",
          ,
          ,
          ,
          "211234567"
        ], [, , "(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}", , , , "712034567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[0136]\\d{6}", , , , "900123456", , , [9]], [, , "801\\d{6}", , , , "801123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RO", 40, "00", "0", " int ", , "0", , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], [, "(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], [
          ,
          "(\\d{3})(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["[236-9]"],
          "0$1"
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:37\\d|80[578])\\d{6}", , , , "372123456", , , [9]], , , [, , , , , , , , , [-1]]],
        RS: [, [, , "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", , , , , , , [6, 7, 8, 9, 10, 11, 12], [4, 5]], [, , "(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", , , , "10234567", , , [7, 8, 9, 10, 11, 12], [4, 5, 6]], [, , "6(?:[0-689]|7\\d)\\d{6,7}", , , , "601234567", , , [8, 9, 10]], [
          ,
          ,
          "800\\d{3,9}",
          ,
          ,
          ,
          "80012345"
        ], [, , "(?:78\\d|90[0169])\\d{3,7}", , , , "90012345", , , [6, 7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RS", 381, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], [, "(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7[06]\\d{4,10}", , , , "700123456"], , , [, , , , , , , , , [-1]]],
        RU: [, [, , "8\\d{13}|[347-9]\\d{9}", , , , , , , [10, 14], [7]], [
          ,
          ,
          "(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",
          ,
          ,
          ,
          "3011234567",
          ,
          ,
          [10],
          [7]
        ], [, , "9\\d{9}", , , , "9123456789", , , [10]], [, , "8(?:0[04]|108\\d{3})\\d{7}", , , , "8001234567"], [, , "80[39]\\d{7}", , , , "8091234567", , , [10]], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567", , , [10]], [, , , , , , , , , [-1]], "RU", 7, "810", "8", , , "8", , "8~10", , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1-$2-$3", ["[0-79]"]], [
          ,
          "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],
          "8 ($1)",
          ,
          1
        ], [, "(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [
          ,
          "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
          "$1 $2-$3-$4",
          ["[349]|8(?:[02-7]|1[1-8])"],
          "8 ($1)",
          ,
          1
        ], [, "(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], [[, "(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", , 1], [
          ,
          "(\\d{5})(\\d)(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],
          "8 ($1)",
          ,
          1
        ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", , 1], [, "(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], [, , , , , , , , , [-1]], 1, "3[04-689]|[489]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        RW: [, [, , "(?:06|[27]\\d\\d|[89]00)\\d{6}", , , , , , , [8, 9]], [, , "(?:06|2[23568]\\d)\\d{6}", , , , "250123456"], [, , "7[237-9]\\d{7}", , , , "720123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [
          ,
          ,
          "900\\d{6}",
          ,
          ,
          ,
          "900123456",
          ,
          ,
          [9]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RW", 250, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SA: [, [, , "92\\d{7}|(?:[15]|8\\d)\\d{8}", , , , , , , [9, 10], [7]], [, , "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", , , , "112345678", , , [9], [7]], [
          ,
          ,
          "579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}",
          ,
          ,
          ,
          "512345678",
          ,
          ,
          [9]
        ], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "925\\d{6}", , , , "925012345", , , [9]], [, , "920\\d{6}", , , , "920012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SA", 966, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["9"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
          ,
          ,
          "811\\d{7}",
          ,
          ,
          ,
          "8110123456",
          ,
          ,
          [10]
        ], , , [, , , , , , , , , [-1]]],
        SB: [, [, , "[6-9]\\d{6}|[1-6]\\d{4}", , , , , , , [5, 7]], [, , "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", , , , "40123", , , [5]], [, , "48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}", , , , "7421234"], [, , "1[38]\\d{3}", , , , "18123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5[12]\\d{3}", , , , "51123", , , [5]], "SB", 677, "0[01]", , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]], , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SC: [, [, , "(?:[2489]\\d|64)\\d{5}", , , , , , , [7]], [, , "4[2-46]\\d{5}", , , , "4217123"], [, , "2[125-8]\\d{5}", , , , "2510123"], [, , "800[08]\\d{3}", , , , "8000000"], [, , "85\\d{5}", , , , "8512345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "971\\d{4}|(?:64|95)\\d{5}", , , , "6412345"], "SC", 248, "010|0[0-2]", , , , , , "00", , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SD: [, [, , "[19]\\d{8}", , , , , , , [9]], [
          ,
          ,
          "1(?:5\\d|8[35-7])\\d{6}",
          ,
          ,
          ,
          "153123456"
        ], [, , "(?:1[0-2]|9[0-3569])\\d{7}", , , , "911231234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SD", 249, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SE: [, [, , "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", , , , , , , [6, 7, 8, 9, 10, 12]], [
          ,
          ,
          "(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
          ,
          ,
          ,
          "8123456",
          ,
          ,
          [7, 8, 9]
        ], [, , "7[02369]\\d{7}", , , , "701234567", , , [9]], [, , "20\\d{4,7}", , , , "20123456", , , [6, 7, 8, 9]], [, , "649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", , , , "9001234567", , , [7, 8, 9, 10]], [, , "77[0-7]\\d{6}", , , , "771234567", , , [9]], [, , "75[1-8]\\d{6}", , , , "751234567", , , [9]], [, , , , , , , , , [-1]], "SE", 46, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1"], [, "(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1"], [
          ,
          "(\\d{2})(\\d{3})(\\d{2})",
          "$1-$2 $3",
          ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],
          "0$1"
        ], [, "(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1"], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1"], [
          ,
          "(\\d)(\\d{3})(\\d{3})(\\d{2})",
          "$1-$2 $3 $4",
          ["8"],
          "0$1"
        ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1"]], [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["20"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["9(?:00|39|44|9)"]], [, "(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"]], [
          ,
          "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["8"]
        ], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1 $2 $3", ["9(?:00|39|44)"]], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["10|7"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["8"]], [
          ,
          "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]
        ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["9"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]"]]], [, , "74[02-9]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , "10[1-8]\\d{6}", , , , "102345678", , , [9]], , , [, , "(?:25[245]|67[3-68])\\d{9}", , , , "254123456789", , , [12]]],
        SG: [, [, , "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", , , , , , , [8, 10, 11]], [
          ,
          ,
          "662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
          ,
          ,
          ,
          "61234567",
          ,
          ,
          [8]
        ], [, , "(?:8(?:0(?:[1-8]\\d|9[0-689])|[1-8]\\d\\d|9(?:[0-4]\\d|5[0-3]|62))|9[0-8]\\d\\d)\\d{4}", , , , "81234567", , , [8]], [, , "(?:18|8)00\\d{7}", , , , "18001234567", , , [10, 11]], [, , "1900\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:3[12]\\d|666)\\d{5}", , , , "31234567", , , [8]], "SG", 65, "0[0-3]\\d", , , , , , , , [[, "(\\d{4,5})", "$1", ["1[013-9]|77", "1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], [
          ,
          "(\\d{3})(\\d{3})(\\d{4})",
          "$1 $2 $3",
          ["8"]
        ], [, "(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [[, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7000\\d{7}", , , , "70001234567", , , [11]], , , [, , , , , , , , , [-1]]],
        SH: [, [, , "(?:[256]\\d|8)\\d{3}", , , , , , , [4, 5]], [, , "2(?:[0-57-9]\\d|6[4-9])\\d\\d", , , , "22158"], [
          ,
          ,
          "[56]\\d{4}",
          ,
          ,
          ,
          "51234",
          ,
          ,
          [5]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "262\\d\\d", , , , "26212", , , [5]], "SH", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], 1, "[256]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SI: [, [, , "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", , , , , , , [5, 6, 7, 8]], [, , "(?:[1-357][2-8]|4[24-8])\\d{6}", , , , "12345678", , , [8], [7]], [, , "65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", , , , "31234567", , , [8]], [, , "80\\d{4,6}", , , , "80123456", , , [6, 7, 8]], [
          ,
          ,
          "89[1-3]\\d{2,5}|90\\d{4,6}",
          ,
          ,
          ,
          "90123456"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", , , , "59012345", , , [8]], "SI", 386, "00|10(?:22|66|88|99)", "0", , , "0", , "00", , [[, "(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        SJ: [, [, , "0\\d{4}|(?:[489]\\d|79)\\d{6}", , , , , , , [5, 8]], [, , "79\\d{6}", , , , "79123456", , , [8]], [, , "(?:4[015-8]|9\\d)\\d{6}", , , , "41234567", , , [8]], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "SJ", 47, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "79", [, , , , , , , , , [-1]], [, , "(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [
          ,
          ,
          "81[23]\\d{5}",
          ,
          ,
          ,
          "81212345",
          ,
          ,
          [8]
        ]],
        SK: [, [, , "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", , , , , , , [6, 7, 9]], [, , "(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d", , , , "221234567"], [, , "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", , , , "912123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "9(?:00|[78]\\d)\\d{6}", , , , "900123456", , , [9]], [, , "8[5-9]\\d{7}", , , , "850123456", , , [9]], [, , , , , , , , , [-1]], [
          ,
          ,
          "6(?:02|5[0-4]|9[0-6])\\d{6}",
          ,
          ,
          ,
          "690123456",
          ,
          ,
          [9]
        ], "SK", 421, "00", "0", , , "0", , , , [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], [, "(\\d{4})(\\d{3})", "$1 $2", ["909", "9090"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [
          ,
          "(\\d{2})(\\d{2})(\\d{2,3})",
          "$1 $2 $3",
          ["[3-5][1-8]1", "[3-5][1-8]1[67]"],
          "0$1"
        ], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], [, , "9090\\d{3}", , , , "9090123", , , [7]], , , [, , "9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}", , , , , , , [7, 9]], [, , "96\\d{7}", , , , "961234567", , , [9]], , , [, , , , , , , , , [-1]]],
        SL: [, [, , "(?:[237-9]\\d|66)\\d{6}", , , , , , , [8], [6]], [, , "22[2-4][2-9]\\d{4}", , , , "22221234", , , , [6]], [
          ,
          ,
          "(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}",
          ,
          ,
          ,
          "25123456"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SL", 232, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SM: [, [, , "(?:0549|[5-7]\\d)\\d{6}", , , , , , , [8, 10], [6]], [, , "0549(?:8[0157-9]|9\\d)\\d{4}", , , , "0549886377", , , [10], [6]], [, , "6[16]\\d{6}", , , , "66661212", , , [8]], [, , , , , , , , , [-1]], [, , "7[178]\\d{6}", , , , "71123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          "5[158]\\d{6}",
          ,
          ,
          ,
          "58001110",
          ,
          ,
          [8]
        ], "SM", 378, "00", , , , "([89]\\d{5})$", "0549$1", , , [[, "(\\d{6})", "$1", ["[89]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SN: [, [, , "(?:[378]\\d|93)\\d{7}", , , , , , , [9]], [, , "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}", , , , "301012345"], [
          ,
          ,
          "7(?:(?:[06-8]\\d|[19]0|21)\\d|5(?:0[01]|[19]0|2[25]|[38]3|[4-7]\\d))\\d{5}",
          ,
          ,
          ,
          "701234567"
        ], [, , "800\\d{6}", , , , "800123456"], [, , "88[4689]\\d{6}", , , , "884123456"], [, , "81[02468]\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}", , , , "933301234"], "SN", 221, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SO: [, [, , "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", , , , , , , [6, 7, 8, 9]], [
          ,
          ,
          "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",
          ,
          ,
          ,
          "4012345",
          ,
          ,
          [6, 7]
        ], [, , "(?:(?:15|(?:3[59]|4[89]|6\\d|7[79]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", , , , "71123456", , , [7, 8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SO", 252, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], [, "(\\d{6})", "$1", ["[134]"]], [, "(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], [
          ,
          "(\\d)(\\d{7})",
          "$1 $2",
          ["(?:2|90)4|[67]"]
        ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], [, "(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SR: [, [, , "(?:[2-5]|68|[78]\\d)\\d{5}", , , , , , , [6, 7]], [, , "(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}", , , , "211234"], [, , "(?:7[124-7]|8[124-9])\\d{5}", , , , "7412345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "56\\d{4}", , , , "561234", , , [6]], "SR", 597, "00", , , , , , , , [[
          ,
          "(\\d{2})(\\d{2})(\\d{2})",
          "$1-$2-$3",
          ["56"]
        ], [, "(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SS: [, [, , "[19]\\d{8}", , , , , , , [9]], [, , "1[89]\\d{7}", , , , "181234567"], [, , "(?:12|9[1257-9])\\d{7}", , , , "977123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SS", 211, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        ST: [, [, , "(?:22|9\\d)\\d{5}", , , , , , , [7]], [, , "22\\d{5}", , , , "2221234"], [, , "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}", , , , "9812345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ST", 239, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SV: [, [, , "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", , , , , , , [7, 8, 11]], [
          ,
          ,
          "2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}",
          ,
          ,
          ,
          "21234567",
          ,
          ,
          [8]
        ], [, , "[67]\\d{7}", , , , "70123456", , , [8]], [, , "800\\d{8}|80[01]\\d{4}", , , , "8001234", , , [7, 11]], [, , "900\\d{4}(?:\\d{4})?", , , , "9001234", , , [7, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SV", 503, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SX: [
          ,
          [, , "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
          [
            ,
            ,
            "7215(?:4[2-8]|8[239]|9[056])\\d{4}",
            ,
            ,
            ,
            "7215425678",
            ,
            ,
            ,
            [7]
          ],
          [, , "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}", , , , "7215205678", , , , [7]],
          [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
          [, , "900[2-9]\\d{6}", , , , "9002123456"],
          [, , , , , , , , , [-1]],
          [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
          [, , , , , , , , , [-1]],
          "SX",
          1,
          "011",
          "1",
          ,
          ,
          "(5\\d{6})$|1",
          "721$1",
          ,
          ,
          ,
          ,
          [, , , , , , , , , [-1]],
          ,
          "721",
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        SY: [, [, , "[1-39]\\d{8}|[1-5]\\d{7}", , , , , , , [8, 9], [6, 7]], [, , "21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}", , , , "112345678", , , , [6, 7]], [, , "9[1-689]\\d{7}", , , , "944567890", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SY", 963, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", , 1], [
          ,
          "(\\d{3})(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["9"],
          "0$1",
          ,
          1
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SZ: [, [, , "0800\\d{4}|(?:[237]\\d|900)\\d{6}", , , , , , , [8, 9]], [, , "[23][2-5]\\d{6}", , , , "22171234", , , [8]], [, , "7[6-9]\\d{6}", , , , "76123456", , , [8]], [, , "0800\\d{4}", , , , "08001234", , , [8]], [, , "900\\d{6}", , , , "900012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70\\d{6}", , , , "70012345", , , [8]], "SZ", 268, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["9"]]], , [, , , , , , , , , [-1]], , , [
          ,
          ,
          "0800\\d{4}",
          ,
          ,
          ,
          ,
          ,
          ,
          [8]
        ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TA: [, [, , "8\\d{3}", , , , , , , [4]], [, , "8\\d{3}", , , , "8999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TA", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "8", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TC: [, [, , "(?:[58]\\d\\d|649|900)\\d{7}", , , , , , , [10], [7]], [, , "649(?:266|712|9(?:4\\d|50))\\d{4}", , , , "6497121234", , , , [7]], [, , "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}", , , , "6492311234", , , , [7]], [
          ,
          ,
          "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "8002345678"
        ], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "649(?:71[01]|966)\\d{4}", , , , "6497101234", , , , [7]], "TC", 1, "011", "1", , , "([2-479]\\d{6})$|1", "649$1", , , , , [, , , , , , , , , [-1]], , "649", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TD: [, [, , "(?:22|[689]\\d|77)\\d{6}", , , , , , , [8]], [, , "22(?:[37-9]0|5[0-5]|6[89])\\d{4}", , , , "22501234"], [, , "(?:[69]\\d|77|8[56])\\d{6}", , , , "63012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TD", 235, "00|16", , , , , , "00", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TG: [, [, , "[279]\\d{7}", , , , , , , [8]], [, , "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}", , , , "22212345"], [
          ,
          ,
          "(?:7[019]|9[0-36-9])\\d{6}",
          ,
          ,
          ,
          "90112345"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TG", 228, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TH: [, [, , "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", , , , , , , [8, 9, 10, 13]], [, , "(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", , , , "21234567", , , [8]], [, , "67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", , , , "812345678", , , [9]], [
          ,
          ,
          "(?:001800\\d|1800)\\d{6}",
          ,
          ,
          ,
          "1800123456",
          ,
          ,
          [10, 13]
        ], [, , "1900\\d{6}", , , , "1900123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "6[08]\\d{7}", , , , "601234567", , , [9]], "TH", 66, "00[1-9]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TJ: [, [, , "[0-57-9]\\d{8}", , , , , , , [9], [3, 5, 6, 7]], [
          ,
          ,
          "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}",
          ,
          ,
          ,
          "372123456",
          ,
          ,
          ,
          [3, 5, 6, 7]
        ], [, , "(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[017]|2[02]|[34]0|5[05]|7[01578]|8[078])\\d{7}", , , , "917123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TJ", 992, "810", , , , , , "8~10", , [[, "(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], [, "(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TK: [, [, , "[2-47]\\d{3,6}", , , , , , , [4, 5, 6, 7]], [, , "(?:2[2-4]|[34]\\d)\\d{2,5}", , , , "3101"], [, , "7[2-4]\\d{2,5}", , , , "7290"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TK", 690, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TL: [
          ,
          [, , "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", , , , , , , [7, 8]],
          [, , "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", , , , "2112345", , , [7]],
          [, , "7[2-8]\\d{6}", , , , "77212345", , , [8]],
          [, , "80\\d{5}", , , , "8012345", , , [7]],
          [, , "90\\d{5}", , , , "9012345", , , [7]],
          [, , , , , , , , , [-1]],
          [, , "70\\d{5}", , , , "7012345", , , [7]],
          [, , , , , , , , , [-1]],
          "TL",
          670,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["7"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        TM: [, [, , "(?:[1-6]\\d|71)\\d{6}", , , , , , , [8]], [, , "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}", , , , "12345678"], [
          ,
          ,
          "(?:6\\d|71)\\d{6}",
          ,
          ,
          ,
          "66123456"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TM", 993, "810", "8", , , "8", , "8~10", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TN: [, [, , "[2-57-9]\\d{7}", , , , , , , [8]], [, , "81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}", , , , "30010123"], [
          ,
          ,
          "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",
          ,
          ,
          ,
          "20123456"
        ], [, , "8010\\d{4}", , , , "80101234"], [, , "88\\d{6}", , , , "88123456"], [, , "8[12]10\\d{4}", , , , "81101234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TN", 216, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TO: [, [, , "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", , , , , , , [5, 7]], [, , "(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", , , , "20123", , , [5]], [
          ,
          ,
          "(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
          ,
          ,
          ,
          "7715123",
          ,
          ,
          [7]
        ], [, , "0800\\d{3}", , , , "0800222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "55[0-37-9]\\d{4}", , , , "5510123", , , [7]], "TO", 676, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], [, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TR: [, [, , "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", , , , , , , [7, 10, 12, 13]], [
          ,
          ,
          "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
          ,
          ,
          ,
          "2123456789",
          ,
          ,
          [10]
        ], [, , "561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", , , , "5012345678", , , [10]], [, , "8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", , , , "8001234567", , , [10, 12, 13]], [, , "(?:8[89]8|900)\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , "592(?:21[12]|461)\\d{4}", , , , "5922121234", , , [10]], [, , "850\\d{7}", , , , "8500123456", , , [10]], "TR", 90, "00", "0", , , "0", , , , [
          [, "(\\d{3})(\\d)(\\d{3})", "$1 $2 $3", ["444"], , , 1],
          [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", , 1],
          [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", , 1],
          [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", , 1],
          [, "(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", , 1]
        ], [[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", , 1], [
          ,
          "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["[24][1-8]|3[1-9]"],
          "(0$1)",
          ,
          1
        ], [, "(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", , 1]], [, , "512\\d{7}", , , , "5123456789", , , [10]], , , [, , "(?:444|811\\d{3})\\d{4}", , , , , , , [7, 10]], [, , "444\\d{4}", , , , "4441444", , , [7]], , , [, , , , , , , , , [-1]]],
        TT: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}", , , , "8682211234", , , , [7]], [
          ,
          ,
          "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}",
          ,
          ,
          ,
          "8682911234",
          ,
          ,
          ,
          [7]
        ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "TT", 1, "011", "1", , , "([2-46-8]\\d{6})$|1", "868$1", , , , , [, , , , , , , , , [-1]], , "868", [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , [, , "868619\\d{4}", , , , "8686191234", , , , [7]]],
        TV: [, [, , "(?:2|7\\d\\d|90)\\d{4}", , , , , , , [5, 6, 7]], [, , "2[02-9]\\d{3}", , , , "20123", , , [5]], [, , "(?:7[01]\\d|90)\\d{4}", , , , "901234", , , [6, 7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TV", 688, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2"]], [, "(\\d{2})(\\d{4})", "$1 $2", ["90"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TW: [, [
          ,
          ,
          "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
          ,
          ,
          ,
          ,
          ,
          ,
          [7, 8, 9, 10, 11]
        ], [
          ,
          ,
          "(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
          ,
          ,
          ,
          "221234567",
          ,
          ,
          [8, 9]
        ], [, , "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", , , , "912345678", , , [9]], [, , "80[0-79]\\d{6}|800\\d{5}", , , , "800123456", , , [8, 9]], [, , "20(?:[013-9]\\d\\d|2)\\d{4}", , , , "203123456", , , [7, 9]], [, , , , , , , , , [-1]], [, , "99\\d{7}", , , , "990123456", , , [9]], [, , "7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", , , , "7012345678", , , [10, 11]], "TW", 886, "0(?:0[25-79]|19)", "0", "#", , "0", , , , [[, "(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], [
          ,
          "(\\d)(\\d{3,4})(\\d{4})",
          "$1 $2 $3",
          ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],
          "0$1"
        ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "50[0-46-9]\\d{6}", , , , "500123456", , , [9]], , , [, , , , , , , , , [-1]]],
        TZ: [
          ,
          [, , "(?:[25-8]\\d|41|90)\\d{7}", , , , , , , [9]],
          [, , "2[2-8]\\d{7}", , , , "222345678"],
          [, , "(?:6[125-9]|7[13-9])\\d{7}", , , , "621234567"],
          [, , "80[08]\\d{6}", , , , "800123456"],
          [, , "90\\d{7}", , , , "900123456"],
          [, , "8(?:40|6[01])\\d{6}", , , , "840123456"],
          [, , , , , , , , , [-1]],
          [, , "41\\d{7}", , , , "412345678"],
          "TZ",
          255,
          "00[056]",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["5"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , "(?:8(?:[04]0|6[01])|90\\d)\\d{6}"],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        UA: [, [, , "[89]\\d{9}|[3-9]\\d{8}", , , , , , , [9, 10], [5, 6, 7]], [
          ,
          ,
          "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
          ,
          ,
          ,
          "311234567",
          ,
          ,
          [9],
          [5, 6, 7]
        ], [, , "790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}", , , , "501234567", , , [9]], [, , "800[1-8]\\d{5,6}", , , , "800123456"], [, , "900[239]\\d{5,6}", , , , "900212345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "89[1-579]\\d{6}", , , , "891234567", , , [9]], "UA", 380, "00", "0", , , "0", , "0~0", , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], [
          ,
          "(\\d{4})(\\d{5})",
          "$1 $2",
          ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],
          "0$1"
        ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        UG: [, [, , "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", , , , , , , [9], [5, 6, 7]], [
          ,
          ,
          "20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
          ,
          ,
          ,
          "312345678",
          ,
          ,
          ,
          [5, 6, 7]
        ], [, , "72[48]0\\d{5}|7(?:[015-8]\\d|2[067]|36|4[0-5]|9[89])\\d{6}", , , , "712345678"], [, , "800[1-3]\\d{5}", , , , "800123456"], [, , "90[1-3]\\d{6}", , , , "901123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UG", 256, "00[057]", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        US: [, [
          ,
          ,
          "[2-9]\\d{9}|3\\d{6}",
          ,
          ,
          ,
          ,
          ,
          ,
          [10],
          [7]
        ], [
          ,
          ,
          "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
          ,
          ,
          ,
          "2015550123",
          ,
          ,
          ,
          [7]
        ], [
          ,
          ,
          "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
          ,
          ,
          ,
          "2015550123",
          ,
          ,
          ,
          [7]
        ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "305209\\d{4}", , , , "3052090123", , , , [7]], "US", 1, "011", "1", , , "1", , , 1, [
          [, "(\\d{3})(\\d{4})", "$1-$2", ["310"], , , 1],
          [, "(\\d{3})(\\d{4})", "$1-$2", ["[24-9]|3(?:[02-9]|1[1-9])"]],
          [, "(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], , , 1]
        ], [[, "(\\d{3})(\\d{4})", "$1-$2", ["310"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-9]"]]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        UY: [, [, , "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", , , , , , , [6, 7, 8, 9, 10, 11, 12, 13]], [, , "(?:1(?:770|9(?:20|[89]7))|(?:2\\d|4[2-7])\\d\\d)\\d{4}", , , , "21231234", , , [8], [7]], [, , "9[1-9]\\d{6}", , , , "94231234", , , [8]], [
          ,
          ,
          "0004\\d{2,9}|(?:405|80[05])\\d{4}",
          ,
          ,
          ,
          "8001234"
        ], [, , "90[0-8]\\d{4}", , , , "9001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UY", 598, "0(?:0|1[3-9]\\d)", "0", " int. ", , "0", , "00", , [[, "(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], [, "(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        UZ: [, [, , "(?:20|33|[5-79]\\d|88)\\d{7}", , , , , , , [9]], [, , "(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|[69]\\d\\d|7(?:[23]\\d|7[69]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|[68]\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}", , , , "669050123"], [
          ,
          ,
          "(?:(?:[25]0|33|88|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
          ,
          ,
          ,
          "912345678"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UZ", 998, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        VA: [, [, , "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [, , "06698\\d{1,6}", , , , "0669812345", , , [6, 7, 8, 9, 10, 11]], [, , "3[1-9]\\d{8}|3[2-9]\\d{7}", , , , "3123456789", , , [9, 10]], [
          ,
          ,
          "80(?:0\\d{3}|3)\\d{3}",
          ,
          ,
          ,
          "800123456",
          ,
          ,
          [6, 9]
        ], [, , "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "VA", 39, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "06698", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]],
        VC: [
          ,
          [, , "(?:[58]\\d\\d|784|900)\\d{7}", , , , , , , [10], [7]],
          [, , "784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}", , , , "7842661234", , , , [7]],
          [, , "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}", , , , "7844301234", , , , [7]],
          [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
          [, , "900[2-9]\\d{6}", , , , "9002345678"],
          [, , , , , , , , , [-1]],
          [
            ,
            ,
            "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
            ,
            ,
            ,
            "5002345678"
          ],
          [, , "78451[0-2]\\d{4}", , , , "7845101234", , , , [7]],
          "VC",
          1,
          "011",
          "1",
          ,
          ,
          "([2-7]\\d{6})$|1",
          "784$1",
          ,
          ,
          ,
          ,
          [, , , , , , , , , [-1]],
          ,
          "784",
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        VE: [
          ,
          [, , "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", , , , , , , [10], [7]],
          [, , "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}", , , , "2121234567", , , , [7]],
          [, , "4(?:1[24-8]|2[46])\\d{7}", , , , "4121234567"],
          [, , "800\\d{7}", , , , "8001234567"],
          [, , "90[01]\\d{7}", , , , "9001234567"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "VE",
          58,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1", "$CC $1"]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , "501\\d{7}", , , , "5010123456", , , , [7]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        VG: [, [, , "(?:284|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}", , , , "2842291234", , , , [7]], [, , "284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}", , , , "2843001234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [
          ,
          ,
          "900[2-9]\\d{6}",
          ,
          ,
          ,
          "9002345678"
        ], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VG", 1, "011", "1", , , "([2-578]\\d{6})$|1", "284$1", , , , , [, , , , , , , , , [-1]], , "284", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        VI: [, [, , "[58]\\d{9}|(?:34|90)0\\d{7}", , , , , , , [10], [7]], [
          ,
          ,
          "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
          ,
          ,
          ,
          "3406421234",
          ,
          ,
          ,
          [7]
        ], [, , "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}", , , , "3406421234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ], [, , , , , , , , , [-1]], "VI", 1, "011", "1", , , "([2-9]\\d{6})$|1", "340$1", , 1, , , [, , , , , , , , , [-1]], , "340", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        VN: [, [, , "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", , , , , , , [7, 8, 9, 10]], [, , "2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", , , , "2101234567", , , [10]], [, , "(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", , , , "912345678", , , [9]], [
          ,
          ,
          "1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
          ,
          ,
          ,
          "1800123456",
          ,
          ,
          [8, 9, 10]
        ], [, , "1900\\d{4,6}", , , , "1900123456", , , [8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "672\\d{6}", , , , "672012345", , , [9]], "VN", 84, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[17]99"], "0$1", , 1], [, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["69"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", , 1], [
          ,
          "(\\d{2})(\\d{4})(\\d{4})",
          "$1 $2 $3",
          ["2[48]"],
          "0$1",
          ,
          1
        ], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [[, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", , 1], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [, , , , , , , , , [-1]], , , [, , "[17]99\\d{4}|69\\d{5,6}", , , , , , , [7, 8]], [
          ,
          ,
          "(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
          ,
          ,
          ,
          "1992000",
          ,
          ,
          [7, 8]
        ], , , [, , , , , , , , , [-1]]],
        VU: [
          ,
          [, , "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", , , , , , , [5, 7]],
          [, , "(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", , , , "22123", , , [5]],
          [, , "(?:[58]\\d|7[013-7])\\d{5}", , , , "5912345", , , [7]],
          [, , "81[18]\\d\\d", , , , "81123", , , [5]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "9(?:0[1-9]|1[01])\\d{4}", , , , "9010123", , , [7]],
          "VU",
          678,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , "(?:3[03]|900\\d)\\d{3}", , , , "30123"],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        WF: [, [, , "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", , , , , , , [6, 9]], [, , "72\\d{4}", , , , "721234", , , [6]], [, , "(?:72|8[23])\\d{4}", , , , "821234", , , [6]], [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WF", 681, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "[48]0\\d{4}", , , , "401234", , , [6]]],
        WS: [, [
          ,
          ,
          "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
          ,
          ,
          ,
          ,
          ,
          ,
          [5, 6, 7, 10]
        ], [, , "6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", , , , "22123", , , [5, 6]], [, , "(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}", , , , "7212345", , , [7, 10]], [, , "800\\d{3}", , , , "800123", , , [6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WS", 685, "0", , , , , , , , [[, "(\\d{5})", "$1", ["[2-5]|6[1-9]"]], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        XK: [
          ,
          [
            ,
            ,
            "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
            ,
            ,
            ,
            ,
            ,
            ,
            [8, 9, 10, 11, 12]
          ],
          [, , "38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})", , , , "28012345"],
          [, , "4[3-9]\\d{6}", , , , "43201234", , , [8]],
          [, , "800\\d{5}", , , , "80001234", , , [8]],
          [, , "900\\d{5}", , , , "90001234", , , [8]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "XK",
          383,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], [, "(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        YE: [
          ,
          [, , "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", , , , , , , [7, 8, 9], [6]],
          [, , "78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", , , , "1234567", , , [7, 8], [6]],
          [, , "7[01378]\\d{7}", , , , "712345678", , , [9]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "YE",
          967,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        YT: [, [, , "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", , , , , , , [9]], [, , "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}", , , , "269601234"], [, , "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}", , , , "639012345"], [, , "80\\d{7}", , , , "801234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:39|47)8[01]|769\\d)\\d{4}", , , , "939801234"], "YT", 262, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        ZA: [, [, , "[1-79]\\d{8}|8\\d{4,9}", , , , , , , [5, 6, 7, 8, 9, 10]], [, , "(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", , , , "101234567", , , [9]], [, , "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d\\d|7(?:[0-46-9]\\d|5[0-4]))\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", , , , "711234567", , , [5, 6, 7, 8, 9]], [
          ,
          ,
          "80\\d{7}",
          ,
          ,
          ,
          "801234567",
          ,
          ,
          [9]
        ], [, , "(?:86[2-9]|9[0-2]\\d)\\d{6}", , , , "862345678", , , [9]], [, , "860\\d{6}", , , , "860123456", , , [9]], [, , , , , , , , , [-1]], [, , "87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}", , , , "871234567", , , [9]], "ZA", 27, "00", "0", , , "0", , , , [
          [, "(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"],
          [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"],
          [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"],
          [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"],
          [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]
        ], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "861\\d{6,7}", , , , "861123456", , , [9, 10]], , , [, , , , , , , , , [-1]]],
        ZM: [, [, , "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", , , , , , , [9], [6]], [, , "21[1-8]\\d{6}", , , , "211234567", , , , [6]], [, , "(?:7[5-79]|9[5-8])\\d{7}", , , , "955123456"], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "63\\d{7}", , , , "630123456"], "ZM", 260, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[1-9]"]], [
          ,
          "(\\d{3})(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["[28]"],
          "0$1"
        ], [, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        ZW: [, [, , "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", , , , , , , [5, 6, 7, 8, 9, 10], [3, 4]], [
          ,
          ,
          "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
          ,
          ,
          ,
          "1312345",
          ,
          ,
          ,
          [3, 4]
        ], [, , "7(?:[1278]\\d|3[1-9])\\d{6}", , , , "712345678", , , [9]], [, , "80(?:[01]\\d|20|8[0-8])\\d{3}", , , , "8001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", , , , "8686123456", , , [10]], "ZW", 263, "00", "0", , , "0", , , , [
          [, "(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"],
          [, "(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"],
          [, "(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"],
          [, "(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"],
          [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
          [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"],
          [, "(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"],
          [
            ,
            "(\\d{2})(\\d{3,5})",
            "$1 $2",
            ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],
            "0$1"
          ],
          [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"],
          [, "(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]
        ], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        800: [
          ,
          [, , "(?:00|[1-9]\\d)\\d{6}", , , , , , , [8]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "(?:00|[1-9]\\d)\\d{6}", , , , "12345678"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "001",
          800,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          1,
          [[, "(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        808: [, [, , "[1-9]\\d{7}", , , , , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[1-9]\\d{7}", , , , "12345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 808, , , , , , , , 1, [[, "(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        870: [, [, , "7\\d{11}|[35-7]\\d{8}", , , , , , , [9, 12]], [, , , , , , , , , [-1]], [, , "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}", , , , "301234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], "001", 870, , , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        878: [, [, , "10\\d{10}", , , , , , , [12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "10\\d{10}", , , , "101234567890"], "001", 878, , , , , , , , 1, [[, "(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        881: [
          ,
          [, , "6\\d{9}|[0-36-9]\\d{8}", , , , , , , [9, 10]],
          [, , , , , , , , , [-1]],
          [, , "6\\d{9}|[0-36-9]\\d{8}", , , , "612345678"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "001",
          881,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], [, "(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        882: [, [, , "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", , , , , , , [7, 8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [
          ,
          ,
          "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
          ,
          ,
          ,
          "3421234",
          ,
          ,
          [7, 8, 9, 10, 12]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}", , , , "390123456789"], "001", 882, , , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], [, "(\\d{2})(\\d{6})", "$1 $2", ["49"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], [, "(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], [
          ,
          "(\\d{2})(\\d{3,4})(\\d{4})",
          "$1 $2 $3",
          ["16"]
        ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], [, "(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "348[57]\\d{7}", , , , "34851234567", , , [11]]],
        883: [, [, , "(?:[1-4]\\d|51)\\d{6,10}", , , , , , , [8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}",
          ,
          ,
          ,
          "510012345"
        ], "001", 883, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], [, "(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        888: [, [, , "\\d{11}", , , , , , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 888, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "\\d{11}", , , , "12345678901"], , , [, , , , , , , , , [-1]]],
        979: [, [, , "[1359]\\d{8}", , , , , , , [9], [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[1359]\\d{8}", , , , "123456789", , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 979, , , , , , , , 1, [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]]
      };
      function Le() {
        this.g = {};
      }
      d(Le);
      var Ne = { 0: "0", 1: "1", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", "０": "0", "１": "1", "２": "2", "３": "3", "４": "4", "５": "5", "６": "6", "７": "7", "８": "8", "９": "9", "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4", "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9", "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4", "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9" }, Ye = {
        0: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        "+": "+",
        "*": "*",
        "#": "#"
      }, qe = {
        0: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        "０": "0",
        "１": "1",
        "２": "2",
        "３": "3",
        "４": "4",
        "５": "5",
        "６": "6",
        "７": "7",
        "８": "8",
        "９": "9",
        "٠": "0",
        "١": "1",
        "٢": "2",
        "٣": "3",
        "٤": "4",
        "٥": "5",
        "٦": "6",
        "٧": "7",
        "٨": "8",
        "٩": "9",
        "۰": "0",
        "۱": "1",
        "۲": "2",
        "۳": "3",
        "۴": "4",
        "۵": "5",
        "۶": "6",
        "۷": "7",
        "۸": "8",
        "۹": "9",
        A: "2",
        B: "2",
        C: "2",
        D: "3",
        E: "3",
        F: "3",
        G: "4",
        H: "4",
        I: "4",
        J: "5",
        K: "5",
        L: "5",
        M: "6",
        N: "6",
        O: "6",
        P: "7",
        Q: "7",
        R: "7",
        S: "7",
        T: "8",
        U: "8",
        V: "8",
        W: "9",
        X: "9",
        Y: "9",
        Z: "9"
      }, Je = /[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/, c1 = RegExp("[+＋]+"), s1 = RegExp("^[+＋]+"), H1 = RegExp("([0-9０-９٠-٩۰-۹])"), lt = RegExp("[+＋0-9０-９٠-٩۰-۹]"), zt = /[\\\/] *x/, Bt = RegExp("[^0-9０-９٠-٩۰-۹A-Za-z#]+$"), gd = /(?:.*?[A-Za-z]){3}.*/, Pt = RegExp("^\\+([0-9０-９٠-٩۰-۹]|[\\-\\.\\(\\)]?)*[0-9０-９٠-٩۰-۹]([0-9０-９٠-٩۰-۹]|[\\-\\.\\(\\)]?)*$"), hd = RegExp("^([A-Za-z0-9０-９٠-٩۰-۹]+((\\-)*[A-Za-z0-9０-９٠-٩۰-۹])*\\.)*[A-Za-z]+((\\-)*[A-Za-z0-9０-９٠-٩۰-۹])*\\.?$");
      function f1(o) {
        return "([0-9０-９٠-٩۰-۹]{1," + o + "})";
      }
      function o1() {
        return ";ext=" + f1("20") + "|[  \\t,]*(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)[:\\.．]?[  \\t,-]*" + (f1("20") + "#?|[  \\t,]*(?:[xｘ#＃~～]|int|ｉｎｔ)[:\\.．]?[  \\t,-]*") + (f1("9") + "#?|[- ]+") + (f1("6") + "#|[  \\t]*(?:,{2}|;)[:\\.．]?[  \\t,-]*") + (f1("15") + "#?|[  \\t]*(?:,)+[:\\.．]?[  \\t,-]*") + (f1("9") + "#?");
      }
      var G1 = new RegExp("(?:" + o1() + ")$", "i"), it = new RegExp("^[0-9０-９٠-٩۰-۹]{2}$|^[+＋]*(?:[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～*]*[0-9０-９٠-٩۰-۹]){3,}[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～*A-Za-z0-9０-９٠-٩۰-۹]*(?:" + o1() + ")?$", "i"), U1 = /(\$\d)/, ut = /^\(?\$1\)?$/;
      function Vt(o) {
        return 2 > o.length ? !1 : a1(it, o);
      }
      function Ot(o) {
        return a1(gd, o) ? E1(o, qe) : E1(o, Ne);
      }
      function Rt(o) {
        var c = Ot(o.toString());
        se(o), o.g(c);
      }
      function Nt() {
        return Object.keys(we).filter(function(o) {
          return isNaN(o);
        });
      }
      function vd() {
        return Object.keys(we).filter(function(o) {
          return !isNaN(o);
        }).map(function(o) {
          return parseInt(o, 10);
        });
      }
      function Ft() {
        var o = Object.keys(ge);
        return [...vd(), ...o.map(function(c) {
          return parseInt(c, 10);
        })];
      }
      function E1(o, c) {
        for (var w = new ve(), A, D = o.length, F = 0; F < D; ++F) A = o.charAt(F), A = c[A.toUpperCase()], A != null && w.g(A);
        return w.toString();
      }
      function ct(o) {
        return o.length == 0 || ut.test(o);
      }
      function w1(o) {
        return o != null && isNaN(o) && o.toUpperCase() in we;
      }
      Le.prototype.format = function(o, c) {
        if (B(o, 2) == 0 && U(o, 5)) {
          var w = V(o, 5);
          if (0 < w.length) return w;
        }
        w = V(o, 1);
        var A = C1(o);
        if (c == 0) return yd(w, 0, A, "");
        if (!(w in ge)) return A;
        var D = v1(this, w, k1(w));
        return o = x0(o, D, c), A = b0(A, D, c), yd(w, c, A, o);
      };
      function v1(o, c, w) {
        return w == "001" ? $1(o, "" + c) : $1(o, w);
      }
      function bd(o, c) {
        var w = Ke;
        if (!w1(c)) return w.format(o, 1);
        var A = V(o, 1), D = C1(o);
        if (!(A in ge)) return D;
        if (A == 1) {
          if (c != null && ge[1].includes(c.toUpperCase())) return A + " " + w.format(o, 2);
        } else if (A == ft(w, c)) return w.format(o, 2);
        var F = $1(w, c), Q = V(F, 11);
        return c = "", U(F, 17) ? c = V(F, 17) : a1(Je, Q) && (c = Q), w = v1(w, A, k1(A)), D = b0(D, w, 1), o = x0(o, w, 1), 0 < c.length ? c + " " + A + " " + D + o : yd(A, 1, D, o);
      }
      function C1(o) {
        if (!U(o, 2)) return "";
        var c = "" + B(o, 2);
        return U(o, 4) && B(o, 4) && 0 < V(o, 8) ? Array(V(o, 8) + 1).join("0") + c : c;
      }
      function yd(o, c, w, A) {
        switch (c) {
          case 0:
            return "+" + o + w + A;
          case 1:
            return "+" + o + " " + w + A;
          case 3:
            return "tel:+" + o + "-" + w + A;
          default:
            return w + A;
        }
      }
      function b0(o, c, w) {
        c = q(c, 20).length == 0 || w == 2 ? q(c, 19) : q(c, 20);
        e: {
          for (var A, D = c.length, F = 0; F < D; ++F) {
            A = c[F];
            var Q = J(A, 3);
            if ((Q == 0 || o.search(B(A, 3, Q - 1)) == 0) && (Q = new RegExp(B(A, 1)), a1(Q, o))) {
              c = A;
              break e;
            }
          }
          c = null;
        }
        return c == null || (D = c, c = V(D, 2), A = new RegExp(B(D, 1)), V(D, 5), D = V(D, 4), o = w == 2 && D != null && 0 < D.length ? o.replace(A, c.replace(U1, D)) : o.replace(A, c), w == 3 && (o = o.replace(RegExp("^[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]+"), ""), o = o.replace(RegExp("[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]+", "g"), "-"))), w = o, w;
      }
      function y0(o, c) {
        var w = Ke;
        if (!w1(o)) return null;
        c = w0($1(w, o), c);
        try {
          if (U(c, 6)) {
            var A = B(c, 6);
            return Cd(w, A, o);
          }
        } catch {
        }
        return null;
      }
      function x0(o, c, w) {
        return U(o, 3) && B(o, 3).length != 0 ? w == 3 ? ";ext=" + B(o, 3) : U(c, 13) ? B(c, 13) + V(o, 3) : " ext. " + V(o, 3) : "";
      }
      function w0(o, c) {
        switch (c) {
          case 4:
            return B(o, 5);
          case 3:
            return B(o, 4);
          case 1:
            return B(o, 3);
          case 0:
          case 2:
            return B(o, 2);
          case 5:
            return B(o, 6);
          case 6:
            return B(o, 8);
          case 7:
            return B(o, 7);
          case 8:
            return B(o, 21);
          case 9:
            return B(o, 25);
          case 10:
            return B(o, 28);
          default:
            return B(o, 1);
        }
      }
      function xd(o, c) {
        return e1(o, B(c, 1)) ? e1(o, B(c, 5)) ? 4 : e1(o, B(c, 4)) ? 3 : e1(o, B(c, 6)) ? 5 : e1(o, B(c, 8)) ? 6 : e1(o, B(c, 7)) ? 7 : e1(o, B(c, 21)) ? 8 : e1(o, B(c, 25)) ? 9 : e1(o, B(c, 28)) ? 10 : e1(o, B(c, 2)) ? B(c, 18) || e1(o, B(c, 3)) ? 2 : 0 : !B(c, 18) && e1(o, B(c, 3)) ? 1 : -1 : -1;
      }
      function $1(o, c) {
        if (c == null) return null;
        c = c.toUpperCase();
        var w = o.g[c];
        if (w == null) {
          if (w = we[c], w == null) return null;
          w = new ie().g(Me.o(), w), o.g[c] = w;
        }
        return w;
      }
      function e1(o, c) {
        var w = o.length;
        return 0 < J(c, 9) && q(c, 9).indexOf(w) == -1 ? !1 : a1(V(c, 2), o);
      }
      function C0(o) {
        var c = Ke, w = _t(c, o), A = V(o, 1), D = v1(c, A, w);
        return D == null || w != "001" && A != ft(c, w) ? D = !1 : (o = C1(o), D = xd(o, D) != -1), D;
      }
      function _t(o, c) {
        if (c == null) return null;
        var w = V(c, 1);
        if (w = ge[w], w == null) o = null;
        else if (w.length == 1) o = w[0];
        else e: {
          c = C1(c);
          for (var A, D = w.length, F = 0; F < D; F++) {
            A = w[F];
            var Q = $1(o, A);
            if (U(Q, 23)) {
              if (c.search(B(Q, 23)) == 0) {
                o = A;
                break e;
              }
            } else if (xd(c, Q) != -1) {
              o = A;
              break e;
            }
          }
          o = null;
        }
        return o;
      }
      function k1(o) {
        return o = ge[o], o == null ? "ZZ" : o[0];
      }
      function ft(o, c) {
        if (o = $1(o, c), o == null) throw Error("Invalid region code: " + c);
        return V(o, 10);
      }
      function k0(o) {
        return o = S0(o), o == 0 || o == 4;
      }
      function wd(o, c, w, A) {
        var D = w0(w, A), F = J(D, 9) == 0 ? q(B(w, 1), 9) : q(D, 9);
        return D = q(D, 10), F[0] == -1 ? 5 : (c = c.length, -1 < D.indexOf(c) ? 4 : (w = F[0], w == c ? 0 : w > c ? 2 : F[F.length - 1] < c ? 3 : -1 < F.indexOf(c, 1) ? 0 : 5));
      }
      function S0(o) {
        var c = Ke, w = C1(o);
        return o = V(o, 1), o in ge ? (o = v1(c, o, k1(o)), wd(c, w, o, -1)) : 1;
      }
      function M0(o, c) {
        if (o = o.toString(), o.length == 0 || o.charAt(0) == "0") return 0;
        for (var w, A = o.length, D = 1; 3 >= D && D <= A; ++D) if (w = parseInt(o.substring(0, D), 10), w in ge) return c.g(o.substring(D)), w;
        return 0;
      }
      function T0(o, c, w, A, D) {
        if (c.length == 0) return 0;
        c = new ve(c);
        var F;
        w != null && (F = B(w, 11)), F == null && (F = "NonMatch");
        var Q = c.toString();
        if (Q.length == 0) F = 20;
        else if (s1.test(Q)) Q = Q.replace(s1, ""), se(c), c.g(Ot(Q)), F = 1;
        else {
          if (Q = new RegExp(F), Rt(c), F = c.toString(), F.search(Q) == 0) {
            Q = F.match(Q)[0].length;
            var pe = F.substring(Q).match(H1);
            pe && pe[1] != null && 0 < pe[1].length && E1(pe[1], Ne) == "0" ? F = !1 : (se(c), c.g(F.substring(Q)), F = !0);
          } else F = !1;
          F = F ? 5 : 20;
        }
        if (F != 20) {
          if (2 >= c.h.length) throw Error("Phone number too short after IDD");
          if (o = M0(
            c,
            A
          ), o != 0) return ee(D, 1, o), o;
          throw Error("Invalid country calling code");
        }
        return w != null && (F = V(w, 10), Q = "" + F, pe = c.toString(), pe.lastIndexOf(Q, 0) == 0 && (Q = new ve(pe.substring(Q.length)), pe = B(w, 1), pe = new RegExp(V(pe, 2)), L0(Q, w, null), Q = Q.toString(), !a1(pe, c.toString()) && a1(pe, Q) || wd(o, c.toString(), w, -1) == 3)) ? (A.g(Q), ee(D, 1, F), F) : (ee(D, 1, 0), 0);
      }
      function L0(o, c, w) {
        var A = o.toString(), D = A.length, F = B(c, 15);
        if (D != 0 && F != null && F.length != 0) {
          var Q = new RegExp("^(?:" + F + ")");
          if (D = Q.exec(A)) {
            F = new RegExp(V(B(c, 1), 2));
            var pe = a1(F, A), Ie = D.length - 1;
            c = B(c, 16), c == null || c.length == 0 || D[Ie] == null || D[Ie].length == 0 ? (!pe || a1(F, A.substring(D[0].length))) && (w != null && 0 < Ie && D[Ie] != null && w.g(D[1]), o.set(A.substring(D[0].length))) : (A = A.replace(Q, c), (!pe || a1(F, A)) && (w != null && 0 < Ie && w.g(D[1]), o.set(A)));
          }
        }
      }
      function Cd(o, c, w) {
        if (c == null) throw Error("The string supplied did not seem to be a phone number");
        if (250 < c.length) throw Error("The string supplied is too long to be a phone number");
        var A = new ve(), D = c.indexOf(";phone-context=");
        if (D === -1) D = null;
        else if (D += 15, D >= c.length) D = "";
        else {
          var F = c.indexOf(";", D);
          D = F !== -1 ? c.substring(D, F) : c.substring(D);
        }
        var Q = D;
        if (Q == null ? F = !0 : Q.length === 0 ? F = !1 : (F = Pt.exec(Q), Q = hd.exec(Q), F = F !== null || Q !== null), !F || (D != null ? (D.charAt(0) === "+" && A.g(D), D = c.indexOf("tel:"), A.g(c.substring(0 <= D ? D + 4 : 0, c.indexOf(";phone-context=")))) : (D = A.g, c = c ?? "", F = c.search(lt), 0 <= F ? (c = c.substring(F), c = c.replace(Bt, ""), F = c.search(zt), 0 <= F && (c = c.substring(0, F))) : c = "", D.call(A, c)), c = A.toString(), D = c.indexOf(";isub="), 0 < D && (se(A), A.g(c.substring(0, D))), !Vt(A.toString()))) throw Error("The string supplied did not seem to be a phone number");
        if (c = A.toString(), !(w1(w) || c != null && 0 < c.length && s1.test(c))) throw Error("Invalid country calling code");
        c = new De();
        e: {
          if (D = A.toString(), F = D.search(G1), 0 <= F && Vt(D.substring(0, F))) {
            Q = D.match(G1);
            for (var pe = Q.length, Ie = 1; Ie < pe; ++Ie) if (Q[Ie] != null && 0 < Q[Ie].length) {
              se(A), A.g(D.substring(0, F)), D = Q[Ie];
              break e;
            }
          }
          D = "";
        }
        0 < D.length && ee(c, 3, D), F = $1(o, w), D = new ve(), Q = 0, pe = A.toString();
        try {
          Q = T0(o, pe, F, D, c);
        } catch (b1) {
          if (b1.message == "Invalid country calling code" && s1.test(pe)) {
            if (pe = pe.replace(s1, ""), Q = T0(o, pe, F, D, c), Q == 0) throw b1;
          } else throw b1;
        }
        if (Q != 0 ? (A = k1(Q), A != w && (F = v1(o, Q, A))) : (Rt(A), D.g(A.toString()), w != null && (Q = V(F, 10), ee(c, 1, Q))), 2 > D.h.length || (F != null && (w = new ve(D.toString()), L0(w, F, new ve()), o = wd(o, w.toString(), F, -1), o != 2 && o != 4 && o != 5 && (D = w)), o = D.toString(), w = o.length, 2 > w)) throw Error("The string supplied is too short to be a phone number");
        if (17 < w) throw Error("The string supplied is too long to be a phone number");
        if (1 < o.length && o.charAt(0) == "0") {
          for (ee(c, 4, !0), w = 1; w < o.length - 1 && o.charAt(w) == "0"; ) w++;
          w != 1 && ee(c, 8, w);
        }
        return ee(c, 2, parseInt(o, 10)), c;
      }
      Le.prototype.ja = function(o) {
        var c = $1(this, _t(this, o));
        return c == null ? !0 : (o = C1(o), !e1(o, B(c, 24)));
      };
      function a1(o, c) {
        return !!((o = typeof o == "string" ? c.match("^(?:" + o + ")$") : c.match(o)) && o[0].length == c.length);
      }
      function l2(o) {
        this.ka = RegExp(" "), this.la = "", this.$ = new ve(), this.da = "", this.u = new ve(), this.ba = new ve(), this.v = !0, this.ea = this.ca = this.oa = !1, this.qa = Le.pa(), this.aa = 0, this.h = new ve(), this.ha = !1, this.s = "", this.g = new ve(), this.j = [], this.ma = o, this.Aa = this.m = kd(this, this.ma);
      }
      var A0 = new Me();
      ee(A0, 11, "NA");
      var i2 = RegExp("^[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]*\\$1[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]*(\\$\\d[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]*)*$"), D0 = /[- ]/;
      function kd(o, c) {
        return c = w1(c) ? ft(o.qa, c) : 0, o = $1(o.qa, k1(c)), o ?? A0;
      }
      function I0(o) {
        for (var c = o.j.length, w = 0; w < c; ++w) {
          var A = o.j[w], D = V(A, 1);
          if (o.da == D) return !1;
          var F = o, Q = A, pe = V(Q, 1);
          se(F.$);
          var Ie = F;
          Q = V(Q, 2);
          var b1 = "999999999999999".match(pe)[0];
          if (b1.length < Ie.g.h.length ? Ie = "" : (Ie = b1.replace(new RegExp(pe, "g"), Q), Ie = Ie.replace(RegExp("9", "g"), " ")), 0 < Ie.length ? (F.$.g(Ie), F = !0) : F = !1, F) return o.da = D, o.ha = D0.test(B(A, 4)), o.aa = 0, !0;
        }
        return o.v = !1;
      }
      function E0(o, c) {
        for (var w = [], A = c.length - 3, D = o.j.length, F = 0; F < D; ++F) {
          var Q = o.j[F];
          J(Q, 3) == 0 ? w.push(o.j[F]) : (Q = B(Q, 3, Math.min(A, J(Q, 3) - 1)), c.search(Q) == 0 && w.push(o.j[F]));
        }
        o.j = w;
      }
      function u2(o, c) {
        o.u.g(c);
        var w = c;
        if (H1.test(w) || o.u.h.length == 1 && c1.test(w) ? (c == "+" ? (w = c, o.ba.g(c)) : (w = Ne[c], o.ba.g(w), o.g.g(w)), c = w) : (o.v = !1, o.oa = !0), !o.v) {
          if (!o.oa) {
            if (O0(o)) {
              if (R0(o)) return z0(o);
            } else if (0 < o.s.length && (c = o.g.toString(), se(o.g), o.g.g(o.s), o.g.g(c), c = o.h.toString(), w = c.lastIndexOf(o.s), se(o.h), o.h.g(c.substring(0, w))), o.s != V0(o)) return o.h.g(" "), z0(o);
          }
          return o.u.toString();
        }
        switch (o.ba.h.length) {
          case 0:
          case 1:
          case 2:
            return o.u.toString();
          case 3:
            if (O0(o)) o.ea = !0;
            else return o.s = V0(o), Sd(o);
          default:
            return o.ea ? (R0(o) && (o.ea = !1), o.h.toString() + o.g.toString()) : 0 < o.j.length ? (c = N0(o, c), w = B0(o), 0 < w.length ? w : (E0(o, o.g.toString()), I0(o) ? P0(o) : o.v ? jt(o, c) : o.u.toString())) : Sd(o);
        }
      }
      function z0(o) {
        return o.v = !0, o.ea = !1, o.j = [], o.aa = 0, se(o.$), o.da = "", Sd(o);
      }
      function B0(o) {
        for (var c = o.g.toString(), w = o.j.length, A = 0; A < w; ++A) {
          var D = o.j[A], F = V(D, 1);
          if (new RegExp("^(?:" + F + ")$").test(c) && (o.ha = D0.test(B(D, 4)), D = c.replace(new RegExp(F, "g"), B(D, 2)), D = jt(o, D), E1(D, Ye) == o.ba)) return D;
        }
        return "";
      }
      function jt(o, c) {
        var w = o.h.h.length;
        return o.ha && 0 < w && o.h.toString().charAt(w - 1) != " " ? o.h + " " + c : o.h + c;
      }
      function Sd(o) {
        var c = o.g.toString();
        if (3 <= c.length) {
          for (var w = o.ca && o.s.length == 0 && 0 < J(o.m, 20) ? q(o.m, 20) : q(o.m, 19), A = w.length, D = 0; D < A; ++D) {
            var F = w[D];
            0 < o.s.length && ct(V(F, 4)) && !B(F, 6) && !U(F, 5) || (o.s.length != 0 || o.ca || ct(V(F, 4)) || B(F, 6)) && i2.test(V(F, 2)) && o.j.push(F);
          }
          return E0(o, c), c = B0(o), 0 < c.length ? c : I0(o) ? P0(o) : o.u.toString();
        }
        return jt(o, c);
      }
      function P0(o) {
        var c = o.g.toString(), w = c.length;
        if (0 < w) {
          for (var A = "", D = 0; D < w; D++) A = N0(o, c.charAt(D));
          return o.v ? jt(o, A) : o.u.toString();
        }
        return o.h.toString();
      }
      function V0(o) {
        var c = o.g.toString(), w = 0;
        if (o.m.ia() != 1) var A = !1;
        else A = o.g.toString(), A = A.charAt(0) == "1" && A.charAt(1) != "0" && A.charAt(1) != "1";
        return A ? (w = 1, o.h.g("1").g(" "), o.ca = !0) : U(o.m, 15) && (A = new RegExp("^(?:" + B(o.m, 15) + ")"), A = c.match(A), A != null && A[0] != null && 0 < A[0].length && (o.ca = !0, w = A[0].length, o.h.g(c.substring(0, w)))), se(o.g), o.g.g(c.substring(w)), c.substring(0, w);
      }
      function O0(o) {
        var c = o.ba.toString(), w = new RegExp("^(?:\\+|" + B(o.m, 11) + ")");
        return w = c.match(w), w != null && w[0] != null && 0 < w[0].length ? (o.ca = !0, w = w[0].length, se(o.g), o.g.g(c.substring(w)), se(o.h), o.h.g(c.substring(0, w)), c.charAt(0) != "+" && o.h.g(" "), !0) : !1;
      }
      function R0(o) {
        if (o.g.h.length == 0) return !1;
        var c = new ve(), w = M0(o.g, c);
        return w == 0 ? !1 : (se(o.g), o.g.g(c.toString()), c = k1(w), c == "001" ? o.m = $1(o.qa, "" + w) : c != o.ma && (o.m = kd(o, c)), o.h.g("" + w).g(" "), o.s = "", !0);
      }
      function N0(o, c) {
        var w = o.$.toString();
        if (0 <= w.substring(o.aa).search(o.ka)) {
          var A = w.search(o.ka);
          return c = w.replace(o.ka, c), se(o.$), o.$.g(c), o.aa = A, c.substring(0, o.aa + 1);
        }
        return o.j.length == 1 && (o.v = !1), o.da = "", o.u.toString();
      }
      var c2 = {
        AC: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "AC", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        AD: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[0268]", , , , "110"], [, , , , , , , , , [-1]], , , , "AD", , , , , , , , , , , , , , , , , , [, , "11[0268]", , , , "110"], , [, , "11[0268]", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        AE: [
          ,
          [, , "[149]\\d{2,3}", , , , , , , [3, 4]],
          ,
          ,
          [, , "112|99[7-9]", , , , "112", , , [3]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "AE",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "112|99[7-9]", , , , "112", , , [3]],
          ,
          [, , "112|445[16]|99[7-9]", , , , "112"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , "445\\d", , , , "4450", , , [4]]
        ],
        AF: [, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "1(?:0[02]|19)", , , , "100", , , [3]], [, , , , , , , , , [-1]], , , , "AF", , , , , , , , , , , , , , , , , , [, , "1(?:0[02]|19)", , , , "100", , , [3]], , [, , "1(?:0[02]|19)|40404", , , , "100"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        AG: [
          ,
          [, , "[19]\\d\\d", , , , , , , [3]],
          ,
          ,
          [, , "9(?:11|88|99)", , , , "911"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "AG",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "9(?:11|99)", , , , "911"],
          ,
          [, , "176|9(?:11|88|99)", , , , "176"],
          [, , , , , , , , , [-1]],
          [, , "176", , , , "176"],
          ,
          [, , "176", , , , "176"]
        ],
        AI: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "AI", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "176|9(?:11|88)", , , , "176"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
        AL: [
          ,
          [, , "[15]\\d{2,5}", , , , , , , [3, 4, 5, 6]],
          ,
          ,
          [, , "1(?:1(?:2|6[01]\\d\\d)|2[7-9]|3[15]|41)", , , , "112", , , [3, 6]],
          [, , "5\\d{4}", , , , "50000", , , [5]],
          ,
          ,
          ,
          "AL",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:12|2[7-9])", , , , "112", , , [3]],
          ,
          [, , "1(?:1(?:6(?:000|1(?:06|11|23))|8\\d\\d)|65\\d|89[12])|5\\d{4}|1(?:[1349]\\d|2[2-9])", , , , "110"],
          [, , , , , , , , , [-1]],
          [, , "123", , , , "123", , , [3]],
          ,
          [, , "131|5\\d{4}", , , , "131", , , [3, 5]]
        ],
        AM: [, [, , "[148]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "10[1-3]", , , , "101", , , [3]], [, , , , , , , , , [-1]], , , , "AM", , , , , , , , , , , , , , , , , , [, , "10[1-3]", , , , "101", , , [3]], , [, , "(?:1|8[1-7])\\d\\d|40404", , , , "100"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        AO: [, [
          ,
          ,
          "1\\d\\d",
          ,
          ,
          ,
          ,
          ,
          ,
          [3]
        ], , , [, , "11[235]", , , , "112"], [, , , , , , , , , [-1]], , , , "AO", , , , , , , , , , , , , , , , , , [, , "11[235]", , , , "112"], , [, , "11[235]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        AR: [, [, , "[01389]\\d{1,4}", , , , , , , [2, 3, 4, 5]], , , [, , "000|1(?:0[0-35-7]|1[0245]|2[015]|3[47]|4[478]|9)|911", , , , "19", , , [2, 3]], [, , , , , , , , , [-1]], , , , "AR", , , , , , , , , , , , , , , , , , [, , "10[017]|911", , , , "100", , , [3]], , [, , "000|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478]|9)|3372|89338|911", , , , "19"], [, , , , , , , , , [-1]], [, , "893\\d\\d", , , , "89300", , , [5]], , [
          ,
          ,
          "(?:337|893\\d)\\d",
          ,
          ,
          ,
          "3370",
          ,
          ,
          [4, 5]
        ]],
        AS: [, [, , "[49]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "9(?:11|88)", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "AS", , , , , , , , , , , , , , , , , , [, , "911", , , , "911", , , [3]], , [, , "40404|9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        AT: [, [, , "[1268]\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "1(?:12|2[0238]|3[03]|4[0-247])|1(?:16\\d\\d|4[58])\\d", , , , "112"], [, , , , , , , , , [-1]], , , , "AT", , , , , , , , , , , , , , , , , , [, , "1(?:[12]2|33|44)", , , , "112", , , [3]], , [
          ,
          ,
          "1(?:1(?:2|6(?:00[06]|1(?:17|23)))|2[0238]|3[03]|4(?:[0-247]|5[05]|84))|(?:220|61|8108[1-3])0",
          ,
          ,
          ,
          "112"
        ], [, , , , , , , , , [-1]], [, , "(?:220|810\\d\\d)\\d|610", , , , "610"], , [, , , , , , , , , [-1]]],
        AU: [, [, , "[0-27]\\d{2,7}", , , , , , , [3, 4, 5, 6, 7, 8]], , , [, , "000|1(?:06|12|258885|55\\d)|733", , , , "000", , , [3, 4, 7]], [, , "1(?:2(?:34|456)|9\\d{4,6})", , , , "1234", , , [4, 5, 6, 7, 8]], , , , "AU", , , , , , , , , , , , , , , , , , [, , "000|1(?:06|12)", , , , "000", , , [3]], , [, , "000|1(?:06|1(?:00|2|9[46])|2(?:014[1-3]|[23]\\d|(?:4|5\\d)\\d{2,3}|68[689]|72(?:20|3\\d\\d)|8(?:[013-9]\\d|2))|555|9\\d{4,6})|225|7(?:33|67)", , , , "000"], [
          ,
          ,
          "1(?:1[09]\\d|24733)|225|767",
          ,
          ,
          ,
          "225",
          ,
          ,
          [3, 4, 6]
        ], [, , "1(?:258885|55\\d)", , , , "1550", , , [4, 7]], , [, , "19\\d{4,6}", , , , "190000", , , [6, 7, 8]]],
        AW: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "100|911", , , , "100"], [, , , , , , , , , [-1]], , , , "AW", , , , , , , , , , , , , , , , , , [, , "100|911", , , , "100"], , [, , "1(?:00|18|76)|91[13]", , , , "100"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
        AX: [, [, , "[17]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "112", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "AX", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "112|75[12]\\d\\d", , , , "112"], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , [, , , , , , , , , [-1]]],
        AZ: [, [, , "[148]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:0[1-3]|12)", , , , "101", , , [3]], [, , , , , , , , , [-1]], , , , "AZ", , , , , , , , , , , , , , , , , , [, , "1(?:0[1-3]|12)", , , , "101", , , [3]], , [, , "1(?:0[1-3]|12)|(?:404|880)0", , , , "101"], [, , , , , , , , , [-1]], [, , "(?:404|880)\\d", , , , "4040", , , [4]], , [, , "(?:404|880)\\d", , , , "4040", , , [4]]],
        BA: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:16\\d{3}|2[2-4])", , , , "122", , , [3, 6]], [, , , , , , , , , [-1]], , , , "BA", , , , , , , , , , , , , , , , , , [, , "12[2-4]", , , , "122", , , [3]], , [
          ,
          ,
          "1(?:16(?:00[06]|1(?:1[17]|23))|2(?:0[0-7]|[2-5]|6[0-26])|(?:[3-5]|7\\d)\\d\\d)|1(?:18|2[78])\\d\\d?",
          ,
          ,
          ,
          "122"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        BB: [, [, , "[2-689]\\d\\d", , , , , , , [3]], , , [, , "988|[2359]11", , , , "211"], [, , , , , , , , , [-1]], , , , "BB", , , , , , , , , , , , , , , , , , [, , "[2359]11", , , , "211"], , [, , "988|[2-689]11", , , , "211"], [, , , , , , , , , [-1]], [, , "[468]11", , , , "411"], , [, , , , , , , , , [-1]]],
        BD: [, [, , "[1579]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "10[0-26]|[19]99", , , , "100", , , [3]], [, , , , , , , , , [-1]], , , , "BD", , , , , , , , , , , , , , , , , , [, , "10[0-2]|[19]99", , , , "100", , , [3]], , [
          ,
          ,
          "1(?:0(?:[0-369]|5[1-4]|7[0-4]|8[0-29])|1[16-9]|2(?:[134]|2[0-5])|3(?:1\\d?|6[3-6])|5[2-9])|5012|786|9594|[19]99|1(?:0(?:50|6\\d)|33|4(?:0|1\\d))\\d",
          ,
          ,
          ,
          "100"
        ], [, , , , , , , , , [-1]], [, , "1(?:11|2[13])|(?:501|959)\\d|786", , , , "111", , , [3, 4]], , [, , "959\\d", , , , "9590", , , [4]]],
        BE: [, [, , "[1-9]\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "1(?:0[0-35-8]|1[0269]|7(?:12|77)|813)|(?:116|8)\\d{3}", , , , "100"], [, , "1(?:2[03]|40)4|(?:1(?:[24]1|3[01])|[2-79]\\d\\d)\\d", , , , "1204", , , [4]], , , , "BE", , , , , , , , , , , , , , , , , , [, , "1(?:0[01]|12)", , , , "100", , , [3]], , [
          ,
          ,
          "1(?:0[0-8]|16117|2(?:12|3[0-24])|313|414|5(?:1[05]|5[15]|66|95)|6(?:1[167]|36|6[16])|7(?:[07][017]|1[27-9]|22|33|65)|81[39])|[2-9]\\d{3}|11[02679]|1(?:1600|45)0|1(?:[2-4]9|78)9|1[2-4]0[47]",
          ,
          ,
          ,
          "100"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "[2-9]\\d{3}", , , , "2000", , , [4]]],
        BF: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "BF", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        BG: [, [, , "1\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "1(?:1(?:2|6\\d{3})|50|6[06])", , , , "112"], [, , , , , , , , , [-1]], , , , "BG", , , , , , , , , , , , , , , , , , [, , "1(?:12|50|6[06])", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|111))|50|6[06])", , , , "112"], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , [, , , , , , , , , [-1]]],
        BH: [, [, , "[0189]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "(?:0[167]|81)\\d{3}|[19]99", , , , "199"], [, , "9[148]\\d{3}", , , , "91000", , , [5]], , , , "BH", , , , , , , , , , , , , , , , , , [, , "[19]99", , , , "199", , , [3]], , [, , "1(?:[02]\\d|12|4[01]|51|8[18]|9[169])|99[02489]|(?:0[167]|8[158]|9[148])\\d{3}", , , , "100"], [, , , , , , , , , [-1]], [, , "0[67]\\d{3}|88000|98555", , , , "06000", , , [5]], , [, , "88000|98555", , , , "88000", , , [5]]],
        BI: [
          ,
          [, , "[16-9]\\d{2,3}", , , , , , , [3, 4]],
          ,
          ,
          [, , "11[237]|611", , , , "112", , , [3]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "BI",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "11[237]", , , , "112", , , [3]],
          ,
          [, , "1(?:1\\d|5[2-9]|6[0-256])|611|7(?:10|77|979)|8[28]8|900", , , , "110"],
          [, , , , , , , , , [-1]],
          [, , "611|7(?:10|77)|888|900", , , , "611", , , [3]],
          ,
          [, , "(?:71|90)0", , , , "710", , , [3]]
        ],
        BJ: [, [, , "[17]\\d{2,3}", , , , , , , [3, 4]], , , [, , "11[78]|7[3-5]\\d\\d", , , , "117"], [, , , , , , , , , [-1]], , , , "BJ", , , , , , , , , , , , , , , , , , [, , "11[78]", , , , "117", , , [3]], , [, , "1(?:1[78]|2[02-5]|60)|7[0-5]\\d\\d", , , , "117"], [, , , , , , , , , [-1]], [, , "12[02-5]", , , , "120", , , [3]], , [, , , , , , , , , [-1]]],
        BL: [, [, , "1\\d", , , , , , , [2]], , , [
          ,
          ,
          "18",
          ,
          ,
          ,
          "18"
        ], [, , , , , , , , , [-1]], , , , "BL", , , , , , , , , , , , , , , , , , [, , "18", , , , "18"], , [, , "18", , , , "18"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        BM: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "BM", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "176|9(?:11|88)", , , , "176"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
        BN: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "99[135]", , , , "991"], [, , , , , , , , , [-1]], , , , "BN", , , , , , , , , , , , , , , , , , [, , "99[135]", , , , "991"], , [, , "99[135]", , , , "991"], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , [, , , , , , , , , [-1]]],
        BO: [, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "11[089]", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "BO", , , , , , , , , , , , , , , , , , [, , "11[089]", , , , "110", , , [3]], , [, , "11[089]|40404", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        BQ: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "112|911", , , , "112"], [, , , , , , , , , [-1]], , , , "BQ", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112"], , [, , "1(?:12|76)|911", , , , "112"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
        BR: [, [
          ,
          ,
          "[1-69]\\d{2,5}",
          ,
          ,
          ,
          ,
          ,
          ,
          [3, 4, 5, 6]
        ], , , [, , "1(?:00|12|28|8[015]|9[0-47-9])|4(?:57|82\\d)|911", , , , "100", , , [3, 4]], [, , , , , , , , , [-1]], , , , "BR", , , , , , , , , , , , , , , , , , [, , "1(?:12|28|9[023])|911", , , , "112", , , [3]], , [
          ,
          ,
          "1(?:0(?:[02]|3(?:1[2-579]|2[13-9]|3[124-9]|4[1-3578]|5[1-468]|6[139]|8[149]|9[168])|5[0-35-9]|6(?:0|1[0-35-8]?|2[0145]|3[0137]?|4[37-9]?|5[0-35]|6[016]?|7[137]?|8[5-8]|9[1359]))|1[25-8]|2[357-9]|3[024-68]|4[12568]|5\\d|6[0-8]|8[015]|9[0-47-9])|2(?:7(?:330|878)|85959?)|(?:32|91)1|4(?:0404?|57|828)|55555|6(?:0\\d{4}|10000)|(?:133|411)[12]",
          ,
          ,
          ,
          "100"
        ], [, , "102|273\\d\\d|321", , , , "102", , , [3, 5]], [, , "151|(?:278|555)\\d\\d|4(?:04\\d\\d?|11\\d|57)", , , , "151", , , [3, 4, 5]], , [, , "285\\d{2,3}|321|40404|(?:27[38]\\d|482)\\d|6(?:0\\d|10)\\d{3}", , , , "321"]],
        BS: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:1[19]|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "BS", , , , , , , , , , , , , , , , , , [, , "91[19]", , , , "911"], , [, , "9(?:1[19]|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        BT: [
          ,
          [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]],
          ,
          ,
          [, , "11[023]", , , , "110", , , [3]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "BT",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "11[023]", , , , "110", , , [3]],
          ,
          [, , "11[0-6]|40404", , , , "110"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , "404\\d\\d", , , , "40400", , , [5]]
        ],
        BW: [, [, , "[19]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "9(?:11|9[7-9])", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "BW", , , , , , , , , , , , , , , , , , [, , "9(?:11|9[7-9])", , , , "911", , , [3]], , [, , "1(?:1[26]|3123)|9(?:1[14]|9[1-57-9])", , , , "112"], [, , , , , , , , , [-1]], [, , "131\\d\\d", , , , "13100", , , [5]], , [, , "131\\d\\d", , , , "13100", , , [5]]],
        BY: [
          ,
          [, , "1\\d\\d", , , , , , , [3]],
          ,
          ,
          [, , "1(?:0[1-3]|12)", , , , "101"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "BY",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:0[1-3]|12)", , , , "101"],
          ,
          [, , "1(?:0[1-79]|1[246]|35|5[1-35]|6[89]|7[5-7]|8[58]|9[1-7])", , , , "101"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        BZ: [, [, , "9\\d\\d?", , , , , , , [2, 3]], , , [, , "9(?:0|11|22|66|77|9[09])", , , , "90"], [, , , , , , , , , [-1]], , , , "BZ", , , , , , , , , , , , , , , , , , [, , "9(?:0|11|90)", , , , "90"], , [, , "9(?:0|11|22|66|77|9[09])", , , , "90"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        CA: [, [, , "[1-9]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [
          ,
          ,
          "112|988|[29]11",
          ,
          ,
          ,
          "112",
          ,
          ,
          [3]
        ], [, , , , , , , , , [-1]], , , , "CA", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112", , , [3]], , [, , "[1-35-9]\\d{4,5}|112|[2-8]11|9(?:11|88)", , , , "112"], [, , , , , , , , , [-1]], [, , "[235-7]11", , , , "211", , , [3]], , [, , "[1-35-9]\\d{4,5}", , , , "10000", , , [5, 6]]],
        CC: [, [, , "[01]\\d\\d", , , , , , , [3]], , , [, , "000|112", , , , "000"], [, , , , , , , , , [-1]], , , , "CC", , , , , , , , , , , , , , , , , , [, , "000|112", , , , "000"], , [, , "000|112", , , , "000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        CD: [
          ,
          [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]],
          ,
          ,
          [, , "1(?:1[348]|77|88)", , , , "113", , , [3]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "CD",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:1[348]|77|88)", , , , "113", , , [3]],
          ,
          [, , "1(?:1[348]|23|77|88)|40404", , , , "113"],
          [, , , , , , , , , [-1]],
          [, , "404\\d\\d", , , , "40400", , , [5]],
          ,
          [, , "404\\d\\d", , , , "40400", , , [5]]
        ],
        CF: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[78]|22\\d)", , , , "117"], [, , , , , , , , , [-1]], , , , "CF", , , , , , , , , , , , , , , , , , [, , "1(?:1[78]|220)", , , , "117"], , [, , "1(?:1[478]|220)", , , , "114"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        CG: [
          ,
          [, , "1\\d\\d", , , , , , , [3]],
          ,
          ,
          [, , "11[178]", , , , "111"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "CG",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "11[78]", , , , "117"],
          ,
          [, , "11[126-8]", , , , "111"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        CH: [, [, , "[1-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:[278]|6\\d{3})|4[47])|5200", , , , "112", , , [3, 4, 6]], [, , "1(?:14|8[0-2589])\\d|543|83111", , , , "543", , , [3, 4, 5]], , , , "CH", , , , , , , , , , , , , , , , , , [, , "1(?:1[278]|44)", , , , "112", , , [3]], , [, , "1(?:0[78]\\d\\d|1(?:[278]|45|6(?:000|111))|4(?:[03-57]|1[0145])|6(?:00|[1-46])|8(?:02|1[189]|[25]0|7|8[08]|99))|[2-9]\\d{2,4}", , , , "112"], [
          ,
          ,
          "1(?:4[035]|6[1-46])|1(?:41|60)\\d",
          ,
          ,
          ,
          "140",
          ,
          ,
          [3, 4]
        ], [, , "5(?:200|35)", , , , "535", , , [3, 4]], , [, , "[2-9]\\d{2,4}", , , , "200", , , [3, 4, 5]]],
        CI: [, [, , "[14]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[01]|[78]0)", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "CI", , , , , , , , , , , , , , , , , , [, , "1(?:1[01]|[78]0)", , , , "110", , , [3]], , [, , "1(?:1[01]|[78]0)|4443", , , , "110"], [, , , , , , , , , [-1]], [, , "444\\d", , , , "4440", , , [4]], , [, , "444\\d", , , , "4440", , , [4]]],
        CK: [
          ,
          [, , "9\\d\\d", , , , , , , [3]],
          ,
          ,
          [, , "99[689]", , , , "996"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "CK",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "99[689]", , , , "996"],
          ,
          [, , "99[689]", , , , "996"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        CL: [, [, , "[1-9]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:213|3[1-3])|434\\d|911", , , , "131", , , [3, 4]], [, , "1(?:211|3(?:13|[348]0|5[01]))|(?:1(?:[05]6|[48]1|9[18])|2(?:01\\d|[23]2|77|88)|3(?:0[59]|13|3[279]|66)|4(?:[12]4|36\\d|4[017]|55)|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d", , , , "1060", , , [4, 5]], , , , "CL", , , , , , , , , , , , , , , , , , [, , "13[1-3]|911", , , , "131", , , [3]], , [
          ,
          ,
          "1(?:00|21[13]|3(?:13|[348]0|5[01])|4(?:0[02-6]|17|[379])|818|919)|2(?:0(?:01|122)|22[47]|323|777|882)|3(?:0(?:51|99)|132|3(?:29|[37]7)|665)|43656|5(?:(?:00|415)4|5(?:66|77)|995)|6(?:131|222|366|699)|7878|8(?:011|11[28]|482|889)|9(?:01|1)1|13\\d|4(?:[13]42|243|4(?:02|15|77)|554)|(?:1(?:[05]6|98)|339|6(?:07|[35])0|9(?:[12]0|33))0",
          ,
          ,
          ,
          "100"
        ], [, , "(?:200|333)\\d", , , , "2000", , , [4]], [, , , , , , , , , [-1]], , [, , "13(?:13|[348]0|5[01])|(?:1(?:[05]6|[28]1|4[01]|9[18])|2(?:0(?:0|1\\d)|[23]2|77|88)|3(?:0[59]|13|3[2379]|66)|436\\d|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d|4(?:[1-3]4|4[017]|55)\\d", , , , "1060", , , [4, 5]]],
        CM: [, [, , "[18]\\d{1,3}", , , , , , , [2, 3, 4]], , , [, , "1(?:1[37]|[37])", , , , "13", , , [2, 3]], [, , , , , , , , , [-1]], , , , "CM", , , , , , , , , , , , , , , , , , [, , "1(?:1[37]|[37])", , , , "13", , , [2, 3]], , [
          ,
          ,
          "1(?:1[37]|[37])|8711",
          ,
          ,
          ,
          "13"
        ], [, , , , , , , , , [-1]], [, , "871\\d", , , , "8710", , , [4]], , [, , "871\\d", , , , "8710", , , [4]]],
        CN: [, [, , "[19]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1[09]|2(?:[02]|1\\d\\d|395))", , , , "110", , , [3, 5]], [, , , , , , , , , [-1]], , , , "CN", , , , , , , , , , , , , , , , , , [, , "1(?:1[09]|20)", , , , "110", , , [3]], , [, , "1(?:00|1[0249]|2395|6[08])|9[56]\\d{3,4}|12[023]|1(?:0(?:[0-26]\\d|8)|21\\d)\\d", , , , "100"], [, , "1(?:0(?:[0-26]\\d|8)\\d|1[24]|23|6[08])|9[56]\\d{3,4}|100", , , , "100"], [, , , , , , , , , [-1]], , [, , "12110", , , , "12110", , , [5]]],
        CO: [, [
          ,
          ,
          "[1-589]\\d\\d(?:\\d{2,3})?",
          ,
          ,
          ,
          ,
          ,
          ,
          [3, 5, 6]
        ], , , [, , "1(?:1[29]|23|32|56)", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "CO", , , , , , , , , , , , , , , , , , [, , "1(?:1[29]|23|32|56)", , , , "112", , , [3]], , [, , "1(?:06|1[2-9]|2[35-7]|3[27]|4[467]|5[36]|6[4-7]|95)|(?:29002|39003)9|40404|5930\\d\\d|85432|(?:[2359][57]|8(?:7|9\\d))\\d{3}", , , , "106"], [, , , , , , , , , [-1]], [, , "(?:40|85)4\\d\\d", , , , "40400", , , [5]], , [, , "(?:40|85)4\\d\\d", , , , "40400", , , [5]]],
        CR: [, [, , "[1359]\\d{2,3}", , , , , , , [3, 4]], , , [, , "112|911", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "CR", , , , , , , , , , , , , , , , , , [
          ,
          ,
          "112|911",
          ,
          ,
          ,
          "112",
          ,
          ,
          [3]
        ], , [, , "1(?:0(?:00|15|2[2-4679])|1(?:1[0-35-9]|2|37|[46]6|7[57]|8[79]|9[0-379])|2(?:00|[12]2|34|55)|3(?:21|33)|4(?:0[06]|1[4-6])|5(?:15|5[15])|693|7(?:00|1[7-9]|2[02]|[67]7)|975)|3855|5(?:0(?:30|49)|510)|911", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "(?:385|5(?:0[34]|51))\\d", , , , "3850", , , [4]]],
        CU: [, [, , "[12]\\d\\d(?:\\d{3,4})?", , , , , , , [3, 6, 7]], , , [, , "10[4-7]|(?:116|204\\d)\\d{3}", , , , "104"], [, , , , , , , , , [-1]], , , , "CU", , , , , , , , , , , , , , , , , , [, , "10[4-6]", , , , "104", , , [3]], , [
          ,
          ,
          "1(?:0[4-7]|1(?:6111|8)|40)|2045252",
          ,
          ,
          ,
          "104"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        CV: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "13[0-2]", , , , "130"], [, , , , , , , , , [-1]], , , , "CV", , , , , , , , , , , , , , , , , , [, , "13[0-2]", , , , "130"], , [, , "13[0-2]", , , , "130"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        CW: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "112|911", , , , "112"], [, , , , , , , , , [-1]], , , , "CW", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112"], , [, , "1(?:12|76)|911", , , , "112"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
        CX: [, [, , "[01]\\d\\d", , , , , , , [3]], , , [
          ,
          ,
          "000|112",
          ,
          ,
          ,
          "000"
        ], [, , , , , , , , , [-1]], , , , "CX", , , , , , , , , , , , , , , , , , [, , "000|112", , , , "000"], , [, , "000|112", , , , "000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        CY: [, [, , "1\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "1(?:1(?:2|6\\d{3})|99)", , , , "112"], [, , , , , , , , , [-1]], , , , "CY", , , , , , , , , , , , , , , , , , [, , "1(?:12|99)", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|111))|99)", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        CZ: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:2|6(?:00[06]|1(?:11|23)))|5\\d)", , , , "112", , , [3, 6]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , , "CZ", , , , , , , , , , , , , , , , , , [, , "1(?:12|5\\d)", , , , "112", , , [3]], , [, , "1(?:1(?:2|8\\d)|(?:2|3\\d)\\d{2,3}|5\\d|99)|1(?:16|4)\\d{3}", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        DE: [, [, , "[13]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:[02]|6\\d{3})", , , , "110", , , [3, 6]], [, , , , , , , , , [-1]], , , , "DE", , , , , , , , , , , , , , , , , , [, , "11[02]", , , , "110", , , [3]], , [, , "11(?:[025]|6(?:00[06]|1(?:1[167]|23))|800\\d)|3311|118\\d\\d", , , , "110"], [, , , , , , , , , [-1]], [, , "331\\d", , , , "3310", , , [4]], , [, , , , , , , , , [-1]]],
        DJ: [, [
          ,
          ,
          "1\\d",
          ,
          ,
          ,
          ,
          ,
          ,
          [2]
        ], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "DJ", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        DK: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:[24]|6\\d{3})", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "DK", , , , , , , , , , , , , , , , , , [, , "11[24]", , , , "112", , , [3]], , [, , "1(?:1(?:[2-48]|6(?:00[06]|111))|619[0-2]|8(?:01|1[0238]|28|30|5[13]|8[18]))", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        DM: [, [, , "[39]\\d\\d", , , , , , , [3]], , , [
          ,
          ,
          "333|9(?:11|88|99)",
          ,
          ,
          ,
          "333"
        ], [, , , , , , , , , [-1]], , , , "DM", , , , , , , , , , , , , , , , , , [, , "333|9(?:11|99)", , , , "333"], , [, , "333|9(?:11|88|99)", , , , "333"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        DO: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "112|9(?:11|88)", , , , "112"], [, , , , , , , , , [-1]], , , , "DO", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112"], , [, , "112|9(?:11|88)", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        DZ: [, [, , "[17]\\d{1,3}", , , , , , , [2, 3, 4]], , , [, , "1(?:12|[47]|54\\d)", , , , "14"], [, , , , , , , , , [-1]], , , , "DZ", , , , , , , , , , , , , , , , , , [
          ,
          ,
          "1(?:12|[47])",
          ,
          ,
          ,
          "14",
          ,
          ,
          [2, 3]
        ], , [, , "1(?:055|12|[47]|548)|730", , , , "14"], [, , , , , , , , , [-1]], [, , "730", , , , "730", , , [3]], , [, , "730", , , , "730", , , [3]]],
        EC: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "1(?:0[12]|12)|911", , , , "101"], [, , , , , , , , , [-1]], , , , "EC", , , , , , , , , , , , , , , , , , [, , "1(?:0[12]|12)|911", , , , "101"], , [, , "1(?:0[12]|12)|911", , , , "101"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        EE: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [
          ,
          ,
          "1(?:1(?:[02]|6\\d{3})|2(?:05|28)|3(?:014|3(?:21|5\\d?)|660)|492|5(?:1[03]|410|501)|6(?:112|333|644)|7(?:012|127|89)|8(?:10|8[57])|9(?:0[134]|14))",
          ,
          ,
          ,
          "110"
        ], [
          ,
          ,
          "1(?:18(?:00|[12458]\\d?)|2(?:0(?:[02-46-8]\\d?|1[0-36])|1(?:[0-4]\\d?|6[06])|2(?:[0-4]\\d?|5[25])|[367]|4(?:0[04]|[12]\\d?|4[24]|54)|55[12457])|3(?:0(?:[02]\\d?|1[13578]|3[356])|1[1347]|2[02-5]|3(?:[01347]\\d?|2[023]|88)|4(?:[35]\\d?|4[34])|5(?:3[134]|5[035])|666)|4(?:2(?:00|4\\d?)|4(?:0[01358]|1[024]|50|7\\d?)|900)|5(?:0[0-35]|1(?:[1267]\\d?|5[0-7]|82)|2(?:[014-6]\\d?|22)|330|4(?:[35]\\d?|44)|5(?:00|[1-69]\\d?)|9(?:[159]\\d?|[38]0|77))|6(?:1(?:00|1[19]|[35-9]\\d?)|2(?:2[26]|[68]\\d?)|3(?:22|36|6[36])|5|6(?:[0-359]\\d?|6[0-26])|7(?:00|55|7\\d?|8[89])|9(?:00|1\\d?|69))|7(?:0(?:[023]\\d?|1[0578])|1(?:00|2[034]|[4-9]\\d?)|2(?:[07]\\d?|20|44)|7(?:[0-57]\\d?|9[79])|8(?:0[08]|2\\d?|8[0178])|9(?:00|97))|8(?:1[127]|8[1268]|9[269])|9(?:0(?:[02]\\d?|69|9[0269])|1[1-3689]|21))",
          ,
          ,
          ,
          "123",
          ,
          ,
          [3, 4, 5]
        ], , , , "EE", , , , , , , , , , , , , , , , , , [, , "11[02]", , , , "110", , , [3]], , [, , "1(?:1(?:[02-579]|6(?:000|111)|8(?:[09]\\d|[1-8]))|2[36-9]|3[7-9]|4[05-7]|5[6-8]|6[05]|7[3-6]|8[02-7]|9[3-9])|1(?:2[0-245]|3[0-6]|4[1-489]|5[0-59]|6[1-46-9]|7[0-27-9]|8[189]|9[0-2])\\d\\d?", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [
          ,
          ,
          "1(?:18[1258]|2(?:0(?:1[036]|[46]\\d?)|166|21|4(?:0[04]|1\\d?|5[47])|[67])|3(?:0(?:1[13-578]|2\\d?|3[56])|1[15]|2[045]|3(?:[13]\\d?|2[13])|43|5(?:00|3[34]|53))|44(?:0[0135]|14|50|7\\d?)|5(?:05|1(?:[12]\\d?|5[1246]|8[12])|2(?:[01]\\d?|22)|3(?:00|3[03])|4(?:15|5\\d?)|500|9(?:5\\d?|77|80))|6(?:1[35-8]|226|3(?:22|3[36]|66)|644|7(?:00|7\\d?|89)|9(?:00|69))|7(?:01[258]|1(?:00|[15]\\d?)|2(?:44|7\\d?)|8(?:00|87|9\\d?))|8(?:1[128]|8[56]|9(?:[26]\\d?|77))|90(?:2\\d?|69|92))",
          ,
          ,
          ,
          "126",
          ,
          ,
          [3, 4, 5]
        ]],
        EG: [, [, , "[13]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "1(?:2[23]|80)", , , , "122", , , [3]], [, , , , , , , , , [-1]], , , , "EG", , , , , , , , , , , , , , , , , , [, , "1(?:2[23]|80)", , , , "122", , , [3]], , [, , "1(?:2[23]|[679]\\d{3}|80)|34400", , , , "122"], [, , , , , , , , , [-1]], [, , "344\\d\\d", , , , "34400", , , [5]], , [, , "344\\d\\d", , , , "34400", , , [5]]],
        EH: [
          ,
          [, , "1\\d\\d?", , , , , , , [2, 3]],
          ,
          ,
          [, , "1(?:[59]|77)", , , , "15"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "EH",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:[59]|77)", , , , "15"],
          ,
          [, , "1(?:[59]|77)", , , , "15"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        ER: [, [, , "[12]\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "11[2-46]|(?:12[47]|20[12])\\d{3}", , , , "112"], [, , , , , , , , , [-1]], , , , "ER", , , , , , , , , , , , , , , , , , [, , "1(?:1[2-46]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99", , , , "112"], , [, , "1(?:1[2-6]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        ES: [, [, , "[0-379]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "0(?:16|6[57]|8[58])|1(?:006|12|[3-7]\\d\\d)|(?:116|20\\d)\\d{3}", , , , "016", , , [3, 4, 6]], [
          ,
          ,
          "[12]2\\d{1,4}|90(?:5\\d|7)|(?:118|2(?:[357]\\d|80)|3[357]\\d)\\d\\d|[79]9[57]\\d{3}",
          ,
          ,
          ,
          "120"
        ], , , , "ES", , , , , , , , , , , , , , , , , , [, , "08[58]|112", , , , "085", , , [3]], , [, , "0(?:1[0-26]|6[0-257]|8[058]|9[12])|1(?:0[03-57]\\d{1,3}|1(?:2|6(?:000|111)|8\\d\\d)|2\\d{1,4}|[3-9]\\d\\d)|2(?:2\\d{1,4}|80\\d\\d)|90(?:5[124578]|7)|1(?:3[34]|77)|(?:2[01]\\d|[79]9[57])\\d{3}|[23][357]\\d{3}", , , , "010"], [, , "0(?:[16][0-2]|80|9[12])|21\\d{4}", , , , "010", , , [3, 6]], [, , "1(?:3[34]|77)|[12]2\\d{1,4}", , , , "120"], , [, , "(?:2[0-2]\\d|3[357]|[79]9[57])\\d{3}|2(?:[2357]\\d|80)\\d\\d", , , , "22000", , , [5, 6]]],
        ET: [, [
          ,
          ,
          "9\\d\\d?",
          ,
          ,
          ,
          ,
          ,
          ,
          [2, 3]
        ], , , [, , "9(?:07|11?|2|39?|9[17])", , , , "91"], [, , , , , , , , , [-1]], , , , "ET", , , , , , , , , , , , , , , , , , [, , "9(?:11?|2|39?|9[17])", , , , "91"], , [, , "9(?:07|11?|2|39?|45|9[17])", , , , "91"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        FI: [
          ,
          [, , "[17]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]],
          ,
          ,
          [, , "11(?:2|6\\d{3})", , , , "112", , , [3, 6]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "FI",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "112", , , , "112", , , [3]],
          ,
          [, , "11(?:2|6(?:00[06]|1(?:1[17]|23)))|(?:1[235-8]\\d|75[12])\\d\\d", , , , "112"],
          [, , "1[235-8]\\d{3}", , , , "12000", , , [5]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        FJ: [, [, , "[0-579]\\d(?:\\d(?:\\d{2})?)?", , , , , , , [2, 3, 5]], , , [, , "91[17]", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "FJ", , , , , , , , , , , , , , , , , , [, , "91[17]", , , , "911", , , [3]], , [, , "0(?:1[34]|8[1-4])|1(?:0[1-3]|[25]9)|2[289]|30|40404|91[137]|[45]4|75", , , , "22"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        FK: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "FK", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "1\\d\\d|999", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        FM: [, [, , "[39]\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "320\\d{3}|911", , , , "911"], [, , , , , , , , , [-1]], , , , "FM", , , , , , , , , , , , , , , , , , [, , "(?:32022|91)1", , , , "911"], , [, , "(?:32022|91)1", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        FO: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[24]|81\\d)", , , , "112"], [, , , , , , , , , [-1]], , , , "FO", , , , , , , , , , , , , , , , , , [, , "11[24]", , , , "112", , , [3]], , [, , "1(?:1[248]|819)|1(?:4[124]|71|8[7-9])\\d", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        FR: [, [
          ,
          ,
          "[1-8]\\d{1,5}",
          ,
          ,
          ,
          ,
          ,
          ,
          [2, 3, 4, 5, 6]
        ], , , [, , "1(?:1[02459]|[578]|9[167])|224|(?:3370|74)0|(?:116\\d|3[01])\\d\\d", , , , "15"], [, , "(?:1(?:0|18\\d)|366|[4-8]\\d\\d)\\d\\d|3[2-9]\\d\\d", , , , "1000", , , [4, 5, 6]], , , , "FR", , , , , , , , , , , , , , , , , , [, , "1(?:12|[578])", , , , "15", , , [2, 3]], , [, , "1(?:0\\d\\d|1(?:[02459]|6(?:000|111)|8\\d{3})|[578]|9[167])|2(?:0(?:00|2)0|24)|[3-8]\\d{4}|3\\d{3}|6(?:1[14]|34)|7(?:0[06]|22|40)", , , , "15"], [, , "202\\d|6(?:1[14]|34)|70[06]", , , , "611", , , [3, 4]], [
          ,
          ,
          "118777|224|6(?:1[14]|34)|7(?:0[06]|22|40)|20(?:0\\d|2)\\d",
          ,
          ,
          ,
          "224",
          ,
          ,
          [3, 4, 5, 6]
        ], , [, , "114|[3-8]\\d{4}", , , , "114", , , [3, 5]]],
        GA: [, [, , "1\\d(?:\\d{2})?", , , , , , , [2, 4]], , , [, , "18|1(?:3\\d|73)\\d", , , , "18"], [, , , , , , , , , [-1]], , , , "GA", , , , , , , , , , , , , , , , , , [, , "1(?:3\\d\\d|730|8)", , , , "18"], , [, , "1(?:3\\d\\d|730|8)", , , , "18"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        GB: [, [, , "[1-46-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:05|1(?:[29]|6\\d{3})|7[56]\\d|8000)|2(?:20\\d|48)|4444|999", , , , "105"], [, , , , , , , , , [-1]], , , , "GB", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "112", , , [3]], , [
          ,
          ,
          "1(?:0[015]|1(?:[129]|6(?:000|1(?:11|23))|8\\d{3})|2(?:[1-3]|50)|33|4(?:1|7\\d)|571|7(?:0\\d|[56]0)|800\\d|9[15])|2(?:0202|1300|2(?:02|11)|3(?:02|336|45)|4(?:25|8))|3[13]3|4(?:0[02]|35[01]|44[45]|5\\d)|(?:[68]\\d|7[089])\\d{3}|15\\d|2[02]2|650|789|9(?:01|99)",
          ,
          ,
          ,
          "100"
        ], [, , , , , , , , , [-1]], [, , "1(?:(?:25|7[56])\\d|571)|2(?:02(?:\\d{2})?|[13]3\\d\\d|48)|4444|901", , , , "202", , , [3, 4, 5]], , [, , "(?:125|2(?:020|13\\d)|(?:7[089]|8[01])\\d\\d)\\d", , , , "1250", , , [4, 5]]],
        GD: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "GD", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "176|9(?:11|88)", , , , "176"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
        GE: [, [, , "[014]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "0(?:11|33)|11[1-3]|[01]22", , , , "011", , , [3]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , , "GE", , , , , , , , , , , , , , , , , , [, , "0(?:11|33)|11[1-3]|[01]22", , , , "011", , , [3]], , [, , "0(?:11|33)|11[1-3]|40404|[01]22", , , , "011"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        GF: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "GF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        GG: [
          ,
          [, , "[19]\\d{2,5}", , , , , , , [3, 4, 5, 6]],
          ,
          ,
          [, , "112|999", , , , "112", , , [3]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "GG",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "112|999", , , , "112", , , [3]],
          ,
          [, , "1(?:0[01]|1[12]|23|41|55|9[05])|999|1(?:1[68]\\d\\d|47|800)\\d", , , , "100"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        GH: [, [, , "[14589]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "19[1-3]|999", , , , "191", , , [3]], [, , , , , , , , , [-1]], , , , "GH", , , , , , , , , , , , , , , , , , [, , "19[1-3]|999", , , , "191", , , [3]], , [, , "19[1-3]|40404|(?:54|83)00|999", , , , "191"], [, , , , , , , , , [-1]], [, , "404\\d\\d|(?:54|83)0\\d", , , , "5400", , , [4, 5]], , [, , "404\\d\\d|(?:54|83)0\\d", , , , "5400", , , [4, 5]]],
        GI: [, [
          ,
          ,
          "[158]\\d{2,5}",
          ,
          ,
          ,
          ,
          ,
          ,
          [3, 4, 5, 6]
        ], , , [, , "1(?:00|1[25]|23|4(?:1|7\\d)|5[15]|9[02-49])|555|(?:116\\d|80)\\d\\d", , , , "100", , , [3, 4, 6]], [, , "8[1-69]\\d\\d", , , , "8100", , , [4]], , , , "GI", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[09])", , , , "112", , , [3]], , [, , "1(?:00|1(?:[25]|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|23|4(?:1|7[014])|5[015]|9[02-49])|555|8[0-79]\\d\\d|8(?:00|4[0-2]|8[0-589])", , , , "100"], [, , "150|87\\d\\d", , , , "150", , , [3, 4]], [, , "1(?:00|1(?:5|8\\d\\d)|23|51|9[2-4])|555|8(?:00|4[0-2]|8[0-589])", , , , "100", , , [3, 5]], , [, , , , , , , , , [-1]]],
        GL: [, [
          ,
          ,
          "1\\d\\d",
          ,
          ,
          ,
          ,
          ,
          ,
          [3]
        ], , , [, , "112", , , , "112"], [, , , , , , , , , [-1]], , , , "GL", , , , , , , , , , , , , , , , , , [, , "112", , , , "112"], , [, , "1[1-8]\\d", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        GM: [, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:1[6-8]|[6-8])", , , , "16"], [, , , , , , , , , [-1]], , , , "GM", , , , , , , , , , , , , , , , , , [, , "1(?:1[6-8]|[6-8])", , , , "16"], , [, , "1(?:1[6-8]|[6-8])", , , , "16"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        GN: [, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "GN", , , , , , , , , , , , , , , , , , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , [, , "12\\d|40404", , , , "120"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        GP: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "GP", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        GR: [, [, , "1\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "1(?:0[089]|1(?:2|6\\d{3})|66|99)", , , , "100", , , [3, 6]], [, , , , , , , , , [-1]], , , , "GR", , , , , , , , , , , , , , , , , , [, , "1(?:00|12|66|99)", , , , "100", , , [3]], , [
          ,
          ,
          "1(?:0[089]|1(?:2|320|6(?:000|1(?:1[17]|23)))|(?:389|9)9|66)",
          ,
          ,
          ,
          "100"
        ], [, , "113\\d\\d", , , , "11300", , , [5]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        GT: [, [, , "[14]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:10|2[03])", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "GT", , , , , , , , , , , , , , , , , , [, , "1(?:10|2[03])", , , , "110", , , [3]], , [, , "110|40404|1(?:2|[57]\\d)\\d", , , , "110"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        GU: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "GU", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "9(?:11|88)", , , , "911"], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        GW: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[378]", , , , "113"], [, , , , , , , , , [-1]], , , , "GW", , , , , , , , , , , , , , , , , , [, , "11[378]", , , , "113"], , [, , "11[378]", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        GY: [, [, , "[019]\\d{2,3}", , , , , , , [3, 4]], , , [, , "91[1-3]", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "GY", , , , , , , , , , , , , , , , , , [, , "91[1-3]", , , , "911", , , [3]], , [, , "0(?:02|(?:17|80)1|444|7(?:[67]7|9)|9(?:0[78]|[2-47]))|1(?:443|5[568])|91[1-3]", , , , "002"], [, , , , , , , , , [-1]], [
          ,
          ,
          "144\\d",
          ,
          ,
          ,
          "1440",
          ,
          ,
          [4]
        ], , [, , "144\\d", , , , "1440", , , [4]]],
        HK: [
          ,
          [, , "[19]\\d{2,6}", , , , , , , [3, 4, 5, 6, 7]],
          ,
          ,
          [, , "112|99[29]", , , , "112", , , [3]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "HK",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "112|99[29]", , , , "112", , , [3]],
          ,
          [, , "1(?:0(?:(?:[0136]\\d|2[14])\\d{0,3}|8[138])|12|2(?:[0-3]\\d{0,4}|(?:58|8[13])\\d{0,3})|7(?:[135-9]\\d{0,4}|219\\d{0,2})|8(?:0(?:(?:[13]|60\\d)\\d|8)|1(?:0\\d|[2-8])|2(?:0[5-9]|(?:18|2)2|3|8[128])|(?:(?:3[0-689]\\d|7(?:2[1-389]|8[0235-9]|93))\\d|8)\\d|50[138]|6(?:1(?:11|86)|8)))|99[29]|10[0139]", , , , "100"],
          [, , , , , , , , , [-1]],
          [, , "109|1(?:08|85\\d)\\d", , , , "109", , , [3, 4, 5]],
          ,
          [, , "992", , , , "992", , , [3]]
        ],
        HN: [, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "199", , , , "199", , , [3]], [, , , , , , , , , [-1]], , , , "HN", , , , , , , , , , , , , , , , , , [, , "199", , , , "199", , , [3]], , [, , "199|40404", , , , "199"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        HR: [
          ,
          [, , "[19]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]],
          ,
          ,
          [, , "1(?:12|9[2-4])|9[34]|1(?:16\\d|39)\\d\\d", , , , "93", , , [2, 3, 5, 6]],
          [, , "118\\d\\d", , , , "11800", , , [5]],
          ,
          ,
          ,
          "HR",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:12|9[2-4])|9[34]", , , , "93", , , [2, 3]],
          ,
          [, , "1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|3977|9(?:[2-5]|87))|9[34]", , , , "93"],
          [, , , , , , , , , [-1]],
          [, , "139\\d\\d", , , , "13900", , , [5]],
          ,
          [, , "139\\d\\d", , , , "13900", , , [5]]
        ],
        HT: [, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "11[48]", , , , "114", , , [3]], [, , , , , , , , , [-1]], , , , "HT", , , , , , , , , , , , , , , , , , [, , "11[48]", , , , "114", , , [3]], , [, , "11[48]|40404", , , , "114"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        HU: [, [
          ,
          ,
          "1\\d{2,5}",
          ,
          ,
          ,
          ,
          ,
          ,
          [3, 4, 5, 6]
        ], , , [, , "1(?:0[457]|12|4[0-4]\\d)|1(?:16\\d|37|45)\\d\\d", , , , "104"], [, , , , , , , , , [-1]], , , , "HU", , , , , , , , , , , , , , , , , , [, , "1(?:0[457]|12)", , , , "104", , , [3]], , [, , "1(?:0[457]|1(?:2|6(?:000|1(?:11|23))|800)|2(?:0[0-4]|1[013489]|2[0-5]|3[0-46]|4[0-24-68]|5[0-2568]|6[06]|7[0-25-7]|8[028]|9[08])|37(?:00|37|7[07])|4(?:0[0-5]|1[013-8]|2[034]|3[23]|4[02-9]|5(?:00|41|67))|777|8(?:1[27-9]|2[04]|40|[589]))", , , , "104"], [, , , , , , , , , [-1]], [, , "1(?:4[0-4]|77)\\d|1(?:18|2|45)\\d\\d", , , , "1200", , , [4, 5]], , [
          ,
          ,
          "184\\d",
          ,
          ,
          ,
          "1840",
          ,
          ,
          [4]
        ]],
        ID: [, [, , "[178]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "11[02389]", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "ID", , , , , , , , , , , , , , , , , , [, , "11[02389]", , , , "110", , , [3]], , [, , "1(?:1[02389]|40\\d\\d|50264)|71400|89887", , , , "110"], [, , , , , , , , , [-1]], [, , "(?:714|898)\\d\\d", , , , "71400", , , [5]], , [, , "714\\d\\d", , , , "71400", , , [5]]],
        IE: [, [, , "[159]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:2|6\\d{3})|999", , , , "112", , , [3, 6]], [, , "5[37]\\d{3}", , , , "53000", , , [5]], , , , "IE", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "112", , , [3]], , [
          ,
          ,
          "11(?:2|6(?:00[06]|1(?:1[17]|23)))|999|(?:1(?:18|9)|5[0137]\\d)\\d\\d",
          ,
          ,
          ,
          "112"
        ], [, , "51\\d{3}", , , , "51000", , , [5]], [, , "51210", , , , "51210", , , [5]], , [, , "51210|(?:118|5[037]\\d)\\d\\d", , , , "11800", , , [5]]],
        IL: [, [, , "[12]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:0[0-2]|12)", , , , "100", , , [3]], [, , , , , , , , , [-1]], , , , "IL", , , , , , , , , , , , , , , , , , [, , "1(?:0[0-2]|12)", , , , "100", , , [3]], , [, , "1(?:0[0-2]|1(?:[013-9]\\d|2)|[2-9]\\d\\d)|2407|(?:104|27)00", , , , "100"], [, , , , , , , , , [-1]], [, , "104\\d\\d", , , , "10400", , , [5]], , [, , "104\\d\\d", , , , "10400", , , [5]]],
        IM: [, [, , "[189]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [
          ,
          ,
          "999",
          ,
          ,
          ,
          "999",
          ,
          ,
          [3]
        ], [, , , , , , , , , [-1]], , , , "IM", , , , , , , , , , , , , , , , , , [, , "999", , , , "999", , , [3]], , [, , "1\\d\\d(?:\\d{3})?|8(?:6444|9887)|999", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "8(?:64|98)\\d\\d", , , , "86400", , , [5]]],
        IN: [
          ,
          [, , "[12578]\\d{2,8}", , , , , , , [3, 4, 5, 6, 7, 8, 9]],
          ,
          ,
          [, , "1(?:0[0-248]|1[289]|21|[39][89]|4[01]|6(?:1|6\\d?)|8[12])|777|800|1[05]5\\d|1(?:07|51|94)\\d\\d?|(?:1(?:[05]5\\d|70)\\d|261)\\d|1(?:0[369]|10|29|3[126]|9[0-256])\\d", , , , "100", , , [3, 4, 5, 6]],
          [, , "11[67]\\d{4}|56161561", , , , "1160000", , , [7, 8]],
          ,
          ,
          ,
          "IN",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:0[0-28]|12|298)|2611", , , , "100", , , [3, 4]],
          ,
          [
            ,
            ,
            "1(?:0(?:[0-248]|3[39]|5(?:010|6)|6[3468]|7(?:[01357]|[28]0?|4[01])|9[0135-9])|1(?:00|[289])|2(?:1|98)|3(?:11|2[0-2]|63|[89])|4[01]|5(?:1(?:0[0-36]|[127])|54)|6(?:1|6[01]?)|7000|8[12]|9(?:0[013-59]|12|25|4[4-9]\\d?|50|6[1347]|[89]))|2611|5(?:0(?:0(?:0\\d|1|20?)|325|5[2-79]\\d{3,5})|1(?:234|555|717|818|96[49])|2(?:0(?:0[01]|[14]0)|151|555|666|888|9(?:06|99\\d?))|3(?:0[01]0|131|553|(?:66|77)6)|(?:464|55[05])\\d{1,3}|6(?:070|3[68]|43)|717\\d)|777|800|5(?:05(?:0|1\\d)|221|3(?:03|3[23]))\\d{1,4}|5(?:(?:04|88)0|2(?:2[0267]|3[16])|4(?:1[04]|20|3[02])|5(?:3[16]|67)|6(?:06|[67]\\d)|787|9(?:64|90))\\d\\d?|(?:1(?:05[79]|(?:1[67][0-2]|802)\\d|55[23])\\d|5(?:(?:00(?:0\\d|1)|(?:304|616)\\d\\d)\\d|1(?:0[12]|4[2-4])|2(?:2[3589]|3(?:1\\d{3}|2)|4[04]|7[78])|4(?:[02]4|32\\d{4}|4[04]|99)|5(?:1[25]|[36]5|4[45]|93)|7(?:(?:17\\d|57)\\d\\d|[27]7|88)|8(?:3[4-69]|4[01]|5[58]|88(?:8\\d\\d|9)|99)|9(?:0(?:0|2\\d{3})|55|6[67]|77|88)))\\d",
            ,
            ,
            ,
            "100"
          ],
          [, , "5(?:14(?:2[5-9]|[34]\\d)|757555)", , , , "51425", , , [5, 7]],
          [, , "1(?:(?:1[67]\\d\\d|70)\\d\\d|55330|909)|5(?:300\\d|6161(?:17[89]|561))|1(?:[19][89]|21|4[01])", , , , "118", , , [3, 4, 5, 6, 7, 8]],
          ,
          [, , "1(?:39|90[019])|5(?:14(?:2[5-9]|[34]\\d)|6161(?:17[89]|561)|757555)", , , , "139", , , [3, 4, 5, 7, 8]]
        ],
        IQ: [, [, , "[1479]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:0[04]|15|22)", , , , "100", , , [3]], [, , , , , , , , , [-1]], , , , "IQ", , , , , , , , , , , , , , , , , , [, , "1(?:0[04]|15|22)", , , , "100", , , [3]], , [, , "1(?:0[04]|15|22)|4432|71117|9988", , , , "100"], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , "(?:443|711\\d|998)\\d", , , , "4430", , , [4, 5]], , [, , "(?:443|711\\d|998)\\d", , , , "4430", , , [4, 5]]],
        IR: [, [, , "[129]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1[0-68]|2[0-59]|9[0-579])|911", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "IR", , , , , , , , , , , , , , , , , , [, , "1(?:1[025]|25)|911", , , , "110", , , [3]], , [
          ,
          ,
          "1(?:1[0-68]|2[0-59]|3[346-8]|4(?:[0147]|[289]0)|5(?:0[14]|1[02479]|2[0-3]|39|[49]0|65)|6(?:[16]6|[27]|90)|8(?:03|1[18]|22|3[37]|4[28]|88|99)|9[0-579])|20(?:[09]0|1(?:[038]|1[079]|26|9[69])|2[01])|9(?:11|9(?:0009|90))",
          ,
          ,
          ,
          "110"
        ], [, , "1(?:5[0-469]|8[0-489])\\d", , , , "1500", , , [4]], [, , "(?:1(?:5[0-469]|8[0-489])|99(?:0\\d\\d|9))\\d", , , , "1500", , , [4, 6]], , [, , "990\\d{3}", , , , "990000", , , [6]]],
        IS: [, [, , "1\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "1(?:12|71\\d)", , , , "112", , , [3, 4]], [, , , , , , , , , [-1]], , , , "IS", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "1(?:1(?:[28]|61(?:16|23))|4(?:00|1[145]|4[0146])|55|7(?:00|17|7[07-9])|8(?:[02]0|1[16-9]|88)|900)", , , , "112"], [, , , , , , , , , [-1]], [, , "14(?:0\\d|41)", , , , "1400", , , [4]], , [
          ,
          ,
          "1(?:415|90\\d)",
          ,
          ,
          ,
          "1415",
          ,
          ,
          [4]
        ]],
        IT: [
          ,
          [, , "[14]\\d{2,6}", , , , , , , [3, 4, 5, 6, 7]],
          ,
          ,
          [, , "1(?:1(?:[2358]|6\\d{3})|87)", , , , "112", , , [3, 6]],
          [, , "(?:12|4(?:[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d", , , , "1200", , , [4, 5, 7]],
          ,
          ,
          ,
          "IT",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "11[2358]", , , , "112", , , [3]],
          ,
          [, , "1(?:0\\d{2,3}|1(?:[2-57-9]|6(?:000|111))|3[39]|4(?:82|9\\d{1,3})|5(?:00|1[58]|2[25]|3[03]|44|[59])|60|8[67]|9(?:[01]|2[2-9]|4\\d|696))|4(?:2323|5045)|(?:1(?:2|92[01])|4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d", , , , "112"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , "4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|5[05])\\d\\d", , , , "43000", , , [5, 7]]
        ],
        JE: [, [, , "[129]\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "112|999", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "JE", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "112", , , [3]], , [, , "1(?:00|1(?:2|8\\d{3})|23|4(?:[14]|28|7\\d)|5\\d|7(?:0[12]|[128]|35?)|808|9[0135])|23[2-4]|999", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        JM: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "11[029]|9(?:11|88)", , , , "110"], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , , "JM", , , , , , , , , , , , , , , , , , [, , "11[029]|911", , , , "110"], , [, , "1(?:1[029]|76)|9(?:11|88)", , , , "110"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
        JO: [, [, , "[19]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "1(?:0[235]|1[2-6]|9[127])|911", , , , "102", , , [3]], [, , "9[0-4689]\\d{3}", , , , "90000", , , [5]], , , , "JO", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[127])|911", , , , "112", , , [3]], , [, , "1(?:0[2359]|1[0-68]|9[0-24-79])|9[0-4689]\\d{3}|911", , , , "102"], [, , , , , , , , , [-1]], [, , "9[0-4689]\\d{3}", , , , "90000", , , [5]], , [
          ,
          ,
          "9[0-4689]\\d{3}",
          ,
          ,
          ,
          "90000",
          ,
          ,
          [5]
        ]],
        JP: [, [, , "[01]\\d\\d(?:\\d{7})?", , , , , , , [3, 10]], , , [, , "11[089]", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "JP", , , , , , , , , , , , , , , , , , [, , "11[09]", , , , "110", , , [3]], , [, , "000[259]\\d{6}|1(?:0[24]|1[089]|44|89)", , , , "102"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "000[259]\\d{6}", , , , "0002000000", , , [10]]],
        KE: [, [, , "[1-9]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:1(?:[246]|9\\d)|5(?:01|2[127]|6[26]\\d))|999", , , , "112"], [, , "909\\d\\d", , , , "90900", , , [5]], , , , "KE", , , , , , , , , , , , , , , , , , [, , "11[24]|999", , , , "112", , , [3]], , [
          ,
          ,
          "1(?:0(?:[07-9]|1[0-25]|400)|1(?:[024-6]|9[0-579])|2[1-3]|3[01]|4[14]|5(?:[01][01]|2[0-24-79]|33|4[05]|5[59]|6(?:00|29|6[67]))|(?:6[035]\\d|[78])\\d|9(?:[02-9]\\d\\d|19))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99))\\d\\d|9(?:09\\d\\d|99)|8988",
          ,
          ,
          ,
          "100"
        ], [, , , , , , , , , [-1]], [, , "1(?:(?:04|6[35])\\d\\d|3[01]|4[14]|5(?:1\\d|2[25]))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99)|909)\\d\\d|898\\d", , , , "130"], , [, , "1(?:(?:04|6[035])\\d\\d|4[14]|5(?:01|55|6[26]\\d))|40404|8988|909\\d\\d", , , , "141"]],
        KG: [, [, , "[14]\\d{2,3}", , , , , , , [3, 4]], , , [, , "10[1-3]", , , , "101", , , [3]], [, , , , , , , , , [-1]], , , , "KG", , , , , , , , , , , , , , , , , , [, , "10[1-3]", , , , "101", , , [3]], , [, , "10[1-3]|4040", , , , "101"], [, , , , , , , , , [-1]], [, , "404\\d", , , , "4040", , , [4]], , [
          ,
          ,
          "404\\d",
          ,
          ,
          ,
          "4040",
          ,
          ,
          [4]
        ]],
        KH: [, [, , "[146]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "11[7-9]|666", , , , "117", , , [3]], [, , , , , , , , , [-1]], , , , "KH", , , , , , , , , , , , , , , , , , [, , "11[7-9]|666", , , , "117", , , [3]], , [, , "11[7-9]|40404|666", , , , "117"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        KI: [, [, , "[179]\\d{2,3}", , , , , , , [3, 4]], , , [, , "19[2-5]|99[2-4]", , , , "192", , , [3]], [, , , , , , , , , [-1]], , , , "KI", , , , , , , , , , , , , , , , , , [, , "19[2-5]|99[2-4]", , , , "192", , , [3]], , [, , "1(?:05[0-259]|88|9[2-5])|777|99[2-4]|10[0-8]", , , , "100"], [
          ,
          ,
          "103",
          ,
          ,
          ,
          "103",
          ,
          ,
          [3]
        ], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        KM: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "KM", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        KN: [, [, , "[39]\\d\\d", , , , , , , [3]], , , [, , "333|9(?:11|88|99)", , , , "333"], [, , , , , , , , , [-1]], , , , "KN", , , , , , , , , , , , , , , , , , [, , "333|9(?:11|99)", , , , "333"], , [, , "333|9(?:11|88|99)", , , , "333"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        KP: [, [, , "[18]\\d\\d", , , , , , , [3]], , , [
          ,
          ,
          "11[29]|819",
          ,
          ,
          ,
          "112"
        ], [, , , , , , , , , [-1]], , , , "KP", , , , , , , , , , , , , , , , , , [, , "11[29]|819", , , , "112"], , [, , "11[29]|819", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        KR: [, [, , "1\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:1[27-9]|28|330|82)", , , , "112", , , [3, 4]], [, , , , , , , , , [-1]], , , , "KR", , , , , , , , , , , , , , , , , , [, , "11[29]", , , , "112", , , [3]], , [, , "1(?:[016-9]114|3(?:0[01]|2|3[0-35-9]|45?|5[057]|6[569]|7[79]|8[2589]|9[0189]))|1(?:0[015]|1\\d|2[01357-9]|41|8[28])", , , , "100"], [, , , , , , , , , [-1]], [
          ,
          ,
          "1(?:0[01]|1[4-6]|41)|1(?:[06-9]1\\d|111)\\d",
          ,
          ,
          ,
          "100",
          ,
          ,
          [3, 5]
        ], , [, , , , , , , , , [-1]]],
        KW: [, [, , "[18]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "112", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "KW", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "1[0-7]\\d|89887", , , , "100"], [, , , , , , , , , [-1]], [, , "898\\d\\d", , , , "89800", , , [5]], , [, , , , , , , , , [-1]]],
        KY: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "KY", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        KZ: [, [, , "[1-4]\\d{2,4}", , , , , , , [
          3,
          4,
          5
        ]], , , [, , "1(?:0[1-3]|12)|212\\d", , , , "101", , , [3, 4]], [, , , , , , , , , [-1]], , , , "KZ", , , , , , , , , , , , , , , , , , [, , "1(?:0[1-3]|12)", , , , "101", , , [3]], , [, , "1(?:0[1-4]|12)|2121|(?:3040|404)0", , , , "101"], [, , , , , , , , , [-1]], [, , "(?:304\\d|404)\\d", , , , "4040", , , [4, 5]], , [, , "(?:304\\d|404)\\d", , , , "4040", , , [4, 5]]],
        LA: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "19[015]", , , , "190"], [, , , , , , , , , [-1]], , , , "LA", , , , , , , , , , , , , , , , , , [, , "19[015]", , , , "190"], , [, , "19[015]", , , , "190"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        LB: [
          ,
          [, , "[19]\\d\\d", , , , , , , [3]],
          ,
          ,
          [, , "1(?:12|40|75)|999", , , , "112"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "LB",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:12|40|75)|999", , , , "112"],
          ,
          [, , "1(?:12|40|75)|999", , , , "112"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        LC: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "LC", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        LI: [
          ,
          [, , "1\\d{2,3}", , , , , , , [3, 4]],
          ,
          ,
          [, , "1(?:1[278]|44)", , , , "112", , , [3]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "LI",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:1[278]|44)", , , , "112", , , [3]],
          ,
          [, , "1(?:1(?:[278]|45)|4[3-57]|50|75|81[18])", , , , "112"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        LK: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "11[02689]", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "LK", , , , , , , , , , , , , , , , , , [, , "11[02689]", , , , "110", , , [3]], , [, , "1(?:1[024-9]|3(?:00|1[2-49]|2[23]|3[1-3]|44|5[07]|[67]9|88|9[039])|9(?:0[0-2589]|1[0-357-9]|2[0-25689]|3[0389]|4[0489]|5[014-69]|6[0-2689]|7[03579]|8[02457-9]|9[0-2569]))", , , , "110"], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , [, , , , , , , , , [-1]]],
        LR: [, [, , "[3489]\\d{2,3}", , , , , , , [3, 4]], , , [, , "355|911", , , , "355", , , [3]], [, , , , , , , , , [-1]], , , , "LR", , , , , , , , , , , , , , , , , , [, , "355|911", , , , "355", , , [3]], , [, , "355|4040|8(?:400|933)|911", , , , "355"], [, , , , , , , , , [-1]], [, , "(?:404|8(?:40|93))\\d", , , , "4040", , , [4]], , [, , "(?:404|8(?:40|93))\\d", , , , "4040", , , [4]]],
        LS: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[257]", , , , "112"], [, , , , , , , , , [-1]], , , , "LS", , , , , , , , , , , , , , , , , , [, , "11[257]", , , , "112"], , [, , "11[257]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        LT: [, [, , "[01]\\d(?:\\d(?:\\d{3})?)?", , , , , , , [2, 3, 6]], , , [, , "0(?:11?|22?|33?)|1(?:0[1-3]|1(?:2|6111))|116(?:0\\d|12)\\d", , , , "01"], [, , , , , , , , , [-1]], , , , "LT", , , , , , , , , , , , , , , , , , [, , "0(?:11?|22?|33?)|1(?:0[1-3]|12)", , , , "01", , , [2, 3]], , [, , "0(?:11?|22?|33?)|1(?:0[1-3]|1(?:[27-9]|6(?:000|1(?:1[17]|23))))", , , , "01"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        LU: [
          ,
          [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]],
          ,
          ,
          [, , "11(?:[23]|6\\d{3})", , , , "112", , , [3, 6]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "LU",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "11[23]", , , , "112", , , [3]],
          ,
          [, , "11(?:[23]|6(?:000|111))|1(?:18|[25]\\d|3)\\d\\d", , , , "112"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        LV: [, [, , "[018]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]], , , [, , "0[1-3]|11(?:[023]|6\\d{3})", , , , "01", , , [2, 3, 6]], [, , "1180|821\\d\\d", , , , "1180", , , [4, 5]], , , , "LV", , , , , , , , , , , , , , , , , , [, , "0[1-3]|11[023]", , , , "01", , , [2, 3]], , [, , "0[1-4]|1(?:1(?:[02-4]|6(?:000|111)|8[0189])|(?:5|65)5|77)|821[57]4", , , , "01"], [, , "1181", , , , "1181", , , [4]], [, , "165\\d", , , , "1650", , , [4]], , [, , , , , , , , , [-1]]],
        LY: [, [, , "1\\d\\d", , , , , , , [3]], , , [
          ,
          ,
          "19[013]",
          ,
          ,
          ,
          "190"
        ], [, , , , , , , , , [-1]], , , , "LY", , , , , , , , , , , , , , , , , , [, , "19[013]", , , , "190"], , [, , "19[013]", , , , "190"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MA: [, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:[59]|77)", , , , "15"], [, , , , , , , , , [-1]], , , , "MA", , , , , , , , , , , , , , , , , , [, , "1(?:[59]|77)", , , , "15"], , [, , "1(?:[59]|77)", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MC: [, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], , , , "MC", , , , , , , , , , , , , , , , , , [, , "1(?:12|[578])", , , , "15"], , [
          ,
          ,
          "1(?:12|41|[578])",
          ,
          ,
          ,
          "15"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MD: [, [, , "[19]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:2|6(?:000|1(?:11|2\\d)))|90[1-3]", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "MD", , , , , , , , , , , , , , , , , , [, , "112|90[1-3]", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d?|99)|90[04-9])|90[1-3]|1(?:4\\d\\d|6[0-389]|9[1-4])\\d", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        ME: [
          ,
          [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]],
          ,
          ,
          [, , "1(?:12|2[2-4])", , , , "112", , , [3]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "ME",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:12|2[2-4])", , , , "112", , , [3]],
          ,
          [, , "1(?:1(?:(?:[013-57-9]|6\\d\\d)\\d|2)|[249]\\d{3}|5999|8(?:0[089]|1[0-8]|888))|1(?:[02-5]\\d\\d|60[06]|700)|12\\d", , , , "112"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        MF: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "MF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MG: [
          ,
          [, , "1\\d\\d?", , , , , , , [2, 3]],
          ,
          ,
          [, , "1(?:1[78]|[78])", , , , "17"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "MG",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:1[78]|[78])", , , , "17"],
          ,
          [, , "1(?:1[78]|[78])", , , , "17"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        MH: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "MH", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MK: [, [, , "1\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "1(?:1(?:2|6\\d{3})|9[2-4])", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "MK", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[2-4])", , , , "112", , , [3]], , [
          ,
          ,
          "1(?:1(?:2|8\\d)|3\\d|9[2-4])|1(?:16|2\\d)\\d{3}",
          ,
          ,
          ,
          "112"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        ML: [, [, , "[136-8]\\d{1,4}", , , , , , , [2, 3, 4, 5]], , , [, , "1[578]|(?:352|67)00|7402|(?:677|744|8000)\\d", , , , "15", , , [2, 4, 5]], [, , "(?:12|800)2\\d|3(?:52(?:11|2[02]|3[04-6]|99)|7574)", , , , "1220", , , [4, 5]], , , , "ML", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15", , , [2]], , [, , "1(?:1(?:[013-9]\\d|2)|2(?:1[02-469]|2[13])|[578])|350(?:35|57)|67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)|800[0-2][12]|3(?:52|[67]\\d)\\d\\d", , , , "15"], [
          ,
          ,
          "37(?:433|575)|7400|8001\\d",
          ,
          ,
          ,
          "7400",
          ,
          ,
          [4, 5]
        ], [, , "3503\\d|(?:3[67]\\d|800)\\d\\d", , , , "35030", , , [5]], , [, , "374(?:0[24-9]|[1-9]\\d)|7400|3(?:6\\d|75)\\d\\d", , , , "7400", , , [4, 5]]],
        MM: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "199", , , , "199"], [, , , , , , , , , [-1]], , , , "MM", , , , , , , , , , , , , , , , , , [, , "199", , , , "199"], , [, , "199", , , , "199"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MN: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "10[0-35]", , , , "100"], [, , , , , , , , , [-1]], , , , "MN", , , , , , , , , , , , , , , , , , [, , "10[0-35]", , , , "100"], , [, , "10[0-35]", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        MO: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "MO", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MP: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "MP", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MQ: [, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], , , , "MQ", , , , , , , , , , , , , , , , , , [
          ,
          ,
          "1(?:12|[578])",
          ,
          ,
          ,
          "15"
        ], , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MR: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "MR", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MS: [, [, , "[29]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "MS", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "211|9(?:11|88|99)", , , , "211"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MT: [, [
          ,
          ,
          "1\\d\\d(?:\\d{3})?",
          ,
          ,
          ,
          ,
          ,
          ,
          [3, 6]
        ], , , [, , "11(?:2|6\\d{3})", , , , "112"], [, , , , , , , , , [-1]], , , , "MT", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "11(?:2|6(?:000|1(?:11|23)))", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MU: [, [, , "[189]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "11[45]|99[59]", , , , "114", , , [3]], [, , , , , , , , , [-1]], , , , "MU", , , , , , , , , , , , , , , , , , [, , "11[45]|99[59]", , , , "114", , , [3]], , [, , "1\\d{2,4}|(?:8\\d\\d|99)\\d", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MV: [, [, , "[14]\\d{2,3}", , , , , , , [3, 4]], , , [
          ,
          ,
          "1(?:02|1[89])",
          ,
          ,
          ,
          "102",
          ,
          ,
          [3]
        ], [, , , , , , , , , [-1]], , , , "MV", , , , , , , , , , , , , , , , , , [, , "1(?:02|1[89])", , , , "102", , , [3]], , [, , "1(?:[0-37-9]|[4-6]\\d)\\d|4040|1[45]1", , , , "100"], [, , , , , , , , , [-1]], [, , "1[45]1", , , , "141", , , [3]], , [, , , , , , , , , [-1]]],
        MW: [, [, , "[189]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "199|99[7-9]", , , , "199", , , [3]], [, , , , , , , , , [-1]], , , , "MW", , , , , , , , , , , , , , , , , , [, , "199|99[7-9]", , , , "199", , , [3]], , [, , "199|80400|99[7-9]", , , , "199"], [, , , , , , , , , [-1]], [, , "804\\d\\d", , , , "80400", , , [5]], , [, , "804\\d\\d", , , , "80400", , , [5]]],
        MX: [, [
          ,
          ,
          "[0579]\\d{2,4}",
          ,
          ,
          ,
          ,
          ,
          ,
          [3, 4, 5]
        ], , , [, , "0(?:6[0568]|80)|911", , , , "060", , , [3]], [, , "(?:530\\d|776)\\d", , , , "7760", , , [4, 5]], , , , "MX", , , , , , , , , , , , , , , , , , [, , "0(?:6[0568]|80)|911", , , , "060", , , [3]], , [, , "0[1-9]\\d|53053|7766|911", , , , "010"], [, , , , , , , , , [-1]], [, , "0(?:[249]0|[35][01])", , , , "020", , , [3]], , [, , , , , , , , , [-1]]],
        MY: [, [, , "[1369]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "112|999", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "MY", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "112", , , [3]], , [
          ,
          ,
          "1(?:0[01348]|1(?:[02]|1[128]|311)|2(?:0[125]|[13-6]|2\\d{0,2})|(?:3[1-35-79]|7[45])\\d\\d?|5(?:454|5\\d\\d?|77|888|999?)|8(?:18?|2|8[18])|9(?:[124]\\d?|68|71|9[0679]))|66628|99[1-469]|13[5-7]|(?:1(?:0[569]|309|5[12]|7[136-9]|9[03])|3[23679]\\d\\d)\\d",
          ,
          ,
          ,
          "100"
        ], [, , "666\\d\\d", , , , "66600", , , [5]], [, , , , , , , , , [-1]], , [, , "(?:3[23679]\\d|666)\\d\\d", , , , "32000", , , [5]]],
        MZ: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[79]|9[78])", , , , "117", , , [3]], [, , , , , , , , , [-1]], , , , "MZ", , , , , , , , , , , , , , , , , , [, , "1(?:1[79]|9[78])", , , , "117", , , [3]], , [, , "1(?:[02-5]\\d\\d|1[79]|9[78])", , , , "117"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        NA: [, [, , "[19]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "10111", , , , "10111", , , [5]], [, , , , , , , , , [-1]], , , , "NA", , , , , , , , , , , , , , , , , , [, , "10111", , , , "10111", , , [5]], , [
          ,
          ,
          "(?:10|93)111|(?:1\\d|9)\\d\\d",
          ,
          ,
          ,
          "900"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        NC: [, [, , "[135]\\d{1,3}", , , , , , , [2, 3, 4]], , , [, , "1(?:0(?:00|1[23]|3[0-2]|8\\d)|[5-8])|363\\d|577", , , , "15"], [, , , , , , , , , [-1]], , , , "NC", , , , , , , , , , , , , , , , , , [, , "1[5-8]", , , , "15", , , [2]], , [, , "1(?:0(?:0[06]|1[02-46]|20|3[0-25]|42|5[058]|77|88)|[5-8])|3631|5[6-8]\\d", , , , "15"], [, , "5(?:67|88)", , , , "567", , , [3]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        NE: [, [, , "[1-3578]\\d(?:\\d(?:\\d{3})?)?", , , , , , , [2, 3, 6]], , , [
          ,
          ,
          "1(?:18|[578])|723\\d{3}",
          ,
          ,
          ,
          "15"
        ], [, , , , , , , , , [-1]], , , , "NE", , , , , , , , , , , , , , , , , , [, , "1(?:18|[578])|723141", , , , "15"], , [, , "1(?:0[01]|1[128]|2[034]|3[013]|[46]0|55?|[78])|222|333|555|723141|888", , , , "15"], [, , , , , , , , , [-1]], [, , "1(?:0[01]|1[12]|2[034]|3[013]|[46]0|55)|222|333|555|888", , , , "100", , , [3]], , [, , , , , , , , , [-1]]],
        NF: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|55|77)", , , , "911"], [, , , , , , , , , [-1]], , , , "NF", , , , , , , , , , , , , , , , , , [, , "9(?:11|55|77)", , , , "911"], , [, , "9(?:11|55|77)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        NG: [, [
          ,
          ,
          "[14]\\d\\d(?:\\d{2})?",
          ,
          ,
          ,
          ,
          ,
          ,
          [3, 5]
        ], , , [, , "199", , , , "199", , , [3]], [, , , , , , , , , [-1]], , , , "NG", , , , , , , , , , , , , , , , , , [, , "199", , , , "199", , , [3]], , [, , "199|40700", , , , "199"], [, , , , , , , , , [-1]], [, , "407\\d\\d", , , , "40700", , , [5]], , [, , "407\\d\\d", , , , "40700", , , [5]]],
        NI: [, [, , "[12467]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[58]|2[08])|737\\d", , , , "115"], [, , , , , , , , , [-1]], , , , "NI", , , , , , , , , , , , , , , , , , [, , "1(?:1[58]|2[08])", , , , "115", , , [3]], , [, , "1(?:1[58]|200)|4878|7(?:010|373)|12[0158]|(?:19|[267]1)00", , , , "115"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        NL: [
          ,
          [, , "[1349]\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]],
          ,
          ,
          [, , "11(?:2|6\\d{3})|911", , , , "112", , , [3, 6]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "NL",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "112|911", , , , "112", , , [3]],
          ,
          [, , "1(?:1(?:2|6(?:00[06]|1(?:11|23)))|2(?:0[0-4]|3[34]|44)|3[03-9]\\d|400|8(?:[02-9]\\d|1[0-79]))|[34]000|911", , , , "112"],
          [, , , , , , , , , [-1]],
          [, , "120\\d", , , , "1200", , , [4]],
          ,
          [, , "[34]00\\d", , , , "3000", , , [4]]
        ],
        NO: [, [, , "[01]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:[023]|6\\d{3})", , , , "110", , , [3, 6]], [, , , , , , , , , [-1]], , , , "NO", , , , , , , , , , , , , , , , , , [
          ,
          ,
          "11[023]",
          ,
          ,
          ,
          "110",
          ,
          ,
          [3]
        ], , [, , "04\\d{3}|1(?:1(?:[0239]|61(?:1[17]|23))|2[048]|4(?:12|[59])|7[57]|8[5-9]\\d|90)", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "04\\d{3}", , , , "04000", , , [5]]],
        NP: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:0[0-36]|12)|1(?:09|11)\\d", , , , "100"], [, , , , , , , , , [-1]], , , , "NP", , , , , , , , , , , , , , , , , , [, , "1(?:0[0-3]|12)", , , , "100", , , [3]], , [, , "1(?:0(?:[0-36]|98)|1(?:1[1-4]|2))", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        NR: [
          ,
          [, , "1\\d\\d", , , , , , , [3]],
          ,
          ,
          [, , "11[0-2]", , , , "110"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "NR",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "11[0-2]", , , , "110"],
          ,
          [, , "1(?:1[0-2]|23|92)", , , , "110"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        NU: [, [, , "[019]\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "NU", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "01[05]|101|999", , , , "010"], [, , , , , , , , , [-1]], [, , "010", , , , "010"], , [, , , , , , , , , [-1]]],
        NZ: [, [, , "\\d{3,4}", , , , , , , [3, 4]], , , [, , "111", , , , "111", , , [3]], [, , "018", , , , "018", , , [3]], , , , "NZ", , , , , , , , , , , , , , , , , , [, , "111", , , , "111", , , [3]], , [
          ,
          ,
          "018|1(?:(?:1|37)1|(?:23|94)4|7[03]7)|[2-57-9]\\d{2,3}|6(?:161|26[0-3]|742)",
          ,
          ,
          ,
          "018"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "018|(?:1(?:23|37|7[03]|94)|6(?:[12]6|74))\\d|[2-57-9]\\d{2,3}", , , , "018"]],
        OM: [, [, , "[19]\\d{3}", , , , , , , [4]], , , [, , "1444|999\\d", , , , "1444"], [, , , , , , , , , [-1]], , , , "OM", , , , , , , , , , , , , , , , , , [, , "1444|9999", , , , "1444"], , [, , "1(?:111|222|4(?:4[0-5]|50|66|7[7-9])|51[0-8])|9999|1(?:2[3-5]|3[0-2]|50)\\d", , , , "1111"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        PA: [
          ,
          [, , "[19]\\d\\d", , , , , , , [3]],
          ,
          ,
          [, , "911", , , , "911"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "PA",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "911", , , , "911"],
          ,
          [, , "10[2-4]|911", , , , "102"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        PE: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "1(?:05|1[67])", , , , "105"], [, , , , , , , , , [-1]], , , , "PE", , , , , , , , , , , , , , , , , , [, , "1(?:05|1[67])", , , , "105"], , [, , "1(?:05|1[67])", , , , "105"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        PF: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "PF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        PG: [, [, , "[01]\\d{2,6}", , , , , , , [
          3,
          4,
          5,
          6,
          7
        ]], , , [, , "000|11[01]", , , , "000", , , [3]], [, , , , , , , , , [-1]], , , , "PG", , , , , , , , , , , , , , , , , , [, , "000|11[01]", , , , "000", , , [3]], , [, , "000|1(?:1[01]|5\\d\\d|6\\d{2,5})", , , , "000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "16\\d{2,5}", , , , "1600", , , [4, 5, 6, 7]]],
        PH: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "11[27]|911", , , , "112"], [, , , , , , , , , [-1]], , , , "PH", , , , , , , , , , , , , , , , , , [, , "11[27]|911", , , , "112"], , [, , "11[27]|911", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        PK: [, [, , "1\\d{1,3}", , , , , , , [2, 3, 4]], , , [
          ,
          ,
          "1(?:1(?:2\\d?|5)|[56])",
          ,
          ,
          ,
          "15"
        ], [, , , , , , , , , [-1]], , , , "PK", , , , , , , , , , , , , , , , , , [, , "1(?:1(?:22?|5)|[56])", , , , "15"], , [, , "1(?:122|3[014]|[56])|11[2457-9]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        PL: [, [, , "[19]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "11(?:2|6\\d{3})|99[7-9]", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "PL", , , , , , , , , , , , , , , , , , [, , "112|99[7-9]", , , , "112", , , [3]], , [, , "1(?:1(?:2|61(?:11|23)|891[23])|9\\d{3})|9(?:8[4-7]|9[1-9])|11[68]000", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        PM: [, [
          ,
          ,
          "[13]\\d(?:\\d{2})?",
          ,
          ,
          ,
          ,
          ,
          ,
          [2, 4]
        ], , , [, , "1[578]", , , , "15", , , [2]], [, , , , , , , , , [-1]], , , , "PM", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15", , , [2]], , [, , "1[578]|3103", , , , "15"], [, , , , , , , , , [-1]], [, , "310\\d", , , , "3100", , , [4]], , [, , , , , , , , , [-1]]],
        PR: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "PR", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        PS: [
          ,
          [, , "1\\d{2,3}", , , , , , , [3, 4]],
          ,
          ,
          [, , "1(?:0[0-2]|66)", , , , "100", , , [3]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "PS",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "10[0-2]", , , , "100", , , [3]],
          ,
          [, , "1(?:0[0-2]|122|44|66|99)", , , , "100"],
          [, , , , , , , , , [-1]],
          [, , "112\\d", , , , "1120", , , [4]],
          ,
          [, , , , , , , , , [-1]]
        ],
        PT: [, [, , "1\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "11[257]|1(?:16\\d\\d|5[1589]|8[279])\\d", , , , "112"], [, , , , , , , , , [-1]], , , , "PT", , , , , , , , , , , , , , , , , , [, , "11[25]", , , , "112", , , [3]], , [, , "1(?:0(?:45|5[01])|1(?:[2578]|600[06])|4(?:1[45]|4)|583|6(?:1[0236]|3[02]|9[169]))|1(?:1611|59)1|1[068]78|1[08]9[16]|1(?:0[1-38]|40|5[15]|6[258]|82)0", , , , "112"], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , [, , , , , , , , , [-1]]],
        PW: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "PW", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        PY: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "128|911", , , , "128"], [, , , , , , , , , [-1]], , , , "PY", , , , , , , , , , , , , , , , , , [, , "128|911", , , , "128"], , [, , "1[1-9]\\d|911", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        QA: [
          ,
          [, , "[129]\\d{2,4}", , , , , , , [3, 4, 5]],
          ,
          ,
          [, , "99\\d", , , , "990", , , [3]],
          [, , "900", , , , "900", , , [3]],
          ,
          ,
          ,
          "QA",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "999", , , , "999", , , [3]],
          ,
          [, , "9(?:00|[19]\\d)|(?:1|20|9[27]\\d)\\d\\d", , , , "100"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        RE: [, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], , , , "RE", , , , , , , , , , , , , , , , , , [, , "1(?:12|[578])", , , , "15"], , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        RO: [
          ,
          [, , "[18]\\d{2,5}", , , , , , , [3, 4, 5, 6]],
          ,
          ,
          [, , "11(?:2|6\\d{3})", , , , "112", , , [3, 6]],
          [, , "(?:1(?:18[39]|[24])|8[48])\\d\\d", , , , "1200", , , [4, 6]],
          ,
          ,
          ,
          "RO",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "112", , , , "112", , , [3]],
          ,
          [, , "1(?:1(?:2|6(?:000|1(?:11|23))|8(?:(?:01|8[18])1|119|[23]00|932))|[24]\\d\\d|9(?:0(?:00|19)|1[19]|21|3[02]|5[178]))|8[48]\\d\\d", , , , "112"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , "(?:1[24]|8[48])\\d\\d", , , , "1200", , , [4]]
        ],
        RS: [, [, , "[19]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]], , , [, , "112|9[2-4]", , , , "92", , , [2, 3]], [, , , , , , , , , [-1]], , , , "RS", , , , , , , , , , , , , , , , , , [, , "112|9[2-4]", , , , "92", , , [2, 3]], , [, , "1[189]\\d{1,4}|9[2-4]", , , , "92"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        RU: [, [, , "[01]\\d\\d?", , , , , , , [2, 3]], , , [, , "112|(?:0|10)[1-3]", , , , "01"], [, , , , , , , , , [-1]], , , , "RU", , , , , , , , , , , , , , , , , , [, , "112|(?:0|10)[1-3]", , , , "01"], , [, , "112|(?:0|10)[1-4]", , , , "01"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        RW: [, [, , "[14]\\d\\d", , , , , , , [3]], , , [, , "11[1245]", , , , "111"], [, , , , , , , , , [-1]], , , , "RW", , , , , , , , , , , , , , , , , , [, , "11[12]", , , , "111"], , [, , "1(?:0[0-2]|1[0-24-6]|2[13]|70|99)|456", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        SA: [, [, , "[19]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [
          ,
          ,
          "11(?:2|6\\d{3})|9(?:11|37|9[7-9])",
          ,
          ,
          ,
          "112",
          ,
          ,
          [3, 6]
        ], [, , , , , , , , , [-1]], , , , "SA", , , , , , , , , , , , , , , , , , [, , "112|9(?:11|9[79])", , , , "112", , , [3]], , [, , "1(?:1(?:00|2|6111)|410|9(?:00|1[89]|9(?:099|22|9[0-3])))|9(?:0[24-79]|11|3[379]|40|66|8[5-9]|9[02-9])", , , , "112"], [, , "141\\d", , , , "1410", , , [4]], [, , "1(?:10|41)\\d|90[24679]", , , , "902", , , [3, 4]], , [, , , , , , , , , [-1]]],
        SB: [, [, , "[127-9]\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "SB", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [
          ,
          ,
          "1(?:[02]\\d|1[12]|[35][01]|[49][1-9]|6[2-9]|7[7-9]|8[0-8])|269|777|835|9(?:[01]1|22|33|55|77|88|99)",
          ,
          ,
          ,
          "100"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        SC: [, [, , "[19]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[1468]|60)|999", , , , "111", , , [3]], [, , , , , , , , , [-1]], , , , "SC", , , , , , , , , , , , , , , , , , [, , "999", , , , "999", , , [3]], , [, , "1(?:[06]\\d|1[0-246-8]|2[0-8]|3[13]|4[0-2]|5[15]|7[124-6]|8[158]|9[015])|9(?:6\\d\\d|99)", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        SD: [
          ,
          [, , "9\\d\\d", , , , , , , [3]],
          ,
          ,
          [, , "999", , , , "999"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "SD",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "999", , , , "999"],
          ,
          [, , "999", , , , "999"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        SE: [, [, , "[1-37-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:2|(?:3|6\\d)\\d\\d|414|77)|900\\d\\d", , , , "112"], [, , "11811[89]|72\\d{3}", , , , "72000", , , [5, 6]], , , , "SE", , , , , , , , , , , , , , , , , , [, , "112|90000", , , , "112", , , [3, 5]], , [, , "11(?:[25]|313|6(?:00[06]|1(?:1[17]|23))|7[0-8])|2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|9(?:0(?:00|51)0|12)|(?:11(?:4|8[02-46-9])|7\\d\\d|90[2-4])\\d\\d|(?:118|90)1(?:[02-9]\\d|1[013-9])", , , , "112"], [, , , , , , , , , [-1]], [
          ,
          ,
          "2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|912",
          ,
          ,
          ,
          "220",
          ,
          ,
          [3]
        ], , [, , "7\\d{4}", , , , "70000", , , [5]]],
        SG: [, [, , "[179]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "99[359]", , , , "993", , , [3]], [, , , , , , , , , [-1]], , , , "SG", , , , , , , , , , , , , , , , , , [, , "99[359]", , , , "993", , , [3]], , [, , "1(?:(?:[01368]\\d|44)\\d|[57]\\d{2,3}|9(?:0[1-9]|[1-9]\\d))|77222|99[02-9]|100", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "772\\d\\d", , , , "77200", , , [5]]],
        SH: [, [, , "[129]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "9(?:11|99)", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "SH", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911", , , [3]], , [
          ,
          ,
          "1\\d{2,3}|26[01]\\d\\d|9(?:11|99)",
          ,
          ,
          ,
          "100"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        SI: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:(?:0|6\\d)\\d\\d|[23]|8\\d\\d?)", , , , "112"], [, , , , , , , , , [-1]], , , , "SI", , , , , , , , , , , , , , , , , , [, , "11[23]", , , , "112", , , [3]], , [, , "1(?:1(?:00[146]|[23]|6(?:000|1(?:11|23))|8(?:[08]|99))|9(?:059|1(?:0[12]|16)|5|70|87|9(?:00|[149])))|19(?:08|81)[09]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        SJ: [, [, , "[01]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [
          ,
          ,
          "11[023]",
          ,
          ,
          ,
          "110",
          ,
          ,
          [3]
        ], [, , , , , , , , , [-1]], , , , "SJ", , , , , , , , , , , , , , , , , , [, , "11[023]", , , , "110", , , [3]], , [, , "04\\d{3}|11[023]", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "04\\d{3}", , , , "04000", , , [5]]],
        SK: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:2|6\\d{3})|5[058])", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "SK", , , , , , , , , , , , , , , , , , [, , "1(?:12|5[058])", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|111)|8[0-8])|[248]\\d{3}|5[0589])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        SL: [, [
          ,
          ,
          "[069]\\d\\d(?:\\d{2})?",
          ,
          ,
          ,
          ,
          ,
          ,
          [3, 5]
        ], , , [, , "(?:01|99)9", , , , "019", , , [3]], [, , , , , , , , , [-1]], , , , "SL", , , , , , , , , , , , , , , , , , [, , "(?:01|99)9", , , , "019", , , [3]], , [, , "(?:01|99)9|60400", , , , "019"], [, , , , , , , , , [-1]], [, , "604\\d\\d", , , , "60400", , , [5]], , [, , "604\\d\\d", , , , "60400", , , [5]]],
        SM: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[358]", , , , "113"], [, , , , , , , , , [-1]], , , , "SM", , , , , , , , , , , , , , , , , , [, , "11[358]", , , , "113"], , [, , "11[358]", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        SN: [, [, , "[12]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]], , , [
          ,
          ,
          "1(?:515|[78])|2(?:00|1)\\d{3}",
          ,
          ,
          ,
          "17",
          ,
          ,
          [2, 4, 5, 6]
        ], [, , "2(?:0[246]|[468])\\d{3}", , , , "24000", , , [5, 6]], , , , "SN", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17", , , [2]], , [, , "1(?:1[69]|(?:[246]\\d|51)\\d)|2(?:0[0-246]|[12468])\\d{3}|1[278]", , , , "12"], [, , "2(?:01|2)\\d{3}", , , , "22000", , , [5, 6]], [, , "1[46]\\d\\d", , , , "1400", , , [4]], , [, , "2[468]\\d{3}", , , , "24000", , , [5]]],
        SO: [, [, , "[57-9]\\d\\d", , , , , , , [3]], , , [, , "555|888|999", , , , "555"], [, , , , , , , , , [-1]], , , , "SO", , , , , , , , , , , , , , , , , , [, , "555|888|999", , , , "555"], , [, , "555|777|888|999", , , , "555"], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , [, , , , , , , , , [-1]]],
        SR: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "115", , , , "115", , , [3]], [, , , , , , , , , [-1]], , , , "SR", , , , , , , , , , , , , , , , , , [, , "115", , , , "115", , , [3]], , [, , "1\\d{2,3}", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        SS: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "SS", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        ST: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "112", , , , "112"], [, , , , , , , , , [-1]], , , , "ST", , , , , , , , , , , , , , , , , , [
          ,
          ,
          "112",
          ,
          ,
          ,
          "112"
        ], , [, , "112", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        SV: [, [, , "[149]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "116\\d{3}|911", , , , "911", , , [3, 6]], [, , , , , , , , , [-1]], , , , "SV", , , , , , , , , , , , , , , , , , [, , "91[13]", , , , "911", , , [3]], , [, , "1(?:1(?:2|6111)|2[136-8]|3[0-6]|9[05])|40404|9(?:1\\d|29)", , , , "112"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        SX: [
          ,
          [, , "9\\d\\d", , , , , , , [3]],
          ,
          ,
          [, , "9(?:19|88)", , , , "919"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "SX",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "919", , , , "919"],
          ,
          [, , "9(?:19|88)", , , , "919"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        SY: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[023]", , , , "110"], [, , , , , , , , , [-1]], , , , "SY", , , , , , , , , , , , , , , , , , [, , "11[023]", , , , "110"], , [, , "11[023]", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        SZ: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "SZ", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TC: [, [, , "9\\d\\d", , , , , , , [3]], , , [
          ,
          ,
          "9(?:11|88|99)",
          ,
          ,
          ,
          "911"
        ], [, , , , , , , , , [-1]], , , , "TC", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TD: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "TD", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TG: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[78]|7[127])", , , , "117", , , [3]], [, , , , , , , , , [-1]], , , , "TG", , , , , , , , , , , , , , , , , , [
          ,
          ,
          "1(?:1[78]|7[127])",
          ,
          ,
          ,
          "117",
          ,
          ,
          [3]
        ], , [, , "1(?:011|1[078]|7[127])", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TH: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1(?:00|2[03]|3[3479]|7[67]|9[0246])|578|6(?:44|6[79]|88|9[16])|88\\d|9[19])|1[15]55", , , , "191"], [, , "1(?:113|2[23]\\d|5(?:09|56))", , , , "1113", , , [4]], , , , "TH", , , , , , , , , , , , , , , , , , [, , "1(?:669|9[19])", , , , "191"], , [
          ,
          ,
          "1(?:0[0-2]|1(?:0[03]|1[1-35]|2[0358]|3[03-79]|4[02-489]|5[04-9]|6[04-79]|7[03-9]|8[027-9]|9[02-9])|2(?:22|3[89]|66)|3(?:18|2[23]|3[013]|5[56]|6[45]|73)|477|5(?:0\\d|4[0-37-9]|5[1-8]|6[01679]|7[12568]|8[0-24589]|9[013589])|6(?:0[0-29]|2[03]|4[3-6]|6[1-9]|7[0257-9]|8[0158]|9[014-9])|7(?:[14]9|7[27]|90)|888|9[19])",
          ,
          ,
          ,
          "100"
        ], [, , "1(?:1(?:03|1[15]|2[58]|3[056]|4[02-49]|5[046-9]|7[03-589]|9[57-9])|5(?:0[0-8]|4[0-378]|5[1-478]|7[156])|6(?:20|4[356]|6[1-68]|7[057-9]|8[015]|9[0457-9]))|1(?:1[68]|26|3[1-35]|5[689]|60|7[17])\\d", , , , "1103", , , [4]], [, , "114[89]", , , , "1148", , , [4]], , [, , , , , , , , , [-1]]],
        TJ: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "1(?:0[1-3]|12)", , , , "101"], [, , , , , , , , , [-1]], , , , "TJ", , , , , , , , , , , , , , , , , , [, , "1(?:0[1-3]|12)", , , , "101"], , [, , "1(?:0[1-3]|12)", , , , "101"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TL: [, [
          ,
          ,
          "1\\d\\d",
          ,
          ,
          ,
          ,
          ,
          ,
          [3]
        ], , , [, , "11[25]", , , , "112"], [, , , , , , , , , [-1]], , , , "TL", , , , , , , , , , , , , , , , , , [, , "11[25]", , , , "112"], , [, , "1(?:0[02]|1[25]|2[0138]|72|9[07])", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TM: [, [, , "0\\d", , , , , , , [2]], , , [, , "0[1-49]", , , , "01"], [, , , , , , , , , [-1]], , , , "TM", , , , , , , , , , , , , , , , , , [, , "0[1-3]", , , , "01"], , [, , "0[1-49]", , , , "01"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TN: [
          ,
          [, , "1\\d\\d", , , , , , , [3]],
          ,
          ,
          [, , "19[078]", , , , "190"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "TN",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "19[078]", , , , "190"],
          ,
          [, , "19[078]", , , , "190"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        TO: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|22|33|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "TO", , , , , , , , , , , , , , , , , , [, , "9(?:11|22|33|99)", , , , "911"], , [, , "9(?:11|22|33|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TR: [, [, , "[1-9]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:1[02]|22|3[126]|4[04]|5[15-9]|6[18]|77|83)", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "TR", , , , , , , , , , , , , , , , , , [, , "1(?:1[02]|55)", , , , "110", , , [3]], , [
          ,
          ,
          "1(?:1(?:[02-79]|8(?:1[018]|2[0245]|3[2-4]|42|5[058]|6[06]|7[07]|8[01389]|9[089]))|3(?:37|[58]6|65)|471|5(?:07|78)|6(?:[02]6|99)|8(?:63|95))|2(?:077|268|4(?:17|23)|5(?:7[26]|82)|6[14]4|8\\d\\d|9(?:30|89))|3(?:0(?:05|72)|353|4(?:06|30|64)|502|674|747|851|9(?:1[29]|60))|4(?:0(?:25|3[12]|[47]2)|3(?:3[13]|[89]1)|439|5(?:43|55)|717|832)|5(?:145|290|[4-6]\\d\\d|772|833|9(?:[06]1|92))|6(?:236|6(?:12|39|8[59])|769)|7890|8(?:688|7(?:28|65)|85[06])|9(?:159|290)|1[2-9]\\d",
          ,
          ,
          ,
          "110"
        ], [, , "(?:285|542)0", , , , "2850", , , [4]], [, , , , , , , , , [-1]], , [, , "1(?:3(?:37|[58]6|65)|4(?:4|71)|5(?:07|78)|6(?:[02]6|99)|8(?:3|63|95))|(?:2(?:07|26|4[12]|5[78]|6[14]|8\\d|9[38])|3(?:0[07]|[38]5|4[036]|50|67|74|9[16])|4(?:0[2-47]|3[389]|[48]3|5[45]|71)|5(?:14|29|[4-6]\\d|77|83|9[069])|6(?:23|6[138]|76)|789|8(?:68|7[26]|85)|9(?:15|29))\\d", , , , "144", , , [3, 4]]],
        TT: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:88|9[09])", , , , "988"], [, , , , , , , , , [-1]], , , , "TT", , , , , , , , , , , , , , , , , , [, , "99[09]", , , , "990"], , [
          ,
          ,
          "9(?:88|9[09])",
          ,
          ,
          ,
          "988"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TV: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "TV", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "1\\d\\d|911", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TW: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "11[0289]|1(?:81|92)\\d", , , , "110"], [, , "10[56]", , , , "105", , , [3]], , , , "TW", , , , , , , , , , , , , , , , , , [, , "11[029]", , , , "110", , , [3]], , [
          ,
          ,
          "1(?:0[04-6]|1[0237-9]|3[389]|6[05-8]|7[07]|8(?:0|11)|9(?:19|22|5[057]|68|8[05]|9[15689]))",
          ,
          ,
          ,
          "100"
        ], [, , "1(?:65|9(?:1\\d|50|85|98))", , , , "165"], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TZ: [, [, , "[149]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "1(?:1[0-79]|9[09])|999", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "TZ", , , , , , , , , , , , , , , , , , [, , "11[0-245]|999", , , , "110", , , [3]], , [, , "1(?:1\\d|9[09])|46400|999", , , , "110"], [, , , , , , , , , [-1]], [, , "464\\d\\d", , , , "46400", , , [5]], , [, , "464\\d\\d", , , , "46400", , , [5]]],
        UA: [
          ,
          [, , "[189]\\d{2,5}", , , , , , , [3, 4, 5, 6]],
          ,
          ,
          [, , "1(?:0[1-3]|1(?:2|6\\d{3}))", , , , "101", , , [3, 6]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "UA",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:0[1-3]|12)", , , , "101", , , [3]],
          ,
          [, , "1(?:0[1-49]|1(?:2|6(?:000|1(?:11|23))|8\\d\\d?)|(?:[278]|5\\d)\\d)|[89]00\\d\\d?|151|1(?:06|4\\d|6)\\d\\d", , , , "101"],
          [, , , , , , , , , [-1]],
          [, , "(?:118|[89]00)\\d\\d?", , , , "1180", , , [4, 5]],
          ,
          [, , , , , , , , , [-1]]
        ],
        UG: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "UG", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        US: [, [, , "[1-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [
          ,
          ,
          "112|611|9(?:11|33|88)",
          ,
          ,
          ,
          "112",
          ,
          ,
          [3]
        ], [, , "24280|(?:381|968)35|4(?:3355|7553|8221)|5(?:(?:489|934)2|5928)|72078|(?:323|960)40|(?:276|414)63|(?:2(?:520|744)|7390|9968)9|(?:693|732|976)88|(?:3(?:556|825)|5294|8623|9729)4|(?:3378|4136|7642|8961|9979)6|(?:4(?:6(?:15|32)|827)|(?:591|720)8|9529)7", , , , "24280", , , [5]], , , , "US", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112", , , [3]], , [, , "11(?:2|5[1-47]|[68]\\d|7[0-57]|98)|[2-9]\\d{3,5}|[2-8]11|9(?:11|33|88)", , , , "112"], [
          ,
          ,
          "2(?:3333|(?:4224|7562|900)2|56447|6688)|3(?:1010|2665|7404)|40404|560560|6(?:0060|22639|5246|7622)|7(?:0701|3822|4666)|8(?:(?:3825|7226)5|4816)|99099",
          ,
          ,
          ,
          "23333",
          ,
          ,
          [5, 6]
        ], [, , "336\\d\\d|[2-9]\\d{3}|[2356]11", , , , "211", , , [3, 4, 5]], , [, , "[2-9]\\d{4,5}", , , , "20000", , , [5, 6]]],
        UY: [, [, , "[129]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "128|911", , , , "128", , , [3]], [, , , , , , , , , [-1]], , , , "UY", , , , , , , , , , , , , , , , , , [, , "128|911", , , , "128", , , [3]], , [, , "1(?:0[4-9]|1[2368]|2[0-3568]|787|997\\d?)|21997|911", , , , "104"], [, , "178\\d", , , , "1780", , , [4]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        UZ: [
          ,
          [, , "[04]\\d(?:\\d(?:\\d{2})?)?", , , , , , , [2, 3, 5]],
          ,
          ,
          [, , "0(?:0[1-3]|[1-3]|50)", , , , "01", , , [2, 3]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "UZ",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "0(?:0[1-3]|[1-3]|50)", , , , "01", , , [2, 3]],
          ,
          [, , "0(?:0[1-3]|[1-3]|50)|45400", , , , "01"],
          [, , , , , , , , , [-1]],
          [, , "454\\d\\d", , , , "45400", , , [5]],
          ,
          [, , "454\\d\\d", , , , "45400", , , [5]]
        ],
        VA: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[2358]", , , , "112"], [, , , , , , , , , [-1]], , , , "VA", , , , , , , , , , , , , , , , , , [, , "11[2358]", , , , "112"], , [, , "11[2358]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        VC: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "VC", , , , , , , , , , , , , , , , , , [
          ,
          ,
          "9(?:11|99)",
          ,
          ,
          ,
          "911"
        ], , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        VE: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "1(?:12|71)|911", , , , "112"], [, , , , , , , , , [-1]], , , , "VE", , , , , , , , , , , , , , , , , , [, , "1(?:12|71)|911", , , , "112"], , [, , "1(?:12|71)|911", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        VG: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "VG", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        VI: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "VI", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        VN: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[3-5]", , , , "113"], [, , , , , , , , , [-1]], , , , "VN", , , , , , , , , , , , , , , , , , [, , "11[3-5]", , , , "113"], , [, , "11[3-5]", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        VU: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "112", , , , "112"], [, , , , , , , , , [-1]], , , , "VU", , , , , , , , , , , , , , , , , , [
          ,
          ,
          "112",
          ,
          ,
          ,
          "112"
        ], , [, , "112", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        WF: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "WF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        WS: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|9[4-69])", , , , "911"], [, , , , , , , , , [-1]], , , , "WS", , , , , , , , , , , , , , , , , , [, , "9(?:11|9[4-69])", , , , "911"], , [, , "1(?:1[12]|2[0-6]|[39]0)|9(?:11|9[4-79])", , , , "111"], [, , , , , , , , , [-1]], [, , "12[0-6]", , , , "120"], , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        XK: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "1(?:12|9[2-4])", , , , "112"], [, , , , , , , , , [-1]], , , , "XK", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[2-4])", , , , "112"], , [, , "1(?:12|9[2-4])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        YE: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "19[1459]", , , , "191"], [, , , , , , , , , [-1]], , , , "YE", , , , , , , , , , , , , , , , , , [, , "19[1459]", , , , "191"], , [, , "19[1459]", , , , "191"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        YT: [
          ,
          [, , "1\\d\\d?", , , , , , , [2, 3]],
          ,
          ,
          [, , "1(?:12|5)", , , , "15"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "YT",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:12|5)", , , , "15"],
          ,
          [, , "1(?:12|5)", , , , "15"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        ZA: [
          ,
          [, , "[134]\\d{2,4}", , , , , , , [3, 4, 5]],
          ,
          ,
          [, , "1(?:01\\d\\d|12)", , , , "112", , , [3, 5]],
          [, , "41(?:348|851)", , , , "41348", , , [5]],
          ,
          ,
          ,
          "ZA",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:01(?:11|77)|12)", , , , "112", , , [3, 5]],
          ,
          [, , "1(?:0(?:1(?:11|77)|20|7)|1[12]|77(?:3[237]|[45]7|6[279]|9[26]))|[34]\\d{4}", , , , "107"],
          [, , "3(?:078[23]|7(?:064|567)|8126)|4(?:394[16]|7751|8837)|4[23]699", , , , "30782", , , [5]],
          [, , "111", , , , "111", , , [3]],
          ,
          [, , "[34]\\d{4}", , , , "30000", , , [5]]
        ],
        ZM: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "112|99[139]", , , , "112"], [, , , , , , , , , [-1]], , , , "ZM", , , , , , , , , , , , , , , , , , [, , "112|99[139]", , , , "112"], , [, , "112|99[139]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        ZW: [, [, , "[139]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "112|9(?:5[023]|61|9[3-59])", , , , "112", , , [3]], [, , "3[013-57-9]\\d{3}", , , , "30000", , , [5]], , , , "ZW", , , , , , , , , , , , , , , , , , [, , "112|99[3-59]", , , , "112", , , [3]], , [
          ,
          ,
          "11[2469]|3[013-57-9]\\d{3}|9(?:5[023]|6[0-25]|9[3-59])",
          ,
          ,
          ,
          "112"
        ], [, , , , , , , , , [-1]], [, , "114|9(?:5[023]|6[0-25])", , , , "114", , , [3]], , [, , , , , , , , , [-1]]]
      };
      function F0() {
        this.g = {};
      }
      d(F0);
      function Md(o) {
        return (o = ge[o]) ? o : [];
      }
      function Td(o) {
        var c = f2;
        if (!o) return null;
        o = o.toUpperCase();
        var w = c.g[o];
        if (w == null) {
          if (w = c2[o], w == null) return null;
          w = new ie().g(Me.o(), w), c.g[o] = w;
        }
        return w;
      }
      function Ld(o) {
        if (!U(o, 2)) return "";
        var c = "" + B(o, 2);
        return U(o, 4) && B(o, 4) && 0 < V(o, 8) ? Array(V(o, 8) + 1).join("0") + c : c;
      }
      function Ad(o, c) {
        return 0 < q(c, 9).length && !q(c, 9).includes(o.length) ? !1 : a1(V(c, 2), o.toString());
      }
      var Ke = Le.pa(), f2 = F0.pa();
      function $2(o) {
        var c = Ke, w = _t(c, o);
        switch (c = v1(c, V(o, 1), w), c == null ? o = -1 : (o = C1(o), o = xd(o, c)), o) {
          case 0:
            return "fixed-line";
          case 2:
            return "fixed-line-or-mobile";
          case 1:
            return "mobile";
          case 8:
            return "pager";
          case 7:
            return "personal-number";
          case 4:
            return "premium-rate";
          case 5:
            return "shared-cost";
          case 3:
            return "toll-free";
          case 9:
            return "uan";
          case 6:
            return "voip";
          default:
          case -1:
            return "unknown";
        }
      }
      function p2(o) {
        switch (o) {
          case "fixed-line":
            return 0;
          case "fixed-line-or-mobile":
            return 2;
          case "mobile":
            return 1;
          case "pager":
            return 8;
          case "personal-number":
            return 7;
          case "premium-rate":
            return 4;
          case "shared-cost":
            return 5;
          case "toll-free":
            return 3;
          case "uan":
            return 9;
          case "voip":
            return 6;
          default:
          case "unknown":
            return -1;
        }
      }
      function _0(o) {
        try {
          switch (S0(o)) {
            case 0:
              return "is-possible";
            case 1:
              return "invalid-country-code";
            case 3:
              return "too-long";
            case 2:
              return "too-short";
          }
          if (k0(o)) return "is-possible";
        } catch {
        }
        return "unknown";
      }
      function m2(o, c) {
        if (o.charAt(0) !== "+" && o.slice(0, 2) !== "00") return { parsed: w, fa: A };
        try {
          var w = Cd(Ke, o, c);
        } catch {
        }
        if (w) {
          var A = _t(Ke, w);
          if (A != null && A !== "ZZ") return { parsed: w, fa: A };
        }
        for (c = 1; 4 > c; ++c) {
          if (A = void 0, o.length < c + 1) return { parsed: w, fa: A };
          if (A = k1(o.substring(1, c + 1)), A !== "ZZ") return { fa: A };
        }
        return { parsed: w, fa: void 0 };
      }
      var Dd;
      e: {
        try {
          Dd = /* @__PURE__ */ new WeakMap();
          break e;
        } catch {
        }
        Dd = void 0;
      }
      var Ht = Dd;
      function ue(o, c) {
        if (!(this instanceof ue)) return new ue(o, c);
        var w = c == null ? void 0 : c.regionCode;
        if (typeof o == "string") var A = !1;
        else try {
          C0(o), A = !0;
        } catch {
          A = !1;
        }
        if (!A && typeof o != "string") throw Error("Invalid phone number, expected a string");
        if (!A && typeof c != "object" && typeof c < "u") throw Error(`Invalid options, expected object, got ${typeof c}. This may be because of not yet upgraded code.`);
        if (!A && w != null && typeof w != "string") throw Error(`Invalid region code, expected a string, got ${typeof w} ${w}`);
        if (A || (o = o.trim(), w && o.charAt(0) === "+" && (w = null), w && o.charAt(0) !== "+" && o.slice(0, 2) !== "00" || ({ fa: w = null, parsed: D } = m2(o, w))), this.g = { number: {}, regionCode: w, valid: !1, possible: !1, shortPossible: !1, shortValid: !1 }, Ht && Ht.set(this.g, this), A) this.l = o;
        else {
          if (this.l = null, this.g.number.input = o, !w) {
            this.g.possibility = "invalid-country-code";
            return;
          }
          if (Id(w) === 0) {
            this.g.possibility = "invalid-country-code";
            return;
          }
          try {
            this.l = D || Cd(Ke, o, w);
          } catch {
            this.g.possibility = _0(o);
            return;
          }
        }
        this.g.number.international = Ke.format(this.l, 1), this.g.number.national = Ke.format(this.l, 2), this.g.number.e164 = Ke.format(this.l, 0), this.g.number.rfc3966 = Ke.format(this.l, 3), this.g.number.significant = C1(this.l), this.g.canBeInternationallyDialled = Ke.ja(this.l), this.g.valid = C0(this.l), this.g.possible = k0(this.l), this.g.possibility = _0(this.l), o = this.g, c = this.l;
        var D = Md(V(c, 1));
        e: if (D.length === 0) A = null;
        else if (D.length === 1) A = D[0];
        else {
          A = Ld(c);
          for (var F = 0; F < D.length; F++) {
            var Q = D[F], pe = Td(Q);
            if (pe && Ad(A, B(pe, 29))) {
              A = Q;
              break e;
            }
          }
          A = null;
        }
        1 < D.length && A != null ? c = !0 : (D = A, A = Md(V(c, 1)), D != null && A.includes(D) && (D = Td(D)) ? (c = Ld(c), A = B(D, 1), Ad(c, A) ? (D = B(D, 29), c = Ad(c, D)) : c = !1) : c = !1), o.shortValid = c, o = this.g;
        e: {
          for (D = this.l, c = Md(V(D, 1)), D = Ld(D).length, A = 0; A < c.length; A++) if ((F = Td(c[A])) && q(B(F, 1), 9).includes(D)) {
            c = !0;
            break e;
          }
          c = !1;
        }
        o.shortPossible = c, this.g.type = $2(this.l), this.g.typeIsMobile = this.ua(), this.g.typeIsFixedLine = this.ta(), this.g.countryCode = w1(w) ? ft(Ke, w) : 0;
      }
      var $t = ["PhoneNumber$$module$src$index"], p1 = t;
      $t[0] in p1 || typeof p1.execScript > "u" || p1.execScript("var " + $t[0]);
      for (var z1; $t.length && (z1 = $t.shift()); ) $t.length || ue === void 0 ? p1[z1] && p1[z1] !== Object.prototype[z1] ? p1 = p1[z1] : p1 = p1[z1] = {} : p1[z1] = ue;
      function Id(o) {
        return w1(o) ? ft(Ke, o) : 0;
      }
      ue.getCountryCodeForRegionCode = Id, ue.getRegionCodeForCountryCode = function(o) {
        return k1(o);
      }, ue.findNumbers = function(o, c) {
        var w = c == null ? void 0 : c.defaultRegionCode, A, D = (A = c == null ? void 0 : c.leniency) != null ? A : "valid", F;
        c = (F = c == null ? void 0 : c.maxTries) != null ? F : Number.MAX_SAFE_INTEGER, F = /([0-9]+(?: [0-9]+)*)/g, A = [];
        for (let b1 = 0; b1 < c; ++b1) {
          var Q = F.exec(o);
          if (!Q) break;
          let pt = Q.index;
          Q = Q.index + Q[1].length, 0 < pt && o.charAt(pt - 1) === "+" && --pt;
          var pe = o.slice(pt, Q), Ie = new ue(pe, { regionCode: w });
          (Ie.wa() || D === "possible" && Ie.va()) && A.push({ text: pe, phoneNumber: Ie.toJSON(), start: pt, end: Q });
        }
        return A;
      };
      function j0(o) {
        var c = {};
        return o.filter((w) => c.hasOwnProperty(w) ? !1 : (c[w] = 1, !0));
      }
      ue.getSupportedRegionCodes = function() {
        return j0(Nt());
      }, ue.getSupportedCallingCodes = function() {
        return j0(Ft());
      }, ue.getExample = function(o, c) {
        var w;
        return c ? w = y0(o, p2(c)) : w = y0(o, 0), new ue(w, o).toJSON();
      }, ue.getAsYouType = function(o) {
        return new je(o);
      }, ue.getNumberFrom = function(o, c) {
        try {
          e: {
            if (Ht) {
              var w = Ht.get(o);
              if (w) {
                var A = w;
                break e;
              }
            }
            let D;
            A = new ue(o == null || (D = o.number) == null ? void 0 : D.e164, {});
          }
          return { valid: !0, number: bd(A.l, c) };
        } catch (D) {
          return { valid: !1, error: D };
        }
      }, ue.prototype.toJSON = function() {
        return this.g;
      }, ue.prototype.toJSON = ue.prototype.toJSON, ue.prototype.ja = function() {
        return this.g.canBeInternationallyDialled;
      }, ue.prototype.canBeInternationallyDialled = ue.prototype.ja, ue.prototype.wa = function() {
        return this.g.valid;
      }, ue.prototype.isValid = ue.prototype.wa, ue.prototype.va = function() {
        return this.g.possible;
      }, ue.prototype.isPossible = ue.prototype.va, ue.prototype.getType = function() {
        return this.g.type;
      }, ue.prototype.getType = ue.prototype.getType, ue.prototype.ua = function() {
        return this.g.type === "mobile" || this.g.type === "fixed-line-or-mobile";
      }, ue.prototype.isMobile = ue.prototype.ua, ue.prototype.ta = function() {
        return this.g.type === "fixed-line" || this.g.type === "fixed-line-or-mobile";
      }, ue.prototype.isFixedLine = ue.prototype.ta, ue.prototype.xa = function(o) {
        return this.g.number[o ?? "e164"];
      }, ue.prototype.getNumber = ue.prototype.xa, ue.prototype.za = function() {
        return this.g.regionCode;
      }, ue.prototype.getRegionCode = ue.prototype.za, ue.prototype.ia = function() {
        return Id(this.g.regionCode);
      }, ue.prototype.getCountryCode = ue.prototype.ia;
      function je(o) {
        this.j = o, this.h = new l2(o), this.l = this.g = "";
      }
      je.prototype.sa = function(o) {
        this.g += o;
        var c = this.h;
        return c.la = u2(c, o), this.l = c.la;
      }, je.prototype.addChar = je.prototype.sa, je.prototype.Ba = function() {
        return this.l;
      }, je.prototype.number = je.prototype.Ba, je.prototype.Ca = function() {
        return this.g === "" ? this.l : this.reset(this.g.slice(0, this.g.length - 1));
      }, je.prototype.removeChar = je.prototype.Ca, je.prototype.reset = function(o) {
        var c = this.h;
        if (c.la = "", se(c.u), se(c.ba), se(c.$), c.aa = 0, c.da = "", se(c.h), c.s = "", se(c.g), c.v = !0, c.oa = !1, c.ca = !1, c.ea = !1, c.j = [], c.ha = !1, c.m != c.Aa && (c.m = kd(c, c.ma)), this.l = this.g = "", o) {
          c = 0;
          for (var w = o.length; c < w; ++c) this.sa(o.charAt(c));
        }
        return this.l;
      }, je.prototype.reset = je.prototype.reset, je.prototype.ya = function() {
        return new ue(this.l, { regionCode: this.j }).toJSON();
      }, je.prototype.getPhoneNumber = je.prototype.ya;
    }).call(
      e.exports || typeof globalThis < "u" && globalThis || typeof ad < "u" && ad || typeof window < "u" && window || typeof self < "u" && self || w9
    );
  }(Jt)), Jt.exports;
}
var k9 = qt.exports, mn;
function S9() {
  return mn || (mn = 1, function(e) {
    const t = "PhoneNumber$$module$src$index";
    e.exports = C9()[t] || (typeof globalThis < "u" && globalThis || typeof ad < "u" && ad || typeof window < "u" && window || typeof self < "u" && self || k9)[t], Object.defineProperty(
      e.exports,
      "__esModule",
      {
        value: !0
      }
    ), e.exports.parsePhoneNumber = (...d) => {
      try {
        const r = e.exports(...d).toJSON();
        return !r.valid && !r.possible && (r.possible = !1, r.possibility || (r.possibility = "invalid")), r;
      } catch (r) {
        return {
          valid: !1,
          possible: !1,
          possibility: "invalid",
          error: r
        };
      }
    }, e.exports.getCountryCodeForRegionCode = e.exports.getCountryCodeForRegionCode, e.exports.getRegionCodeForCountryCode = e.exports.getRegionCodeForCountryCode, e.exports.getSupportedCallingCodes = e.exports.getSupportedCallingCodes, e.exports.getSupportedRegionCodes = e.exports.getSupportedRegionCodes, e.exports.getExample = e.exports.getExample, e.exports.getAsYouType = e.exports.getAsYouType, e.exports.getNumberFrom = e.exports.getNumberFrom, e.exports.findNumbers = e.exports.findNumbers;
  }(qt)), qt.exports;
}
var M9 = S9(), a2 = /* @__PURE__ */ x9(M9);
const {
  PhoneNumber: D5,
  AsYouType: I5,
  getCountryCodeForRegionCode: Yt,
  getRegionCodeForCountryCode: E5,
  getSupportedCallingCodes: z5,
  getSupportedRegionCodes: T9,
  findNumbers: B5,
  getExample: L9,
  getAsYouType: P5,
  getNumberFrom: V5
} = a2, gn = (...e) => {
  try {
    const t = a2(...e).toJSON();
    return !t.valid && !t.possible && (t.possible = !1, t.possibility || (t.possibility = "invalid")), t;
  } catch (t) {
    return {
      valid: !1,
      possible: !1,
      possibility: "invalid",
      error: t
    };
  }
}, A9 = { class: "flex flex-row" }, D9 = { key: 0 }, I9 = { class: "p-2 hover:bg-grey-50" }, E9 = ["innerHTML"], O5 = /* @__PURE__ */ X({
  __name: "CfgPhoneNumberField",
  props: /* @__PURE__ */ ye({
    ...Ze,
    countries: {
      type: Array,
      default: () => ["CZ", "SK"]
    },
    showCountries: {
      type: Boolean,
      default: !0
    },
    selectedCountry: {
      type: String,
      default: "CZ"
    }
  }, {
    modelValue: {
      required: !0,
      default: {
        phoneNumber: "",
        parsedPhoneNumber: ""
      }
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: t }) {
    const d = e, r = j(() => x1(d, Object.keys({ ...Ze }))), n = ze(e, "modelValue");
    r1(() => {
      n.value = { phoneNumber: `+${Yt(d.selectedCountry)}` || "", parsedPhoneNumber: "" };
    });
    const a = de([]);
    T9().forEach((v) => {
      d.countries.includes(v) && a.value.push({
        value: v.toLowerCase(),
        label: `+${Yt(v)}`
      });
    });
    const s = de({
      value: d.selectedCountry.toLowerCase(),
      label: `+${Yt(d.selectedCountry)}`
    }), l = j(() => `+${Yt(s.value.value.toUpperCase())}`);
    t({ getExamplePhone: m, getPhoneNumber: h });
    const i = j({
      get() {
        var v;
        return ((v = n.value) == null ? void 0 : v.phoneNumber) || "";
      },
      set(v) {
        var S;
        const M = gn(v);
        n.value = {
          phoneNumber: v,
          parsedPhoneNumber: ((S = M.number) == null ? void 0 : S.e164) ?? ""
        };
      }
    }), f = j(() => i.value === l.value), p = j(() => {
      var v;
      return !((v = n.value) != null && v.phoneNumber) || f.value ? !0 : gn(n.value.phoneNumber).valid;
    });
    function m(v = d.selectedCountry) {
      return L9(v);
    }
    function h() {
      var v;
      return ((v = n.value) == null ? void 0 : v.parsedPhoneNumber) ?? "";
    }
    const C = j(() => d.errorMessage ? d.errorMessage : "Telefonní číslo není validní");
    return Ce(i, () => {
      const v = a.value.find((M) => M.label === i.value);
      v && (s.value = v);
    }), Ce(s, () => {
      var v;
      n.value = {
        phoneNumber: (v = s.value) == null ? void 0 : v.label,
        parsedPhoneNumber: ""
      };
    }), (v, M) => ($(), k("div", A9, [
      y(n1, fe({
        ...r.value,
        fluid: !0
      }, {
        modelValue: i.value,
        "onUpdate:modelValue": M[1] || (M[1] = (S) => i.value = S),
        autocomplete: "tel",
        class: "relative cursor-pointer",
        error: !p.value,
        "error-message": C.value,
        type: "tel"
      }), Dt({ _: 2 }, [
        a.value && e.showCountries ? {
          name: "placeLeft",
          fn: b(() => [
            y(g0, {
              modelValue: s.value,
              "onUpdate:modelValue": M[0] || (M[0] = (S) => s.value = S),
              class: "flex max-w-[20px]",
              "content-min-width": "100px",
              options: a.value
            }, {
              trigger: b(() => [
                s.value ? ($(), k("div", D9, [
                  x("span", {
                    class: z(`fi fi-${s.value.value}`)
                  }, null, 2)
                ])) : P("", !0)
              ]),
              item: b(({ option: S }) => [
                x("div", I9, [
                  x("span", {
                    class: z(`fi fi-${S.value} mr-2`)
                  }, null, 2),
                  x("span", {
                    class: z(["leading-6 text-grey-500", { "text-brand": S.selected, "text-grey-500": !S.selected }]),
                    innerHTML: S == null ? void 0 : S.label
                  }, null, 10, E9)
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "options"])
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["modelValue", "error", "error-message"])
    ]));
  }
}), z9 = {
  ...Ze,
  ...p0,
  observerSlotEvents: {
    type: Object,
    required: !0
  }
}, R5 = /* @__PURE__ */ X({
  __name: "CfgValidatedField",
  props: /* @__PURE__ */ ye(z9, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, d = ze(e, "modelValue"), r = j(() => x1(t, Object.keys(Ze))), n = j(() => x1(t, Object.keys(p0)));
    return (a, s) => ($(), _(Wn, fe({
      modelValue: d.value,
      "onUpdate:modelValue": s[0] || (s[0] = (l) => d.value = l),
      required: r.value.required,
      validators: n.value.validators
    }, wt(a.observerSlotEvents || {})), {
      default: b(({ on: l, attrs: i }) => [
        y(n1, fe({ ...a.$attrs, ...r.value, ...i }, {
          "model-value": i.modelValue
        }, wt(l)), {
          icon: b(() => [
            W(a.$slots, "icon")
          ]),
          _: 2
        }, 1040, ["model-value"])
      ]),
      _: 3
    }, 16, ["modelValue", "required", "validators"]));
  }
});
function N5(e) {
  const t = {
    color: "#FFFFFF4D",
    duration: 900,
    ...e
  };
  return {
    mounted(d, r) {
      var l, i, f, p, m, h;
      const n = {
        color: ((l = r.value) == null ? void 0 : l.color) || t.color,
        duration: ((i = r.value) == null ? void 0 : i.duration) || t.duration,
        scale: {
          x: ((p = (f = r.value) == null ? void 0 : f.scale) == null ? void 0 : p.x) || 1,
          y: ((h = (m = r.value) == null ? void 0 : m.scale) == null ? void 0 : h.y) || 1
        }
      };
      if (typeof window > "u")
        return;
      ["static", "fixed", "absolute", "relative", "sticky"].some((C) => d.classList.contains(C)) || d.classList.add("relative");
      const s = r.dir;
      s.handleOnClick = (C) => {
        const v = document.createElement("div");
        v.style.position = "absolute", v.style.top = "50%", v.style.left = "50%", v.style.width = "100%", v.style.height = "100%", v.style.overflow = "hidden", v.style.pointerEvents = "none", v.style.zIndex = "0", v.style.transform = `translate(-50%, -50%) scale(${n.scale.x}, ${n.scale.y})`, d.classList.forEach((I) => {
          /^rounded(?:-[trbl]{1,2})?(?:-[a-z]+)?$/.test(I) && v.classList.add(I);
        }), d.appendChild(v);
        const M = d.getBoundingClientRect(), S = Math.max(M.width, M.height), L = C.clientX - M.left - S / 2, T = C.clientY - M.top - S / 2, g = document.createElement("span");
        g.className = "ripple-animation rounded-full pointer-events-none opacity-30", g.style.position = "absolute", g.style.width = `${S}px`, g.style.height = `${S}px`, g.style.top = `${T}px`, g.style.left = `${L}px`, g.style.backgroundColor = n.color, g.style.animationDuration = `${n.duration}ms`, g.style.transform = "scale(0)", v.appendChild(g), setTimeout(() => {
          v.contains(g) && (v.removeChild(g), d.removeChild(v));
        }, n.duration);
      }, d.addEventListener("click", s.handleOnClick);
    },
    unmounted(d, r) {
      if (typeof window > "u")
        return;
      const n = r.dir;
      d.removeEventListener("click", n.handleOnClick);
    }
  };
}
export {
  G9 as CfgAccordion,
  U9 as CfgAccordionItem,
  p5 as CfgAddressDetailsField,
  W9 as CfgAlert,
  He as CfgAlertVariants,
  e5 as CfgApplicationError,
  m5 as CfgBankAccountField,
  g5 as CfgBirthNumberField,
  f3 as CfgBottomSheet,
  t5 as CfgBreadcrumbs,
  I1 as CfgButton,
  d5 as CfgButtonsGroup,
  ks as CfgCalendar,
  Y9 as CfgCard,
  K9 as CfgCarousel,
  rd as CfgCheckbox,
  n5 as CfgCheckboxGroup,
  sd as CfgChip,
  t1 as CfgChipColors,
  r5 as CfgChipsToggle,
  zo as CfgCircularProgress,
  Bn as CfgCollapsable,
  a5 as CfgCombobox,
  sn as CfgCompactInput,
  Wl as CfgDateField,
  s5 as CfgDialog,
  ta as CfgDropdown,
  Z9 as CfgFilterChip,
  Yn as CfgFloating,
  b5 as CfgForm,
  q9 as CfgHeaderBanner,
  et as CfgHint,
  n1 as CfgInput,
  y5 as CfgInvestCalculator,
  h5 as CfgIssuesCard,
  Ql as CfgIssuesCardHeader,
  Zn as CfgIssuesCollaterals,
  hi as CfgIssuesCollateralsSheet,
  C5 as CfgIssuesDetailCompany,
  bi as CfgIssuesDetailCompanyAbout,
  xi as CfgIssuesDetailCompanyInfo,
  Mi as CfgIssuesDetailCompanyPeople,
  Ei as CfgIssuesDetailCompanyResults,
  k5 as CfgIssuesDetailHeader,
  S5 as CfgIssuesDetailProject,
  d4 as CfgIssuesDetailProjectAbout,
  o4 as CfgIssuesDetailProjectCollaterals,
  h4 as CfgIssuesDetailProjectExample,
  b4 as CfgIssuesDetailProjectInfoTable,
  x4 as CfgIssuesDetailProjectMotivation,
  S4 as CfgIssuesDetailProjectVideo,
  Yi as CfgIssuesDetailRatingChip,
  M5 as CfgIssuesDetailReturns,
  T5 as CfgIssuesDetailTabs,
  Bi as CfgIssuesInfo,
  L5 as CfgIssuesProgress,
  od as CfgIssuesRatingChip,
  Y1 as CfgModalSizes,
  J9 as CfgOtpInput,
  Ma as CfgPagination,
  A5 as CfgPasswordField,
  O5 as CfgPhoneNumberField,
  It as CfgPreloader,
  za as CfgRadio,
  o5 as CfgRadioGroup,
  Pa as CfgScrollbarView,
  g0 as CfgSelect,
  Q1 as CfgSeparator,
  E3 as CfgSlideOver,
  l5 as CfgSlider,
  X9 as CfgSwitch,
  i5 as CfgTab,
  u5 as CfgTabPanel,
  h0 as CfgTable,
  x5 as CfgTableMenuItem,
  c5 as CfgTabs,
  Q9 as CfgTextarea,
  f5 as CfgTimeline,
  Pl as CfgTimelineItem,
  Ve as CfgTimelineItemColors,
  $5 as CfgToastNotification,
  d1 as CfgToastNotificationType,
  da as CfgTransition,
  O as CfgTypography,
  H as CfgTypographySizes,
  R5 as CfgValidatedField,
  Ya as CfgValidationObserver,
  Wn as CfgValidationProvider,
  B1 as CollateralGroups,
  Re as FormControlNames,
  Xe as TableCallAlign,
  Jn as buildFormResults,
  W1 as collateralsGroupMap,
  w5 as collateralsIconMap,
  N5 as ripple,
  v5 as useForm
};
